//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Operation } from "Utils/jsonPatch";
import ClientBase from "./ClientBase";

export class AccountClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    forgotPassword(request: ForgotPasswordRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/account/password/forgot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForgotPassword(_response));
        });
    }

    protected processForgotPassword(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    changePassword(model: ChangePasswordModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/account/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangePassword(_response));
        });
    }

    protected processChangePassword(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    personalInformation(signal?: AbortSignal): Promise<MemberDataModel> {
        let url_ = this.baseUrl + "/api/account/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPersonalInformation(_response));
        });
    }

    protected processPersonalInformation(response: Response): Promise<MemberDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberDataModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberDataModel>(null as any);
    }

    updatePersonalInformation(model: MemberDataModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/account/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePersonalInformation(_response));
        });
    }

    protected processUpdatePersonalInformation(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    notificationList(signal?: AbortSignal): Promise<MemberNotificationModel[]> {
        let url_ = this.baseUrl + "/api/account/notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNotificationList(_response));
        });
    }

    protected processNotificationList(response: Response): Promise<MemberNotificationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberNotificationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberNotificationModel[]>(null as any);
    }

    setNotificationValue(notificationSettingType: MemberNotificationSettingType, value: boolean, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/account/notifications/{notificationSettingType}";
        if (notificationSettingType === undefined || notificationSettingType === null)
            throw new Error("The parameter 'notificationSettingType' must be defined.");
        url_ = url_.replace("{notificationSettingType}", encodeURIComponent("" + notificationSettingType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetNotificationValue(_response));
        });
    }

    protected processSetNotificationValue(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    changeEmailRequest(signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/account/email/change-request";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeEmailRequest(_response));
        });
    }

    protected processChangeEmailRequest(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    changeEmail(model: ChangeEmailModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/account/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeEmail(_response));
        });
    }

    protected processChangeEmail(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    ssoMember(signal?: AbortSignal): Promise<SsoMemberModel[]> {
        let url_ = this.baseUrl + "/api/account/sso";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSsoMember(_response));
        });
    }

    protected processSsoMember(response: Response): Promise<SsoMemberModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SsoMemberModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SsoMemberModel[]>(null as any);
    }

    removeMemberSSO(ssoType: SsoType, ssoId: string, signal?: AbortSignal): Promise<SsoMemberModel[]> {
        let url_ = this.baseUrl + "/api/account/sso/{ssoType}/{ssoId}";
        if (ssoType === undefined || ssoType === null)
            throw new Error("The parameter 'ssoType' must be defined.");
        url_ = url_.replace("{ssoType}", encodeURIComponent("" + ssoType));
        if (ssoId === undefined || ssoId === null)
            throw new Error("The parameter 'ssoId' must be defined.");
        url_ = url_.replace("{ssoId}", encodeURIComponent("" + ssoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveMemberSSO(_response));
        });
    }

    protected processRemoveMemberSSO(response: Response): Promise<SsoMemberModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SsoMemberModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SsoMemberModel[]>(null as any);
    }

    setSocialVisibility(visibility: SocialVisibility | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/account/social-visibility?";
        if (visibility === null)
            throw new Error("The parameter 'visibility' cannot be null.");
        else if (visibility !== undefined)
            url_ += "visibility=" + encodeURIComponent("" + visibility) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetSocialVisibility(_response));
        });
    }

    protected processSetSocialVisibility(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ApiClientsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(signal?: AbortSignal): Promise<ApiClientListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/apiclients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<ApiClientListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiClientListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiClientListItemViewModel[]>(null as any);
    }

    create(model: EditableApiClientModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/apiclients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ResponseWrapper.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    get(clientId: string, signal?: AbortSignal): Promise<EditableApiClientModel> {
        let url_ = this.baseUrl + "/api/apiclients/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<EditableApiClientModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditableApiClientModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditableApiClientModel>(null as any);
    }

    patch(clientId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/apiclients/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    delete(clientId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/apiclients/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class BlogsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    byTag(tag: BlogTag, signal?: AbortSignal): Promise<BlogViewModel> {
        let url_ = this.baseUrl + "/api/blogs/{tag}";
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processByTag(_response));
        });
    }

    protected processByTag(response: Response): Promise<BlogViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlogViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlogViewModel>(null as any);
    }
}

export class BookingClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    prerequisites(request: BookingPrerequisites, signal?: AbortSignal): Promise<BookingPrerequisitesValidationResult> {
        let url_ = this.baseUrl + "/api/booking/prerequisites/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrerequisites(_response));
        });
    }

    protected processPrerequisites(response: Response): Promise<BookingPrerequisitesValidationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingPrerequisitesValidationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookingPrerequisitesValidationResult>(null as any);
    }

    representee(venueId: string | undefined, workspaceId: string | undefined, signal?: AbortSignal): Promise<BookingRepresenteeViewModel[]> {
        let url_ = this.baseUrl + "/api/booking/representee?";
        if (venueId === null)
            throw new Error("The parameter 'venueId' cannot be null.");
        else if (venueId !== undefined)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRepresentee(_response));
        });
    }

    protected processRepresentee(response: Response): Promise<BookingRepresenteeViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingRepresenteeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookingRepresenteeViewModel[]>(null as any);
    }

    check(request: WorkspaceAvailabilityCheckViewModel, signal?: AbortSignal): Promise<WorkspaceAvailabilityCheckViewModel> {
        let url_ = this.baseUrl + "/api/booking/availability/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheck(_response));
        });
    }

    protected processCheck(response: Response): Promise<WorkspaceAvailabilityCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceAvailabilityCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceAvailabilityCheckViewModel>(null as any);
    }
}

export class CollectionsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    collections(signal?: AbortSignal): Promise<FavoriteCollectionViewModel[]> {
        let url_ = this.baseUrl + "/api/collections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCollections(_response));
        });
    }

    protected processCollections(response: Response): Promise<FavoriteCollectionViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FavoriteCollectionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavoriteCollectionViewModel[]>(null as any);
    }

    count(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/collections/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCount(_response));
        });
    }

    protected processCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    memberVenues(onlyHourlySpaces: boolean | undefined, signal?: AbortSignal): Promise<VenueSearchResult[]> {
        let url_ = this.baseUrl + "/api/collections/venues?";
        if (onlyHourlySpaces === null)
            throw new Error("The parameter 'onlyHourlySpaces' cannot be null.");
        else if (onlyHourlySpaces !== undefined)
            url_ += "onlyHourlySpaces=" + encodeURIComponent("" + onlyHourlySpaces) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMemberVenues(_response));
        });
    }

    protected processMemberVenues(response: Response): Promise<VenueSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueSearchResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueSearchResult[]>(null as any);
    }

    createCollection(newName: string, signal?: AbortSignal): Promise<FavoriteCollectionViewModel> {
        let url_ = this.baseUrl + "/api/collections/{newName}";
        if (newName === undefined || newName === null)
            throw new Error("The parameter 'newName' must be defined.");
        url_ = url_.replace("{newName}", encodeURIComponent("" + newName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCollection(_response));
        });
    }

    protected processCreateCollection(response: Response): Promise<FavoriteCollectionViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FavoriteCollectionViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavoriteCollectionViewModel>(null as any);
    }

    isValid(collectionId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsValid(_response));
        });
    }

    protected processIsValid(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    deleteCollection(collectionId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteCollection(_response));
        });
    }

    protected processDeleteCollection(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    renameCollection(collectionId: string, newName: string, signal?: AbortSignal): Promise<FavoriteCollectionViewModel> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/name";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRenameCollection(_response));
        });
    }

    protected processRenameCollection(response: Response): Promise<FavoriteCollectionViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FavoriteCollectionViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavoriteCollectionViewModel>(null as any);
    }

    copyCollection(collectionId: string, newName: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/copy";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopyCollection(_response));
        });
    }

    protected processCopyCollection(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    collectionCollaborators(collectionId: string, signal?: AbortSignal): Promise<CollaboratorViewModel[]> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/collaborators";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCollectionCollaborators(_response));
        });
    }

    protected processCollectionCollaborators(response: Response): Promise<CollaboratorViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollaboratorViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollaboratorViewModel[]>(null as any);
    }

    removeCollectionCollaborator(collectionId: string, collaboratorId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/collaborators/{collaboratorId}";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        if (collaboratorId === undefined || collaboratorId === null)
            throw new Error("The parameter 'collaboratorId' must be defined.");
        url_ = url_.replace("{collaboratorId}", encodeURIComponent("" + collaboratorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveCollectionCollaborator(_response));
        });
    }

    protected processRemoveCollectionCollaborator(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    venues(collectionId: string, signal?: AbortSignal): Promise<VenueSearchResult[]> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/venues";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVenues(_response));
        });
    }

    protected processVenues(response: Response): Promise<VenueSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueSearchResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueSearchResult[]>(null as any);
    }

    workspaces(collectionId: string, signal?: AbortSignal): Promise<FavoriteCollectionWorkspacesViewModel> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/workspaces";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processWorkspaces(_response));
        });
    }

    protected processWorkspaces(response: Response): Promise<FavoriteCollectionWorkspacesViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FavoriteCollectionWorkspacesViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavoriteCollectionWorkspacesViewModel>(null as any);
    }

    deleteWorkspaceFromCollection(collectionId: string, workspaceId: string, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/workspaces/{workspaceId}";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteWorkspaceFromCollection(_response));
        });
    }

    protected processDeleteWorkspaceFromCollection(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    shareCollectionData(collectionId: string, signal?: AbortSignal): Promise<ShareCollectionModel> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/sharedata";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processShareCollectionData(_response));
        });
    }

    protected processShareCollectionData(response: Response): Promise<ShareCollectionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareCollectionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShareCollectionModel>(null as any);
    }

    sharedCollections(signal?: AbortSignal): Promise<FavoriteCollectionViewModel[]> {
        let url_ = this.baseUrl + "/api/collections/shared";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSharedCollections(_response));
        });
    }

    protected processSharedCollections(response: Response): Promise<FavoriteCollectionViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FavoriteCollectionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavoriteCollectionViewModel[]>(null as any);
    }

    deleteSharedCollection(collectionId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/collections/shared/{collectionId}";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSharedCollection(_response));
        });
    }

    protected processDeleteSharedCollection(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ConciergeRequestClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Request from Unclaimed XPP
     */
    notifyMe(model: ConciergeRequestViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/concierge-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNotifyMe(_response));
        });
    }

    protected processNotifyMe(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ConfigClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    classAndEnumConverter(signal?: AbortSignal): Promise<ClassesAndEnumsToConvert> {
        let url_ = this.baseUrl + "/api/config/classandenumconverter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClassAndEnumConverter(_response));
        });
    }

    protected processClassAndEnumConverter(response: Response): Promise<ClassesAndEnumsToConvert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassesAndEnumsToConvert.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassesAndEnumsToConvert>(null as any);
    }

    getMarketingStats(signal?: AbortSignal): Promise<MarketingStats> {
        let url_ = this.baseUrl + "/api/config/marketingstats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMarketingStats(_response));
        });
    }

    protected processGetMarketingStats(response: Response): Promise<MarketingStats> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingStats.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingStats>(null as any);
    }

    getTimeZones(signal?: AbortSignal): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/config/timezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTimeZones(_response));
        });
    }

    protected processGetTimeZones(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

export class ConnectionsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(connectionKind: ConnectionKind | undefined, signal?: AbortSignal): Promise<ConnectionInfo[]> {
        let url_ = this.baseUrl + "/api/connections?";
        if (connectionKind === null)
            throw new Error("The parameter 'connectionKind' cannot be null.");
        else if (connectionKind !== undefined)
            url_ += "connectionKind=" + encodeURIComponent("" + connectionKind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<ConnectionInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConnectionInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConnectionInfo[]>(null as any);
    }

    follow(targetUserId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/connections/{targetUserId}";
        if (targetUserId === undefined || targetUserId === null)
            throw new Error("The parameter 'targetUserId' must be defined.");
        url_ = url_.replace("{targetUserId}", encodeURIComponent("" + targetUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFollow(_response));
        });
    }

    protected processFollow(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    unfollow(targetUserId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/connections/{targetUserId}";
        if (targetUserId === undefined || targetUserId === null)
            throw new Error("The parameter 'targetUserId' must be defined.");
        url_ = url_.replace("{targetUserId}", encodeURIComponent("" + targetUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnfollow(_response));
        });
    }

    protected processUnfollow(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class CostsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    calculate(request: CostRequest, signal?: AbortSignal): Promise<CostDetailsViewModel> {
        let url_ = this.baseUrl + "/api/Costs/calculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCalculate(_response));
        });
    }

    protected processCalculate(response: Response): Promise<CostDetailsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostDetailsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CostDetailsViewModel>(null as any);
    }
}

export class CountriesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getCodes(forceAllCountries: boolean | null | undefined, signal?: AbortSignal): Promise<CountryCodeBase[]> {
        let url_ = this.baseUrl + "/api/countries?";
        if (forceAllCountries !== undefined && forceAllCountries !== null)
            url_ += "forceAllCountries=" + encodeURIComponent("" + forceAllCountries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCodes(_response));
        });
    }

    protected processGetCodes(response: Response): Promise<CountryCodeBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryCodeBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryCodeBase[]>(null as any);
    }

    listWithStates(forceAllCountries: boolean | null | undefined, signal?: AbortSignal): Promise<CountryCode[]> {
        let url_ = this.baseUrl + "/api/countries/states?";
        if (forceAllCountries !== undefined && forceAllCountries !== null)
            url_ += "forceAllCountries=" + encodeURIComponent("" + forceAllCountries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListWithStates(_response));
        });
    }

    protected processListWithStates(response: Response): Promise<CountryCode[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryCode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryCode[]>(null as any);
    }

    submitWaitlistForm(request: WaitlistRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/countries/submit-waitlist-form";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitWaitlistForm(_response));
        });
    }

    protected processSubmitWaitlistForm(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class DataRemovalRequestsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    sendRequest(model: DataRemovalRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/data-removal-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendRequest(_response));
        });
    }

    protected processSendRequest(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ActivityReservationInternalClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get list of Enterprise Account reservations optionally filtered by Team or Member
     * @param accountId Enterprise Account ID
     * @param reservationsStatuses (optional) Reservation statuses to read
     * @param teamId (optional) Team ID
     * @param memberId (optional) Member ID
     * @param start (optional) Start time (included)
     * @param end (optional) End time (included; use 1s before target time. ex.: 23:59:59)
     * @param requestId (optional) Async progress request id
     */
    reservations(accountId: string, reservationsStatuses: ActivityReservationStatusFilter | undefined, teamId: string | null | undefined, memberId: string | null | undefined, start: string | null | undefined, end: string | null | undefined, requestId: string | null | undefined, signal?: AbortSignal): Promise<ActivityReservationInternalModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/internal/reservations?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (reservationsStatuses === null)
            throw new Error("The parameter 'reservationsStatuses' cannot be null.");
        else if (reservationsStatuses !== undefined)
            url_ += "reservationsStatuses=" + encodeURIComponent("" + reservationsStatuses) + "&";
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReservations(_response));
        });
    }

    protected processReservations(response: Response): Promise<ActivityReservationInternalModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityReservationInternalModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityReservationInternalModel[]>(null as any);
    }
}

export class ActivityReservationPrivateClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get list of Enterprise Account reservations optionally filtered by Team or Member
     * @param accountId Enterprise Account ID
     * @param reservationsStatuses (optional) Reservation statuses to read
     * @param teamId (optional) Team ID
     * @param memberId (optional) Member ID
     * @param start (optional) Start time (included)
     * @param end (optional) End time (included; use 1s before target time. ex.: 23:59:59)
     * @param requestId (optional) 
     */
    reservations(accountId: string, reservationsStatuses: ActivityReservationStatusFilter | undefined, teamId: string | null | undefined, memberId: string | null | undefined, start: string | null | undefined, end: string | null | undefined, requestId: string | null | undefined, signal?: AbortSignal): Promise<ActivityReservationPrivateModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reservations?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (reservationsStatuses === null)
            throw new Error("The parameter 'reservationsStatuses' cannot be null.");
        else if (reservationsStatuses !== undefined)
            url_ += "reservationsStatuses=" + encodeURIComponent("" + reservationsStatuses) + "&";
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReservations(_response));
        });
    }

    protected processReservations(response: Response): Promise<ActivityReservationPrivateModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityReservationPrivateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityReservationPrivateModel[]>(null as any);
    }

    reservationsCached(accountId: string, signal?: AbortSignal): Promise<ActivityReservationPrivateModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reservations/cached";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReservationsCached(_response));
        });
    }

    protected processReservationsCached(response: Response): Promise<ActivityReservationPrivateModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityReservationPrivateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityReservationPrivateModel[]>(null as any);
    }

    reservationsOverview(accountId: string, teamId: string | null | undefined, start: string | undefined, end: string | undefined, requestId: string | null | undefined, signal?: AbortSignal): Promise<ReservationOverview[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reservations/overview?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReservationsOverview(_response));
        });
    }

    protected processReservationsOverview(response: Response): Promise<ReservationOverview[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationOverview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationOverview[]>(null as any);
    }

    reservationsOverviewCached(accountId: string, signal?: AbortSignal): Promise<ReservationOverview[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reservations/overview/cached";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReservationsOverviewCached(_response));
        });
    }

    protected processReservationsOverviewCached(response: Response): Promise<ReservationOverview[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationOverview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationOverview[]>(null as any);
    }
}

export class ActivityReservationReportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    generate(accountId: string, hourlyMonthly: HourlyMonthly | undefined, teamId: string | null | undefined, memberId: string | null | undefined, start: string | null | undefined, end: string | null | undefined, fileFormat: DownloadFileFormat | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reservations/report?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (hourlyMonthly === null)
            throw new Error("The parameter 'hourlyMonthly' cannot be null.");
        else if (hourlyMonthly !== undefined)
            url_ += "hourlyMonthly=" + encodeURIComponent("" + hourlyMonthly) + "&";
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (fileFormat === null)
            throw new Error("The parameter 'fileFormat' cannot be null.");
        else if (fileFormat !== undefined)
            url_ += "fileFormat=" + encodeURIComponent("" + fileFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerate(_response));
        });
    }

    protected processGenerate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    list(accountId: string, memberId: string | null | undefined, signal?: AbortSignal): Promise<ActivityReservationReportStatus[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reservations/report?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<ActivityReservationReportStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityReservationReportStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityReservationReportStatus[]>(null as any);
    }

    get(accountId: string, reportId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reservations/report/{reportId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(accountId: string, reportId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reservations/report/{reportId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ActivityReviewClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    reviews(accountId: string, teamId: string | null | undefined, start: string | null | undefined, end: string | null | undefined, requestId: string | null | undefined, signal?: AbortSignal): Promise<ActivityReview[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reviews?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviews(_response));
        });
    }

    protected processReviews(response: Response): Promise<ActivityReview[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityReview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityReview[]>(null as any);
    }

    reviewsOverview(accountId: string, requestId: string | null | undefined, signal?: AbortSignal): Promise<ReviewOverview[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reviews/overview?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewsOverview(_response));
        });
    }

    protected processReviewsOverview(response: Response): Promise<ReviewOverview[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReviewOverview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReviewOverview[]>(null as any);
    }

    reviewDetails(reviewId: string | undefined, workspaceId: string | undefined, accountId: string, signal?: AbortSignal): Promise<ActivityReviewDetails> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/reviews/details?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (reviewId === null)
            throw new Error("The parameter 'reviewId' cannot be null.");
        else if (reviewId !== undefined)
            url_ += "reviewId=" + encodeURIComponent("" + reviewId) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewDetails(_response));
        });
    }

    protected processReviewDetails(response: Response): Promise<ActivityReviewDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityReviewDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityReviewDetails>(null as any);
    }
}

export class ActivitySearchClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    searchesOverview(accountId: string, requestId: string | null | undefined, signal?: AbortSignal): Promise<SearchOverview[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/searches/searchesOverview?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchesOverview(_response));
        });
    }

    protected processSearchesOverview(response: Response): Promise<SearchOverview[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchOverview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchOverview[]>(null as any);
    }

    searches(accountId: string, teamId: string | null | undefined, start: string | null | undefined, end: string | null | undefined, requestId: string | null | undefined, signal?: AbortSignal): Promise<ActivitySearch[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/searches/searches?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearches(_response));
        });
    }

    protected processSearches(response: Response): Promise<ActivitySearch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivitySearch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivitySearch[]>(null as any);
    }

    searchDetails(searchId: string | undefined, searchDate: string | undefined, accountId: string, signal?: AbortSignal): Promise<ActivitySearchDetails> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/activities/searches/searchDetails?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (searchId === null)
            throw new Error("The parameter 'searchId' cannot be null.");
        else if (searchId !== undefined)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (searchDate === null)
            throw new Error("The parameter 'searchDate' cannot be null.");
        else if (searchDate !== undefined)
            url_ += "searchDate=" + encodeURIComponent("" + searchDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchDetails(_response));
        });
    }

    protected processSearchDetails(response: Response): Promise<ActivitySearchDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivitySearchDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivitySearchDetails>(null as any);
    }
}

export class BrandingClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(accountId: string, signal?: AbortSignal): Promise<BrandedOptionsModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/Branding";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<BrandedOptionsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrandedOptionsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrandedOptionsModel>(null as any);
    }

    patch(accountId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/Branding";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ContentClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id: string | undefined, signal?: AbortSignal): Promise<ContentItemModel[]> {
        let url_ = this.baseUrl + "/api/Content?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ContentItemModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentItemModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentItemModel[]>(null as any);
    }

    delete(id: string | undefined, itemId: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/Content?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "ItemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    add(id: string | undefined, model: ContentItemAddModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/Content?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    patch(id: string | undefined, itemId: string | undefined, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/Content?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "ItemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    order(accountId: string | undefined, contentOrder: { [key: string]: number; }, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Content/order?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contentOrder);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOrder(_response));
        });
    }

    protected processOrder(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DashboardClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    dashboard(accountId: string, start: string | null | undefined, end: string | null | undefined, requestId: string | null | undefined, signal?: AbortSignal): Promise<DashboardViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/Dashboard?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDashboard(_response));
        });
    }

    protected processDashboard(response: Response): Promise<DashboardViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardViewModel>(null as any);
    }

    dashboardCached(accountId: string, signal?: AbortSignal): Promise<DashboardViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/Dashboard/cached";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDashboardCached(_response));
        });
    }

    protected processDashboardCached(response: Response): Promise<DashboardViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardViewModel>(null as any);
    }
}

export class EnrollmentClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(accountId: string, signal?: AbortSignal): Promise<EnrollmentSettingsModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/Enrollment";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<EnrollmentSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnrollmentSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnrollmentSettingsModel>(null as any);
    }

    patch(accountId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/Enrollment";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class EnterpriseAccountAdminClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(accountId: string, signal?: AbortSignal): Promise<AccountAdminInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/admin";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<AccountAdminInfoViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountAdminInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountAdminInfoViewModel[]>(null as any);
    }

    delete(accountId: string, memberId: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/admin?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === null)
            throw new Error("The parameter 'memberId' cannot be null.");
        else if (memberId !== undefined)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    add(accountId: string, model: AddAccountAdminModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/admin";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class EnterpriseAccountApiClientsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(accountId: string, signal?: AbortSignal): Promise<EnterpriseAccountApiClientListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/apiClients";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<EnterpriseAccountApiClientListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnterpriseAccountApiClientListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountApiClientListItemViewModel[]>(null as any);
    }

    get(accountId: string, clientId: string, signal?: AbortSignal): Promise<EditableEnterpriseAccountApiClientViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/apiClients/{clientId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<EditableEnterpriseAccountApiClientViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditableEnterpriseAccountApiClientViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditableEnterpriseAccountApiClientViewModel>(null as any);
    }

    assignApiClient(accountId: string, clientId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/apiClients/{clientId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssignApiClient(_response));
        });
    }

    protected processAssignApiClient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unassignApiClient(accountId: string, clientId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/apiClients/{clientId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnassignApiClient(_response));
        });
    }

    protected processUnassignApiClient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    patch(accountId: string, clientId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/apiClients/{clientId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class EnterpriseAccountBillingsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(accountId: string, signal?: AbortSignal): Promise<EnterpriseAccountBillingModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/billings";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<EnterpriseAccountBillingModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnterpriseAccountBillingModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountBillingModel[]>(null as any);
    }

    create(accountId: string, request: EnterpriseAccountBillingCreateRequest, signal?: AbortSignal): Promise<EnterpriseAccountBillingModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/billings";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<EnterpriseAccountBillingModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseAccountBillingModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountBillingModel>(null as any);
    }

    patch(accountId: string, billingId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/billings/{billingId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (billingId === undefined || billingId === null)
            throw new Error("The parameter 'billingId' must be defined.");
        url_ = url_.replace("{billingId}", encodeURIComponent("" + billingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    cancel(accountId: string, billingId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/billings/{billingId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (billingId === undefined || billingId === null)
            throw new Error("The parameter 'billingId' must be defined.");
        url_ = url_.replace("{billingId}", encodeURIComponent("" + billingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancel(_response));
        });
    }

    protected processCancel(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    force(accountId: string, billingId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/billings/{billingId}/force";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (billingId === undefined || billingId === null)
            throw new Error("The parameter 'billingId' must be defined.");
        url_ = url_.replace("{billingId}", encodeURIComponent("" + billingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForce(_response));
        });
    }

    protected processForce(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class EnterpriseAccountClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    accountInfo(accountId: string, signal?: AbortSignal): Promise<AccountInfoViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/info";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAccountInfo(_response));
        });
    }

    protected processAccountInfo(response: Response): Promise<AccountInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoViewModel>(null as any);
    }

    /**
     * List available Enterprise Accounts
     * @return List of Enterprise Account models. Note that depending on access level there list can consist of EnterpriseAccountListViewModel or EnterpriseAccountExtendedListViewModel
     */
    list(signal?: AbortSignal): Promise<EnterpriseAccountListViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<EnterpriseAccountListViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnterpriseAccountListViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountListViewModel[]>(null as any);
    }

    create(model: EnterpriseAccountSettingsModel, signal?: AbortSignal): Promise<EnterpriseAccountSettingsModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<EnterpriseAccountSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseAccountSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountSettingsModel>(null as any);
    }

    ssoUrl(accountId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/ssourl";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSsoUrl(_response));
        });
    }

    protected processSsoUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * List teams in Enterprise Account
     * @param accountId Enterprise Account ID
     */
    teams(accountId: string, signal?: AbortSignal): Promise<TeamInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/teams";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTeams(_response));
        });
    }

    protected processTeams(response: Response): Promise<TeamInfoViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamInfoViewModel[]>(null as any);
    }

    deleteTeam(accountId: string, teamId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/teams/{teamId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTeam(_response));
        });
    }

    protected processDeleteTeam(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    attachTeam(accountId: string, teamId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/teams/{teamId}/attach";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAttachTeam(_response));
        });
    }

    protected processAttachTeam(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    attachTeamList(accountId: string, signal?: AbortSignal): Promise<TeamListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/attachteamlist";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAttachTeamList(_response));
        });
    }

    protected processAttachTeamList(response: Response): Promise<TeamListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamListItemViewModel[]>(null as any);
    }

    get(accountId: string, signal?: AbortSignal): Promise<AccountModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<AccountModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountModel>(null as any);
    }

    patch(accountId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    delete(accountId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    importMessage(accountId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/importmessage";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportMessage(_response));
        });
    }

    protected processImportMessage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class EnterpriseAccountEventsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(accountId: string, signal?: AbortSignal): Promise<EventHistoryModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/events";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<EventHistoryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventHistoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventHistoryModel[]>(null as any);
    }

    add(accountId: string, message: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/events?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    edit(accountId: string, eventId: string, message: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/events/{eventId}?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEdit(_response));
        });
    }

    protected processEdit(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    delete(accountId: string, eventId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/events/{eventId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class EnterpriseAccountHeadquarterClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getHeadquarters(accountId: string, signal?: AbortSignal): Promise<EnterpriseAccountHeadquarterViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/headquarter";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHeadquarters(_response));
        });
    }

    protected processGetHeadquarters(response: Response): Promise<EnterpriseAccountHeadquarterViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnterpriseAccountHeadquarterViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountHeadquarterViewModel[]>(null as any);
    }

    addHeadquarter(accountId: string, model: EnterpriseAccountHeadquarterViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/headquarter";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddHeadquarter(_response));
        });
    }

    protected processAddHeadquarter(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getHeadquarter(accountId: string, headquarterId: string, signal?: AbortSignal): Promise<EnterpriseAccountHeadquarterViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/headquarter/{headquarterId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (headquarterId === undefined || headquarterId === null)
            throw new Error("The parameter 'headquarterId' must be defined.");
        url_ = url_.replace("{headquarterId}", encodeURIComponent("" + headquarterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHeadquarter(_response));
        });
    }

    protected processGetHeadquarter(response: Response): Promise<EnterpriseAccountHeadquarterViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseAccountHeadquarterViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountHeadquarterViewModel>(null as any);
    }

    deleteHeadquarter(accountId: string, headquarterId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/headquarter/{headquarterId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (headquarterId === undefined || headquarterId === null)
            throw new Error("The parameter 'headquarterId' must be defined.");
        url_ = url_.replace("{headquarterId}", encodeURIComponent("" + headquarterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteHeadquarter(_response));
        });
    }

    protected processDeleteHeadquarter(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    updateHeadquarter(accountId: string, headquarterId: string, model: EnterpriseAccountHeadquarterViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/headquarter/{headquarterId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (headquarterId === undefined || headquarterId === null)
            throw new Error("The parameter 'headquarterId' must be defined.");
        url_ = url_.replace("{headquarterId}", encodeURIComponent("" + headquarterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateHeadquarter(_response));
        });
    }

    protected processUpdateHeadquarter(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class EnterpriseAccountMemberClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * List Members in Enterprise Account
     * @param accountId Enterprise Account ID
     * @param take (optional) Optional limit of returned items
     */
    list(accountId: string, take: number | null | undefined, signal?: AbortSignal): Promise<TeamMemberInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<TeamMemberInfoViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMemberInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberInfoViewModel[]>(null as any);
    }

    /**
     * Register member for Enterprise Account
     * @param accountId Enterprise Account ID
     * @param invite (optional) Team name
     * @param request Registration model
     */
    register(accountId: string, invite: string | null | undefined, request: EnterprisePortalRegisterRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (invite !== undefined && invite !== null)
            url_ += "invite=" + encodeURIComponent("" + invite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegister(_response));
        });
    }

    protected processRegister(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    /**
     * Get Member by ID or email
     * @param accountId Enterprise Account ID
     * @param memberId Member ID or email
     */
    get(accountId: string, memberId: string, signal?: AbortSignal): Promise<TeamMemberViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/{memberId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<TeamMemberViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamMemberViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberViewModel>(null as any);
    }

    patch(accountId: string, memberId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/{memberId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getInfo(accountId: string, memberId: string, signal?: AbortSignal): Promise<TeamMemberInfoViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/{memberId}/info";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInfo(_response));
        });
    }

    protected processGetInfo(response: Response): Promise<TeamMemberInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamMemberInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberInfoViewModel>(null as any);
    }

    memberAutocomplete(accountId: string, emailPart: string | undefined, signal?: AbortSignal): Promise<MemberAutocomplete[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/autocomplete?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (emailPart === null)
            throw new Error("The parameter 'emailPart' cannot be null.");
        else if (emailPart !== undefined)
            url_ += "emailPart=" + encodeURIComponent("" + emailPart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMemberAutocomplete(_response));
        });
    }

    protected processMemberAutocomplete(response: Response): Promise<MemberAutocomplete[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberAutocomplete.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberAutocomplete[]>(null as any);
    }

    resendInvite(accountId: string, memberId: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/reinvite?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === null)
            throw new Error("The parameter 'memberId' cannot be null.");
        else if (memberId !== undefined)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResendInvite(_response));
        });
    }

    protected processResendInvite(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    resendInvites(accountId: string, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/reinvite-all";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResendInvites(_response));
        });
    }

    protected processResendInvites(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    spendThisMonth(accountId: string, memberId: string, signal?: AbortSignal): Promise<TeamMemberSpendResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/{memberId}/spendthismonth";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSpendThisMonth(_response));
        });
    }

    protected processSpendThisMonth(response: Response): Promise<TeamMemberSpendResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamMemberSpendResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberSpendResponse>(null as any);
    }

    ratingCounters(accountId: string, memberId: string, signal?: AbortSignal): Promise<TeamMemberRatingCounters> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/{memberId}/ratingcounters";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRatingCounters(_response));
        });
    }

    protected processRatingCounters(response: Response): Promise<TeamMemberRatingCounters> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamMemberRatingCounters.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberRatingCounters>(null as any);
    }

    activity(accountId: string, memberId: string, signal?: AbortSignal): Promise<TeamMemberActivity[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/{memberId}/activity";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivity(_response));
        });
    }

    protected processActivity(response: Response): Promise<TeamMemberActivity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMemberActivity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberActivity[]>(null as any);
    }

    budgetSettings(accountId: string, memberId: string, signal?: AbortSignal): Promise<TeamMemberBudgetViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/{memberId}/budgetsettings";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBudgetSettings(_response));
        });
    }

    protected processBudgetSettings(response: Response): Promise<TeamMemberBudgetViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamMemberBudgetViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberBudgetViewModel>(null as any);
    }

    updateBudgetSettings(accountId: string, memberId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/{memberId}/budgetsettings";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateBudgetSettings(_response));
        });
    }

    protected processUpdateBudgetSettings(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    listTeamMemberPaymentProfileSettings(accountId: string, memberId: string, signal?: AbortSignal): Promise<PaymentProfileSettingsViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/{memberId}/paymentProfileSettings";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListTeamMemberPaymentProfileSettings(_response));
        });
    }

    protected processListTeamMemberPaymentProfileSettings(response: Response): Promise<PaymentProfileSettingsViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentProfileSettingsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentProfileSettingsViewModel[]>(null as any);
    }

    updateTeamMemberPaymentProfileSettings(accountId: string, memberId: string, paymentProvider: PaymentProviderType, model: PaymentProfileSettingsViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/{memberId}/paymentProfileSettings/{paymentProvider}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (paymentProvider === undefined || paymentProvider === null)
            throw new Error("The parameter 'paymentProvider' must be defined.");
        url_ = url_.replace("{paymentProvider}", encodeURIComponent("" + paymentProvider));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTeamMemberPaymentProfileSettings(_response));
        });
    }

    protected processUpdateTeamMemberPaymentProfileSettings(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    verifySignup(accountId: string, email: string | undefined, signal?: AbortSignal): Promise<EnterprisePortalSignupInfoViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/verifysignup?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVerifySignup(_response));
        });
    }

    protected processVerifySignup(response: Response): Promise<EnterprisePortalSignupInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterprisePortalSignupInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterprisePortalSignupInfoViewModel>(null as any);
    }

    onlineMembers(accountId: string, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/online";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOnlineMembers(_response));
        });
    }

    protected processOnlineMembers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    billableUsersCount(accountId: string, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/billable-count";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBillableUsersCount(_response));
        });
    }

    protected processBillableUsersCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class EnterpriseAccountMemberImportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    template(accountId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/import/template";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTemplate(_response));
        });
    }

    protected processTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getResults(accountId: string, importId: string, signal?: AbortSignal): Promise<EnterpriseAccountMembersImportResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/import/{importId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetResults(_response));
        });
    }

    protected processGetResults(response: Response): Promise<EnterpriseAccountMembersImportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseAccountMembersImportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountMembersImportResponse>(null as any);
    }

    import(accountId: string, csvFile: FileParameter | null | undefined, importMode: string | null | undefined, teamId: string | undefined, message: string | null | undefined, suppressInviteEmail: boolean | undefined, signal?: AbortSignal): Promise<EnterpriseAccountMembersImportResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/import";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (csvFile !== null && csvFile !== undefined)
            content_.append("CsvFile", csvFile.data, csvFile.fileName ? csvFile.fileName : "CsvFile");
        if (importMode !== null && importMode !== undefined)
            content_.append("ImportMode", importMode.toString());
        if (teamId === null || teamId === undefined)
            throw new Error("The parameter 'teamId' cannot be null.");
        else
            content_.append("TeamId", teamId.toString());
        if (message !== null && message !== undefined)
            content_.append("Message", message.toString());
        if (suppressInviteEmail === null || suppressInviteEmail === undefined)
            throw new Error("The parameter 'suppressInviteEmail' cannot be null.");
        else
            content_.append("SuppressInviteEmail", suppressInviteEmail.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<EnterpriseAccountMembersImportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseAccountMembersImportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountMembersImportResponse>(null as any);
    }
}

export class EnterpriseAccountMemberReportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    generate(accountId: string, fileFormat: DownloadFileFormat | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/reports?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (fileFormat === null)
            throw new Error("The parameter 'fileFormat' cannot be null.");
        else if (fileFormat !== undefined)
            url_ += "fileFormat=" + encodeURIComponent("" + fileFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerate(_response));
        });
    }

    protected processGenerate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    list(accountId: string, signal?: AbortSignal): Promise<ActivityReservationReportStatus[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/reports";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<ActivityReservationReportStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityReservationReportStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityReservationReportStatus[]>(null as any);
    }

    get(accountId: string, reportId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/reports/{reportId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(accountId: string, reportId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/members/reports/{reportId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EnterpriseAccountMemberReservationClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    reservations(accountId: string, memberId: string, timeType: ReservationTimeType | undefined, countOnPage: number | undefined, includeInviteeReservations: boolean | undefined, signal?: AbortSignal): Promise<TeamMemberReservation[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/member/{memberId}/reservation?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (timeType === null)
            throw new Error("The parameter 'timeType' cannot be null.");
        else if (timeType !== undefined)
            url_ += "timeType=" + encodeURIComponent("" + timeType) + "&";
        if (countOnPage === null)
            throw new Error("The parameter 'countOnPage' cannot be null.");
        else if (countOnPage !== undefined)
            url_ += "countOnPage=" + encodeURIComponent("" + countOnPage) + "&";
        if (includeInviteeReservations === null)
            throw new Error("The parameter 'includeInviteeReservations' cannot be null.");
        else if (includeInviteeReservations !== undefined)
            url_ += "includeInviteeReservations=" + encodeURIComponent("" + includeInviteeReservations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReservations(_response));
        });
    }

    protected processReservations(response: Response): Promise<TeamMemberReservation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMemberReservation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberReservation[]>(null as any);
    }

    reservationCounters(accountId: string, memberId: string, signal?: AbortSignal): Promise<TeamMemberReservationCounters> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/member/{memberId}/reservation/counters";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReservationCounters(_response));
        });
    }

    protected processReservationCounters(response: Response): Promise<TeamMemberReservationCounters> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamMemberReservationCounters.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberReservationCounters>(null as any);
    }
}

export class EnterpriseAccountSettingsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(accountId: string, signal?: AbortSignal): Promise<EnterpriseAccountSettingsModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/settings";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<EnterpriseAccountSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseAccountSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountSettingsModel>(null as any);
    }

    patch(accountId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/settings";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class EnterpriseAccountsExportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    export(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class EnterpriseAccountsExportStatusClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(signal?: AbortSignal): Promise<ExportEnterpriseAccountStatus[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/export/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ExportEnterpriseAccountStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportEnterpriseAccountStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportEnterpriseAccountStatus[]>(null as any);
    }

    get(exportId: string, signal?: AbortSignal): Promise<ExportEnterpriseAccountStatus> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/export/status/{exportId}";
        if (exportId === undefined || exportId === null)
            throw new Error("The parameter 'exportId' must be defined.");
        url_ = url_.replace("{exportId}", encodeURIComponent("" + exportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ExportEnterpriseAccountStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportEnterpriseAccountStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportEnterpriseAccountStatus>(null as any);
    }

    delete(exportId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/export/status/{exportId}";
        if (exportId === undefined || exportId === null)
            throw new Error("The parameter 'exportId' must be defined.");
        url_ = url_.replace("{exportId}", encodeURIComponent("" + exportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EnterpriseAccountsImportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    import(model: EnterpriseAccountsImportViewModel, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class EnterpriseAccountsImportStatusClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(signal?: AbortSignal): Promise<ImportEnterpriseAccountStatus[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/import/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ImportEnterpriseAccountStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportEnterpriseAccountStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportEnterpriseAccountStatus[]>(null as any);
    }

    get(importId: string, signal?: AbortSignal): Promise<ImportEnterpriseAccountStatus> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/import/status/{importId}";
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ImportEnterpriseAccountStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportEnterpriseAccountStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportEnterpriseAccountStatus>(null as any);
    }

    delete(importId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/import/status/{importId}";
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDetails(importId: string, signal?: AbortSignal): Promise<ImportEnterpriseAccountStatusDetails> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/import/status/{importId}/details";
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDetails(_response));
        });
    }

    protected processGetDetails(response: Response): Promise<ImportEnterpriseAccountStatusDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportEnterpriseAccountStatusDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportEnterpriseAccountStatusDetails>(null as any);
    }
}

export class EnterpriseAccountUnassignedMemberClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(accountId: string, signal?: AbortSignal): Promise<TeamMemberInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/member/unassigned";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<TeamMemberInfoViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMemberInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberInfoViewModel[]>(null as any);
    }
}

export class EnterpriseClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    requestDemo(request: EnterpriseDemoRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/Enterprise/requestdemo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequestDemo(_response));
        });
    }

    protected processRequestDemo(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    submitProRequest(request: LiquidspaceProRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/Enterprise/submitprorequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitProRequest(_response));
        });
    }

    protected processSubmitProRequest(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class EnterpriseAccountIntegrationOfficeRnDClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    officeRnDHybridSync(accountId: string, requestId: string | null | undefined, signal?: AbortSignal): Promise<OfficeRnDHybridSyncResult> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/integration/ornd/hybrid/sync?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOfficeRnDHybridSync(_response));
        });
    }

    protected processOfficeRnDHybridSync(response: Response): Promise<OfficeRnDHybridSyncResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficeRnDHybridSyncResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeRnDHybridSyncResult>(null as any);
    }
}

export class EnterpriseAccountIntegrationSlackClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getInstallUrl(accountId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/integration/slack/installUrl";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInstallUrl(_response));
        });
    }

    protected processGetInstallUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getConfigs(accountId: string, signal?: AbortSignal): Promise<EnterpriseAccountIntegrationSlackConfig[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/integration/slack";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigs(_response));
        });
    }

    protected processGetConfigs(response: Response): Promise<EnterpriseAccountIntegrationSlackConfig[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnterpriseAccountIntegrationSlackConfig.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountIntegrationSlackConfig[]>(null as any);
    }

    deleteConfig(accountId: string, appId: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/integration/slack?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (appId === null)
            throw new Error("The parameter 'appId' cannot be null.");
        else if (appId !== undefined)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteConfig(_response));
        });
    }

    protected processDeleteConfig(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class EnterpriseAccountLocationClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    onDemandLocations(accountId: string, signal?: AbortSignal): Promise<OnDemandLocationViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/ondemand";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOnDemandLocations(_response));
        });
    }

    protected processOnDemandLocations(response: Response): Promise<OnDemandLocationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnDemandLocationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnDemandLocationViewModel[]>(null as any);
    }

    dedicatedLocations(accountId: string, requestId: string | null | undefined, signal?: AbortSignal): Promise<DedicatedLocationViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/dedicated?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDedicatedLocations(_response));
        });
    }

    protected processDedicatedLocations(response: Response): Promise<DedicatedLocationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DedicatedLocationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DedicatedLocationViewModel[]>(null as any);
    }

    venueList(accountId: string, signal?: AbortSignal): Promise<VenueListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/venuelist";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVenueList(_response));
        });
    }

    protected processVenueList(response: Response): Promise<VenueListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueListItemViewModel[]>(null as any);
    }

    venueGroupList(accountId: string, signal?: AbortSignal): Promise<VenueGroupListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/venuegrouplist";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVenueGroupList(_response));
        });
    }

    protected processVenueGroupList(response: Response): Promise<VenueGroupListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueGroupListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupListItemViewModel[]>(null as any);
    }

    getCollection(accountId: string, collectionId: string, signal?: AbortSignal): Promise<EnterpriseAccountCollectionViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/collection/{collectionId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCollection(_response));
        });
    }

    protected processGetCollection(response: Response): Promise<EnterpriseAccountCollectionViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseAccountCollectionViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseAccountCollectionViewModel>(null as any);
    }

    deleteCollection(accountId: string, collectionId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/collection/{collectionId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteCollection(_response));
        });
    }

    protected processDeleteCollection(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    updateCollection(accountId: string, collectionId: string, model: EnterpriseAccountCollectionViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/collection/{collectionId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCollection(_response));
        });
    }

    protected processUpdateCollection(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    addCollection(accountId: string, model: EnterpriseAccountCollectionViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/collection";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddCollection(_response));
        });
    }

    protected processAddCollection(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getBrands(accountId: string, signal?: AbortSignal): Promise<BrandsViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/brands";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBrands(_response));
        });
    }

    protected processGetBrands(response: Response): Promise<BrandsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrandsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResponseWrapper.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrandsViewModel>(null as any);
    }

    setBrandsOptions(accountId: string, brandsOptionsModel: BrandsOptionsViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/location/brands-options";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(brandsOptionsModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetBrandsOptions(_response));
        });
    }

    protected processSetBrandsOptions(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResponseWrapper.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class PortalClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    currentMember(accountId: string, signal?: AbortSignal): Promise<EnterpriseUserInfoViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/me";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCurrentMember(_response));
        });
    }

    protected processCurrentMember(response: Response): Promise<EnterpriseUserInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseUserInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseUserInfoViewModel>(null as any);
    }

    headquarters(accountId: string, signal?: AbortSignal): Promise<VenueSearchResult[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/headquarters";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHeadquarters(_response));
        });
    }

    protected processHeadquarters(response: Response): Promise<VenueSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueSearchResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueSearchResult[]>(null as any);
    }

    collections(accountId: string, signal?: AbortSignal): Promise<CollectionViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/collections";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCollections(_response));
        });
    }

    protected processCollections(response: Response): Promise<CollectionViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollectionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollectionViewModel[]>(null as any);
    }

    preferredCollectionVenues(accountId: string, collectionId: string | undefined, signal?: AbortSignal): Promise<CollectionViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/preferredcollectionvenues?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (collectionId === null)
            throw new Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreferredCollectionVenues(_response));
        });
    }

    protected processPreferredCollectionVenues(response: Response): Promise<CollectionViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollectionViewModel>(null as any);
    }

    questionsAndAnswers(accountId: string, signal?: AbortSignal): Promise<ContentItemViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/questionsanswers";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestionsAndAnswers(_response));
        });
    }

    protected processQuestionsAndAnswers(response: Response): Promise<ContentItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentItemViewModel[]>(null as any);
    }

    onboardingContent(accountId: string, memberId: string | null | undefined, signal?: AbortSignal): Promise<OnboardingContentViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/onboardingcontent?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOnboardingContent(_response));
        });
    }

    protected processOnboardingContent(response: Response): Promise<OnboardingContentViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnboardingContentViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnboardingContentViewModel>(null as any);
    }

    reviews(accountId: string, signal?: AbortSignal): Promise<PortalReviews> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/reviews";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviews(_response));
        });
    }

    protected processReviews(response: Response): Promise<PortalReviews> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortalReviews.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalReviews>(null as any);
    }

    supportRequest(accountId: string, request: SupportRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/SupportRequest";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSupportRequest(_response));
        });
    }

    protected processSupportRequest(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    question(accountId: string, request: QuestionRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/question";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion(_response));
        });
    }

    protected processQuestion(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getMember(memberId: string, accountId: string, signal?: AbortSignal): Promise<MemberViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/members/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMember(_response));
        });
    }

    protected processGetMember(response: Response): Promise<MemberViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberViewModel>(null as any);
    }

    /**
     * Get Enterprise Member Homebase
     */
    getMemberHomebase(accountId: string, memberId: string, signal?: AbortSignal): Promise<EnterpriseUserHomebaseViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/members/{memberId}/homebase";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberHomebase(_response));
        });
    }

    protected processGetMemberHomebase(response: Response): Promise<EnterpriseUserHomebaseViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseUserHomebaseViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnterpriseUserHomebaseViewModel>(null as any);
    }

    banner(accountId: string, signal?: AbortSignal): Promise<BrandedBannerViewModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/banner";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBanner(_response));
        });
    }

    protected processBanner(response: Response): Promise<BrandedBannerViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrandedBannerViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrandedBannerViewModel>(null as any);
    }

    getMessengerTargets(accountId: string, signal?: AbortSignal): Promise<MessageTargetAutocompleteItem[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/messengertargets";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMessengerTargets(_response));
        });
    }

    protected processGetMessengerTargets(response: Response): Promise<MessageTargetAutocompleteItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageTargetAutocompleteItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageTargetAutocompleteItem[]>(null as any);
    }

    completePortalGuide(accountId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/completePortalGuide";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompletePortalGuide(_response));
        });
    }

    protected processCompletePortalGuide(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    subscribeOnEmail(accountId: string, memberId: string | null | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/subscribeOnEmail?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubscribeOnEmail(_response));
        });
    }

    protected processSubscribeOnEmail(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    unsubscribeOnEmail(accountId: string, memberId: string | null | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/unsubscribeOnEmail?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnsubscribeOnEmail(_response));
        });
    }

    protected processUnsubscribeOnEmail(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getColleaguesNearBy(accountId: string, signal?: AbortSignal): Promise<ReservationMemberViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/members/nearby";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetColleaguesNearBy(_response));
        });
    }

    protected processGetColleaguesNearBy(response: Response): Promise<ReservationMemberViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationMemberViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationMemberViewModel[]>(null as any);
    }

    getActivities(accountId: string, selectedDate: string | null | undefined, signal?: AbortSignal): Promise<DayActivityViewModel[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/portal/activities?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (selectedDate !== undefined && selectedDate !== null)
            url_ += "selectedDate=" + encodeURIComponent("" + selectedDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivities(_response));
        });
    }

    protected processGetActivities(response: Response): Promise<DayActivityViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DayActivityViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DayActivityViewModel[]>(null as any);
    }
}

export class SingleSignOnClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(accountId: string, signal?: AbortSignal): Promise<SSOSettingsModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/SingleSignOn";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SSOSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SSOSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SSOSettingsModel>(null as any);
    }

    patch(accountId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/SingleSignOn";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    setScimDataFromLS(accountId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/SingleSignOn";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetScimDataFromLS(_response));
        });
    }

    protected processSetScimDataFromLS(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    federationMetadata(accountId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/SingleSignOn/FederationMetadata";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFederationMetadata(_response));
        });
    }

    protected processFederationMetadata(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getScimProgress(progressId: string | undefined, accountId: string, signal?: AbortSignal): Promise<CommandProgressModel> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/SingleSignOn/GetScimProgress?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (progressId === null)
            throw new Error("The parameter 'progressId' cannot be null.");
        else if (progressId !== undefined)
            url_ += "progressId=" + encodeURIComponent("" + progressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetScimProgress(_response));
        });
    }

    protected processGetScimProgress(response: Response): Promise<CommandProgressModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandProgressModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommandProgressModel>(null as any);
    }
}

export class TeamClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get team information
     */
    get(teamId: string, signal?: AbortSignal): Promise<TeamViewModel> {
        let url_ = this.baseUrl + "/api/teams/{teamId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<TeamViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamViewModel>(null as any);
    }

    patch(teamId: string, patch: Operation[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/teams/{teamId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    add(model: TeamAddViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    /**
     * List members assigned to the team
     * @param teamId Team ID
     * @param take (optional) Optional number of entried to return
     * @return List of members. Response length can be limited to return only first take members, ordered by ID
     */
    members(teamId: string, take: number | null | undefined, signal?: AbortSignal): Promise<TeamMemberInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/members?";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMembers(_response));
        });
    }

    protected processMembers(response: Response): Promise<TeamMemberInfoViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMemberInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberInfoViewModel[]>(null as any);
    }

    /**
     * Create and invite member to team
     * @param teamId Team ID
     * @param suppressInviteEmail (optional) true to supress sending invitation email
     * @param model Member model
     */
    addMember(teamId: string, suppressInviteEmail: boolean | undefined, model: TeamMemberAddViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/members?";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (suppressInviteEmail === null)
            throw new Error("The parameter 'suppressInviteEmail' cannot be null.");
        else if (suppressInviteEmail !== undefined)
            url_ += "suppressInviteEmail=" + encodeURIComponent("" + suppressInviteEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddMember(_response));
        });
    }

    protected processAddMember(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    deleteMember(teamId: string, memberId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/members/{memberId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMember(_response));
        });
    }

    protected processDeleteMember(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    setMemberSuspended(teamId: string, memberId: string, isSuspended: boolean | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/members/{memberId}/suspended?";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (isSuspended === null)
            throw new Error("The parameter 'isSuspended' cannot be null.");
        else if (isSuspended !== undefined)
            url_ += "isSuspended=" + encodeURIComponent("" + isSuspended) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetMemberSuspended(_response));
        });
    }

    protected processSetMemberSuspended(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    addMembers(teamId: string, model: TeamMembersAddViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/members/import";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddMembers(_response));
        });
    }

    protected processAddMembers(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    resendInvites(teamId: string, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/reinvite-all";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResendInvites(_response));
        });
    }

    protected processResendInvites(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TeamReportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    generate(accountId: string, teamId: string, fileFormat: DownloadFileFormat | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/teams/{teamId}/reports?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (fileFormat === null)
            throw new Error("The parameter 'fileFormat' cannot be null.");
        else if (fileFormat !== undefined)
            url_ += "fileFormat=" + encodeURIComponent("" + fileFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerate(_response));
        });
    }

    protected processGenerate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    list(accountId: string, teamId: string, signal?: AbortSignal): Promise<ActivityReservationReportStatus[]> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/teams/{teamId}/reports";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<ActivityReservationReportStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityReservationReportStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityReservationReportStatus[]>(null as any);
    }

    get(accountId: string, teamId: string, reportId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/teams/{teamId}/reports/{reportId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(accountId: string, teamId: string, reportId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/enterpriseaccounts/{accountId}/teams/{teamId}/reports/{reportId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class GeocoderClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    geocode(requestModel: GeocodeRequestModel, signal?: AbortSignal): Promise<LocationViewModel[]> {
        let url_ = this.baseUrl + "/api/geocoder/geocode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGeocode(_response));
        });
    }

    protected processGeocode(response: Response): Promise<LocationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationViewModel[]>(null as any);
    }

    getPlacePredictions(requestModel: PlacePredictionsRequestViewModel, signal?: AbortSignal): Promise<PlacePredictionViewModel[]> {
        let url_ = this.baseUrl + "/api/geocoder/getplacepredictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPlacePredictions(_response));
        });
    }

    protected processGetPlacePredictions(response: Response): Promise<PlacePredictionViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlacePredictionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlacePredictionViewModel[]>(null as any);
    }

    getPlaceDetails(placeId: string, sessionToken: string | null | undefined, signal?: AbortSignal): Promise<LocationViewModel> {
        let url_ = this.baseUrl + "/api/geocoder/place/{placeId}?";
        if (placeId === undefined || placeId === null)
            throw new Error("The parameter 'placeId' must be defined.");
        url_ = url_.replace("{placeId}", encodeURIComponent("" + placeId));
        if (sessionToken !== undefined && sessionToken !== null)
            url_ += "sessionToken=" + encodeURIComponent("" + sessionToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPlaceDetails(_response));
        });
    }

    protected processGetPlaceDetails(response: Response): Promise<LocationViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationViewModel>(null as any);
    }
}

export class HourlyRequestsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    accept(requestId: string, model: AcceptRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/hourly-requests/{requestId}/accept";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAccept(_response));
        });
    }

    protected processAccept(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    decline(requestId: string, model: DeclineRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/hourly-requests/{requestId}/decline";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDecline(_response));
        });
    }

    protected processDecline(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    pause(requestId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/hourly-requests/{requestId}/pause";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPause(_response));
        });
    }

    protected processPause(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    hourlyRequestReservationDetails(requestId: string, signal?: AbortSignal): Promise<ReservationRequestDetailsModel> {
        let url_ = this.baseUrl + "/api/hourly-requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHourlyRequestReservationDetails(_response));
        });
    }

    protected processHourlyRequestReservationDetails(response: Response): Promise<ReservationRequestDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationRequestDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationRequestDetailsModel>(null as any);
    }
}

export class InternationalClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    countries(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/international/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCountries(_response));
        });
    }

    protected processCountries(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getMerchantAccounts(signal?: AbortSignal): Promise<MerchantAccountModel[]> {
        let url_ = this.baseUrl + "/api/international/merchantaccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMerchantAccounts(_response));
        });
    }

    protected processGetMerchantAccounts(response: Response): Promise<MerchantAccountModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantAccountModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MerchantAccountModel[]>(null as any);
    }
}

export class LocationClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    currentCountry(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/location/current/country";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCurrentCountry(_response));
        });
    }

    protected processCurrentCountry(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class MarketplaceCustomerProfilesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getCustomerProfile(payableType: PayableType, payableId: string, signal?: AbortSignal): Promise<MarketplaceCustomerProfileModel> {
        let url_ = this.baseUrl + "/api/marketplace/{payableType}/{payableId}/customer-profiles";
        if (payableType === undefined || payableType === null)
            throw new Error("The parameter 'payableType' must be defined.");
        url_ = url_.replace("{payableType}", encodeURIComponent("" + payableType));
        if (payableId === undefined || payableId === null)
            throw new Error("The parameter 'payableId' must be defined.");
        url_ = url_.replace("{payableId}", encodeURIComponent("" + payableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomerProfile(_response));
        });
    }

    protected processGetCustomerProfile(response: Response): Promise<MarketplaceCustomerProfileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketplaceCustomerProfileModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplaceCustomerProfileModel>(null as any);
    }

    createPaymentProfile(payableType: PayableType, payableId: string, request: MarketplacePaymentProfileCreateRequest, signal?: AbortSignal): Promise<PaymentMethodResponse> {
        let url_ = this.baseUrl + "/api/marketplace/{payableType}/{payableId}/customer-profiles/payment-profiles";
        if (payableType === undefined || payableType === null)
            throw new Error("The parameter 'payableType' must be defined.");
        url_ = url_.replace("{payableType}", encodeURIComponent("" + payableType));
        if (payableId === undefined || payableId === null)
            throw new Error("The parameter 'payableId' must be defined.");
        url_ = url_.replace("{payableId}", encodeURIComponent("" + payableId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreatePaymentProfile(_response));
        });
    }

    protected processCreatePaymentProfile(response: Response): Promise<PaymentMethodResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentMethodResponse>(null as any);
    }
}

export class MembersClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(emailFilter: string | null | undefined, firstNameFilter: string | null | undefined, lastNameFilter: string | null | undefined, status: string | null | undefined, lastReadEmail: string | null | undefined, take: number | undefined, signal?: AbortSignal): Promise<MemberListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/members?";
        if (emailFilter !== undefined && emailFilter !== null)
            url_ += "emailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (firstNameFilter !== undefined && firstNameFilter !== null)
            url_ += "firstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&";
        if (lastNameFilter !== undefined && lastNameFilter !== null)
            url_ += "lastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (lastReadEmail !== undefined && lastReadEmail !== null)
            url_ += "lastReadEmail=" + encodeURIComponent("" + lastReadEmail) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<MemberListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberListItemViewModel[]>(null as any);
    }

    delete(memberId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/members/memberId?";
        if (memberId === null)
            throw new Error("The parameter 'memberId' cannot be null.");
        else if (memberId !== undefined)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    searchEmail(term: string | undefined, takeCount: number | undefined, roles: MemberRole[] | null | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/members/search?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (takeCount === null)
            throw new Error("The parameter 'takeCount' cannot be null.");
        else if (takeCount !== undefined)
            url_ += "takeCount=" + encodeURIComponent("" + takeCount) + "&";
        if (roles !== undefined && roles !== null)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchEmail(_response));
        });
    }

    protected processSearchEmail(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    searchOrganizerListAutocomplete(venueId: string | undefined, workspaceId: string | undefined, ownerId: string | null | undefined, searchPart: string | null | undefined, signal?: AbortSignal): Promise<OrganizerViewModel[]> {
        let url_ = this.baseUrl + "/api/members/organizer-list/autocomlete?";
        if (venueId === null)
            throw new Error("The parameter 'venueId' cannot be null.");
        else if (venueId !== undefined)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (ownerId !== undefined && ownerId !== null)
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        if (searchPart !== undefined && searchPart !== null)
            url_ += "searchPart=" + encodeURIComponent("" + searchPart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchOrganizerListAutocomplete(_response));
        });
    }

    protected processSearchOrganizerListAutocomplete(response: Response): Promise<OrganizerViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizerViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizerViewModel[]>(null as any);
    }

    connections(ownerId: string | null | undefined, signal?: AbortSignal): Promise<OrganizerViewModel[]> {
        let url_ = this.baseUrl + "/api/members/connections?";
        if (ownerId !== undefined && ownerId !== null)
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConnections(_response));
        });
    }

    protected processConnections(response: Response): Promise<OrganizerViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizerViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizerViewModel[]>(null as any);
    }

    bookingReasons(ownerId: string, signal?: AbortSignal): Promise<BookingReasonViewModel> {
        let url_ = this.baseUrl + "/api/members/{ownerId}/booking-reasons";
        if (ownerId === undefined || ownerId === null)
            throw new Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{ownerId}", encodeURIComponent("" + ownerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBookingReasons(_response));
        });
    }

    protected processBookingReasons(response: Response): Promise<BookingReasonViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingReasonViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookingReasonViewModel>(null as any);
    }

    getPicture(memberId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/members/{memberId}/picture";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPicture(_response));
        });
    }

    protected processGetPicture(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getMemberProfile(memberId: string, signal?: AbortSignal): Promise<MemberProfileViewModel> {
        let url_ = this.baseUrl + "/api/members/{memberId}/member-profile";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberProfile(_response));
        });
    }

    protected processGetMemberProfile(response: Response): Promise<MemberProfileViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberProfileViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberProfileViewModel>(null as any);
    }

    isEnterpriseAccountMember(email: string | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/members/is-enterprise-member?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsEnterpriseAccountMember(_response));
        });
    }

    protected processIsEnterpriseAccountMember(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPictures(memberIdsRequest: string[], signal?: AbortSignal): Promise<MemberPicture[]> {
        let url_ = this.baseUrl + "/api/members/pictures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIdsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPictures(_response));
        });
    }

    protected processGetPictures(response: Response): Promise<MemberPicture[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberPicture.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberPicture[]>(null as any);
    }
}

export class PaymentMethodClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    paymentMethods(payableType: PayableType, payableId: string, signal?: AbortSignal): Promise<PaymentMethodListViewModel> {
        let url_ = this.baseUrl + "/api/paymentmethods/{payableType}/{payableId}";
        if (payableType === undefined || payableType === null)
            throw new Error("The parameter 'payableType' must be defined.");
        url_ = url_.replace("{payableType}", encodeURIComponent("" + payableType));
        if (payableId === undefined || payableId === null)
            throw new Error("The parameter 'payableId' must be defined.");
        url_ = url_.replace("{payableId}", encodeURIComponent("" + payableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPaymentMethods(_response));
        });
    }

    protected processPaymentMethods(response: Response): Promise<PaymentMethodListViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodListViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentMethodListViewModel>(null as any);
    }

    updateDescription(request: UpdatePaymentMethodDescriptionRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/paymentmethods/updatedescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDescription(_response));
        });
    }

    protected processUpdateDescription(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    createCreditCard(request: CreditCardRequest, signal?: AbortSignal): Promise<PaymentMethodResponse> {
        let url_ = this.baseUrl + "/api/paymentmethods/credit-card";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCreditCard(_response));
        });
    }

    protected processCreateCreditCard(response: Response): Promise<PaymentMethodResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentMethodResponse>(null as any);
    }

    exchangePlaidToken(request: ExchangePlaidTokenRequest, signal?: AbortSignal): Promise<PaymentMethodResponse> {
        let url_ = this.baseUrl + "/api/paymentmethods/exchangeplaidtoken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExchangePlaidToken(_response));
        });
    }

    protected processExchangePlaidToken(response: Response): Promise<PaymentMethodResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentMethodResponse>(null as any);
    }

    createLinkToken(request: CreatePlaidLinkTokenRequest, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/paymentmethods/create-link-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateLinkToken(_response));
        });
    }

    protected processCreateLinkToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deletePaymentMethod(request: PaymentMethodRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/paymentmethods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePaymentMethod(_response));
        });
    }

    protected processDeletePaymentMethod(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    makeDefault(request: PaymentMethodRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/paymentmethods/makedefault";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMakeDefault(_response));
        });
    }

    protected processMakeDefault(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    stateCodes(signal?: AbortSignal): Promise<CountryStateCodesRepsonse> {
        let url_ = this.baseUrl + "/api/paymentmethods/statecodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStateCodes(_response));
        });
    }

    protected processStateCodes(response: Response): Promise<CountryStateCodesRepsonse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryStateCodesRepsonse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryStateCodesRepsonse>(null as any);
    }

    supportedCurrencies(signal?: AbortSignal): Promise<{ [key: string]: CurrencyType; }> {
        let url_ = this.baseUrl + "/api/paymentmethods/SupportedCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSupportedCurrencies(_response));
        });
    }

    protected processSupportedCurrencies(response: Response): Promise<{ [key: string]: CurrencyType; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: CurrencyType; }>(null as any);
    }
}

export class PictureClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getMemberPictureViewModel(memberId: string, tag: ImageTagConstants | undefined, signal?: AbortSignal): Promise<PictureViewModel> {
        let url_ = this.baseUrl + "/api/picture/member/{memberId}?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (tag === null)
            throw new Error("The parameter 'tag' cannot be null.");
        else if (tag !== undefined)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberPictureViewModel(_response));
        });
    }

    protected processGetMemberPictureViewModel(response: Response): Promise<PictureViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PictureViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PictureViewModel>(null as any);
    }
}

export class ProposalClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(venueId: string | undefined, workspaceId: string | undefined, savedSearchId: string | undefined, savedSearchMemberId: string | undefined, message: string | undefined, validatedMessage: string | undefined, chainId: string | null | undefined, attachments: FileParameter[] | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Proposal/Create?";
        if (venueId === null)
            throw new Error("The parameter 'venueId' cannot be null.");
        else if (venueId !== undefined)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (savedSearchId === null)
            throw new Error("The parameter 'savedSearchId' cannot be null.");
        else if (savedSearchId !== undefined)
            url_ += "savedSearchId=" + encodeURIComponent("" + savedSearchId) + "&";
        if (savedSearchMemberId === null)
            throw new Error("The parameter 'savedSearchMemberId' cannot be null.");
        else if (savedSearchMemberId !== undefined)
            url_ += "savedSearchMemberId=" + encodeURIComponent("" + savedSearchMemberId) + "&";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (validatedMessage === null)
            throw new Error("The parameter 'validatedMessage' cannot be null.");
        else if (validatedMessage !== undefined)
            url_ += "validatedMessage=" + encodeURIComponent("" + validatedMessage) + "&";
        if (chainId !== undefined && chainId !== null)
            url_ += "chainId=" + encodeURIComponent("" + chainId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("attachments", item_.data, item_.fileName ? item_.fileName : "attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    decline(proposalId: string | undefined, memberId: string | null | undefined, message: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Proposal/Decline?";
        if (proposalId === null)
            throw new Error("The parameter 'proposalId' cannot be null.");
        else if (proposalId !== undefined)
            url_ += "proposalId=" + encodeURIComponent("" + proposalId) + "&";
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDecline(_response));
        });
    }

    protected processDecline(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class RatingClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(workspaceId: string, take: number | null | undefined, signal?: AbortSignal): Promise<RatingViewModel[]> {
        let url_ = this.baseUrl + "/api/Rating/list/{workspaceId}?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<RatingViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RatingViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RatingViewModel[]>(null as any);
    }

    average(venueId: string, workspaceId: string | null | undefined, signal?: AbortSignal): Promise<AverageRatingModel> {
        let url_ = this.baseUrl + "/api/Rating/average/{venueId}?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAverage(_response));
        });
    }

    protected processAverage(response: Response): Promise<AverageRatingModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AverageRatingModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AverageRatingModel>(null as any);
    }

    ownByReservationId(reservationId: string, signal?: AbortSignal): Promise<RatingViewModel> {
        let url_ = this.baseUrl + "/api/Rating/own/reservation/{reservationId}";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOwnByReservationId(_response));
        });
    }

    protected processOwnByReservationId(response: Response): Promise<RatingViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RatingViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RatingViewModel>(null as any);
    }

    save(ratingViewModel: RatingUpsertModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/Rating/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ratingViewModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResponseWrapper.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ReportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    hourlyReservations(start: string | undefined, end: string | undefined, requestId: string | null | undefined, signal?: AbortSignal): Promise<HourlyReservation[]> {
        let url_ = this.baseUrl + "/api/reports/reservations/hourly?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHourlyReservations(_response));
        });
    }

    protected processHourlyReservations(response: Response): Promise<HourlyReservation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HourlyReservation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HourlyReservation[]>(null as any);
    }
}

export class SearchMetricsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    searchMetrics(signal?: AbortSignal): Promise<SearchMetrics> {
        let url_ = this.baseUrl + "/api/searchmetrics/search-metrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchMetrics(_response));
        });
    }

    protected processSearchMetrics(response: Response): Promise<SearchMetrics> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchMetrics.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchMetrics>(null as any);
    }

    searchCount(startDate: string | undefined, endDate: string | undefined, signal?: AbortSignal): Promise<SMStats> {
        let url_ = this.baseUrl + "/api/searchmetrics/search-count?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchCount(_response));
        });
    }

    protected processSearchCount(response: Response): Promise<SMStats> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMStats.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SMStats>(null as any);
    }
}

export class SlackClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getEnterpriseToken(appId: string, enterpriseId: string, signal?: AbortSignal): Promise<SlackToken> {
        let url_ = this.baseUrl + "/api/slack/{appId}/token/enterprise/{enterpriseId}";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        if (enterpriseId === undefined || enterpriseId === null)
            throw new Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEnterpriseToken(_response));
        });
    }

    protected processGetEnterpriseToken(response: Response): Promise<SlackToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlackToken.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackToken>(null as any);
    }

    getTeamToken(appId: string, teamId: string, signal?: AbortSignal): Promise<SlackToken> {
        let url_ = this.baseUrl + "/api/slack/{appId}/token/team/{teamId}";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTeamToken(_response));
        });
    }

    protected processGetTeamToken(response: Response): Promise<SlackToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlackToken.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackToken>(null as any);
    }

    getAccountToken(appId: string, accountId: string, signal?: AbortSignal): Promise<SlackToken> {
        let url_ = this.baseUrl + "/api/slack/{appId}/token/account/{accountId}";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccountToken(_response));
        });
    }

    protected processGetAccountToken(response: Response): Promise<SlackToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlackToken.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlackToken>(null as any);
    }

    addToken(token: SlackToken, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/slack/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddToken(_response));
        });
    }

    protected processAddToken(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addEnterpriseInstallation(enterpriseId: string, appId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/slack/enterprise-account/{enterpriseId}/installation/{appId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddEnterpriseInstallation(_response));
        });
    }

    protected processAddEnterpriseInstallation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteEnterpriseInstallation(enterpriseId: string, appId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/slack/enterprise-account/{enterpriseId}/installation/{appId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteEnterpriseInstallation(_response));
        });
    }

    protected processDeleteEnterpriseInstallation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getEnterpriseInstallations(enterpriseId: string, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/slack/enterprise-account/{enterpriseId}/installation";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEnterpriseInstallations(_response));
        });
    }

    protected processGetEnterpriseInstallations(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class TourClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    guestNoShow(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/tour/{id}/GuestNoShow";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGuestNoShow(_response));
        });
    }

    protected processGuestNoShow(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    cancel(id: string, reason: TourCancelReason | undefined, message: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/tour/{id}/Cancel?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancel(_response));
        });
    }

    protected processCancel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    isFirstConfirmedTourInVenue(id: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/tour/{id}/IsFirstConfirmedTourInVenue";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsFirstConfirmedTourInVenue(_response));
        });
    }

    protected processIsFirstConfirmedTourInVenue(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    confirm(id: string, message: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/tour/{id}/Confirm?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirm(_response));
        });
    }

    protected processConfirm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    update(id: string, date: string | undefined, message: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/tour/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    suggest(request: SuggestTourViewModel, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/tour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSuggest(_response));
        });
    }

    protected processSuggest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VenueGroupExportStatusClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(venueGroupId: string, signal?: AbortSignal): Promise<ExportVenueGroupStatus[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/export/status";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ExportVenueGroupStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportVenueGroupStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportVenueGroupStatus[]>(null as any);
    }

    get(venueGroupId: string, exportId: string, signal?: AbortSignal): Promise<ExportVenueGroupStatus> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/export/status/{exportId}";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (exportId === undefined || exportId === null)
            throw new Error("The parameter 'exportId' must be defined.");
        url_ = url_.replace("{exportId}", encodeURIComponent("" + exportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ExportVenueGroupStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportVenueGroupStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportVenueGroupStatus>(null as any);
    }

    delete(venueGroupId: string, exportId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/export/status/{exportId}";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (exportId === undefined || exportId === null)
            throw new Error("The parameter 'exportId' must be defined.");
        url_ = url_.replace("{exportId}", encodeURIComponent("" + exportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VenueGroupExportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    export(venueGroupId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/export";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class VenueGroupImportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    import(venueGroupId: string, model: VenueGroupImportViewModel, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/import";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class VenueGroupImportStatusClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(venueGroupId: string, signal?: AbortSignal): Promise<ImportVenueGroupStatus[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/import/status";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ImportVenueGroupStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportVenueGroupStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportVenueGroupStatus[]>(null as any);
    }

    get(venueGroupId: string, importId: string, signal?: AbortSignal): Promise<ImportVenueGroupStatus> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/import/status/{importId}";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ImportVenueGroupStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportVenueGroupStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportVenueGroupStatus>(null as any);
    }

    delete(venueGroupId: string, importId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/import/status/{importId}";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDetails(venueGroupId: string, importId: string, signal?: AbortSignal): Promise<ImportVenueGroupStatusDetails> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/import/status/{importId}/details";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDetails(_response));
        });
    }

    protected processGetDetails(response: Response): Promise<ImportVenueGroupStatusDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportVenueGroupStatusDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportVenueGroupStatusDetails>(null as any);
    }

    getPerformanceCounters(venueGroupId: string, importId: string, signal?: AbortSignal): Promise<ImportVenueGroupPerformanceCounters> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/import/status/{importId}/performance";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPerformanceCounters(_response));
        });
    }

    protected processGetPerformanceCounters(response: Response): Promise<ImportVenueGroupPerformanceCounters> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportVenueGroupPerformanceCounters.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportVenueGroupPerformanceCounters>(null as any);
    }
}

export class VenueGroupAdminsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(venueGroupId: string, signal?: AbortSignal): Promise<VenueAdminModel[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/admins";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<VenueAdminModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueAdminModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueAdminModel[]>(null as any);
    }

    add(venueGroupId: string, pregeneratedPictureId: string | undefined, model: VenueAdminModel, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/admins?";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (pregeneratedPictureId === null)
            throw new Error("The parameter 'pregeneratedPictureId' cannot be null.");
        else if (pregeneratedPictureId !== undefined)
            url_ += "pregeneratedPictureId=" + encodeURIComponent("" + pregeneratedPictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    edit(venueGroupId: string, memberId: string, isPasswordChanging: boolean | undefined, patch: Operation[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/admins/{memberId}?";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (isPasswordChanging === null)
            throw new Error("The parameter 'isPasswordChanging' cannot be null.");
        else if (isPasswordChanging !== undefined)
            url_ += "isPasswordChanging=" + encodeURIComponent("" + isPasswordChanging) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEdit(_response));
        });
    }

    protected processEdit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(venueGroupId: string, memberId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/admins/{memberId}";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VenueGroupPricingRatesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getPricingRate(venueGroupId: string, pricingRateId: string, isMonthly: boolean | undefined, signal?: AbortSignal): Promise<PricingRateViewModel> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/pricing-rates/{pricingRateId}?";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (pricingRateId === undefined || pricingRateId === null)
            throw new Error("The parameter 'pricingRateId' must be defined.");
        url_ = url_.replace("{pricingRateId}", encodeURIComponent("" + pricingRateId));
        if (isMonthly === null)
            throw new Error("The parameter 'isMonthly' cannot be null.");
        else if (isMonthly !== undefined)
            url_ += "isMonthly=" + encodeURIComponent("" + isMonthly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPricingRate(_response));
        });
    }

    protected processGetPricingRate(response: Response): Promise<PricingRateViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PricingRateViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PricingRateViewModel>(null as any);
    }

    deletePricingRate(venueGroupId: string, pricingRateId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/pricing-rates/{pricingRateId}";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (pricingRateId === undefined || pricingRateId === null)
            throw new Error("The parameter 'pricingRateId' must be defined.");
        url_ = url_.replace("{pricingRateId}", encodeURIComponent("" + pricingRateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePricingRate(_response));
        });
    }

    protected processDeletePricingRate(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    addOrEditPricingRate(venueGroupId: string, pricingRateViewModel: PricingRateViewModel, signal?: AbortSignal): Promise<PricingRateViewModel> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/pricing-rates";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pricingRateViewModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddOrEditPricingRate(_response));
        });
    }

    protected processAddOrEditPricingRate(response: Response): Promise<PricingRateViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PricingRateViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PricingRateViewModel>(null as any);
    }
}

export class VenueGroupReportsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    reports(venueGroupId: string, signal?: AbortSignal): Promise<VenueGroupReportsViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/reports";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReports(_response));
        });
    }

    protected processReports(response: Response): Promise<VenueGroupReportsViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueGroupReportsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupReportsViewModel[]>(null as any);
    }

    monthlyLeadsReport(venueGroupId: string, model: VenueGroupMonthlyLeadsReportParamsViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/reports/monthly-leads";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMonthlyLeadsReport(_response));
        });
    }

    protected processMonthlyLeadsReport(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    pdfReport(venueGroupId: string, onDate: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/reports/pdf?";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (onDate === null)
            throw new Error("The parameter 'onDate' cannot be null.");
        else if (onDate !== undefined)
            url_ += "onDate=" + encodeURIComponent("" + onDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPdfReport(_response));
        });
    }

    protected processPdfReport(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    deleteReport(reportId: string, venueGroupId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/reports/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteReport(_response));
        });
    }

    protected processDeleteReport(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    downloadReport(reportId: string, venueGroupId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/reports/{reportId}/download";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadReport(_response));
        });
    }

    protected processDownloadReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VenueGroupReservationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDataTiles(venueGroupId: string, signal?: AbortSignal): Promise<DataTilesViewModel> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/reservations/statistics";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataTiles(_response));
        });
    }

    protected processGetDataTiles(response: Response): Promise<DataTilesViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataTilesViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTilesViewModel>(null as any);
    }

    getUpcomingReservations(venueGroupId: string, signal?: AbortSignal): Promise<HourlyReservationViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/reservations/upcoming";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUpcomingReservations(_response));
        });
    }

    protected processGetUpcomingReservations(response: Response): Promise<HourlyReservationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HourlyReservationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HourlyReservationViewModel[]>(null as any);
    }

    getPastReservations(venueGroupId: string, signal?: AbortSignal): Promise<HourlyReservationViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/reservations/past";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPastReservations(_response));
        });
    }

    protected processGetPastReservations(response: Response): Promise<HourlyReservationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HourlyReservationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HourlyReservationViewModel[]>(null as any);
    }

    reservations(venueGroupId: string, signal?: AbortSignal): Promise<VenueGroupReservationsComposer> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/reservations/list";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReservations(_response));
        });
    }

    protected processReservations(response: Response): Promise<VenueGroupReservationsComposer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueGroupReservationsComposer.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupReservationsComposer>(null as any);
    }
}

export class VenueGroupsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    venueGroup(venueGroupId: string, signal?: AbortSignal): Promise<VenueGroupModel> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVenueGroup(_response));
        });
    }

    protected processVenueGroup(response: Response): Promise<VenueGroupModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueGroupModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupModel>(null as any);
    }

    delete(venueGroupId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    hourlyRequestToBook(venueGroupId: string, signal?: AbortSignal): Promise<HourlyRequestToBookModel[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/hourly-requests-to-book";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHourlyRequestToBook(_response));
        });
    }

    protected processHourlyRequestToBook(response: Response): Promise<HourlyRequestToBookModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HourlyRequestToBookModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HourlyRequestToBookModel[]>(null as any);
    }

    venueGroupVenues(venueGroupId: string, signal?: AbortSignal): Promise<VenueGroupVenueListItem[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/venues";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVenueGroupVenues(_response));
        });
    }

    protected processVenueGroupVenues(response: Response): Promise<VenueGroupVenueListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueGroupVenueListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupVenueListItem[]>(null as any);
    }

    getLogoPictureUrl(venueGroupId: string, signal?: AbortSignal): Promise<PictureURLViewModel> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/pictures/logo";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLogoPictureUrl(_response));
        });
    }

    protected processGetLogoPictureUrl(response: Response): Promise<PictureURLViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PictureURLViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PictureURLViewModel>(null as any);
    }

    resendClaimProposals(venueId: string, venueGroupId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/venues/{venueId}/resend-claim-proposals";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResendClaimProposals(_response));
        });
    }

    protected processResendClaimProposals(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    setForceGrantVisa(venueGroupId: string, forceGrant: boolean | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/force-grant-visa?";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (forceGrant === null)
            throw new Error("The parameter 'forceGrant' cannot be null.");
        else if (forceGrant !== undefined)
            url_ += "forceGrant=" + encodeURIComponent("" + forceGrant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetForceGrantVisa(_response));
        });
    }

    protected processSetForceGrantVisa(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    sendClaimProposals(venueGroupId: string, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/claim-proposals";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendClaimProposals(_response));
        });
    }

    protected processSendClaimProposals(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkAddVenues(venueGroupId: string, visaType: VenueGroupVisaType, signal?: AbortSignal): Promise<VenueGroupBulkAddVenueViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/bulk-add-venues/{visaType}";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (visaType === undefined || visaType === null)
            throw new Error("The parameter 'visaType' must be defined.");
        url_ = url_.replace("{visaType}", encodeURIComponent("" + visaType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBulkAddVenues(_response));
        });
    }

    protected processGetBulkAddVenues(response: Response): Promise<VenueGroupBulkAddVenueViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueGroupBulkAddVenueViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupBulkAddVenueViewModel[]>(null as any);
    }

    bulkAddVenues(venueGroupId: string, bulkData: VenueGroupBulkData, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/bulk-add-venues";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBulkAddVenues(_response));
        });
    }

    protected processBulkAddVenues(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    qualifyingMemberGroups(venueGroupId: string, signal?: AbortSignal): Promise<KeyValuePairOfGuidAndString[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/qualifying-member-groups";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQualifyingMemberGroups(_response));
        });
    }

    protected processQualifyingMemberGroups(response: Response): Promise<KeyValuePairOfGuidAndString[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfGuidAndString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyValuePairOfGuidAndString[]>(null as any);
    }

    venueVisas(venueGroupId: string, venueId: string, visaType: VenueGroupVisaType | null | undefined, signal?: AbortSignal): Promise<KeyValuePairOfGuidAndString[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/venues/{venueId}/visas?";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (visaType !== undefined && visaType !== null)
            url_ += "visaType=" + encodeURIComponent("" + visaType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVenueVisas(_response));
        });
    }

    protected processVenueVisas(response: Response): Promise<KeyValuePairOfGuidAndString[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfGuidAndString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyValuePairOfGuidAndString[]>(null as any);
    }
}

export class VenueGroupSettingsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(venueGroupId: string, signal?: AbortSignal): Promise<VenueGroupSettingsViewModel> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/settings";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<VenueGroupSettingsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueGroupSettingsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupSettingsViewModel>(null as any);
    }

    patch(venueGroupId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/settings";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class VenueGroupsRootClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(signal?: AbortSignal): Promise<VenueGroupListViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<VenueGroupListViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueGroupListViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupListViewModel[]>(null as any);
    }

    create(venueGroupModel: VenueGroupSettingsViewModel, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/venue-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(venueGroupModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class VenueGroupStatementsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    statements(venueGroupId: string, signal?: AbortSignal): Promise<VenueGroupVenuesStatementWrapper> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/statements";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStatements(_response));
        });
    }

    protected processStatements(response: Response): Promise<VenueGroupVenuesStatementWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueGroupVenuesStatementWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupVenuesStatementWrapper>(null as any);
    }

    reportXlsxByDataId(venueGroupId: string, spreadsheetDataId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/statements/{spreadsheetDataId}/report.xlsx";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (spreadsheetDataId === undefined || spreadsheetDataId === null)
            throw new Error("The parameter 'spreadsheetDataId' must be defined.");
        url_ = url_.replace("{spreadsheetDataId}", encodeURIComponent("" + spreadsheetDataId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReportXlsxByDataId(_response));
        });
    }

    protected processReportXlsxByDataId(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VenueGroupVisasClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getVisas(venueGroupId: string, visaType: VenueGroupVisaType | undefined, signal?: AbortSignal): Promise<VenueGroupVisaViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/visas?";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (visaType === null)
            throw new Error("The parameter 'visaType' cannot be null.");
        else if (visaType !== undefined)
            url_ += "visaType=" + encodeURIComponent("" + visaType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVisas(_response));
        });
    }

    protected processGetVisas(response: Response): Promise<VenueGroupVisaViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueGroupVisaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupVisaViewModel[]>(null as any);
    }

    addVisa(venueGroupId: string, request: AddVisaRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/visas";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddVisa(_response));
        });
    }

    protected processAddVisa(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(ResponseWrapper.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteVisa(venueGroupId: string, venueId: string | undefined, visaId: string, visaType: VenueGroupVisaType | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-groups/{venueGroupId}/visas/{visaId}?";
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        if (visaId === undefined || visaId === null)
            throw new Error("The parameter 'visaId' must be defined.");
        url_ = url_.replace("{visaId}", encodeURIComponent("" + visaId));
        if (venueId === null)
            throw new Error("The parameter 'venueId' cannot be null.");
        else if (venueId !== undefined)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (visaType === null)
            throw new Error("The parameter 'visaType' cannot be null.");
        else if (visaType !== undefined)
            url_ += "visaType=" + encodeURIComponent("" + visaType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteVisa(_response));
        });
    }

    protected processDeleteVisa(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class WebhookExampleClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Example webhook endpoint for API Clients
     */
    callback(event: WebhookEvent, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/webhook/example";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(event);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCallback(_response));
        });
    }

    protected processCallback(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class WorkspaceScenariosClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(signal?: AbortSignal): Promise<WorkspaceScenarioViewModel[]> {
        let url_ = this.baseUrl + "/api/workspace-scenarios";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<WorkspaceScenarioViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkspaceScenarioViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceScenarioViewModel[]>(null as any);
    }
}

export class VenueAmenitiesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * List of all requestable/included amenities for reservation
     */
    amenities(venueId: string, signal?: AbortSignal): Promise<VenueAmenityViewModel[]> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/amenities";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAmenities(_response));
        });
    }

    protected processAmenities(response: Response): Promise<VenueAmenityViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueAmenityViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueAmenityViewModel[]>(null as any);
    }

    /**
     * List of all requestable/included workspace amenities for reservation
     */
    workspaceAmenities(venueId: string, workspaceId: string, signal?: AbortSignal): Promise<VenueAmenityViewModel[]> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces/{workspaceId}/amenities";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processWorkspaceAmenities(_response));
        });
    }

    protected processWorkspaceAmenities(response: Response): Promise<VenueAmenityViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueAmenityViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueAmenityViewModel[]>(null as any);
    }
}

export class VenueClaimClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    claim(venueId: string, resend: boolean | undefined, signal?: AbortSignal): Promise<ClaimVenueResult> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/claim?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (resend === null)
            throw new Error("The parameter 'resend' cannot be null.");
        else if (resend !== undefined)
            url_ += "resend=" + encodeURIComponent("" + resend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClaim(_response));
        });
    }

    protected processClaim(response: Response): Promise<ClaimVenueResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClaimVenueResult>(null as any);
    }

    verifyHost(venueId: string, ticketId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/claim/{ticketId}/verify";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVerifyHost(_response));
        });
    }

    protected processVerifyHost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VenuePermissionsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    permissions(venueId: string, memberId: string | null | undefined, signal?: AbortSignal): Promise<VenuePermissionsViewModel> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/permissions?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPermissions(_response));
        });
    }

    protected processPermissions(response: Response): Promise<VenuePermissionsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenuePermissionsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenuePermissionsViewModel>(null as any);
    }

    requestPermissions(venueId: string, request: VenuePermissionsRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/permissions";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequestPermissions(_response));
        });
    }

    protected processRequestPermissions(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class VenuesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get venue details
     * @param venueId Venue ID
     * @return Venue details
     */
    get(venueId: string, signal?: AbortSignal): Promise<VenueModel> {
        let url_ = this.baseUrl + "/api/venues/{venueId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<VenueModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueModel>(null as any);
    }

    hasLiquidspacePro(venueId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/hasliquidspacepro";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasLiquidspacePro(_response));
        });
    }

    protected processHasLiquidspacePro(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    healthAndSafetyPolicy(venueId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/healthandsafetypolicy";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHealthAndSafetyPolicy(_response));
        });
    }

    protected processHealthAndSafetyPolicy(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Search venues by prefix term
     * @param term (optional) Venue name prefix term
     * @return List of venue ID+Name pairs
     */
    autocomplete(term: string | null | undefined, signal?: AbortSignal): Promise<VenueAutocompleteItem[]> {
        let url_ = this.baseUrl + "/api/venues/search?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAutocomplete(_response));
        });
    }

    protected processAutocomplete(response: Response): Promise<VenueAutocompleteItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueAutocompleteItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueAutocompleteItem[]>(null as any);
    }

    getHeadquarterData(venueId: string, signal?: AbortSignal): Promise<VenueHeadquarterDataViewModel> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/headquarterdata";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHeadquarterData(_response));
        });
    }

    protected processGetHeadquarterData(response: Response): Promise<VenueHeadquarterDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueHeadquarterDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueHeadquarterDataViewModel>(null as any);
    }
}

export class WorkspacesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * List workspaces of venue
     * @param venueId Venue ID
     * @return List of workspace details
     */
    list(venueId: string, signal?: AbortSignal): Promise<VenueWorkspaceModel[]> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<VenueWorkspaceModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueWorkspaceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueWorkspaceModel[]>(null as any);
    }

    /**
     * Get workspaces details
     * @param venueId Venue ID
     * @param workspaceId Workspace ID
     * @return Workspace details
     */
    get(venueId: string, workspaceId: string, signal?: AbortSignal): Promise<VenueWorkspaceModel> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces/{workspaceId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<VenueWorkspaceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueWorkspaceModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueWorkspaceModel>(null as any);
    }
}

export class VenueAvailabilityClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get venue hourly availability at requested date
     * @param venueId Venue ID
     * @param date Date on which the availability calculation is to be made (Venue time zone)
     * @param timeChunkSize (optional) Granularity of response time chunks. Min15 is most accurate
     */
    hourlyAvailability(venueId: string, date: string, timeChunkSize: TimeChunkSize | undefined, signal?: AbortSignal): Promise<ReservationCalendarWorkspaceModel[]> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/availability/hourly/{date}?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (timeChunkSize === null)
            throw new Error("The parameter 'timeChunkSize' cannot be null.");
        else if (timeChunkSize !== undefined)
            url_ += "timeChunkSize=" + encodeURIComponent("" + timeChunkSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHourlyAvailability(_response));
        });
    }

    protected processHourlyAvailability(response: Response): Promise<ReservationCalendarWorkspaceModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationCalendarWorkspaceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationCalendarWorkspaceModel[]>(null as any);
    }
}

export class WorkspaceAvailabilityClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get workspace closed days for requested month
     * @param venueId Venue ID
     * @param workspaceId Workspace ID
     * @param date First day of month on which the availability calculation is to be made
     */
    closedDays(venueId: string, workspaceId: string, date: string, signal?: AbortSignal): Promise<ClosedDayModel[]> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces/{workspaceId}/availability/closed-days/{date}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClosedDays(_response));
        });
    }

    protected processClosedDays(response: Response): Promise<ClosedDayModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClosedDayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClosedDayModel[]>(null as any);
    }

    /**
     * Get workspace open hours at requested date
     * @param venueId Venue ID
     * @param workspaceId Workspace ID
     * @param date Date on which the availability calculation is to be made
     */
    openHours(venueId: string, workspaceId: string, date: string, signal?: AbortSignal): Promise<OpenHoursItem[]> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces/{workspaceId}/availability/open-hours/{date}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenHours(_response));
        });
    }

    protected processOpenHours(response: Response): Promise<OpenHoursItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpenHoursItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpenHoursItem[]>(null as any);
    }

    /**
     * Get workspace open for tour hours at requested date
     * @param venueId Venue ID
     * @param workspaceId Workspace ID
     * @param date Date on which the availability calculation is to be made
     */
    openHoursForTour(venueId: string, workspaceId: string, date: string, signal?: AbortSignal): Promise<OpenHoursItem[]> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces/{workspaceId}/availability/tour/open-hours/{date}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenHoursForTour(_response));
        });
    }

    protected processOpenHoursForTour(response: Response): Promise<OpenHoursItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpenHoursItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpenHoursItem[]>(null as any);
    }

    /**
     * Get monthly workspace closed days for requested month
     * @param venueId Venue ID
     * @param workspaceId Monthly Workspace ID
     * @param date First day of month on which the availability calculation is to be made
     * @param memberId (optional) 
     * @param existingReservationId (optional) Optional monthly reservation ID to be excluded from availability calculations.
    Shuold be used in order to calculated proper availability in edit reservation scenario.
     */
    unavailableDays(venueId: string, workspaceId: string, date: string, memberId: string | null | undefined, existingReservationId: string | null | undefined, signal?: AbortSignal): Promise<ClosedDayModel[]> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces/{workspaceId}/availability/unavailable-days/{date}?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        if (existingReservationId !== undefined && existingReservationId !== null)
            url_ += "existingReservationId=" + encodeURIComponent("" + existingReservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnavailableDays(_response));
        });
    }

    protected processUnavailableDays(response: Response): Promise<ClosedDayModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClosedDayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClosedDayModel[]>(null as any);
    }

    /**
     * Get workspace hourly availability at requested date
     * @param venueId Venue ID
     * @param workspaceId Workspace ID
     * @param date Date on which the availability calculation is to be made (Venue time zone)
     * @param timeChunkSize (optional) Granularity of response time chunks. Min15 is most accurate
     * @param reservationId (optional) Id of reservation to exclude from availability calculations (for example when editing)
     * @param occurrenceDate (optional) Occurrence date to exclude occurrence of recurrent from availability calculations
     */
    hourlyAvailability(venueId: string, workspaceId: string, date: string, timeChunkSize: TimeChunkSize | undefined, reservationId: string | null | undefined, occurrenceDate: string | null | undefined, signal?: AbortSignal): Promise<ReservationCalendarTimeChunkStateModel[]> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces/{workspaceId}/availability/hourly/{date}?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (timeChunkSize === null)
            throw new Error("The parameter 'timeChunkSize' cannot be null.");
        else if (timeChunkSize !== undefined)
            url_ += "timeChunkSize=" + encodeURIComponent("" + timeChunkSize) + "&";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (occurrenceDate !== undefined && occurrenceDate !== null)
            url_ += "occurrenceDate=" + encodeURIComponent("" + occurrenceDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHourlyAvailability(_response));
        });
    }

    protected processHourlyAvailability(response: Response): Promise<ReservationCalendarTimeChunkStateModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationCalendarTimeChunkStateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationCalendarTimeChunkStateModel[]>(null as any);
    }

    /**
     * Check workspace availability and get next available date
     * @param venueId Venue ID
     * @param workspaceId Workspace ID
     * @param request Additional details (date, time, quantity, existing reservation id)
     * @return Next available date for the workspace in the venue time zone or null if none found
     */
    checkAvailability(venueId: string, workspaceId: string, request: CheckAvailabilityRequest, signal?: AbortSignal): Promise<CheckAvailabilityResponse> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces/{workspaceId}/availability/check";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckAvailability(_response));
        });
    }

    protected processCheckAvailability(response: Response): Promise<CheckAvailabilityResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckAvailabilityResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckAvailabilityResponse>(null as any);
    }

    /**
     * Get available desks quantity for specific date.
     * @param existingReservationId (optional) Id of the reservation you are editing to exclude from quantity calculations (in case you plan to edit it's quantity)
     */
    quantityAvilable(venueId: string, workspaceId: string, date: string, existingReservationId: string | null | undefined, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces/{workspaceId}/availability/quantity/{date}?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (existingReservationId !== undefined && existingReservationId !== null)
            url_ += "existingReservationId=" + encodeURIComponent("" + existingReservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuantityAvilable(_response));
        });
    }

    protected processQuantityAvilable(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Check workspace availability and get next available date
     * @param venueId Venue ID
     * @param workspaceId Workspace ID
     * @param request Additional details (date, time, quantity, existing reservation id)
     * @return Next available date for the workspace in the venue time zone or null if none found
     */
    checkRegusAvailability(venueId: string, workspaceId: string, request: CheckAvailabilityRequest, signal?: AbortSignal): Promise<CheckRegusAvailabilityResponse> {
        let url_ = this.baseUrl + "/api/venues/{venueId}/workspaces/{workspaceId}/availability/checkregus";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckRegusAvailability(_response));
        });
    }

    protected processCheckRegusAvailability(response: Response): Promise<CheckRegusAvailabilityResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckRegusAvailabilityResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckRegusAvailabilityResponse>(null as any);
    }
}

export class UserClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    currentMember(signal?: AbortSignal): Promise<UserInfoViewModel> {
        let url_ = this.baseUrl + "/api/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCurrentMember(_response));
        });
    }

    protected processCurrentMember(response: Response): Promise<UserInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfoViewModel>(null as any);
    }

    enterpriseAccountMembership(signal?: AbortSignal): Promise<UserInfoEnterpriseAccountResponse> {
        let url_ = this.baseUrl + "/api/users/me/ea";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEnterpriseAccountMembership(_response));
        });
    }

    protected processEnterpriseAccountMembership(response: Response): Promise<UserInfoEnterpriseAccountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoEnterpriseAccountResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfoEnterpriseAccountResponse>(null as any);
    }

    getCounters(signal?: AbortSignal): Promise<HeaderMenuCountersViewModel> {
        let url_ = this.baseUrl + "/api/users/me/counters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCounters(_response));
        });
    }

    protected processGetCounters(response: Response): Promise<HeaderMenuCountersViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HeaderMenuCountersViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HeaderMenuCountersViewModel>(null as any);
    }
}

export class UserVenuesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getOwned(venueId: string | null | undefined, takeCount: number | null | undefined, signal?: AbortSignal): Promise<MyVenueViewModel[]> {
        let url_ = this.baseUrl + "/api/users/me/venues/owned?";
        if (venueId !== undefined && venueId !== null)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (takeCount !== undefined && takeCount !== null)
            url_ += "takeCount=" + encodeURIComponent("" + takeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOwned(_response));
        });
    }

    protected processGetOwned(response: Response): Promise<MyVenueViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MyVenueViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MyVenueViewModel[]>(null as any);
    }

    getRecent(signal?: AbortSignal): Promise<VenueSearchResult[]> {
        let url_ = this.baseUrl + "/api/users/me/venues/recent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRecent(_response));
        });
    }

    protected processGetRecent(response: Response): Promise<VenueSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueSearchResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueSearchResult[]>(null as any);
    }

    getUnfinished(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/users/me/venues/owned/unfinished";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUnfinished(_response));
        });
    }

    protected processGetUnfinished(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class SavedSearchRequestClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(savedSearchRequestId: string, signal?: AbortSignal): Promise<SavedSearchRequestWithId> {
        let url_ = this.baseUrl + "/api/search/request/{savedSearchRequestId}";
        if (savedSearchRequestId === undefined || savedSearchRequestId === null)
            throw new Error("The parameter 'savedSearchRequestId' must be defined.");
        url_ = url_.replace("{savedSearchRequestId}", encodeURIComponent("" + savedSearchRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SavedSearchRequestWithId> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedSearchRequestWithId.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SavedSearchRequestWithId>(null as any);
    }

    update(savedSearchRequestId: string, searchRequest: SavedSearchRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/search/request/{savedSearchRequestId}";
        if (savedSearchRequestId === undefined || savedSearchRequestId === null)
            throw new Error("The parameter 'savedSearchRequestId' must be defined.");
        url_ = url_.replace("{savedSearchRequestId}", encodeURIComponent("" + savedSearchRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create new Saved Search Request
     * @param searchRequest Payload
     * @return ID of just created entity
     */
    create(searchRequest: SavedSearchRequest, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/search/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SearchAutocompleteClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    geoAutocomplete(query: string | undefined, signal?: AbortSignal): Promise<GeoSearchAutocomplete[]> {
        let url_ = this.baseUrl + "/api/search/autocomplete/geo?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGeoAutocomplete(_response));
        });
    }

    protected processGeoAutocomplete(response: Response): Promise<GeoSearchAutocomplete[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeoSearchAutocomplete.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GeoSearchAutocomplete[]>(null as any);
    }

    liquidSpaceAutocomplete(query: string | undefined, signal?: AbortSignal): Promise<BaseSearchAutocomplete[]> {
        let url_ = this.baseUrl + "/api/search/autocomplete/ls?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLiquidSpaceAutocomplete(_response));
        });
    }

    protected processLiquidSpaceAutocomplete(response: Response): Promise<BaseSearchAutocomplete[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BaseSearchAutocomplete.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseSearchAutocomplete[]>(null as any);
    }

    dropdownAutocomplete(signal?: AbortSignal): Promise<BaseSearchAutocomplete[]> {
        let url_ = this.baseUrl + "/api/search/autocomplete/dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDropdownAutocomplete(_response));
        });
    }

    protected processDropdownAutocomplete(response: Response): Promise<BaseSearchAutocomplete[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BaseSearchAutocomplete.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseSearchAutocomplete[]>(null as any);
    }

    textToSearchQuery(text: string | undefined, signal?: AbortSignal): Promise<SearchQueryAutocomplete> {
        let url_ = this.baseUrl + "/api/search/autocomplete/query?";
        if (text === null)
            throw new Error("The parameter 'text' cannot be null.");
        else if (text !== undefined)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTextToSearchQuery(_response));
        });
    }

    protected processTextToSearchQuery(response: Response): Promise<SearchQueryAutocomplete> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchQueryAutocomplete.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchQueryAutocomplete>(null as any);
    }
}

export class SearchClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Execute default search request type
     * @param request Geo search request
     * @return Found spaces with geocoding information
     */
    default(request: DefaultSearchRequest, signal?: AbortSignal): Promise<VenuesSearchResult> {
        let url_ = this.baseUrl + "/api/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDefault(_response));
        });
    }

    protected processDefault(response: Response): Promise<VenuesSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenuesSearchResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenuesSearchResult>(null as any);
    }

    /**
     * Execute full-fledged search request
     * @param request Search request parameters model
     * @return Found spaces with geocoding information
     */
    execute(request: BaseSearchRequest, signal?: AbortSignal): Promise<VenuesSearchResult> {
        let url_ = this.baseUrl + "/api/search/execute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecute(_response));
        });
    }

    protected processExecute(response: Response): Promise<VenuesSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenuesSearchResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenuesSearchResult>(null as any);
    }

    /**
     * Execute saved search request search
     * @param savedSearchRequestId Saved search request ID
     * @return Found spaces with geocoding information
     */
    executeSavedSearch(savedSearchRequestId: string, signal?: AbortSignal): Promise<VenuesSearchResult> {
        let url_ = this.baseUrl + "/api/search/{savedSearchRequestId}";
        if (savedSearchRequestId === undefined || savedSearchRequestId === null)
            throw new Error("The parameter 'savedSearchRequestId' must be defined.");
        url_ = url_.replace("{savedSearchRequestId}", encodeURIComponent("" + savedSearchRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecuteSavedSearch(_response));
        });
    }

    protected processExecuteSavedSearch(response: Response): Promise<VenuesSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenuesSearchResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenuesSearchResult>(null as any);
    }

    config(signal?: AbortSignal): Promise<SearchConfig> {
        let url_ = this.baseUrl + "/api/search/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfig(_response));
        });
    }

    protected processConfig(response: Response): Promise<SearchConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchConfig.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchConfig>(null as any);
    }
}

export class RegusReservationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    syncRegusBooking(reservationId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/sync-regus-booking";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncRegusBooking(_response));
        });
    }

    protected processSyncRegusBooking(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getRegusBookingServices(reservationId: string, signal?: AbortSignal): Promise<RegusBookingService[]> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/regus-booking-services";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRegusBookingServices(_response));
        });
    }

    protected processGetRegusBookingServices(response: Response): Promise<RegusBookingService[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegusBookingService.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegusBookingService[]>(null as any);
    }

    saveRegusBookingServices(reservationId: string, request: RegusBookingServicesRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/regus-booking-services";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveRegusBookingServices(_response));
        });
    }

    protected processSaveRegusBookingServices(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ReservationGuestsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(reservationId: string, signal?: AbortSignal): Promise<ReservationMaybeMemberViewModel[]> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/guests";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ReservationMaybeMemberViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationMaybeMemberViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationMaybeMemberViewModel[]>(null as any);
    }

    invite(reservationId: string, model: InviteGuestsViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/guests";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInvite(_response));
        });
    }

    protected processInvite(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ReservationPagesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get reservations pages model for current User or defined by memberId
     * @param memberId (optional) Optional Member ID. This field is required in machine-to-machine context.
     * @return Model with list of page tokens
     */
    pager(memberId: string | null | undefined, pagerRequest: ReservationPagerRequest, signal?: AbortSignal): Promise<ReservationPager> {
        let url_ = this.baseUrl + "/api/reservations/pages?";
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagerRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPager(_response));
        });
    }

    protected processPager(response: Response): Promise<ReservationPager> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationPager.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationPager>(null as any);
    }

    /**
     * Get page of reservations by page token
     * @param token Page token
     */
    page(token: string, signal?: AbortSignal): Promise<TeamMemberReservation[]> {
        let url_ = this.baseUrl + "/api/reservations/pages?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPage(_response));
        });
    }

    protected processPage(response: Response): Promise<TeamMemberReservation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMemberReservation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberReservation[]>(null as any);
    }
}

export class ReservationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get Reservation details
     * @param reservationId Reservation ID
     * @param occurrenceDate (optional) Reservation occurrence date. Suitable only for Recurrent Reservation
     * @param applyDate (optional) Reservation apply date. Suitable only for Recurrent Reservation
     */
    get(reservationId: string, occurrenceDate: string | null | undefined, applyDate: string | null | undefined, signal?: AbortSignal): Promise<TeamMemberReservation> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        if (occurrenceDate !== undefined && occurrenceDate !== null)
            url_ += "occurrenceDate=" + encodeURIComponent("" + occurrenceDate) + "&";
        if (applyDate !== undefined && applyDate !== null)
            url_ += "applyDate=" + encodeURIComponent("" + applyDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<TeamMemberReservation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamMemberReservation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberReservation>(null as any);
    }

    /**
     * Edit reservation
     * @param reservationId Reservation ID
     * @param occurrenceDate (optional) Optional reservation occurrence data used to identify instance of recurrent resrvation
     * @param applyDate (optional) Setting this parameter for Recurrent Reservation will edit all following reservations since given date
     * @param request Request containing patch document with reservation updates and additional info
     */
    edit(reservationId: string, occurrenceDate: string | null | undefined, applyDate: string | null | undefined, request: EditReservationRequest, signal?: AbortSignal): Promise<EditReservationResponse> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        if (occurrenceDate !== undefined && occurrenceDate !== null)
            url_ += "occurrenceDate=" + encodeURIComponent("" + occurrenceDate) + "&";
        if (applyDate !== undefined && applyDate !== null)
            url_ += "applyDate=" + encodeURIComponent("" + applyDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEdit(_response));
        });
    }

    protected processEdit(response: Response): Promise<EditReservationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditReservationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditReservationResponse>(null as any);
    }

    /**
     * Cancel (delete) reservation
     * @param reservationId Reservation ID
     * @param occurrenceDate (optional) Optional reservation occurrence data used to identify instance of recurrent resrvation
     * @param applyDate (optional) Setting this parameter for Recurrent Reservation will delete all following reservations since given date
     */
    cancel(reservationId: string, occurrenceDate: string | null | undefined, applyDate: string | null | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        if (occurrenceDate !== undefined && occurrenceDate !== null)
            url_ += "occurrenceDate=" + encodeURIComponent("" + occurrenceDate) + "&";
        if (applyDate !== undefined && applyDate !== null)
            url_ += "applyDate=" + encodeURIComponent("" + applyDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancel(_response));
        });
    }

    protected processCancel(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResponseWrapper.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getUrgencyStatus(reservationId: string, signal?: AbortSignal): Promise<HourlyReservationUrgencyStatus> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/urgency";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUrgencyStatus(_response));
        });
    }

    protected processGetUrgencyStatus(response: Response): Promise<HourlyReservationUrgencyStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HourlyReservationUrgencyStatus>(null as any);
    }

    getRaw(reservationId: string, signal?: AbortSignal): Promise<ReservationRaw> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/raw";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRaw(_response));
        });
    }

    protected processGetRaw(response: Response): Promise<ReservationRaw> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationRaw.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationRaw>(null as any);
    }

    closestFinishDate(reservationId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/closest-finish-date";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClosestFinishDate(_response));
        });
    }

    protected processClosestFinishDate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    stopAutoRenew(reservationId: string, finishDate: string | null | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/stop-autorenew?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        if (finishDate !== undefined && finishDate !== null)
            url_ += "finishDate=" + encodeURIComponent("" + finishDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStopAutoRenew(_response));
        });
    }

    protected processStopAutoRenew(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getReservationCardPicture(reservationId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/reservationcardpicture";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReservationCardPicture(_response));
        });
    }

    protected processGetReservationCardPicture(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ReservationsCreateClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    previewLicense(request: ReservationRequest, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/reservations/license/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreviewLicense(_response));
        });
    }

    protected processPreviewLicense(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    create(request: ReservationRequest, signal?: AbortSignal): Promise<CreateReservationResponse> {
        let url_ = this.baseUrl + "/api/reservations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CreateReservationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateReservationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateReservationResponse>(null as any);
    }
}

export class ReservationVenueConfirmationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    set(reservationId: string, status: VenueConfirmationStatus | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/venue-confirmation?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSet(_response));
        });
    }

    protected processSet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    get(reservationId: string, signal?: AbortSignal): Promise<VenueConfirmationViewModel> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/venue-confirmation";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<VenueConfirmationViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueConfirmationViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueConfirmationViewModel>(null as any);
    }
}

export class ReservationVisitStatesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Perform reservation check-in procedure
     * @param reservationId Reservation ID
     * @param occurrenceDate (optional) Reservation occurrence date. Suitable only for Recurrent Reservation
     */
    checkIn(reservationId: string, occurrenceDate: string | null | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/visit-state/checkin?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        if (occurrenceDate !== undefined && occurrenceDate !== null)
            url_ += "occurrenceDate=" + encodeURIComponent("" + occurrenceDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckIn(_response));
        });
    }

    protected processCheckIn(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    /**
     * Perform reservation check-out procedure
     * @param reservationId Reservation ID
     * @param occurrenceDate (optional) Reservation occurrence date. Suitable only for Recurrent Reservation
     */
    checkOut(reservationId: string, occurrenceDate: string | null | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/visit-state/checkout?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        if (occurrenceDate !== undefined && occurrenceDate !== null)
            url_ += "occurrenceDate=" + encodeURIComponent("" + occurrenceDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckOut(_response));
        });
    }

    protected processCheckOut(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    set(reservationId: string, wasVisited: boolean | undefined, occurrenceDate: string | null | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/reservations/{reservationId}/visit-state?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        if (wasVisited === null)
            throw new Error("The parameter 'wasVisited' cannot be null.");
        else if (wasVisited !== undefined)
            url_ += "wasVisited=" + encodeURIComponent("" + wasVisited) + "&";
        if (occurrenceDate !== undefined && occurrenceDate !== null)
            url_ += "occurrenceDate=" + encodeURIComponent("" + occurrenceDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSet(_response));
        });
    }

    protected processSet(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class PromotionClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(signal?: AbortSignal): Promise<PromotionListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/promotions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PromotionListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotionListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromotionListItemViewModel[]>(null as any);
    }

    create(model: PromotionSettingsViewModel, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/promotions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    get(id: string, signal?: AbortSignal): Promise<PromotionListItemViewModel> {
        let url_ = this.baseUrl + "/api/promotions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PromotionListItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionListItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromotionListItemViewModel>(null as any);
    }

    delete(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/promotions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRedemptions(id: string, signal?: AbortSignal): Promise<PromotionRedemptionListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/promotions/{id}/redemptions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRedemptions(_response));
        });
    }

    protected processGetRedemptions(response: Response): Promise<PromotionRedemptionListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotionRedemptionListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromotionRedemptionListItemViewModel[]>(null as any);
    }

    visibility(venueId: string | undefined, workspaceId: string | undefined, ownerId: string | null | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/promotions/visibility?";
        if (venueId === null)
            throw new Error("The parameter 'venueId' cannot be null.");
        else if (venueId !== undefined)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (ownerId !== undefined && ownerId !== null)
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVisibility(_response));
        });
    }

    protected processVisibility(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    validate(code: string | undefined, venueId: string | undefined, workspaceId: string | undefined, ownerId: string | null | undefined, signal?: AbortSignal): Promise<PromotionValidationResultViewModel> {
        let url_ = this.baseUrl + "/api/promotions/validate?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (venueId === null)
            throw new Error("The parameter 'venueId' cannot be null.");
        else if (venueId !== undefined)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (ownerId !== undefined && ownerId !== null)
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidate(_response));
        });
    }

    protected processValidate(response: Response): Promise<PromotionValidationResultViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionValidationResultViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromotionValidationResultViewModel>(null as any);
    }

    getInitialCouponCode(venueId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/promotions/{venueId}/venues/initial-code";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInitialCouponCode(_response));
        });
    }

    protected processGetInitialCouponCode(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    duplicate(id: string, newCode: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/promotions/{id}/duplicate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newCode === null)
            throw new Error("The parameter 'newCode' cannot be null.");
        else if (newCode !== undefined)
            url_ += "newCode=" + encodeURIComponent("" + newCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDuplicate(_response));
        });
    }

    protected processDuplicate(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class PromotionMemberGroupsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id: string, signal?: AbortSignal): Promise<PromotionMemberGroupListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/promotions/{id}/membergroups";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PromotionMemberGroupListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotionMemberGroupListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromotionMemberGroupListItemViewModel[]>(null as any);
    }

    add(id: string, memberGroupId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/promotions/{id}/membergroups/{memberGroupId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: string, memberGroupId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/promotions/{id}/membergroups/{memberGroupId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PromotionSettingsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id: string, signal?: AbortSignal): Promise<PromotionSettingsViewModel> {
        let url_ = this.baseUrl + "/api/promotions/{id}/settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PromotionSettingsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionSettingsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromotionSettingsViewModel>(null as any);
    }

    patch(id: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/promotions/{id}/settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class PromotionVenueGroupsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id: string, signal?: AbortSignal): Promise<PromotionVenueGroupListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/promotions/{id}/venuegroups";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PromotionVenueGroupListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotionVenueGroupListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromotionVenueGroupListItemViewModel[]>(null as any);
    }

    add(id: string, venueGroupId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/promotions/{id}/venuegroups/{venueGroupId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: string, venueGroupId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/promotions/{id}/venuegroups/{venueGroupId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (venueGroupId === undefined || venueGroupId === null)
            throw new Error("The parameter 'venueGroupId' must be defined.");
        url_ = url_.replace("{venueGroupId}", encodeURIComponent("" + venueGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PromotionVenuesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id: string, signal?: AbortSignal): Promise<PromotionVenueListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/promotions/{id}/venues";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PromotionVenueListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotionVenueListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromotionVenueListItemViewModel[]>(null as any);
    }

    add(id: string, venueId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/promotions/{id}/venues/{venueId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: string, venueId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/promotions/{id}/venues/{venueId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MessageAttachmentsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/messages/attachments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MessagesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    sendMessage(targetId: string | undefined, chainId: string | null | undefined, subject: string | null | undefined, venueId: string | null | undefined, fromVenue: boolean | undefined, text: string | null | undefined, attachments: FileParameter[] | null | undefined, signal?: AbortSignal): Promise<SendMessageResponse> {
        let url_ = this.baseUrl + "/api/messages?";
        if (targetId === null)
            throw new Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (chainId !== undefined && chainId !== null)
            url_ += "chainId=" + encodeURIComponent("" + chainId) + "&";
        if (subject !== undefined && subject !== null)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (venueId !== undefined && venueId !== null)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (fromVenue === null)
            throw new Error("The parameter 'fromVenue' cannot be null.");
        else if (fromVenue !== undefined)
            url_ += "fromVenue=" + encodeURIComponent("" + fromVenue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (text !== null && text !== undefined)
            content_.append("text", text.toString());
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("attachments", item_.data, item_.fileName ? item_.fileName : "attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendMessage(_response));
        });
    }

    protected processSendMessage(response: Response): Promise<SendMessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendMessageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendMessageResponse>(null as any);
    }

    messages(memberId: string | null | undefined, chainId: string | null | undefined, venueId: string | null | undefined, filter: MessagesFilterEnum | undefined, signal?: AbortSignal): Promise<MemberMessagesModel> {
        let url_ = this.baseUrl + "/api/messages?";
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        if (chainId !== undefined && chainId !== null)
            url_ += "chainId=" + encodeURIComponent("" + chainId) + "&";
        if (venueId !== undefined && venueId !== null)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMessages(_response));
        });
    }

    protected processMessages(response: Response): Promise<MemberMessagesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberMessagesModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberMessagesModel>(null as any);
    }

    getChain(chainId: string, venueId: string | null | undefined, memberId: string | null | undefined, signal?: AbortSignal): Promise<MessageChain> {
        let url_ = this.baseUrl + "/api/messages/chains/{chainId}?";
        if (chainId === undefined || chainId === null)
            throw new Error("The parameter 'chainId' must be defined.");
        url_ = url_.replace("{chainId}", encodeURIComponent("" + chainId));
        if (venueId !== undefined && venueId !== null)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChain(_response));
        });
    }

    protected processGetChain(response: Response): Promise<MessageChain> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageChain.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageChain>(null as any);
    }

    markChainAsRead(chainId: string, venueId: string | null | undefined, memberId: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/messages/chains/{chainId}/mark-as-read?";
        if (chainId === undefined || chainId === null)
            throw new Error("The parameter 'chainId' must be defined.");
        url_ = url_.replace("{chainId}", encodeURIComponent("" + chainId));
        if (venueId !== undefined && venueId !== null)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMarkChainAsRead(_response));
        });
    }

    protected processMarkChainAsRead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMessengerTargets(venueId: string | null | undefined, signal?: AbortSignal): Promise<MessageTargetAutocompleteItem[]> {
        let url_ = this.baseUrl + "/api/messages/targets?";
        if (venueId !== undefined && venueId !== null)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMessengerTargets(_response));
        });
    }

    protected processGetMessengerTargets(response: Response): Promise<MessageTargetAutocompleteItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageTargetAutocompleteItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageTargetAutocompleteItem[]>(null as any);
    }

    chainArchiveAction(chainId: string, archive: boolean | undefined, ownerId: string | null | undefined, ownerType: EntityType | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/messages/chains/{chainId}/archive?";
        if (chainId === undefined || chainId === null)
            throw new Error("The parameter 'chainId' must be defined.");
        url_ = url_.replace("{chainId}", encodeURIComponent("" + chainId));
        if (archive === null)
            throw new Error("The parameter 'archive' cannot be null.");
        else if (archive !== undefined)
            url_ += "archive=" + encodeURIComponent("" + archive) + "&";
        if (ownerId !== undefined && ownerId !== null)
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        if (ownerType !== undefined && ownerType !== null)
            url_ += "ownerType=" + encodeURIComponent("" + ownerType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChainArchiveAction(_response));
        });
    }

    protected processChainArchiveAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    existingChain(memberId: string | undefined, signal?: AbortSignal): Promise<string | null> {
        let url_ = this.baseUrl + "/api/messages/chains/existing?";
        if (memberId === null)
            throw new Error("The parameter 'memberId' cannot be null.");
        else if (memberId !== undefined)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExistingChain(_response));
        });
    }

    protected processExistingChain(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    deleteMessage(messageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/messages/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMessage(_response));
        });
    }

    protected processDeleteMessage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MemberGroupAdminsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    addAdmin(memberGroupId: string, adminEmail: string | null | undefined, signal?: AbortSignal): Promise<MemberListItemViewModel> {
        let url_ = this.baseUrl + "/api/member-groups/${memberGroupId}/admins/add?";
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        if (adminEmail !== undefined && adminEmail !== null)
            url_ += "adminEmail=" + encodeURIComponent("" + adminEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddAdmin(_response));
        });
    }

    protected processAddAdmin(response: Response): Promise<MemberListItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberListItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberListItemViewModel>(null as any);
    }

    removeAdmin(memberGroupId: string, userId: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/member-groups/${memberGroupId}/admins/remove?";
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveAdmin(_response));
        });
    }

    protected processRemoveAdmin(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    addBookingDelegate(memberGroupId: string, bookingDelegateEmail: string | null | undefined, signal?: AbortSignal): Promise<MemberListItemViewModel> {
        let url_ = this.baseUrl + "/api/member-groups/${memberGroupId}/admins/add-booking-delegate?";
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        if (bookingDelegateEmail !== undefined && bookingDelegateEmail !== null)
            url_ += "bookingDelegateEmail=" + encodeURIComponent("" + bookingDelegateEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddBookingDelegate(_response));
        });
    }

    protected processAddBookingDelegate(response: Response): Promise<MemberListItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberListItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberListItemViewModel>(null as any);
    }

    removeBookingDelegate(memberGroupId: string, userId: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/member-groups/${memberGroupId}/admins/remove-booking-delegate?";
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveBookingDelegate(_response));
        });
    }

    protected processRemoveBookingDelegate(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class MemberGroupClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id: string, signal?: AbortSignal): Promise<MemberGroupViewModel> {
        let url_ = this.baseUrl + "/api/member-groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<MemberGroupViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberGroupViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberGroupViewModel>(null as any);
    }

    delete(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/member-groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    list(signal?: AbortSignal): Promise<MemberGroupListViewModel[]> {
        let url_ = this.baseUrl + "/api/member-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<MemberGroupListViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberGroupListViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberGroupListViewModel[]>(null as any);
    }

    create(model: MemberGroupViewModel, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/member-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    patch(memberGroupId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/member-groups/{memberGroupId}";
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getMembers(memberGroupId: string, signal?: AbortSignal): Promise<MemberListItemViewModel[]> {
        let url_ = this.baseUrl + "/api/member-groups/{memberGroupId}/members";
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMembers(_response));
        });
    }

    protected processGetMembers(response: Response): Promise<MemberListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberListItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberListItemViewModel[]>(null as any);
    }
}

export class MemberGroupHQClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    headquarters(memberGroupId: string, signal?: AbortSignal): Promise<MemberGroupHeadquarterViewModel[]> {
        let url_ = this.baseUrl + "/api/member-groups/${memberGroupId}/headquarters";
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHeadquarters(_response));
        });
    }

    protected processHeadquarters(response: Response): Promise<MemberGroupHeadquarterViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberGroupHeadquarterViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberGroupHeadquarterViewModel[]>(null as any);
    }

    saveHeadquarter(memberGroupId: string, headquarterModel: MemberGroupHeadquarterViewModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/member-groups/${memberGroupId}/headquarters/save";
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(headquarterModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveHeadquarter(_response));
        });
    }

    protected processSaveHeadquarter(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    removeHeadquarter(memberGroupId: string, hqId: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/member-groups/${memberGroupId}/headquarters/remove?";
        if (memberGroupId === undefined || memberGroupId === null)
            throw new Error("The parameter 'memberGroupId' must be defined.");
        url_ = url_.replace("{memberGroupId}", encodeURIComponent("" + memberGroupId));
        if (hqId === null)
            throw new Error("The parameter 'hqId' cannot be null.");
        else if (hqId !== undefined)
            url_ += "hqId=" + encodeURIComponent("" + hqId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveHeadquarter(_response));
        });
    }

    protected processRemoveHeadquarter(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class MemberGroupInvitationClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    previewEmail(id: string, model: ManageMemberGroupInvitationPreviewEmailViewModel, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/member-groups/{id}/invitation/email/render";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreviewEmail(_response));
        });
    }

    protected processPreviewEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MarketplaceAccountsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(signal?: AbortSignal): Promise<MarketplaceAccount[]> {
        let url_ = this.baseUrl + "/api/marketplace-accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<MarketplaceAccount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketplaceAccount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplaceAccount[]>(null as any);
    }

    transactions(accountId: string, signal?: AbortSignal): Promise<MarketplaceTransaction[]> {
        let url_ = this.baseUrl + "/api/marketplace-accounts/{accountId}/transactions";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTransactions(_response));
        });
    }

    protected processTransactions(response: Response): Promise<MarketplaceTransaction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketplaceTransaction.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplaceTransaction[]>(null as any);
    }

    transactionsWithReservationStartDate(accountId: string, signal?: AbortSignal): Promise<MarketplaceTransactionWithStartDate[]> {
        let url_ = this.baseUrl + "/api/marketplace-accounts/{accountId}/transactions/with-start-date";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTransactionsWithReservationStartDate(_response));
        });
    }

    protected processTransactionsWithReservationStartDate(response: Response): Promise<MarketplaceTransactionWithStartDate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketplaceTransactionWithStartDate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplaceTransactionWithStartDate[]>(null as any);
    }

    invoices(accountId: string, signal?: AbortSignal): Promise<MarketplaceInvoice[]> {
        let url_ = this.baseUrl + "/api/marketplace-accounts/{accountId}/invoices";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInvoices(_response));
        });
    }

    protected processInvoices(response: Response): Promise<MarketplaceInvoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketplaceInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplaceInvoice[]>(null as any);
    }

    addInvoice(accountId: string, request: AddMarketplaceInvoiceRequest, signal?: AbortSignal): Promise<MarketplaceInvoice> {
        let url_ = this.baseUrl + "/api/marketplace-accounts/{accountId}/invoices";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddInvoice(_response));
        });
    }

    protected processAddInvoice(response: Response): Promise<MarketplaceInvoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketplaceInvoice.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplaceInvoice>(null as any);
    }

    deleteInvoice(accountId: string, invoiceId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/marketplace-accounts/{accountId}/invoices/{invoiceId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteInvoice(_response));
        });
    }

    protected processDeleteInvoice(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    syncInvoice(accountId: string, invoiceId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/marketplace-accounts/{accountId}/invoices/{invoiceId}/sync";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncInvoice(_response));
        });
    }

    protected processSyncInvoice(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    generateInvoice(accountId: string, periodDate: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/marketplace-accounts/{accountId}/invoices/generate?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (periodDate === null)
            throw new Error("The parameter 'periodDate' cannot be null.");
        else if (periodDate !== undefined)
            url_ += "periodDate=" + encodeURIComponent("" + periodDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateInvoice(_response));
        });
    }

    protected processGenerateInvoice(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ManageVenueAdminsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    admins(venueId: string, signal?: AbortSignal): Promise<VenueAdminModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/admins";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdmins(_response));
        });
    }

    protected processAdmins(response: Response): Promise<VenueAdminModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueAdminModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueAdminModel[]>(null as any);
    }

    add(venueId: string, pregeneratedPictureId: string | undefined, model: VenueAdminModel, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/admins?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (pregeneratedPictureId === null)
            throw new Error("The parameter 'pregeneratedPictureId' cannot be null.");
        else if (pregeneratedPictureId !== undefined)
            url_ += "pregeneratedPictureId=" + encodeURIComponent("" + pregeneratedPictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    remove(venueId: string, memberId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/admins/{memberId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemove(_response));
        });
    }

    protected processRemove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    admin(venueId: string, memberId: string, isPasswordChanging: boolean | undefined, patch: Operation[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/admins/{memberId}?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (isPasswordChanging === null)
            throw new Error("The parameter 'isPasswordChanging' cannot be null.");
        else if (isPasswordChanging !== undefined)
            url_ += "isPasswordChanging=" + encodeURIComponent("" + isPasswordChanging) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdmin(_response));
        });
    }

    protected processAdmin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ManageVenueClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    venueSelector(currentVenueId: string | null | undefined, signal?: AbortSignal): Promise<VenueSelectorListItem[]> {
        let url_ = this.baseUrl + "/api/venue-management?";
        if (currentVenueId !== undefined && currentVenueId !== null)
            url_ += "currentVenueId=" + encodeURIComponent("" + currentVenueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVenueSelector(_response));
        });
    }

    protected processVenueSelector(response: Response): Promise<VenueSelectorListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueSelectorListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueSelectorListItem[]>(null as any);
    }

    venueBrief(venueId: string, signal?: AbortSignal): Promise<VenueBrief> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/brief";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVenueBrief(_response));
        });
    }

    protected processVenueBrief(response: Response): Promise<VenueBrief> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueBrief.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueBrief>(null as any);
    }

    removeSavedSearch(venueId: string, savedSearchId: string, chainId: string | null | undefined, message: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/searches/{savedSearchId}?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (savedSearchId === undefined || savedSearchId === null)
            throw new Error("The parameter 'savedSearchId' must be defined.");
        url_ = url_.replace("{savedSearchId}", encodeURIComponent("" + savedSearchId));
        if (chainId !== undefined && chainId !== null)
            url_ += "chainId=" + encodeURIComponent("" + chainId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveSavedSearch(_response));
        });
    }

    protected processRemoveSavedSearch(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    newMessagesCount(signal?: AbortSignal): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/venue-management/new-messages-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNewMessagesCount(_response));
        });
    }

    protected processNewMessagesCount(response: Response): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    newMessagesCountByVenue(venueId: string, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/new-messages-count";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNewMessagesCountByVenue(_response));
        });
    }

    protected processNewMessagesCountByVenue(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    hasReservations(venueId: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/has-reservations";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasReservations(_response));
        });
    }

    protected processHasReservations(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    setIntegrationOption(venueId: string, integrationOptionRequest: IntegrationOptionRequest, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/integration-option";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(integrationOptionRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetIntegrationOption(_response));
        });
    }

    protected processSetIntegrationOption(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    settings(venueId: string, signal?: AbortSignal): Promise<VenueSettingsModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSettings(_response));
        });
    }

    protected processSettings(response: Response): Promise<VenueSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueSettingsModel>(null as any);
    }

    patchSettings(venueId: string, applyDefaultBookingMethodForExistingSpaces: HourlyMonthly | undefined, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (applyDefaultBookingMethodForExistingSpaces === null)
            throw new Error("The parameter 'applyDefaultBookingMethodForExistingSpaces' cannot be null.");
        else if (applyDefaultBookingMethodForExistingSpaces !== undefined)
            url_ += "applyDefaultBookingMethodForExistingSpaces=" + encodeURIComponent("" + applyDefaultBookingMethodForExistingSpaces) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatchSettings(_response));
        });
    }

    protected processPatchSettings(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    openStatus(venueId: string, openStatus: VenueOpenStatus | undefined, signal?: AbortSignal): Promise<VenueOpenStatus> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/open-status?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (openStatus === null)
            throw new Error("The parameter 'openStatus' cannot be null.");
        else if (openStatus !== undefined)
            url_ += "openStatus=" + encodeURIComponent("" + openStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenStatus(_response));
        });
    }

    protected processOpenStatus(response: Response): Promise<VenueOpenStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueOpenStatus>(null as any);
    }

    venueGroupMembership(venueId: string, signal?: AbortSignal): Promise<VenueGroupMembershipModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/venue-groups";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVenueGroupMembership(_response));
        });
    }

    protected processVenueGroupMembership(response: Response): Promise<VenueGroupMembershipModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueGroupMembershipModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueGroupMembershipModel[]>(null as any);
    }

    priceRate(venueId: string, reservationStartTime: string | undefined, isMonthly: boolean | undefined, reservationCount: number | undefined, pricingRateType: PricingRateType | undefined, signal?: AbortSignal): Promise<PriceRateCheckerResponse> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/price-rates?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (reservationStartTime === null)
            throw new Error("The parameter 'reservationStartTime' cannot be null.");
        else if (reservationStartTime !== undefined)
            url_ += "reservationStartTime=" + encodeURIComponent("" + reservationStartTime) + "&";
        if (isMonthly === null)
            throw new Error("The parameter 'isMonthly' cannot be null.");
        else if (isMonthly !== undefined)
            url_ += "isMonthly=" + encodeURIComponent("" + isMonthly) + "&";
        if (reservationCount === null)
            throw new Error("The parameter 'reservationCount' cannot be null.");
        else if (reservationCount !== undefined)
            url_ += "reservationCount=" + encodeURIComponent("" + reservationCount) + "&";
        if (pricingRateType === null)
            throw new Error("The parameter 'pricingRateType' cannot be null.");
        else if (pricingRateType !== undefined)
            url_ += "pricingRateType=" + encodeURIComponent("" + pricingRateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPriceRate(_response));
        });
    }

    protected processPriceRate(response: Response): Promise<PriceRateCheckerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceRateCheckerResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PriceRateCheckerResponse>(null as any);
    }

    verifyPermalink(venueId: string, permalinkToVerify: string | null | undefined, country: string | null | undefined, state: string | null | undefined, city: string | null | undefined, signal?: AbortSignal): Promise<VerifyVenueParmalinkResult> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/verify-permalink?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (permalinkToVerify !== undefined && permalinkToVerify !== null)
            url_ += "permalinkToVerify=" + encodeURIComponent("" + permalinkToVerify) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (city !== undefined && city !== null)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVerifyPermalink(_response));
        });
    }

    protected processVerifyPermalink(response: Response): Promise<VerifyVenueParmalinkResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyVenueParmalinkResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyVenueParmalinkResult>(null as any);
    }

    populationPercent(venueId: string, signal?: AbortSignal): Promise<VenuePopulationPercentModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/population-percent";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPopulationPercent(_response));
        });
    }

    protected processPopulationPercent(response: Response): Promise<VenuePopulationPercentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenuePopulationPercentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenuePopulationPercentModel>(null as any);
    }

    properties(venueId: string, signal?: AbortSignal): Promise<VenuePropertiesModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/properties";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProperties(_response));
        });
    }

    protected processProperties(response: Response): Promise<VenuePropertiesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenuePropertiesModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenuePropertiesModel>(null as any);
    }

    isPaymentInformationRequired(venueId: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/is-payment-information-required";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsPaymentInformationRequired(_response));
        });
    }

    protected processIsPaymentInformationRequired(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    checklist(venueId: string, signal?: AbortSignal): Promise<ProfileChecklist[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/checklist";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChecklist(_response));
        });
    }

    protected processChecklist(response: Response): Promise<ProfileChecklist[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileChecklist[]>(null as any);
    }
}

export class ManageVenueEventsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(venueId: string, signal?: AbortSignal): Promise<VenueEventModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/events";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<VenueEventModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueEventModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(VenueEventModel.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueEventModel[]>(null as any);
    }

    add(venueId: string, message: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/events?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    edit(venueId: string, eventId: string, createdTicks: string | undefined, message: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/events/{eventId}?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        if (createdTicks === null)
            throw new Error("The parameter 'createdTicks' cannot be null.");
        else if (createdTicks !== undefined)
            url_ += "createdTicks=" + encodeURIComponent("" + createdTicks) + "&";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEdit(_response));
        });
    }

    protected processEdit(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    delete(venueId: string, eventId: string, created: string | undefined, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/events/{eventId}?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        if (created === null)
            throw new Error("The parameter 'created' cannot be null.");
        else if (created !== undefined)
            url_ += "created=" + encodeURIComponent("" + created) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ManageVenueHooRulesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getExceptionHooRuleList(venueId: string, signal?: AbortSignal): Promise<HooRuleSplitViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/exceptions";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExceptionHooRuleList(_response));
        });
    }

    protected processGetExceptionHooRuleList(response: Response): Promise<HooRuleSplitViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HooRuleSplitViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleSplitViewModel[]>(null as any);
    }

    editExceptionHooRule(venueId: string, model: HooRuleSplitEditViewModel, signal?: AbortSignal): Promise<HooRuleSplitViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/exceptions";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditExceptionHooRule(_response));
        });
    }

    protected processEditExceptionHooRule(response: Response): Promise<HooRuleSplitViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HooRuleSplitViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleSplitViewModel[]>(null as any);
    }

    getExceptionHooRule(venueId: string, hooRuleId: string, signal?: AbortSignal): Promise<HooRuleSplitEditViewModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/exceptions/{hooRuleId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (hooRuleId === undefined || hooRuleId === null)
            throw new Error("The parameter 'hooRuleId' must be defined.");
        url_ = url_.replace("{hooRuleId}", encodeURIComponent("" + hooRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExceptionHooRule(_response));
        });
    }

    protected processGetExceptionHooRule(response: Response): Promise<HooRuleSplitEditViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HooRuleSplitEditViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleSplitEditViewModel>(null as any);
    }

    deleteExceptionHooRule(venueId: string, hooRuleId: string, signal?: AbortSignal): Promise<HooRuleSplitViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/exceptions/{hooRuleId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (hooRuleId === undefined || hooRuleId === null)
            throw new Error("The parameter 'hooRuleId' must be defined.");
        url_ = url_.replace("{hooRuleId}", encodeURIComponent("" + hooRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteExceptionHooRule(_response));
        });
    }

    protected processDeleteExceptionHooRule(response: Response): Promise<HooRuleSplitViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HooRuleSplitViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleSplitViewModel[]>(null as any);
    }

    exceptionHooRuleReorderUp(venueId: string, hooRuleId: string, signal?: AbortSignal): Promise<HooRuleSplitViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/exceptions/{hooRuleId}/reorder-up";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (hooRuleId === undefined || hooRuleId === null)
            throw new Error("The parameter 'hooRuleId' must be defined.");
        url_ = url_.replace("{hooRuleId}", encodeURIComponent("" + hooRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExceptionHooRuleReorderUp(_response));
        });
    }

    protected processExceptionHooRuleReorderUp(response: Response): Promise<HooRuleSplitViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HooRuleSplitViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleSplitViewModel[]>(null as any);
    }

    exceptionHooRuleReorderDown(venueId: string, hooRuleId: string, signal?: AbortSignal): Promise<HooRuleSplitViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/exceptions/{hooRuleId}/reorder-down";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (hooRuleId === undefined || hooRuleId === null)
            throw new Error("The parameter 'hooRuleId' must be defined.");
        url_ = url_.replace("{hooRuleId}", encodeURIComponent("" + hooRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExceptionHooRuleReorderDown(_response));
        });
    }

    protected processExceptionHooRuleReorderDown(response: Response): Promise<HooRuleSplitViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HooRuleSplitViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleSplitViewModel[]>(null as any);
    }

    getBookingWindowHooRuleList(venueId: string, signal?: AbortSignal): Promise<HooRuleForBookingWindowFlexViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/booking-windows";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBookingWindowHooRuleList(_response));
        });
    }

    protected processGetBookingWindowHooRuleList(response: Response): Promise<HooRuleForBookingWindowFlexViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HooRuleForBookingWindowFlexViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleForBookingWindowFlexViewModel[]>(null as any);
    }

    editBookingWindowHooRule(venueId: string, model: HooRuleForBookingWindowFlexEditViewModel, signal?: AbortSignal): Promise<HooRuleForBookingWindowFlexViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/booking-windows";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditBookingWindowHooRule(_response));
        });
    }

    protected processEditBookingWindowHooRule(response: Response): Promise<HooRuleForBookingWindowFlexViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HooRuleForBookingWindowFlexViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleForBookingWindowFlexViewModel[]>(null as any);
    }

    getBookingWindowHooRule(venueId: string, hooRuleId: string, signal?: AbortSignal): Promise<HooRuleForBookingWindowFlexEditViewModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/booking-windows/{hooRuleId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (hooRuleId === undefined || hooRuleId === null)
            throw new Error("The parameter 'hooRuleId' must be defined.");
        url_ = url_.replace("{hooRuleId}", encodeURIComponent("" + hooRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBookingWindowHooRule(_response));
        });
    }

    protected processGetBookingWindowHooRule(response: Response): Promise<HooRuleForBookingWindowFlexEditViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HooRuleForBookingWindowFlexEditViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleForBookingWindowFlexEditViewModel>(null as any);
    }

    deleteBookingWindowHooRule(venueId: string, hooRuleId: string, signal?: AbortSignal): Promise<HooRuleForBookingWindowFlexViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/booking-windows/{hooRuleId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (hooRuleId === undefined || hooRuleId === null)
            throw new Error("The parameter 'hooRuleId' must be defined.");
        url_ = url_.replace("{hooRuleId}", encodeURIComponent("" + hooRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteBookingWindowHooRule(_response));
        });
    }

    protected processDeleteBookingWindowHooRule(response: Response): Promise<HooRuleForBookingWindowFlexViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HooRuleForBookingWindowFlexViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleForBookingWindowFlexViewModel[]>(null as any);
    }

    bookingWindowHooRuleReorderUp(venueId: string, hooRuleId: string, signal?: AbortSignal): Promise<HooRuleForBookingWindowFlexViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/booking-windows/{hooRuleId}/reorder-up";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (hooRuleId === undefined || hooRuleId === null)
            throw new Error("The parameter 'hooRuleId' must be defined.");
        url_ = url_.replace("{hooRuleId}", encodeURIComponent("" + hooRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBookingWindowHooRuleReorderUp(_response));
        });
    }

    protected processBookingWindowHooRuleReorderUp(response: Response): Promise<HooRuleForBookingWindowFlexViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HooRuleForBookingWindowFlexViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleForBookingWindowFlexViewModel[]>(null as any);
    }

    bookingWindowHooRuleReorderDown(venueId: string, hooRuleId: string, signal?: AbortSignal): Promise<HooRuleForBookingWindowFlexViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/guest-hours/booking-windows/{hooRuleId}/reorder-down";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (hooRuleId === undefined || hooRuleId === null)
            throw new Error("The parameter 'hooRuleId' must be defined.");
        url_ = url_.replace("{hooRuleId}", encodeURIComponent("" + hooRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBookingWindowHooRuleReorderDown(_response));
        });
    }

    protected processBookingWindowHooRuleReorderDown(response: Response): Promise<HooRuleForBookingWindowFlexViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HooRuleForBookingWindowFlexViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HooRuleForBookingWindowFlexViewModel[]>(null as any);
    }
}

export class ManageVenueHourlyRequestsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(venueId: string, start: string | null | undefined, end: string | null | undefined, status: HourlyRequestToBookStatus[] | null | undefined, signal?: AbortSignal): Promise<ReservationRequestDetailsModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/hourly-requests?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "status=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<ReservationRequestDetailsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationRequestDetailsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationRequestDetailsModel[]>(null as any);
    }
}

export class ManageVenueIntegrationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    loadOwners(venueId: string, workspaceId: string | null | undefined, signal?: AbortSignal): Promise<OwnerInfoModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/integrations/owners?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadOwners(_response));
        });
    }

    protected processLoadOwners(response: Response): Promise<OwnerInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OwnerInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OwnerInfoModel[]>(null as any);
    }

    loadOwnersForDeskimo(venueId: string, signal?: AbortSignal): Promise<OwnerInfoModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/integrations/owners-deskimo";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadOwnersForDeskimo(_response));
        });
    }

    protected processLoadOwnersForDeskimo(response: Response): Promise<OwnerInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OwnerInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OwnerInfoModel[]>(null as any);
    }

    exchangeConfiguration(venueId: string, signal?: AbortSignal): Promise<ExchangeConfigurationModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/integrations/exchange/configuration";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExchangeConfiguration(_response));
        });
    }

    protected processExchangeConfiguration(response: Response): Promise<ExchangeConfigurationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExchangeConfigurationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExchangeConfigurationModel>(null as any);
    }

    pushToCalendar(venueId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/integrations/push-to-calendar";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPushToCalendar(_response));
        });
    }

    protected processPushToCalendar(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getOfficeRnDWorkspacesSync(venueId: string, signal?: AbortSignal): Promise<OfficeRnDWorkspacesSyncModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/integrations/officernd/workspaces";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOfficeRnDWorkspacesSync(_response));
        });
    }

    protected processGetOfficeRnDWorkspacesSync(response: Response): Promise<OfficeRnDWorkspacesSyncModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficeRnDWorkspacesSyncModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeRnDWorkspacesSyncModel>(null as any);
    }

    submitOfficeRnDWorkspacesSync(venueId: string, requestId: string | null | undefined, model: OfficeRnDWorkspacesSyncSubmitModel, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/integrations/officernd/workspaces?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitOfficeRnDWorkspacesSync(_response));
        });
    }

    protected processSubmitOfficeRnDWorkspacesSync(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ManageVenueLeadsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(venueId: string, dashboardLeadStatuses: DashboardLeadStatus[] | null | undefined, signal?: AbortSignal): Promise<DashboardLeadViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/leads?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (dashboardLeadStatuses !== undefined && dashboardLeadStatuses !== null)
            dashboardLeadStatuses && dashboardLeadStatuses.forEach(item => { url_ += "dashboardLeadStatuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<DashboardLeadViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardLeadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardLeadViewModel[]>(null as any);
    }

    get(venueId: string, workflowId: string, signal?: AbortSignal): Promise<DashboardLeadViewModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/leads/{workflowId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workflowId === undefined || workflowId === null)
            throw new Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DashboardLeadViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardLeadViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardLeadViewModel>(null as any);
    }

    updateToActive(venueId: string, workflowId: string, signal?: AbortSignal): Promise<DashboardLeadViewModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/leads/{workflowId}/update-to-active";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workflowId === undefined || workflowId === null)
            throw new Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateToActive(_response));
        });
    }

    protected processUpdateToActive(response: Response): Promise<DashboardLeadViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardLeadViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardLeadViewModel>(null as any);
    }

    archive(venueId: string, workflowId: string, signal?: AbortSignal): Promise<DashboardLeadViewModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/leads/{workflowId}/archive";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workflowId === undefined || workflowId === null)
            throw new Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchive(_response));
        });
    }

    protected processArchive(response: Response): Promise<DashboardLeadViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardLeadViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardLeadViewModel>(null as any);
    }

    unarchive(venueId: string, workflowId: string, signal?: AbortSignal): Promise<DashboardLeadViewModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/leads/{workflowId}/unarchive";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workflowId === undefined || workflowId === null)
            throw new Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchive(_response));
        });
    }

    protected processUnarchive(response: Response): Promise<DashboardLeadViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardLeadViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardLeadViewModel>(null as any);
    }
}

export class ManageVenueLicensesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    uploadCustomLicensePdfTemplate(venueId: string, customLicensePdfTemplates: FileParameter[] | null | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/licenses/custom";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (customLicensePdfTemplates !== null && customLicensePdfTemplates !== undefined)
            customLicensePdfTemplates.forEach(item_ => content_.append("customLicensePdfTemplates", item_.data, item_.fileName ? item_.fileName : "customLicensePdfTemplates") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadCustomLicensePdfTemplate(_response));
        });
    }

    protected processUploadCustomLicensePdfTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteCustomLicensePdfTemplate(venueId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/licenses/custom";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteCustomLicensePdfTemplate(_response));
        });
    }

    protected processDeleteCustomLicensePdfTemplate(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    validateTemplate(venueId: string, signal?: AbortSignal): Promise<CheckResult> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/licenses/ValidateTemplate";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateTemplate(_response));
        });
    }

    protected processValidateTemplate(response: Response): Promise<CheckResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckResult>(null as any);
    }
}

export class ManageVenueMemberInvitationClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    previewEmail(venueId: string, model: ManageVenueMemberInvitationPreviewEmailViewModel, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/members/invitation/email/render";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreviewEmail(_response));
        });
    }

    protected processPreviewEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ManageVenueMembersClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(venueId: string, signal?: AbortSignal): Promise<VenueMemberModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/members";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<VenueMemberModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueMemberModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResponseWrapper.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueMemberModel[]>(null as any);
    }

    profile(venueId: string, memberId: string, signal?: AbortSignal): Promise<VenueMemberProfileModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/members/{memberId}/profile";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProfile(_response));
        });
    }

    protected processProfile(response: Response): Promise<VenueMemberProfileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueMemberProfileModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueMemberProfileModel>(null as any);
    }

    editProfile(venueId: string, memberId: string, model: VenueMemberProfileModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/members/{memberId}/profile";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditProfile(_response));
        });
    }

    protected processEditProfile(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    deleteProfile(venueId: string, memberId: string, visaId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/members/{memberId}/visas/{visaId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (visaId === undefined || visaId === null)
            throw new Error("The parameter 'visaId' must be defined.");
        url_ = url_.replace("{visaId}", encodeURIComponent("" + visaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteProfile(_response));
        });
    }

    protected processDeleteProfile(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    assignVisaGET(venueId: string, signal?: AbortSignal): Promise<AddMemberToVisaModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/members/assign-visa";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssignVisaGET(_response));
        });
    }

    protected processAssignVisaGET(response: Response): Promise<AddMemberToVisaModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddMemberToVisaModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddMemberToVisaModel>(null as any);
    }

    assignVisaPOST(venueId: string, model: AddMemberToVisaModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/members/assign-visa";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssignVisaPOST(_response));
        });
    }

    protected processAssignVisaPOST(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class ManageVenueMemberVisaStatesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    grant(venueId: string, visaId: string, memberId: string, workspaceId: string | null | undefined, bookingDate: string | null | undefined, workflowId: string | null | undefined, sync: boolean | undefined, chainId: string | null | undefined, message: string | undefined, signal?: AbortSignal): Promise<ChangeVisaStateReponse> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/visas/{visaId}/members/{memberId}/grant?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (visaId === undefined || visaId === null)
            throw new Error("The parameter 'visaId' must be defined.");
        url_ = url_.replace("{visaId}", encodeURIComponent("" + visaId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (bookingDate !== undefined && bookingDate !== null)
            url_ += "bookingDate=" + encodeURIComponent("" + bookingDate) + "&";
        if (workflowId !== undefined && workflowId !== null)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        if (sync === null)
            throw new Error("The parameter 'sync' cannot be null.");
        else if (sync !== undefined)
            url_ += "sync=" + encodeURIComponent("" + sync) + "&";
        if (chainId !== undefined && chainId !== null)
            url_ += "chainId=" + encodeURIComponent("" + chainId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGrant(_response));
        });
    }

    protected processGrant(response: Response): Promise<ChangeVisaStateReponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeVisaStateReponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeVisaStateReponse>(null as any);
    }

    deny(venueId: string, visaId: string, memberId: string, workspaceId: string | null | undefined, workflowId: string | null | undefined, sync: boolean | undefined, chainId: string | null | undefined, reason: DenyVisaReason | undefined, message: string | undefined, signal?: AbortSignal): Promise<ChangeVisaStateReponse> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/visas/{visaId}/members/{memberId}/deny?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (visaId === undefined || visaId === null)
            throw new Error("The parameter 'visaId' must be defined.");
        url_ = url_.replace("{visaId}", encodeURIComponent("" + visaId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (workflowId !== undefined && workflowId !== null)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        if (sync === null)
            throw new Error("The parameter 'sync' cannot be null.");
        else if (sync !== undefined)
            url_ += "sync=" + encodeURIComponent("" + sync) + "&";
        if (chainId !== undefined && chainId !== null)
            url_ += "chainId=" + encodeURIComponent("" + chainId) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeny(_response));
        });
    }

    protected processDeny(response: Response): Promise<ChangeVisaStateReponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeVisaStateReponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeVisaStateReponse>(null as any);
    }
}

export class ManageVenueReservationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(venueId: string, start: string | null | undefined, end: string | null | undefined, signal?: AbortSignal): Promise<VenueReservationViewModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/reservations?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<VenueReservationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueReservationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueReservationViewModel[]>(null as any);
    }
}

export class ManageVenueScoreClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    venueScore(venueId: string, signal?: AbortSignal): Promise<VenueScoreViewModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/score";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVenueScore(_response));
        });
    }

    protected processVenueScore(response: Response): Promise<VenueScoreViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VenueScoreViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueScoreViewModel>(null as any);
    }
}

export class ManageVenueStatementsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(venueId: string, start: string | null | undefined, end: string | null | undefined, signal?: AbortSignal): Promise<VenueStatementSummaryModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/statements?";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<VenueStatementSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VenueStatementSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueStatementSummaryModel[]>(null as any);
    }
}

export class ManageVenueVisasClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(venueId: string, signal?: AbortSignal): Promise<VisaInfoModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/visas";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<VisaInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisaInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VisaInfoModel[]>(null as any);
    }

    upsert(venueId: string, model: VisaModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/visas";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpsert(_response));
        });
    }

    protected processUpsert(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    delete(venueId: string, visaId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/visas/{visaId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (visaId === undefined || visaId === null)
            throw new Error("The parameter 'visaId' must be defined.");
        url_ = url_.replace("{visaId}", encodeURIComponent("" + visaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    visa(venueId: string, visaId: string, signal?: AbortSignal): Promise<VisaModel> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/visas/{visaId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (visaId === undefined || visaId === null)
            throw new Error("The parameter 'visaId' must be defined.");
        url_ = url_.replace("{visaId}", encodeURIComponent("" + visaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVisa(_response));
        });
    }

    protected processVisa(response: Response): Promise<VisaModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VisaModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VisaModel>(null as any);
    }
}

export class ManageVenueWorkspacesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(venueId: string, signal?: AbortSignal): Promise<WorkspaceModel[]> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/spaces";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<WorkspaceModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkspaceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceModel[]>(null as any);
    }

    order(venueId: string, workspacesOrder: { [key: string]: number; }, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/spaces/order";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workspacesOrder);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOrder(_response));
        });
    }

    protected processOrder(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    confirm(venueId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/spaces/confirm";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirm(_response));
        });
    }

    protected processConfirm(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    isBooked(venueId: string, workspaceId: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/spaces/{workspaceId}/is-booked";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsBooked(_response));
        });
    }

    protected processIsBooked(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    delete(venueId: string, workspaceId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/spaces/{workspaceId}";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    duplicate(venueId: string, workspaceId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/venue-management/{venueId}/spaces/{workspaceId}/duplicate";
        if (venueId === undefined || venueId === null)
            throw new Error("The parameter 'venueId' must be defined.");
        url_ = url_.replace("{venueId}", encodeURIComponent("" + venueId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDuplicate(_response));
        });
    }

    protected processDuplicate(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class DeskimoIntegrationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    markets(signal?: AbortSignal): Promise<DeskimoMarketModel[]> {
        let url_ = this.baseUrl + "/api/integrations/deskimo/markets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMarkets(_response));
        });
    }

    protected processMarkets(response: Response): Promise<DeskimoMarketModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeskimoMarketModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeskimoMarketModel[]>(null as any);
    }

    properties(marketCode: string | undefined, signal?: AbortSignal): Promise<DeskimoPropertyModel[]> {
        let url_ = this.baseUrl + "/api/integrations/deskimo/properties?";
        if (marketCode === null)
            throw new Error("The parameter 'marketCode' cannot be null.");
        else if (marketCode !== undefined)
            url_ += "marketCode=" + encodeURIComponent("" + marketCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProperties(_response));
        });
    }

    protected processProperties(response: Response): Promise<DeskimoPropertyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeskimoPropertyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeskimoPropertyModel[]>(null as any);
    }
}

export class EvoIntegrationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    options(evoApiId: string | null | undefined, signal?: AbortSignal): Promise<EvoOptionsModel> {
        let url_ = this.baseUrl + "/api/integrations/evo/options?";
        if (evoApiId !== undefined && evoApiId !== null)
            url_ += "evoApiId=" + encodeURIComponent("" + evoApiId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOptions(_response));
        });
    }

    protected processOptions(response: Response): Promise<EvoOptionsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EvoOptionsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvoOptionsModel>(null as any);
    }
}

export class MicrosoftGraphIntegrationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    callback(venueId: string | undefined, workspaceId: string | null | undefined, accesstoken: string | undefined, signal?: AbortSignal): Promise<MSGraphUserModel> {
        let url_ = this.baseUrl + "/api/integrations/msgraph/callback?";
        if (venueId === null)
            throw new Error("The parameter 'venueId' cannot be null.");
        else if (venueId !== undefined)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (accesstoken === null)
            throw new Error("The parameter 'accesstoken' cannot be null.");
        else if (accesstoken !== undefined)
            url_ += "accesstoken=" + encodeURIComponent("" + accesstoken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCallback(_response));
        });
    }

    protected processCallback(response: Response): Promise<MSGraphUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MSGraphUserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MSGraphUserModel>(null as any);
    }
}

export class MorningstarIntegrationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    validate(venueId: string | undefined, settings: MorningStarSettingsModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/integrations/morningstar/validate?";
        if (venueId === null)
            throw new Error("The parameter 'venueId' cannot be null.");
        else if (venueId !== undefined)
            url_ += "venueId=" + encodeURIComponent("" + venueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidate(_response));
        });
    }

    protected processValidate(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }
}

export class OfficeRnDOrganizationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(signal?: AbortSignal): Promise<OfficeRnDOrganizationListItemModel[]> {
        let url_ = this.baseUrl + "/api/integrations/officernd/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<OfficeRnDOrganizationListItemModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeRnDOrganizationListItemModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeRnDOrganizationListItemModel[]>(null as any);
    }

    add(organizationModel: OfficeRnDOrganizationEditModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/integrations/officernd/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organizationModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    get(organizationId: string, signal?: AbortSignal): Promise<OfficeRnDOrganizationDetailsModel> {
        let url_ = this.baseUrl + "/api/integrations/officernd/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<OfficeRnDOrganizationDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficeRnDOrganizationDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeRnDOrganizationDetailsModel>(null as any);
    }

    patch(organizationId: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/integrations/officernd/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    delete(organizationId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/integrations/officernd/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    savePartnerIntegrationContact(organizationId: string, postConnectToken: string | null | undefined, model: OfficeRnDOrganizationPartnerIntegrationContactEditModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/integrations/officernd/organizations/{organizationId}/partnerintegration/contact?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (postConnectToken !== undefined && postConnectToken !== null)
            url_ += "postConnectToken=" + encodeURIComponent("" + postConnectToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSavePartnerIntegrationContact(_response));
        });
    }

    protected processSavePartnerIntegrationContact(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    deletePartnerIntegration(organizationId: string, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/integrations/officernd/organizations/{organizationId}/partnerintegration";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePartnerIntegration(_response));
        });
    }

    protected processDeletePartnerIntegration(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    offices(organizationId: string, signal?: AbortSignal): Promise<OfficeRndOfficeModel[]> {
        let url_ = this.baseUrl + "/api/integrations/officernd/organizations/{organizationId}/offices";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOffices(_response));
        });
    }

    protected processOffices(response: Response): Promise<OfficeRndOfficeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeRndOfficeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeRndOfficeModel[]>(null as any);
    }

    teams(organizationId: string, signal?: AbortSignal): Promise<OfficeRndTeamModel[]> {
        let url_ = this.baseUrl + "/api/integrations/officernd/organizations/{organizationId}/teams";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTeams(_response));
        });
    }

    protected processTeams(response: Response): Promise<OfficeRndTeamModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeRndTeamModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeRndTeamModel[]>(null as any);
    }

    members(organizationId: string, signal?: AbortSignal): Promise<OfficeRndMemberModel[]> {
        let url_ = this.baseUrl + "/api/integrations/officernd/organizations/{organizationId}/members";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMembers(_response));
        });
    }

    protected processMembers(response: Response): Promise<OfficeRndMemberModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeRndMemberModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeRndMemberModel[]>(null as any);
    }
}

export class RJmetisIntegrationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    options(signal?: AbortSignal): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/integrations/rjmetis/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOptions(_response));
        });
    }

    protected processOptions(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

export class DiagnosticsApplicationConfigurationClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/application-configurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DiagnosticsAuditLogClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    types(signal?: AbortSignal): Promise<DiagnosticsAuditLogType[]> {
        let url_ = this.baseUrl + "/api/diagnostics/auditlog/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTypes(_response));
        });
    }

    protected processTypes(response: Response): Promise<DiagnosticsAuditLogType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosticsAuditLogType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsAuditLogType[]>(null as any);
    }

    search(filter: DiagnosticsAuditLogFilter, signal?: AbortSignal): Promise<AuditLogMessageViewModel[]> {
        let url_ = this.baseUrl + "/api/diagnostics/auditlog/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<AuditLogMessageViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditLogMessageViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditLogMessageViewModel[]>(null as any);
    }
}

export class DiagnosticsConsoleClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getMethods(signal?: AbortSignal): Promise<DiagnosticsConsoleMethod[]> {
        let url_ = this.baseUrl + "/api/diagnostics/console/method";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMethods(_response));
        });
    }

    protected processGetMethods(response: Response): Promise<DiagnosticsConsoleMethod[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosticsConsoleMethod.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsConsoleMethod[]>(null as any);
    }

    executeMethod(methodName: string | undefined, runner: DiagnosticsMethodRunner | undefined, parameters: { [key: string]: string; }, signal?: AbortSignal): Promise<DiagnosticsConsoleRunKey> {
        let url_ = this.baseUrl + "/api/diagnostics/console/method?";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "methodName=" + encodeURIComponent("" + methodName) + "&";
        if (runner === null)
            throw new Error("The parameter 'runner' cannot be null.");
        else if (runner !== undefined)
            url_ += "runner=" + encodeURIComponent("" + runner) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecuteMethod(_response));
        });
    }

    protected processExecuteMethod(response: Response): Promise<DiagnosticsConsoleRunKey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiagnosticsConsoleRunKey.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsConsoleRunKey>(null as any);
    }

    getLog(lastKnownTick: string | null | undefined, taskId: string | null | undefined, takeCount: number | undefined, signal?: AbortSignal): Promise<DiagnosticsConsoleLineViewModel[]> {
        let url_ = this.baseUrl + "/api/diagnostics/console/log?";
        if (lastKnownTick !== undefined && lastKnownTick !== null)
            url_ += "lastKnownTick=" + encodeURIComponent("" + lastKnownTick) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (takeCount === null)
            throw new Error("The parameter 'takeCount' cannot be null.");
        else if (takeCount !== undefined)
            url_ += "takeCount=" + encodeURIComponent("" + takeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLog(_response));
        });
    }

    protected processGetLog(response: Response): Promise<DiagnosticsConsoleLineViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosticsConsoleLineViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsConsoleLineViewModel[]>(null as any);
    }

    clearLog(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/console/log";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClearLog(_response));
        });
    }

    protected processClearLog(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DiagnosticsContentSecurityPolicyClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(signal?: AbortSignal): Promise<ContentSecurityPolicyViewModel> {
        let url_ = this.baseUrl + "/api/diagnostics/csp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ContentSecurityPolicyViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContentSecurityPolicyViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentSecurityPolicyViewModel>(null as any);
    }

    patch(patch: Operation[], signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/csp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DiagnosticsCryptoClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    decrypt(input: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/diagnostics/crypto/decrypt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDecrypt(_response));
        });
    }

    protected processDecrypt(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    encrypt(input: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/diagnostics/crypto/encrypt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEncrypt(_response));
        });
    }

    protected processEncrypt(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class EchoClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/echo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    post(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/echo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DiagnosticsEmailsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    templates(signal?: AbortSignal): Promise<EmailTemplate[]> {
        let url_ = this.baseUrl + "/api/diagnostics/email/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTemplates(_response));
        });
    }

    protected processTemplates(response: Response): Promise<EmailTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailTemplate[]>(null as any);
    }

    model(emailTypeName: string, signal?: AbortSignal): Promise<DiagnosticsEmailModel> {
        let url_ = this.baseUrl + "/api/diagnostics/email/template/{emailTypeName}/model";
        if (emailTypeName === undefined || emailTypeName === null)
            throw new Error("The parameter 'emailTypeName' must be defined.");
        url_ = url_.replace("{emailTypeName}", encodeURIComponent("" + emailTypeName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processModel(_response));
        });
    }

    protected processModel(response: Response): Promise<DiagnosticsEmailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiagnosticsEmailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsEmailModel>(null as any);
    }

    template(emailTypeName: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/diagnostics/email/template/{emailTypeName}";
        if (emailTypeName === undefined || emailTypeName === null)
            throw new Error("The parameter 'emailTypeName' must be defined.");
        url_ = url_.replace("{emailTypeName}", encodeURIComponent("" + emailTypeName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTemplate(_response));
        });
    }

    protected processTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    render(emailTypeName: string, model: any, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/diagnostics/email/template/{emailTypeName}";
        if (emailTypeName === undefined || emailTypeName === null)
            throw new Error("The parameter 'emailTypeName' must be defined.");
        url_ = url_.replace("{emailTypeName}", encodeURIComponent("" + emailTypeName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRender(_response));
        });
    }

    protected processRender(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    send(model: SendTestEmailModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSend(_response));
        });
    }

    protected processSend(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DiagnosticsIntegrationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(signal?: AbortSignal): Promise<DiagnosticsIntegrationListItemModel[]> {
        let url_ = this.baseUrl + "/api/diagnostics/integrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<DiagnosticsIntegrationListItemModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosticsIntegrationListItemModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsIntegrationListItemModel[]>(null as any);
    }
}

export class DiagnosticsLogsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(start: string | undefined, end: string | undefined, messageSubstring: string | null | undefined, levels: DiagnosticsLogLevels | undefined, signal?: AbortSignal): Promise<DiagnosticsLogItem[]> {
        let url_ = this.baseUrl + "/api/diagnostics/log?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (messageSubstring !== undefined && messageSubstring !== null)
            url_ += "messageSubstring=" + encodeURIComponent("" + messageSubstring) + "&";
        if (levels === null)
            throw new Error("The parameter 'levels' cannot be null.");
        else if (levels !== undefined)
            url_ += "levels=" + encodeURIComponent("" + levels) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DiagnosticsLogItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosticsLogItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsLogItem[]>(null as any);
    }

    getConfig(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/diagnostics/log/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfig(_response));
        });
    }

    protected processGetConfig(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    setConfig(config: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/log/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetConfig(_response));
        });
    }

    protected processSetConfig(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PaymentClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getPaymentsCsv(reservationId: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/payment/csv?";
        if (reservationId === null)
            throw new Error("The parameter 'reservationId' cannot be null.");
        else if (reservationId !== undefined)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaymentsCsv(_response));
        });
    }

    protected processGetPaymentsCsv(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DiagnosticsPoisonsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(signal?: AbortSignal): Promise<PoisonMessageViewModel[]> {
        let url_ = this.baseUrl + "/api/diagnostics/poison";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<PoisonMessageViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoisonMessageViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PoisonMessageViewModel[]>(null as any);
    }

    get(envelopeId: string, signal?: AbortSignal): Promise<PoisonMessageDetailsViewModel> {
        let url_ = this.baseUrl + "/api/diagnostics/poison/{envelopeId}";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PoisonMessageDetailsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PoisonMessageDetailsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PoisonMessageDetailsViewModel>(null as any);
    }

    delete(envelopeId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/poison/{envelopeId}";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    restart(envelopeId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/poison/{envelopeId}";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestart(_response));
        });
    }

    protected processRestart(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    raw(envelopeId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/poison/{envelopeId}/raw";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRaw(_response));
        });
    }

    protected processRaw(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DiagnosticsShortUrlClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    search(urlPrefix: string | undefined, signal?: AbortSignal): Promise<DiagnosticsShortUrlViewModel[]> {
        let url_ = this.baseUrl + "/api/diagnostics/shorturl/search?";
        if (urlPrefix === null)
            throw new Error("The parameter 'urlPrefix' cannot be null.");
        else if (urlPrefix !== undefined)
            url_ += "urlPrefix=" + encodeURIComponent("" + urlPrefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<DiagnosticsShortUrlViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosticsShortUrlViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsShortUrlViewModel[]>(null as any);
    }

    get(id: string, signal?: AbortSignal): Promise<DiagnosticsShortUrlViewModel> {
        let url_ = this.baseUrl + "/api/diagnostics/shorturl/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DiagnosticsShortUrlViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiagnosticsShortUrlViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsShortUrlViewModel>(null as any);
    }

    delete(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/diagnostics/shorturl/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    create(model: DiagnosticsShortUrlCreateModel, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/diagnostics/shorturl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DiagnosticsWorkspaceScenariosClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    scenarios(signal?: AbortSignal): Promise<DiagnosticsWorkspaceScenarioViewModel[]> {
        let url_ = this.baseUrl + "/api/diagnostics/workspace-scenarios/api/diagnostics/workspace-scenarios";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processScenarios(_response));
        });
    }

    protected processScenarios(response: Response): Promise<DiagnosticsWorkspaceScenarioViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosticsWorkspaceScenarioViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsWorkspaceScenarioViewModel[]>(null as any);
    }

    spaceTypes(signal?: AbortSignal): Promise<DiagnosticsSpaceTypeViewModel[]> {
        let url_ = this.baseUrl + "/api/diagnostics/workspace-scenarios/api/diagnostics/space-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSpaceTypes(_response));
        });
    }

    protected processSpaceTypes(response: Response): Promise<DiagnosticsSpaceTypeViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosticsSpaceTypeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticsSpaceTypeViewModel[]>(null as any);
    }
}

export class InternationalConfigurationClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(signal?: AbortSignal): Promise<InternationalConfigurationModel[]> {
        let url_ = this.baseUrl + "/api/international/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<InternationalConfigurationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InternationalConfigurationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternationalConfigurationModel[]>(null as any);
    }

    create(model: EditableInternationalConfigurationModel, signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/international/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    getDefault(signal?: AbortSignal): Promise<InternationalConfigurationModel> {
        let url_ = this.baseUrl + "/api/international/configuration/default";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDefault(_response));
        });
    }

    protected processGetDefault(response: Response): Promise<InternationalConfigurationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternationalConfigurationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternationalConfigurationModel>(null as any);
    }

    patch(id: string, patch: Operation[], signal?: AbortSignal): Promise<ResponseWrapper> {
        let url_ = this.baseUrl + "/api/international/configuration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<ResponseWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseWrapper.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWrapper>(null as any);
    }

    delete(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/international/configuration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ResponseWrapper implements IResponseWrapper {
    isResponseWrapper!: boolean;
    success!: boolean;
    errorMessage!: string | undefined;
    validationErrors!: SerializableError | undefined;
    errorCode!: string | undefined;
    detailedDebugException!: string | undefined;

    constructor(data?: IResponseWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.isResponseWrapper = _data["isResponseWrapper"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.validationErrors = _data["validationErrors"] ? SerializableError.fromJS(_data["validationErrors"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
            this.detailedDebugException = _data["detailedDebugException"];
        }
    }

    static fromJS(data: any): ResponseWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isResponseWrapper"] = this.isResponseWrapper;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["validationErrors"] = this.validationErrors ? this.validationErrors.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        data["detailedDebugException"] = this.detailedDebugException;
        return data;
    }
}

export interface IResponseWrapper {
    isResponseWrapper: boolean;
    success: boolean;
    errorMessage: string | undefined;
    validationErrors: SerializableError | undefined;
    errorCode: string | undefined;
    detailedDebugException: string | undefined;
}

export class SerializableError implements ISerializableError {

    [key: string]: any;

    constructor(data?: ISerializableError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): SerializableError {
        data = typeof data === 'object' ? data : {};
        let result = new SerializableError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface ISerializableError {

    [key: string]: any;
}

export abstract class RecaptchaRequestBase implements IRecaptchaRequestBase {
    recaptchaToken!: string;

    constructor(data?: IRecaptchaRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): RecaptchaRequestBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RecaptchaRequestBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface IRecaptchaRequestBase {
    recaptchaToken: string;
}

export class ForgotPasswordRequest extends RecaptchaRequestBase implements IForgotPasswordRequest {
    email!: string;
    enterpriseAccountId!: string | undefined;

    constructor(data?: IForgotPasswordRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"];
            this.enterpriseAccountId = _data["enterpriseAccountId"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["enterpriseAccountId"] = this.enterpriseAccountId;
        super.toJSON(data);
        return data;
    }
}

export interface IForgotPasswordRequest extends IRecaptchaRequestBase {
    email: string;
    enterpriseAccountId: string | undefined;
}

export class ChangePasswordModel implements IChangePasswordModel {
    currentPassword!: string | undefined;
    confirmPassword!: string;
    newPassword!: string;
    skipPasswordValidation!: boolean;

    constructor(data?: IChangePasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.confirmPassword = _data["confirmPassword"];
            this.newPassword = _data["newPassword"];
            this.skipPasswordValidation = _data["skipPasswordValidation"];
        }
    }

    static fromJS(data: any): ChangePasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["confirmPassword"] = this.confirmPassword;
        data["newPassword"] = this.newPassword;
        data["skipPasswordValidation"] = this.skipPasswordValidation;
        return data;
    }
}

export interface IChangePasswordModel {
    currentPassword: string | undefined;
    confirmPassword: string;
    newPassword: string;
    skipPasswordValidation: boolean;
}

export class MemberDataModel implements IMemberDataModel {
    firstName!: string;
    lastName!: string;
    company!: string | undefined;
    title!: string | undefined;
    phoneNumber!: string | undefined;
    postalCode!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    country!: string | undefined;

    constructor(data?: IMemberDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.company = _data["company"];
            this.title = _data["title"];
            this.phoneNumber = _data["phoneNumber"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): MemberDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["company"] = this.company;
        data["title"] = this.title;
        data["phoneNumber"] = this.phoneNumber;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        return data;
    }
}

export interface IMemberDataModel {
    firstName: string;
    lastName: string;
    company: string | undefined;
    title: string | undefined;
    phoneNumber: string | undefined;
    postalCode: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
}

export class MemberNotificationModel implements IMemberNotificationModel {
    type!: MemberNotificationSettingType;
    enabled!: boolean;
    order!: number;
    description!: string;
    subDescription!: string;

    constructor(data?: IMemberNotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.enabled = _data["enabled"];
            this.order = _data["order"];
            this.description = _data["description"];
            this.subDescription = _data["subDescription"];
        }
    }

    static fromJS(data: any): MemberNotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberNotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["enabled"] = this.enabled;
        data["order"] = this.order;
        data["description"] = this.description;
        data["subDescription"] = this.subDescription;
        return data;
    }
}

export interface IMemberNotificationModel {
    type: MemberNotificationSettingType;
    enabled: boolean;
    order: number;
    description: string;
    subDescription: string;
}

/** 0 = SpecialOffersAndEvents 1 = MonthlyNewsLetters 2 = MeetingReminders 3 = TextMessages 4 = SearchAlerts 5 = DemandSignal 6 = ProposalAlerts 7 = LiquidSpaceTutarials 8 = PreferWeeklyOverDaily 9 = ClaimProfile */
export enum MemberNotificationSettingType {
    SpecialOffersAndEvents = 0,
    MonthlyNewsLetters = 1,
    MeetingReminders = 2,
    TextMessages = 3,
    SearchAlerts = 4,
    DemandSignal = 5,
    ProposalAlerts = 6,
    LiquidSpaceTutarials = 7,
    PreferWeeklyOverDaily = 8,
    ClaimProfile = 9,
}

export class ChangeEmailModel implements IChangeEmailModel {
    email!: string;
    confirmationPassword!: string | undefined;
    skipPasswordValidation!: boolean;

    constructor(data?: IChangeEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.confirmationPassword = _data["confirmationPassword"];
            this.skipPasswordValidation = _data["skipPasswordValidation"];
        }
    }

    static fromJS(data: any): ChangeEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["confirmationPassword"] = this.confirmationPassword;
        data["skipPasswordValidation"] = this.skipPasswordValidation;
        return data;
    }
}

export interface IChangeEmailModel {
    email: string;
    confirmationPassword: string | undefined;
    skipPasswordValidation: boolean;
}

export class SsoMemberModel implements ISsoMemberModel {
    ssoId!: string;
    ssoType!: SsoType;

    constructor(data?: ISsoMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.ssoId = _data["ssoId"];
            this.ssoType = _data["ssoType"];
        }
    }

    static fromJS(data: any): SsoMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new SsoMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssoId"] = this.ssoId;
        data["ssoType"] = this.ssoType;
        return data;
    }
}

export interface ISsoMemberModel {
    ssoId: string;
    ssoType: SsoType;
}

/** 0 = LinkedIn 1 = Twitter 2 = Google 3 = SAML 4 = Facebook 5 = Apple 100 = None */
export enum SsoType {
    LinkedIn = 0,
    Twitter = 1,
    Google = 2,
    SAML = 3,
    Facebook = 4,
    Apple = 5,
    None = 100,
}

/** 0 = Visible 1 = Invisible */
export enum SocialVisibility {
    Visible = 0,
    Invisible = 1,
}

export class ApiClientListItemViewModel implements IApiClientListItemViewModel {
    clientId!: string;
    name!: string | undefined;
    enterpriseAccountApiClientsCount!: number;
    isLegacyCompatibility!: boolean;

    constructor(data?: IApiClientListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.enterpriseAccountApiClientsCount = _data["enterpriseAccountApiClientsCount"];
            this.isLegacyCompatibility = _data["isLegacyCompatibility"];
        }
    }

    static fromJS(data: any): ApiClientListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiClientListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["enterpriseAccountApiClientsCount"] = this.enterpriseAccountApiClientsCount;
        data["isLegacyCompatibility"] = this.isLegacyCompatibility;
        return data;
    }
}

export interface IApiClientListItemViewModel {
    clientId: string;
    name: string | undefined;
    enterpriseAccountApiClientsCount: number;
    isLegacyCompatibility: boolean;
}

export class EditableApiClientModel implements IEditableApiClientModel {
    enterpriseAccountIds!: string[];
    clientId!: string;
    clientSecret!: string;
    subscriptionKey!: string | undefined;
    description!: string | undefined;
    name!: string | undefined;
    allowedGrantTypes!: string[];
    allowedScopes!: string[];
    isLegacyCompatibility!: boolean;

    constructor(data?: IEditableApiClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enterpriseAccountIds"])) {
                this.enterpriseAccountIds = [] as any;
                for (let item of _data["enterpriseAccountIds"])
                    this.enterpriseAccountIds!.push(item);
            }
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.subscriptionKey = _data["subscriptionKey"];
            this.description = _data["description"];
            this.name = _data["name"];
            if (Array.isArray(_data["allowedGrantTypes"])) {
                this.allowedGrantTypes = [] as any;
                for (let item of _data["allowedGrantTypes"])
                    this.allowedGrantTypes!.push(item);
            }
            if (Array.isArray(_data["allowedScopes"])) {
                this.allowedScopes = [] as any;
                for (let item of _data["allowedScopes"])
                    this.allowedScopes!.push(item);
            }
            this.isLegacyCompatibility = _data["isLegacyCompatibility"];
        }
    }

    static fromJS(data: any): EditableApiClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditableApiClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enterpriseAccountIds)) {
            data["enterpriseAccountIds"] = [];
            for (let item of this.enterpriseAccountIds)
                data["enterpriseAccountIds"].push(item);
        }
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["subscriptionKey"] = this.subscriptionKey;
        data["description"] = this.description;
        data["name"] = this.name;
        if (Array.isArray(this.allowedGrantTypes)) {
            data["allowedGrantTypes"] = [];
            for (let item of this.allowedGrantTypes)
                data["allowedGrantTypes"].push(item);
        }
        if (Array.isArray(this.allowedScopes)) {
            data["allowedScopes"] = [];
            for (let item of this.allowedScopes)
                data["allowedScopes"].push(item);
        }
        data["isLegacyCompatibility"] = this.isLegacyCompatibility;
        return data;
    }
}

export interface IEditableApiClientModel {
    enterpriseAccountIds: string[];
    clientId: string;
    clientSecret: string;
    subscriptionKey: string | undefined;
    description: string | undefined;
    name: string | undefined;
    allowedGrantTypes: string[];
    allowedScopes: string[];
    isLegacyCompatibility: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class BlogViewModel implements IBlogViewModel {
    link!: string;
    items!: BlogItem[];

    constructor(data?: IBlogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BlogItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BlogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BlogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBlogViewModel {
    link: string;
    items: BlogItem[];
}

export class BlogItem implements IBlogItem {
    title!: string | undefined;
    link!: string | undefined;
    imgSource!: string | undefined;
    date!: string | undefined;
    categories!: string[];
    tags!: string[];
    category!: string | undefined;
    imgAlt!: string | undefined;
    summary!: string | undefined;
    readTime!: string | undefined;

    constructor(data?: IBlogItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.link = _data["link"];
            this.imgSource = _data["imgSource"];
            this.date = _data["date"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.category = _data["category"];
            this.imgAlt = _data["imgAlt"];
            this.summary = _data["summary"];
            this.readTime = _data["readTime"];
        }
    }

    static fromJS(data: any): BlogItem {
        data = typeof data === 'object' ? data : {};
        let result = new BlogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["link"] = this.link;
        data["imgSource"] = this.imgSource;
        data["date"] = this.date;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["category"] = this.category;
        data["imgAlt"] = this.imgAlt;
        data["summary"] = this.summary;
        data["readTime"] = this.readTime;
        return data;
    }
}

export interface IBlogItem {
    title: string | undefined;
    link: string | undefined;
    imgSource: string | undefined;
    date: string | undefined;
    categories: string[];
    tags: string[];
    category: string | undefined;
    imgAlt: string | undefined;
    summary: string | undefined;
    readTime: string | undefined;
}

/** 0 = Homefeature 1 = Perspectives */
export enum BlogTag {
    Homefeature = 0,
    Perspectives = 1,
}

export class BookingPrerequisitesValidationResult implements IBookingPrerequisitesValidationResult {
    isValid!: boolean;
    errors!: BookingPrerequisitesValidationPolicyError[];

    constructor(data?: IBookingPrerequisitesValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(BookingPrerequisitesValidationPolicyError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingPrerequisitesValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new BookingPrerequisitesValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBookingPrerequisitesValidationResult {
    isValid: boolean;
    errors: BookingPrerequisitesValidationPolicyError[];
}

export class BookingPrerequisitesValidationPolicyError implements IBookingPrerequisitesValidationPolicyError {
    message!: string;

    protected _discriminator: string;

    constructor(data?: IBookingPrerequisitesValidationPolicyError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "BookingPrerequisitesValidationPolicyError";
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BookingPrerequisitesValidationPolicyError {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "RequiresApproval") {
            let result = new BookingPrerequisitesValidationPolicyRequiresApprovalError();
            result.init(data);
            return result;
        }
        if (data["type"] === "RequiresLogin") {
            let result = new BookingPrerequisitesValidationPolicyRequiresLoginError();
            result.init(data);
            return result;
        }
        if (data["type"] === "RequiresRequest") {
            let result = new BookingPrerequisitesValidationPolicyRequiresRequestError();
            result.init(data);
            return result;
        }
        let result = new BookingPrerequisitesValidationPolicyError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this._discriminator;
        data["message"] = this.message;
        return data;
    }
}

export interface IBookingPrerequisitesValidationPolicyError {
    message: string;
}

export class BookingPrerequisitesValidationPolicyRequiresApprovalError extends BookingPrerequisitesValidationPolicyError implements IBookingPrerequisitesValidationPolicyRequiresApprovalError {
    agreeToShareViewModel!: AgreeToShareViewModel;

    constructor(data?: IBookingPrerequisitesValidationPolicyRequiresApprovalError) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "RequiresApproval";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agreeToShareViewModel = _data["agreeToShareViewModel"] ? AgreeToShareViewModel.fromJS(_data["agreeToShareViewModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BookingPrerequisitesValidationPolicyRequiresApprovalError {
        data = typeof data === 'object' ? data : {};
        let result = new BookingPrerequisitesValidationPolicyRequiresApprovalError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreeToShareViewModel"] = this.agreeToShareViewModel ? this.agreeToShareViewModel.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBookingPrerequisitesValidationPolicyRequiresApprovalError extends IBookingPrerequisitesValidationPolicyError {
    agreeToShareViewModel: AgreeToShareViewModel;
}

export class AgreeToShareViewModel implements IAgreeToShareViewModel {
    memberId!: string;
    fullName!: string | undefined;
    company!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    freeFormTextForApproval!: string | undefined;
    venueId!: string;

    constructor(data?: IAgreeToShareViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.fullName = _data["fullName"];
            this.company = _data["company"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.freeFormTextForApproval = _data["freeFormTextForApproval"];
            this.venueId = _data["venueId"];
        }
    }

    static fromJS(data: any): AgreeToShareViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgreeToShareViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["fullName"] = this.fullName;
        data["company"] = this.company;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["freeFormTextForApproval"] = this.freeFormTextForApproval;
        data["venueId"] = this.venueId;
        return data;
    }
}

export interface IAgreeToShareViewModel {
    memberId: string;
    fullName: string | undefined;
    company: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    freeFormTextForApproval: string | undefined;
    venueId: string;
}

export class BookingPrerequisitesValidationPolicyRequiresLoginError extends BookingPrerequisitesValidationPolicyError implements IBookingPrerequisitesValidationPolicyRequiresLoginError {

    constructor(data?: IBookingPrerequisitesValidationPolicyRequiresLoginError) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "RequiresLogin";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): BookingPrerequisitesValidationPolicyRequiresLoginError {
        data = typeof data === 'object' ? data : {};
        let result = new BookingPrerequisitesValidationPolicyRequiresLoginError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBookingPrerequisitesValidationPolicyRequiresLoginError extends IBookingPrerequisitesValidationPolicyError {
}

export class BookingPrerequisitesValidationPolicyRequiresRequestError extends BookingPrerequisitesValidationPolicyError implements IBookingPrerequisitesValidationPolicyRequiresRequestError {
    requestType!: WorkspaceRequestType;

    constructor(data?: IBookingPrerequisitesValidationPolicyRequiresRequestError) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "RequiresRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestType = _data["requestType"];
        }
    }

    static fromJS(data: any): BookingPrerequisitesValidationPolicyRequiresRequestError {
        data = typeof data === 'object' ? data : {};
        let result = new BookingPrerequisitesValidationPolicyRequiresRequestError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestType"] = this.requestType;
        super.toJSON(data);
        return data;
    }
}

export interface IBookingPrerequisitesValidationPolicyRequiresRequestError extends IBookingPrerequisitesValidationPolicyError {
    requestType: WorkspaceRequestType;
}

/** 0 = Inquire 1 = Tour 2 = Book */
export enum WorkspaceRequestType {
    Inquire = 0,
    Tour = 1,
    Book = 2,
}

/** Root type for JSON inheritance tree */
export abstract class BookingPrerequisites implements IBookingPrerequisites {

    protected _discriminator: string;

    constructor(data?: IBookingPrerequisites) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "BookingPrerequisites";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BookingPrerequisites {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "NEW") {
            let result = new NewReservationBookingPrerequisites();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "EDIT") {
            let result = new EditReservationBookingPrerequisites();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "BASED") {
            let result = new BasedOnReservationBookingPrerequisites();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BookingPrerequisites' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        return data;
    }
}

/** Root type for JSON inheritance tree */
export interface IBookingPrerequisites {
}

export class NewReservationBookingPrerequisites extends BookingPrerequisites implements INewReservationBookingPrerequisites {
    venueId!: string;
    workspaceId!: string;
    startDate!: string | undefined;
    startTime!: string | undefined;
    durationMinutes!: number | undefined;
    daysAhead!: number | undefined;
    /** Actual member ID to become owner of requested reservation.
Executing member should have booking delegation access for requested OwnerId. */
    ownerId!: string | undefined;
    guestCount!: number | undefined;

    constructor(data?: INewReservationBookingPrerequisites) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "NEW";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.venueId = _data["venueId"];
            this.workspaceId = _data["workspaceId"];
            this.startDate = _data["startDate"];
            this.startTime = _data["startTime"];
            this.durationMinutes = _data["durationMinutes"];
            this.daysAhead = _data["daysAhead"];
            this.ownerId = _data["ownerId"];
            this.guestCount = _data["guestCount"];
        }
    }

    static fromJS(data: any): NewReservationBookingPrerequisites {
        data = typeof data === 'object' ? data : {};
        let result = new NewReservationBookingPrerequisites();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["workspaceId"] = this.workspaceId;
        data["startDate"] = this.startDate;
        data["startTime"] = this.startTime;
        data["durationMinutes"] = this.durationMinutes;
        data["daysAhead"] = this.daysAhead;
        data["ownerId"] = this.ownerId;
        data["guestCount"] = this.guestCount;
        super.toJSON(data);
        return data;
    }
}

export interface INewReservationBookingPrerequisites extends IBookingPrerequisites {
    venueId: string;
    workspaceId: string;
    startDate: string | undefined;
    startTime: string | undefined;
    durationMinutes: number | undefined;
    daysAhead: number | undefined;
    /** Actual member ID to become owner of requested reservation.
Executing member should have booking delegation access for requested OwnerId. */
    ownerId: string | undefined;
    guestCount: number | undefined;
}

export class EditReservationBookingPrerequisites extends BookingPrerequisites implements IEditReservationBookingPrerequisites {
    /** Existing reservation ID to edit */
    reservationId!: string;
    /** Date of a signle reservation occurence from the recurrent reservation */
    occurenceDate!: string | undefined;

    constructor(data?: IEditReservationBookingPrerequisites) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "EDIT";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.occurenceDate = _data["occurenceDate"];
        }
    }

    static fromJS(data: any): EditReservationBookingPrerequisites {
        data = typeof data === 'object' ? data : {};
        let result = new EditReservationBookingPrerequisites();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["occurenceDate"] = this.occurenceDate;
        super.toJSON(data);
        return data;
    }
}

export interface IEditReservationBookingPrerequisites extends IBookingPrerequisites {
    /** Existing reservation ID to edit */
    reservationId: string;
    /** Date of a signle reservation occurence from the recurrent reservation */
    occurenceDate: string | undefined;
}

export class BasedOnReservationBookingPrerequisites extends BookingPrerequisites implements IBasedOnReservationBookingPrerequisites {
    /** Existing reservation ID to be base for new reservation */
    reservationId!: string;

    constructor(data?: IBasedOnReservationBookingPrerequisites) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "BASED";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reservationId = _data["reservationId"];
        }
    }

    static fromJS(data: any): BasedOnReservationBookingPrerequisites {
        data = typeof data === 'object' ? data : {};
        let result = new BasedOnReservationBookingPrerequisites();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        super.toJSON(data);
        return data;
    }
}

export interface IBasedOnReservationBookingPrerequisites extends IBookingPrerequisites {
    /** Existing reservation ID to be base for new reservation */
    reservationId: string;
}

export class BookingRepresenteeViewModel implements IBookingRepresenteeViewModel {
    id!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string;
    fullName!: string;

    constructor(data?: IBookingRepresenteeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): BookingRepresenteeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookingRepresenteeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IBookingRepresenteeViewModel {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string;
    fullName: string;
}

export class WorkspaceAvailabilityCheckViewModel implements IWorkspaceAvailabilityCheckViewModel {
    venueId!: string;
    workspaceId!: string;
    startTime!: string;
    endTime!: string;
    desksCount!: number | undefined;
    editReservationId!: string | undefined;

    constructor(data?: IWorkspaceAvailabilityCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.workspaceId = _data["workspaceId"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.desksCount = _data["desksCount"];
            this.editReservationId = _data["editReservationId"];
        }
    }

    static fromJS(data: any): WorkspaceAvailabilityCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceAvailabilityCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["workspaceId"] = this.workspaceId;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["desksCount"] = this.desksCount;
        data["editReservationId"] = this.editReservationId;
        return data;
    }
}

export interface IWorkspaceAvailabilityCheckViewModel {
    venueId: string;
    workspaceId: string;
    startTime: string;
    endTime: string;
    desksCount: number | undefined;
    editReservationId: string | undefined;
}

export class FavoriteCollectionViewModel implements IFavoriteCollectionViewModel {
    id!: string;
    name!: string;
    numberOfSpaces!: number;
    order!: number;
    images!: string[];
    collectionType!: CollectionType;
    collaborators!: CollaboratorViewModel[];
    url!: string;

    constructor(data?: IFavoriteCollectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numberOfSpaces = _data["numberOfSpaces"];
            this.order = _data["order"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.collectionType = _data["collectionType"];
            if (Array.isArray(_data["collaborators"])) {
                this.collaborators = [] as any;
                for (let item of _data["collaborators"])
                    this.collaborators!.push(CollaboratorViewModel.fromJS(item));
            }
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): FavoriteCollectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteCollectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numberOfSpaces"] = this.numberOfSpaces;
        data["order"] = this.order;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["collectionType"] = this.collectionType;
        if (Array.isArray(this.collaborators)) {
            data["collaborators"] = [];
            for (let item of this.collaborators)
                data["collaborators"].push(item.toJSON());
        }
        data["url"] = this.url;
        return data;
    }
}

export interface IFavoriteCollectionViewModel {
    id: string;
    name: string;
    numberOfSpaces: number;
    order: number;
    images: string[];
    collectionType: CollectionType;
    collaborators: CollaboratorViewModel[];
    url: string;
}

/** 0 = None 1 = Regular 2 = Shared */
export enum CollectionType {
    None = 0,
    Regular = 1,
    Shared = 2,
}

export class CollaboratorViewModel implements ICollaboratorViewModel {
    id!: string;
    fullName!: string;
    initials!: string;
    firstName!: string | undefined;
    email!: string;
    pictureURL!: string | undefined;

    constructor(data?: ICollaboratorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.initials = _data["initials"];
            this.firstName = _data["firstName"];
            this.email = _data["email"];
            this.pictureURL = _data["pictureURL"];
        }
    }

    static fromJS(data: any): CollaboratorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CollaboratorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["initials"] = this.initials;
        data["firstName"] = this.firstName;
        data["email"] = this.email;
        data["pictureURL"] = this.pictureURL;
        return data;
    }
}

export interface ICollaboratorViewModel {
    id: string;
    fullName: string;
    initials: string;
    firstName: string | undefined;
    email: string;
    pictureURL: string | undefined;
}

export class VenueSearchResult implements IVenueSearchResult {
    venueId!: string;
    latitude!: number | undefined;
    longitude!: number | undefined;
    name!: string | undefined;
    address!: string | undefined;
    minPrice!: number;
    minPriceFormatted!: string | undefined;
    imageUrl!: string | undefined;
    imageUrls!: string[];
    workspaceTypesFormatted!: string[];
    url!: string | undefined;
    averageRating!: number;
    ratingCount!: number;
    hasHealthAndSafetyPolicy!: boolean;
    hasLiquidspacePro!: boolean;
    enterpriseHeadquarter!: boolean;
    enterprisePreferredLocation!: boolean;
    isExtendedNetwork!: boolean;
    workspaceSearchResults!: WorkspaceSearchResult[];
    defaultBookingMethod!: BookingMethod;
    defaultBookingMethodHourly!: BookingMethod;

    constructor(data?: IVenueSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.minPrice = _data["minPrice"];
            this.minPriceFormatted = _data["minPriceFormatted"];
            this.imageUrl = _data["imageUrl"];
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls!.push(item);
            }
            if (Array.isArray(_data["workspaceTypesFormatted"])) {
                this.workspaceTypesFormatted = [] as any;
                for (let item of _data["workspaceTypesFormatted"])
                    this.workspaceTypesFormatted!.push(item);
            }
            this.url = _data["url"];
            this.averageRating = _data["averageRating"];
            this.ratingCount = _data["ratingCount"];
            this.hasHealthAndSafetyPolicy = _data["hasHealthAndSafetyPolicy"];
            this.hasLiquidspacePro = _data["hasLiquidspacePro"];
            this.enterpriseHeadquarter = _data["enterpriseHeadquarter"];
            this.enterprisePreferredLocation = _data["enterprisePreferredLocation"];
            this.isExtendedNetwork = _data["isExtendedNetwork"];
            if (Array.isArray(_data["workspaceSearchResults"])) {
                this.workspaceSearchResults = [] as any;
                for (let item of _data["workspaceSearchResults"])
                    this.workspaceSearchResults!.push(WorkspaceSearchResult.fromJS(item));
            }
            this.defaultBookingMethod = _data["defaultBookingMethod"];
            this.defaultBookingMethodHourly = _data["defaultBookingMethodHourly"];
        }
    }

    static fromJS(data: any): VenueSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new VenueSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["name"] = this.name;
        data["address"] = this.address;
        data["minPrice"] = this.minPrice;
        data["minPriceFormatted"] = this.minPriceFormatted;
        data["imageUrl"] = this.imageUrl;
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        if (Array.isArray(this.workspaceTypesFormatted)) {
            data["workspaceTypesFormatted"] = [];
            for (let item of this.workspaceTypesFormatted)
                data["workspaceTypesFormatted"].push(item);
        }
        data["url"] = this.url;
        data["averageRating"] = this.averageRating;
        data["ratingCount"] = this.ratingCount;
        data["hasHealthAndSafetyPolicy"] = this.hasHealthAndSafetyPolicy;
        data["hasLiquidspacePro"] = this.hasLiquidspacePro;
        data["enterpriseHeadquarter"] = this.enterpriseHeadquarter;
        data["enterprisePreferredLocation"] = this.enterprisePreferredLocation;
        data["isExtendedNetwork"] = this.isExtendedNetwork;
        if (Array.isArray(this.workspaceSearchResults)) {
            data["workspaceSearchResults"] = [];
            for (let item of this.workspaceSearchResults)
                data["workspaceSearchResults"].push(item.toJSON());
        }
        data["defaultBookingMethod"] = this.defaultBookingMethod;
        data["defaultBookingMethodHourly"] = this.defaultBookingMethodHourly;
        return data;
    }
}

export interface IVenueSearchResult {
    venueId: string;
    latitude: number | undefined;
    longitude: number | undefined;
    name: string | undefined;
    address: string | undefined;
    minPrice: number;
    minPriceFormatted: string | undefined;
    imageUrl: string | undefined;
    imageUrls: string[];
    workspaceTypesFormatted: string[];
    url: string | undefined;
    averageRating: number;
    ratingCount: number;
    hasHealthAndSafetyPolicy: boolean;
    hasLiquidspacePro: boolean;
    enterpriseHeadquarter: boolean;
    enterprisePreferredLocation: boolean;
    isExtendedNetwork: boolean;
    workspaceSearchResults: WorkspaceSearchResult[];
    defaultBookingMethod: BookingMethod;
    defaultBookingMethodHourly: BookingMethod;
}

export class WorkspaceSearchResult implements IWorkspaceSearchResult {
    id!: string;
    name!: string | undefined;
    imgUrl!: string | undefined;
    url!: string | undefined;
    price!: number;
    priceAmount!: string | undefined;
    priceDescription!: string | undefined;
    spaceType!: SpaceType;
    spaceTypeFormatted!: string | undefined;
    capacity!: number;
    searchScoreHint!: number | undefined;
    averageRating!: number | undefined;

    constructor(data?: IWorkspaceSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imgUrl = _data["imgUrl"];
            this.url = _data["url"];
            this.price = _data["price"];
            this.priceAmount = _data["priceAmount"];
            this.priceDescription = _data["priceDescription"];
            this.spaceType = _data["spaceType"];
            this.spaceTypeFormatted = _data["spaceTypeFormatted"];
            this.capacity = _data["capacity"];
            this.searchScoreHint = _data["searchScoreHint"];
            this.averageRating = _data["averageRating"];
        }
    }

    static fromJS(data: any): WorkspaceSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imgUrl"] = this.imgUrl;
        data["url"] = this.url;
        data["price"] = this.price;
        data["priceAmount"] = this.priceAmount;
        data["priceDescription"] = this.priceDescription;
        data["spaceType"] = this.spaceType;
        data["spaceTypeFormatted"] = this.spaceTypeFormatted;
        data["capacity"] = this.capacity;
        data["searchScoreHint"] = this.searchScoreHint;
        data["averageRating"] = this.averageRating;
        return data;
    }
}

export interface IWorkspaceSearchResult {
    id: string;
    name: string | undefined;
    imgUrl: string | undefined;
    url: string | undefined;
    price: number;
    priceAmount: string | undefined;
    priceDescription: string | undefined;
    spaceType: SpaceType;
    spaceTypeFormatted: string | undefined;
    capacity: number;
    searchScoreHint: number | undefined;
    averageRating: number | undefined;
}

/** 0 = Any 1 = Meeting 2 = Office 4 = Desk 8 = Training 16 = TeamSpace 32 = PrivateOffice 64 = EventSpace 128 = OpenDesk 256 = DedicatedDesk 512 = Membership */
export enum SpaceType {
    Any = 0,
    Meeting = 1,
    Office = 2,
    Desk = 4,
    Training = 8,
    TeamSpace = 16,
    PrivateOffice = 32,
    EventSpace = 64,
    OpenDesk = 128,
    DedicatedDesk = 256,
    Membership = 512,
}

/** 0 = NotAvailable 1 = InquireNow 2 = BookItNow 3 = RequestToBook */
export enum BookingMethod {
    NotAvailable = 0,
    InquireNow = 1,
    BookItNow = 2,
    RequestToBook = 3,
}

export class FavoriteCollectionWorkspacesViewModel implements IFavoriteCollectionWorkspacesViewModel {
    collection!: FavoriteCollectionViewModel;
    workspaces!: FavoriteWorkspaceViewModel[];

    constructor(data?: IFavoriteCollectionWorkspacesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.collection = _data["collection"] ? FavoriteCollectionViewModel.fromJS(_data["collection"]) : <any>undefined;
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(FavoriteWorkspaceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FavoriteCollectionWorkspacesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteCollectionWorkspacesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collection"] = this.collection ? this.collection.toJSON() : <any>undefined;
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFavoriteCollectionWorkspacesViewModel {
    collection: FavoriteCollectionViewModel;
    workspaces: FavoriteWorkspaceViewModel[];
}

export class FavoriteWorkspaceViewModel implements IFavoriteWorkspaceViewModel {
    order!: number;
    image!: string;
    priceAmount!: string;
    priceDescription!: string;
    address!: string;
    hasHealthAndSafetyPolicy!: boolean;
    liquidspacePro!: boolean;
    capacityFilterWithScenario!: string;
    nRatings!: number;
    averageRating!: number;
    status!: WorkspaceStatus;
    name!: string;
    id!: string;
    venueId!: string;
    url!: string;
    bookingMethod!: BookingMethod;
    reservationMethod!: WorkspaceReservationMethod;

    constructor(data?: IFavoriteWorkspaceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.image = _data["image"];
            this.priceAmount = _data["priceAmount"];
            this.priceDescription = _data["priceDescription"];
            this.address = _data["address"];
            this.hasHealthAndSafetyPolicy = _data["hasHealthAndSafetyPolicy"];
            this.liquidspacePro = _data["liquidspacePro"];
            this.capacityFilterWithScenario = _data["capacityFilterWithScenario"];
            this.nRatings = _data["nRatings"];
            this.averageRating = _data["averageRating"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.id = _data["id"];
            this.venueId = _data["venueId"];
            this.url = _data["url"];
            this.bookingMethod = _data["bookingMethod"];
            this.reservationMethod = _data["reservationMethod"];
        }
    }

    static fromJS(data: any): FavoriteWorkspaceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteWorkspaceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["image"] = this.image;
        data["priceAmount"] = this.priceAmount;
        data["priceDescription"] = this.priceDescription;
        data["address"] = this.address;
        data["hasHealthAndSafetyPolicy"] = this.hasHealthAndSafetyPolicy;
        data["liquidspacePro"] = this.liquidspacePro;
        data["capacityFilterWithScenario"] = this.capacityFilterWithScenario;
        data["nRatings"] = this.nRatings;
        data["averageRating"] = this.averageRating;
        data["status"] = this.status;
        data["name"] = this.name;
        data["id"] = this.id;
        data["venueId"] = this.venueId;
        data["url"] = this.url;
        data["bookingMethod"] = this.bookingMethod;
        data["reservationMethod"] = this.reservationMethod;
        return data;
    }
}

export interface IFavoriteWorkspaceViewModel {
    order: number;
    image: string;
    priceAmount: string;
    priceDescription: string;
    address: string;
    hasHealthAndSafetyPolicy: boolean;
    liquidspacePro: boolean;
    capacityFilterWithScenario: string;
    nRatings: number;
    averageRating: number;
    status: WorkspaceStatus;
    name: string;
    id: string;
    venueId: string;
    url: string;
    bookingMethod: BookingMethod;
    reservationMethod: WorkspaceReservationMethod;
}

/** 0 = Unknown 1 = Hidden 2 = Private 3 = Public */
export enum WorkspaceStatus {
    Unknown = 0,
    Hidden = 1,
    Private = 2,
    Public = 3,
}

/** 0 = SpecificTimePeriod 1 = DayPass 2 = Period */
export enum WorkspaceReservationMethod {
    SpecificTimePeriod = 0,
    DayPass = 1,
    Period = 2,
}

export class ShareCollectionModel implements IShareCollectionModel {
    collectionId!: string;
    collectionOwnerId!: string;
    collectionUrl!: string;
    brokerId!: string | undefined;
    bmgId!: string | undefined;
    shareModel!: ShareModel;

    constructor(data?: IShareCollectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.collectionId = _data["collectionId"];
            this.collectionOwnerId = _data["collectionOwnerId"];
            this.collectionUrl = _data["collectionUrl"];
            this.brokerId = _data["brokerId"];
            this.bmgId = _data["bmgId"];
            this.shareModel = _data["shareModel"] ? ShareModel.fromJS(_data["shareModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShareCollectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareCollectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionId"] = this.collectionId;
        data["collectionOwnerId"] = this.collectionOwnerId;
        data["collectionUrl"] = this.collectionUrl;
        data["brokerId"] = this.brokerId;
        data["bmgId"] = this.bmgId;
        data["shareModel"] = this.shareModel ? this.shareModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IShareCollectionModel {
    collectionId: string;
    collectionOwnerId: string;
    collectionUrl: string;
    brokerId: string | undefined;
    bmgId: string | undefined;
    shareModel: ShareModel;
}

export class ShareModel implements IShareModel {
    facebookShareUrl!: string;
    twitterShareUrl!: string;
    linkedInShareUrl!: string;

    constructor(data?: IShareModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.facebookShareUrl = _data["facebookShareUrl"];
            this.twitterShareUrl = _data["twitterShareUrl"];
            this.linkedInShareUrl = _data["linkedInShareUrl"];
        }
    }

    static fromJS(data: any): ShareModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebookShareUrl"] = this.facebookShareUrl;
        data["twitterShareUrl"] = this.twitterShareUrl;
        data["linkedInShareUrl"] = this.linkedInShareUrl;
        return data;
    }
}

export interface IShareModel {
    facebookShareUrl: string;
    twitterShareUrl: string;
    linkedInShareUrl: string;
}

export class ConciergeRequestViewModel implements IConciergeRequestViewModel {
    venueId!: string;
    spaceTypes!: SpaceType;
    reservationMethod!: WorkspaceReservationMethod;
    phoneNumber!: string | undefined;
    company!: string | undefined;
    email!: string | undefined;
    fullName!: string | undefined;
    searchFilter!: WorkspaceFilterViewModel | undefined;

    constructor(data?: IConciergeRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.spaceTypes = _data["spaceTypes"];
            this.reservationMethod = _data["reservationMethod"];
            this.phoneNumber = _data["phoneNumber"];
            this.company = _data["company"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.searchFilter = _data["searchFilter"] ? WorkspaceFilterViewModel.fromJS(_data["searchFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConciergeRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConciergeRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["spaceTypes"] = this.spaceTypes;
        data["reservationMethod"] = this.reservationMethod;
        data["phoneNumber"] = this.phoneNumber;
        data["company"] = this.company;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConciergeRequestViewModel {
    venueId: string;
    spaceTypes: SpaceType;
    reservationMethod: WorkspaceReservationMethod;
    phoneNumber: string | undefined;
    company: string | undefined;
    email: string | undefined;
    fullName: string | undefined;
    searchFilter: WorkspaceFilterViewModel | undefined;
}

export class WorkspaceFilterViewModel implements IWorkspaceFilterViewModel {
    reservationLengthMinutes!: number | undefined;
    startTime!: string | undefined;
    reservationStart!: string | undefined;
    amenities!: string | undefined;
    workspaceCapacity!: number | undefined;
    spaceTypes!: SpaceType;
    reservationMethod!: WorkspaceReservationMethod | undefined;

    constructor(data?: IWorkspaceFilterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.reservationLengthMinutes = _data["reservationLengthMinutes"];
            this.startTime = _data["startTime"];
            this.reservationStart = _data["reservationStart"];
            this.amenities = _data["amenities"];
            this.workspaceCapacity = _data["workspaceCapacity"];
            this.spaceTypes = _data["spaceTypes"];
            this.reservationMethod = _data["reservationMethod"];
        }
    }

    static fromJS(data: any): WorkspaceFilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceFilterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationLengthMinutes"] = this.reservationLengthMinutes;
        data["startTime"] = this.startTime;
        data["reservationStart"] = this.reservationStart;
        data["amenities"] = this.amenities;
        data["workspaceCapacity"] = this.workspaceCapacity;
        data["spaceTypes"] = this.spaceTypes;
        data["reservationMethod"] = this.reservationMethod;
        return data;
    }
}

export interface IWorkspaceFilterViewModel {
    reservationLengthMinutes: number | undefined;
    startTime: string | undefined;
    reservationStart: string | undefined;
    amenities: string | undefined;
    workspaceCapacity: number | undefined;
    spaceTypes: SpaceType;
    reservationMethod: WorkspaceReservationMethod | undefined;
}

export class ClassesAndEnumsToConvert implements IClassesAndEnumsToConvert {
    workspaceRequestType!: WorkspaceRequestType;
    workspaceReqEnterpriseAccountMembersImportModeuestType!: EnterpriseAccountMembersImportMode;

    constructor(data?: IClassesAndEnumsToConvert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.workspaceRequestType = _data["workspaceRequestType"];
            this.workspaceReqEnterpriseAccountMembersImportModeuestType = _data["workspaceReqEnterpriseAccountMembersImportModeuestType"];
        }
    }

    static fromJS(data: any): ClassesAndEnumsToConvert {
        data = typeof data === 'object' ? data : {};
        let result = new ClassesAndEnumsToConvert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceRequestType"] = this.workspaceRequestType;
        data["workspaceReqEnterpriseAccountMembersImportModeuestType"] = this.workspaceReqEnterpriseAccountMembersImportModeuestType;
        return data;
    }
}

export interface IClassesAndEnumsToConvert {
    workspaceRequestType: WorkspaceRequestType;
    workspaceReqEnterpriseAccountMembersImportModeuestType: EnterpriseAccountMembersImportMode;
}

/** 0 = AddNew 1 = Remove 2 = Update 3 = Suspend */
export enum EnterpriseAccountMembersImportMode {
    AddNew = 0,
    Remove = 1,
    Update = 2,
    Suspend = 3,
}

export class MarketingStats implements IMarketingStats {
    teamsAndProfessionals!: number;
    verifiedVenuePartners!: number;
    millionTransactions!: number;
    citiesCounting!: number;
    workspacesCount!: number;

    constructor(data?: IMarketingStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.teamsAndProfessionals = _data["teamsAndProfessionals"];
            this.verifiedVenuePartners = _data["verifiedVenuePartners"];
            this.millionTransactions = _data["millionTransactions"];
            this.citiesCounting = _data["citiesCounting"];
            this.workspacesCount = _data["workspacesCount"];
        }
    }

    static fromJS(data: any): MarketingStats {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamsAndProfessionals"] = this.teamsAndProfessionals;
        data["verifiedVenuePartners"] = this.verifiedVenuePartners;
        data["millionTransactions"] = this.millionTransactions;
        data["citiesCounting"] = this.citiesCounting;
        data["workspacesCount"] = this.workspacesCount;
        return data;
    }
}

export interface IMarketingStats {
    teamsAndProfessionals: number;
    verifiedVenuePartners: number;
    millionTransactions: number;
    citiesCounting: number;
    workspacesCount: number;
}

export class ConnectionInfo implements IConnectionInfo {
    targetId!: string;
    connectionMode!: ConnectionMode;

    constructor(data?: IConnectionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.targetId = _data["targetId"];
            this.connectionMode = _data["connectionMode"];
        }
    }

    static fromJS(data: any): ConnectionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetId"] = this.targetId;
        data["connectionMode"] = this.connectionMode;
        return data;
    }
}

export interface IConnectionInfo {
    targetId: string;
    connectionMode: ConnectionMode;
}

/** 0 = Following 1 = Followed */
export enum ConnectionMode {
    Following = 0,
    Followed = 1,
}

/** 1 = Following 2 = Followed 4 = Pending 8 = Approved 255 = All */
export enum ConnectionKind {
    Following = 1,
    Followed = 2,
    Pending = 4,
    Approved = 8,
    All = 255,
}

export class CostDetailsViewModel implements ICostDetailsViewModel {
    /** Does pricing schema has zeroed prices? */
    isFreePricingSchema!: boolean;
    currency!: CurrencyType;
    subtotal!: number;
    salesPrice!: number;
    salesTax!: number;
    totalPrice!: number;
    amountDue!: number;
    credit!: number | undefined;
    duration!: string;
    pricingComponents!: string[];
    budgetLimit!: BudgetLimitModel | undefined;

    protected _discriminator: string;

    constructor(data?: ICostDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "CostDetailsViewModel";
    }

    init(_data?: any) {
        if (_data) {
            this.isFreePricingSchema = _data["isFreePricingSchema"];
            this.currency = _data["currency"];
            this.subtotal = _data["subtotal"];
            this.salesPrice = _data["salesPrice"];
            this.salesTax = _data["salesTax"];
            this.totalPrice = _data["totalPrice"];
            this.amountDue = _data["amountDue"];
            this.credit = _data["credit"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["pricingComponents"])) {
                this.pricingComponents = [] as any;
                for (let item of _data["pricingComponents"])
                    this.pricingComponents!.push(item);
            }
            this.budgetLimit = _data["budgetLimit"] ? BudgetLimitModel.fromJS(_data["budgetLimit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CostDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "HourlyCostDetailsViewModel") {
            let result = new HourlyCostDetailsViewModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MonthlyCostDetailsViewModel") {
            let result = new MonthlyCostDetailsViewModel();
            result.init(data);
            return result;
        }
        let result = new CostDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["isFreePricingSchema"] = this.isFreePricingSchema;
        data["currency"] = this.currency;
        data["subtotal"] = this.subtotal;
        data["salesPrice"] = this.salesPrice;
        data["salesTax"] = this.salesTax;
        data["totalPrice"] = this.totalPrice;
        data["amountDue"] = this.amountDue;
        data["credit"] = this.credit;
        data["duration"] = this.duration;
        if (Array.isArray(this.pricingComponents)) {
            data["pricingComponents"] = [];
            for (let item of this.pricingComponents)
                data["pricingComponents"].push(item);
        }
        data["budgetLimit"] = this.budgetLimit ? this.budgetLimit.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICostDetailsViewModel {
    /** Does pricing schema has zeroed prices? */
    isFreePricingSchema: boolean;
    currency: CurrencyType;
    subtotal: number;
    salesPrice: number;
    salesTax: number;
    totalPrice: number;
    amountDue: number;
    credit: number | undefined;
    duration: string;
    pricingComponents: string[];
    budgetLimit: BudgetLimitModel | undefined;
}

/** 0 = USD 1 = AUD 2 = CAD 3 = UK 3 = GBP 4 = AED 5 = AFN 6 = ALL 7 = AMD 8 = ANG 9 = AOA 10 = ARS 11 = AWG 12 = AZN 13 = BAM 14 = BBD 15 = BDT 16 = BGN 17 = BHD 18 = BIF 19 = BMD 20 = BND 21 = BOB 22 = BRL 23 = BSD 24 = BTN 25 = BWP 26 = BYN 27 = BZD 28 = CDF 29 = CHF 30 = CLP 31 = CNY 32 = COP 33 = CRC 35 = CUP 36 = CVE 37 = CZK 38 = DJF 39 = DKK 40 = DOP 41 = DZD 42 = EGP 43 = ERN 44 = ETB 45 = EUR 46 = FJD 47 = FKP 48 = GEL 50 = GHS 51 = GIP 52 = GMD 53 = GNF 54 = GTQ 55 = GYD 56 = HKD 57 = HNL 58 = HRK 59 = HTG 60 = HUF 61 = IDR 62 = ILS 64 = INR 65 = IQD 66 = IRR 67 = ISK 69 = JMD 70 = JOD 71 = JPY 72 = KES 73 = KGS 74 = KHR 75 = KMF 76 = KPW 77 = KRW 78 = KWD 79 = KYD 80 = KZT 81 = LAK 82 = LBP 83 = LKR 84 = LRD 86 = LYD 87 = MAD 88 = MDL 89 = MGA 90 = MKD 91 = MMK 92 = MNT 93 = MOP 94 = MRU 95 = MUR 96 = MVR 97 = MWK 98 = MXN 99 = MYR 100 = MZN 101 = NAD 102 = NGN 103 = NIO 104 = NOK 105 = NPR 106 = NZD 107 = OMR 108 = PAB 109 = PEN 110 = PGK 111 = PHP 112 = PKR 113 = PLN 114 = PYG 115 = QAR 116 = RON 117 = RSD 118 = RUB 119 = RWF 120 = SAR 121 = SBD 122 = SCR 123 = SDG 124 = SEK 125 = SGD 126 = SHP 127 = SLL 128 = SOS 130 = SRD 131 = STN 133 = SYP 134 = SZL 135 = THB 136 = TJS 137 = TMT 138 = TND 139 = TOP 140 = TRY 141 = TTD 143 = TWD 144 = TZS 145 = UAH 146 = UGX 147 = UYU 148 = UZS 150 = VND 151 = VUV 152 = WST 153 = XAF 154 = XCD 156 = XOF 157 = XPF 158 = YER 159 = ZAR 160 = ZMW 162 = SSP 163 = VES */
export enum CurrencyType {
    USD = 0,
    AUD = 1,
    CAD = 2,
    UK = 3,
    GBP = 3,
    AED = 4,
    AFN = 5,
    ALL = 6,
    AMD = 7,
    ANG = 8,
    AOA = 9,
    ARS = 10,
    AWG = 11,
    AZN = 12,
    BAM = 13,
    BBD = 14,
    BDT = 15,
    BGN = 16,
    BHD = 17,
    BIF = 18,
    BMD = 19,
    BND = 20,
    BOB = 21,
    BRL = 22,
    BSD = 23,
    BTN = 24,
    BWP = 25,
    BYN = 26,
    BZD = 27,
    CDF = 28,
    CHF = 29,
    CLP = 30,
    CNY = 31,
    COP = 32,
    CRC = 33,
    CUP = 35,
    CVE = 36,
    CZK = 37,
    DJF = 38,
    DKK = 39,
    DOP = 40,
    DZD = 41,
    EGP = 42,
    ERN = 43,
    ETB = 44,
    EUR = 45,
    FJD = 46,
    FKP = 47,
    GEL = 48,
    GHS = 50,
    GIP = 51,
    GMD = 52,
    GNF = 53,
    GTQ = 54,
    GYD = 55,
    HKD = 56,
    HNL = 57,
    HRK = 58,
    HTG = 59,
    HUF = 60,
    IDR = 61,
    ILS = 62,
    INR = 64,
    IQD = 65,
    IRR = 66,
    ISK = 67,
    JMD = 69,
    JOD = 70,
    JPY = 71,
    KES = 72,
    KGS = 73,
    KHR = 74,
    KMF = 75,
    KPW = 76,
    KRW = 77,
    KWD = 78,
    KYD = 79,
    KZT = 80,
    LAK = 81,
    LBP = 82,
    LKR = 83,
    LRD = 84,
    LYD = 86,
    MAD = 87,
    MDL = 88,
    MGA = 89,
    MKD = 90,
    MMK = 91,
    MNT = 92,
    MOP = 93,
    MRU = 94,
    MUR = 95,
    MVR = 96,
    MWK = 97,
    MXN = 98,
    MYR = 99,
    MZN = 100,
    NAD = 101,
    NGN = 102,
    NIO = 103,
    NOK = 104,
    NPR = 105,
    NZD = 106,
    OMR = 107,
    PAB = 108,
    PEN = 109,
    PGK = 110,
    PHP = 111,
    PKR = 112,
    PLN = 113,
    PYG = 114,
    QAR = 115,
    RON = 116,
    RSD = 117,
    RUB = 118,
    RWF = 119,
    SAR = 120,
    SBD = 121,
    SCR = 122,
    SDG = 123,
    SEK = 124,
    SGD = 125,
    SHP = 126,
    SLL = 127,
    SOS = 128,
    SRD = 130,
    STN = 131,
    SYP = 133,
    SZL = 134,
    THB = 135,
    TJS = 136,
    TMT = 137,
    TND = 138,
    TOP = 139,
    TRY = 140,
    TTD = 141,
    TWD = 143,
    TZS = 144,
    UAH = 145,
    UGX = 146,
    UYU = 147,
    UZS = 148,
    VND = 150,
    VUV = 151,
    WST = 152,
    XAF = 153,
    XCD = 154,
    XOF = 156,
    XPF = 157,
    YER = 158,
    ZAR = 159,
    ZMW = 160,
    SSP = 162,
    VES = 163,
}

export class BudgetLimitModel implements IBudgetLimitModel {
    warningMessageHtml!: string | undefined;
    canExceedMaxBudget!: boolean;

    constructor(data?: IBudgetLimitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.warningMessageHtml = _data["warningMessageHtml"];
            this.canExceedMaxBudget = _data["canExceedMaxBudget"];
        }
    }

    static fromJS(data: any): BudgetLimitModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetLimitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warningMessageHtml"] = this.warningMessageHtml;
        data["canExceedMaxBudget"] = this.canExceedMaxBudget;
        return data;
    }
}

export interface IBudgetLimitModel {
    warningMessageHtml: string | undefined;
    canExceedMaxBudget: boolean;
}

export class HourlyCostDetailsViewModel extends CostDetailsViewModel implements IHourlyCostDetailsViewModel {
    incidentalsTotalWithTax!: number | undefined;
    serviceCharge!: number;
    serviceChargePercentage!: number;
    serviceChargeMerchandisingEnabled!: boolean;
    lessDiscount!: number;

    constructor(data?: IHourlyCostDetailsViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "HourlyCostDetailsViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incidentalsTotalWithTax = _data["incidentalsTotalWithTax"];
            this.serviceCharge = _data["serviceCharge"];
            this.serviceChargePercentage = _data["serviceChargePercentage"];
            this.serviceChargeMerchandisingEnabled = _data["serviceChargeMerchandisingEnabled"];
            this.lessDiscount = _data["lessDiscount"];
        }
    }

    static fromJS(data: any): HourlyCostDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HourlyCostDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentalsTotalWithTax"] = this.incidentalsTotalWithTax;
        data["serviceCharge"] = this.serviceCharge;
        data["serviceChargePercentage"] = this.serviceChargePercentage;
        data["serviceChargeMerchandisingEnabled"] = this.serviceChargeMerchandisingEnabled;
        data["lessDiscount"] = this.lessDiscount;
        super.toJSON(data);
        return data;
    }
}

export interface IHourlyCostDetailsViewModel extends ICostDetailsViewModel {
    incidentalsTotalWithTax: number | undefined;
    serviceCharge: number;
    serviceChargePercentage: number;
    serviceChargeMerchandisingEnabled: boolean;
    lessDiscount: number;
}

export class MonthlyCostDetailsViewModel extends CostDetailsViewModel implements IMonthlyCostDetailsViewModel {
    proRated!: number | undefined;
    monthlyPrices!: { [key: string]: number; };
    nextMonthPrice!: number;
    setUpFee!: number | undefined;
    editFee!: number | undefined;
    serviceRetainer!: number | undefined;

    constructor(data?: IMonthlyCostDetailsViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "MonthlyCostDetailsViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.proRated = _data["proRated"];
            if (_data["monthlyPrices"]) {
                this.monthlyPrices = {} as any;
                for (let key in _data["monthlyPrices"]) {
                    if (_data["monthlyPrices"].hasOwnProperty(key))
                        (<any>this.monthlyPrices)![key] = _data["monthlyPrices"][key];
                }
            }
            this.nextMonthPrice = _data["nextMonthPrice"];
            this.setUpFee = _data["setUpFee"];
            this.editFee = _data["editFee"];
            this.serviceRetainer = _data["serviceRetainer"];
        }
    }

    static fromJS(data: any): MonthlyCostDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyCostDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proRated"] = this.proRated;
        if (this.monthlyPrices) {
            data["monthlyPrices"] = {};
            for (let key in this.monthlyPrices) {
                if (this.monthlyPrices.hasOwnProperty(key))
                    (<any>data["monthlyPrices"])[key] = (<any>this.monthlyPrices)[key];
            }
        }
        data["nextMonthPrice"] = this.nextMonthPrice;
        data["setUpFee"] = this.setUpFee;
        data["editFee"] = this.editFee;
        data["serviceRetainer"] = this.serviceRetainer;
        super.toJSON(data);
        return data;
    }
}

export interface IMonthlyCostDetailsViewModel extends ICostDetailsViewModel {
    proRated: number | undefined;
    monthlyPrices: { [key: string]: number; };
    nextMonthPrice: number;
    setUpFee: number | undefined;
    editFee: number | undefined;
    serviceRetainer: number | undefined;
}

export class CostRequest implements ICostRequest {
    venueId!: string;
    workspaceId!: string;
    reservationId!: string | undefined;
    occurrenceDate!: string | undefined;
    applyDate!: string | undefined;
    ownerId!: string | undefined;
    reservationDetails!: ReservationDetails | undefined;
    couponCode!: string | undefined;
    changeWorkspaceRequest!: ChangeWorkspaceRequest | undefined;
    /** Intermidiate data for integrations, i.e. Regus. Ensures that availability and price calculations are consistent between display and submit */
    integrationReferences!: ReservationIntegrationReferences | undefined;

    constructor(data?: ICostRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.workspaceId = _data["workspaceId"];
            this.reservationId = _data["reservationId"];
            this.occurrenceDate = _data["occurrenceDate"];
            this.applyDate = _data["applyDate"];
            this.ownerId = _data["ownerId"];
            this.reservationDetails = _data["reservationDetails"] ? ReservationDetails.fromJS(_data["reservationDetails"]) : <any>undefined;
            this.couponCode = _data["couponCode"];
            this.changeWorkspaceRequest = _data["changeWorkspaceRequest"] ? ChangeWorkspaceRequest.fromJS(_data["changeWorkspaceRequest"]) : <any>undefined;
            this.integrationReferences = _data["integrationReferences"] ? ReservationIntegrationReferences.fromJS(_data["integrationReferences"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CostRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CostRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["workspaceId"] = this.workspaceId;
        data["reservationId"] = this.reservationId;
        data["occurrenceDate"] = this.occurrenceDate;
        data["applyDate"] = this.applyDate;
        data["ownerId"] = this.ownerId;
        data["reservationDetails"] = this.reservationDetails ? this.reservationDetails.toJSON() : <any>undefined;
        data["couponCode"] = this.couponCode;
        data["changeWorkspaceRequest"] = this.changeWorkspaceRequest ? this.changeWorkspaceRequest.toJSON() : <any>undefined;
        data["integrationReferences"] = this.integrationReferences ? this.integrationReferences.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICostRequest {
    venueId: string;
    workspaceId: string;
    reservationId: string | undefined;
    occurrenceDate: string | undefined;
    applyDate: string | undefined;
    ownerId: string | undefined;
    reservationDetails: ReservationDetails | undefined;
    couponCode: string | undefined;
    changeWorkspaceRequest: ChangeWorkspaceRequest | undefined;
    /** Intermidiate data for integrations, i.e. Regus. Ensures that availability and price calculations are consistent between display and submit */
    integrationReferences: ReservationIntegrationReferences | undefined;
}

export abstract class ReservationDetails implements IReservationDetails {
    startDate!: string;

    protected _discriminator: string;

    constructor(data?: IReservationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ReservationDetails";
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
        }
    }

    static fromJS(data: any): ReservationDetails {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "RecurrentReservationDetails") {
            throw new Error("The abstract class 'RecurrentReservationDetails' cannot be instantiated.");
        }
        if (data["discriminator"] === "HourlyReservationDetails") {
            let result = new HourlyReservationDetails();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DaypassReservationDetails") {
            let result = new DaypassReservationDetails();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MonthlyReservationDetails") {
            let result = new MonthlyReservationDetails();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "GenericReservationDetails") {
            let result = new GenericReservationDetails();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ReservationDetails' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["startDate"] = this.startDate;
        return data;
    }
}

export interface IReservationDetails {
    startDate: string;
}

export abstract class RecurrentReservationDetails extends ReservationDetails implements IRecurrentReservationDetails {
    recurrencePattern!: string | undefined;
    recurrenceExcludedDates!: string[];

    constructor(data?: IRecurrentReservationDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "RecurrentReservationDetails";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recurrencePattern = _data["recurrencePattern"];
            if (Array.isArray(_data["recurrenceExcludedDates"])) {
                this.recurrenceExcludedDates = [] as any;
                for (let item of _data["recurrenceExcludedDates"])
                    this.recurrenceExcludedDates!.push(item);
            }
        }
    }

    static fromJS(data: any): RecurrentReservationDetails {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "HourlyReservationDetails") {
            let result = new HourlyReservationDetails();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DaypassReservationDetails") {
            let result = new DaypassReservationDetails();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RecurrentReservationDetails' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurrencePattern"] = this.recurrencePattern;
        if (Array.isArray(this.recurrenceExcludedDates)) {
            data["recurrenceExcludedDates"] = [];
            for (let item of this.recurrenceExcludedDates)
                data["recurrenceExcludedDates"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRecurrentReservationDetails extends IReservationDetails {
    recurrencePattern: string | undefined;
    recurrenceExcludedDates: string[];
}

export class HourlyReservationDetails extends RecurrentReservationDetails implements IHourlyReservationDetails {
    startTime!: string;
    durationMinutes!: number;

    constructor(data?: IHourlyReservationDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "HourlyReservationDetails";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startTime = _data["startTime"];
            this.durationMinutes = _data["durationMinutes"];
        }
    }

    static fromJS(data: any): HourlyReservationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HourlyReservationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime;
        data["durationMinutes"] = this.durationMinutes;
        super.toJSON(data);
        return data;
    }
}

export interface IHourlyReservationDetails extends IRecurrentReservationDetails {
    startTime: string;
    durationMinutes: number;
}

export class DaypassReservationDetails extends RecurrentReservationDetails implements IDaypassReservationDetails {
    quantity!: number;

    constructor(data?: IDaypassReservationDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "DaypassReservationDetails";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): DaypassReservationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DaypassReservationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        super.toJSON(data);
        return data;
    }
}

export interface IDaypassReservationDetails extends IRecurrentReservationDetails {
    quantity: number;
}

export class MonthlyReservationDetails extends ReservationDetails implements IMonthlyReservationDetails {
    /** In months */
    term!: number;
    autoRenew!: boolean;
    quantity!: number | undefined;

    constructor(data?: IMonthlyReservationDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "MonthlyReservationDetails";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"];
            this.autoRenew = _data["autoRenew"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): MonthlyReservationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyReservationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term;
        data["autoRenew"] = this.autoRenew;
        data["quantity"] = this.quantity;
        super.toJSON(data);
        return data;
    }
}

export interface IMonthlyReservationDetails extends IReservationDetails {
    /** In months */
    term: number;
    autoRenew: boolean;
    quantity: number | undefined;
}

export class GenericReservationDetails extends ReservationDetails implements IGenericReservationDetails {
    startTime!: string | undefined;

    constructor(data?: IGenericReservationDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "GenericReservationDetails";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startTime = _data["startTime"];
        }
    }

    static fromJS(data: any): GenericReservationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new GenericReservationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime;
        super.toJSON(data);
        return data;
    }
}

export interface IGenericReservationDetails extends IReservationDetails {
    startTime: string | undefined;
}

export class ChangeWorkspaceRequest implements IChangeWorkspaceRequest {
    workspaceId!: string;
    useExistingPrice!: boolean;

    constructor(data?: IChangeWorkspaceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.useExistingPrice = _data["useExistingPrice"];
        }
    }

    static fromJS(data: any): ChangeWorkspaceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeWorkspaceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["useExistingPrice"] = this.useExistingPrice;
        return data;
    }
}

export interface IChangeWorkspaceRequest {
    workspaceId: string;
    useExistingPrice: boolean;
}

export abstract class ReservationIntegrationReferences implements IReservationIntegrationReferences {

    protected _discriminator: string;

    constructor(data?: IReservationIntegrationReferences) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ReservationIntegrationReferences";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ReservationIntegrationReferences {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "RegusIntegrationReferences") {
            let result = new RegusIntegrationReferences();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ReservationIntegrationReferences' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        return data;
    }
}

export interface IReservationIntegrationReferences {
}

export class RegusIntegrationReferences extends ReservationIntegrationReferences implements IRegusIntegrationReferences {
    spaceReferenceToken!: string | undefined;

    constructor(data?: IRegusIntegrationReferences) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "RegusIntegrationReferences";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.spaceReferenceToken = _data["spaceReferenceToken"];
        }
    }

    static fromJS(data: any): RegusIntegrationReferences {
        data = typeof data === 'object' ? data : {};
        let result = new RegusIntegrationReferences();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceReferenceToken"] = this.spaceReferenceToken;
        super.toJSON(data);
        return data;
    }
}

export interface IRegusIntegrationReferences extends IReservationIntegrationReferences {
    spaceReferenceToken: string | undefined;
}

export class CountryCodeBase implements ICountryCodeBase {
    value!: string;
    text!: string;

    constructor(data?: ICountryCodeBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CountryCodeBase {
        data = typeof data === 'object' ? data : {};
        let result = new CountryCodeBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        return data;
    }
}

export interface ICountryCodeBase {
    value: string;
    text: string;
}

export class CountryCode extends CountryCodeBase implements ICountryCode {
    stateCodes!: StateCode[];

    constructor(data?: ICountryCode) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["stateCodes"])) {
                this.stateCodes = [] as any;
                for (let item of _data["stateCodes"])
                    this.stateCodes!.push(StateCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryCode {
        data = typeof data === 'object' ? data : {};
        let result = new CountryCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stateCodes)) {
            data["stateCodes"] = [];
            for (let item of this.stateCodes)
                data["stateCodes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICountryCode extends ICountryCodeBase {
    stateCodes: StateCode[];
}

export class StateCode implements IStateCode {
    value!: string;
    text!: string;

    constructor(data?: IStateCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): StateCode {
        data = typeof data === 'object' ? data : {};
        let result = new StateCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        return data;
    }
}

export interface IStateCode {
    value: string;
    text: string;
}

export class WaitlistRequest extends RecaptchaRequestBase implements IWaitlistRequest {
    fullName!: string;
    email!: string;
    phoneNumber!: string | undefined;
    venueName!: string;
    locationCount!: number;
    comment!: string | undefined;

    constructor(data?: IWaitlistRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.venueName = _data["venueName"];
            this.locationCount = _data["locationCount"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): WaitlistRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WaitlistRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["venueName"] = this.venueName;
        data["locationCount"] = this.locationCount;
        data["comment"] = this.comment;
        super.toJSON(data);
        return data;
    }
}

export interface IWaitlistRequest extends IRecaptchaRequestBase {
    fullName: string;
    email: string;
    phoneNumber: string | undefined;
    venueName: string;
    locationCount: number;
    comment: string | undefined;
}

export class DataRemovalRequest implements IDataRemovalRequest {
    country!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    reason!: string | undefined;
    isAcknowledgedProcessing!: boolean;
    isAcknowledgedNotProcessing!: boolean;
    signedOn!: string;
    signature!: string | undefined;
    recaptchaToken!: string | undefined;

    constructor(data?: IDataRemovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.reason = _data["reason"];
            this.isAcknowledgedProcessing = _data["isAcknowledgedProcessing"];
            this.isAcknowledgedNotProcessing = _data["isAcknowledgedNotProcessing"];
            this.signedOn = _data["signedOn"];
            this.signature = _data["signature"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): DataRemovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DataRemovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["reason"] = this.reason;
        data["isAcknowledgedProcessing"] = this.isAcknowledgedProcessing;
        data["isAcknowledgedNotProcessing"] = this.isAcknowledgedNotProcessing;
        data["signedOn"] = this.signedOn;
        data["signature"] = this.signature;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface IDataRemovalRequest {
    country: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    reason: string | undefined;
    isAcknowledgedProcessing: boolean;
    isAcknowledgedNotProcessing: boolean;
    signedOn: string;
    signature: string | undefined;
    recaptchaToken: string | undefined;
}

/** EA member data */
export class ActivityReservationInternalModel implements IActivityReservationInternalModel {
    startDate!: string;
    endDate!: string | undefined;
    memberId!: string;
    memberFullName!: string | undefined;
    memberEmail!: string | undefined;
    venueId!: string;
    venueName!: string;
    reservationType!: ReservationMethod;
    /** Reservation ID or Parent Reservation ID for recurrent reservation occurence */
    reservationId!: string;
    occurrenceDate!: string | undefined;
    country!: string;
    state!: string | undefined;
    latitude!: number;
    longitude!: number;
    venueXPPUrl!: string;
    guestsCount!: number;
    teamId!: string;
    workspaceId!: string;

    constructor(data?: IActivityReservationInternalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.memberId = _data["memberId"];
            this.memberFullName = _data["memberFullName"];
            this.memberEmail = _data["memberEmail"];
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
            this.reservationType = _data["reservationType"];
            this.reservationId = _data["reservationId"];
            this.occurrenceDate = _data["occurrenceDate"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.venueXPPUrl = _data["venueXPPUrl"];
            this.guestsCount = _data["guestsCount"];
            this.teamId = _data["teamId"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): ActivityReservationInternalModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReservationInternalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["memberId"] = this.memberId;
        data["memberFullName"] = this.memberFullName;
        data["memberEmail"] = this.memberEmail;
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        data["reservationType"] = this.reservationType;
        data["reservationId"] = this.reservationId;
        data["occurrenceDate"] = this.occurrenceDate;
        data["country"] = this.country;
        data["state"] = this.state;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["venueXPPUrl"] = this.venueXPPUrl;
        data["guestsCount"] = this.guestsCount;
        data["teamId"] = this.teamId;
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

/** EA member data */
export interface IActivityReservationInternalModel {
    startDate: string;
    endDate: string | undefined;
    memberId: string;
    memberFullName: string | undefined;
    memberEmail: string | undefined;
    venueId: string;
    venueName: string;
    reservationType: ReservationMethod;
    /** Reservation ID or Parent Reservation ID for recurrent reservation occurence */
    reservationId: string;
    occurrenceDate: string | undefined;
    country: string;
    state: string | undefined;
    latitude: number;
    longitude: number;
    venueXPPUrl: string;
    guestsCount: number;
    teamId: string;
    workspaceId: string;
}

/** 0 = Hourly 1 = DayPass 2 = Monthly */
export enum ReservationMethod {
    Hourly = 0,
    DayPass = 1,
    Monthly = 2,
}

/** 1 = Deleted 2 = Completed 4 = CancellationPolicy 8 = Future 16 = Active 255 = All */
export enum ActivityReservationStatusFilter {
    Deleted = 1,
    Completed = 2,
    CancellationPolicy = 4,
    Future = 8,
    Active = 16,
    All = 255,
}

/** EA admin data */
export class ActivityReservationPrivateModel implements IActivityReservationPrivateModel {
    startDate!: string;
    endDate!: string | undefined;
    memberId!: string;
    memberFullName!: string | undefined;
    memberEmail!: string | undefined;
    teamId!: string;
    teamName!: string;
    location!: string;
    venueId!: string;
    workspaceId!: string;
    venueName!: string;
    spaceName!: string;
    spaceType!: SpaceType;
    spaceTypeDescription!: string;
    cost!: CostInfoModel;
    reservationType!: ReservationMethod;
    status!: ReservationStatus;
    paymentProvider!: PaymentProviderType;
    /** Reservation ID or Parent Reservation ID for recurrent reservation occurence */
    reservationId!: string;
    occurrenceDate!: string | undefined;
    isOutOfBudget!: boolean;
    memberRemovedFromAccount!: boolean;
    externalAccountId!: string | undefined;
    invitees!: ReservationMaybeMemberViewModel[];

    constructor(data?: IActivityReservationPrivateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.memberId = _data["memberId"];
            this.memberFullName = _data["memberFullName"];
            this.memberEmail = _data["memberEmail"];
            this.teamId = _data["teamId"];
            this.teamName = _data["teamName"];
            this.location = _data["location"];
            this.venueId = _data["venueId"];
            this.workspaceId = _data["workspaceId"];
            this.venueName = _data["venueName"];
            this.spaceName = _data["spaceName"];
            this.spaceType = _data["spaceType"];
            this.spaceTypeDescription = _data["spaceTypeDescription"];
            this.cost = _data["cost"] ? CostInfoModel.fromJS(_data["cost"]) : <any>undefined;
            this.reservationType = _data["reservationType"];
            this.status = _data["status"];
            this.paymentProvider = _data["paymentProvider"];
            this.reservationId = _data["reservationId"];
            this.occurrenceDate = _data["occurrenceDate"];
            this.isOutOfBudget = _data["isOutOfBudget"];
            this.memberRemovedFromAccount = _data["memberRemovedFromAccount"];
            this.externalAccountId = _data["externalAccountId"];
            if (Array.isArray(_data["invitees"])) {
                this.invitees = [] as any;
                for (let item of _data["invitees"])
                    this.invitees!.push(ReservationMaybeMemberViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityReservationPrivateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReservationPrivateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["memberId"] = this.memberId;
        data["memberFullName"] = this.memberFullName;
        data["memberEmail"] = this.memberEmail;
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["location"] = this.location;
        data["venueId"] = this.venueId;
        data["workspaceId"] = this.workspaceId;
        data["venueName"] = this.venueName;
        data["spaceName"] = this.spaceName;
        data["spaceType"] = this.spaceType;
        data["spaceTypeDescription"] = this.spaceTypeDescription;
        data["cost"] = this.cost ? this.cost.toJSON() : <any>undefined;
        data["reservationType"] = this.reservationType;
        data["status"] = this.status;
        data["paymentProvider"] = this.paymentProvider;
        data["reservationId"] = this.reservationId;
        data["occurrenceDate"] = this.occurrenceDate;
        data["isOutOfBudget"] = this.isOutOfBudget;
        data["memberRemovedFromAccount"] = this.memberRemovedFromAccount;
        data["externalAccountId"] = this.externalAccountId;
        if (Array.isArray(this.invitees)) {
            data["invitees"] = [];
            for (let item of this.invitees)
                data["invitees"].push(item.toJSON());
        }
        return data;
    }
}

/** EA admin data */
export interface IActivityReservationPrivateModel {
    startDate: string;
    endDate: string | undefined;
    memberId: string;
    memberFullName: string | undefined;
    memberEmail: string | undefined;
    teamId: string;
    teamName: string;
    location: string;
    venueId: string;
    workspaceId: string;
    venueName: string;
    spaceName: string;
    spaceType: SpaceType;
    spaceTypeDescription: string;
    cost: CostInfoModel;
    reservationType: ReservationMethod;
    status: ReservationStatus;
    paymentProvider: PaymentProviderType;
    /** Reservation ID or Parent Reservation ID for recurrent reservation occurence */
    reservationId: string;
    occurrenceDate: string | undefined;
    isOutOfBudget: boolean;
    memberRemovedFromAccount: boolean;
    externalAccountId: string | undefined;
    invitees: ReservationMaybeMemberViewModel[];
}

export class CostInfoModel implements ICostInfoModel {
    amount!: number;
    currency!: CurrencyType;
    currencyPrefix!: string;
    currencyRate!: number | undefined;

    constructor(data?: ICostInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.currencyPrefix = _data["currencyPrefix"];
            this.currencyRate = _data["currencyRate"];
        }
    }

    static fromJS(data: any): CostInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new CostInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["currencyPrefix"] = this.currencyPrefix;
        data["currencyRate"] = this.currencyRate;
        return data;
    }
}

export interface ICostInfoModel {
    amount: number;
    currency: CurrencyType;
    currencyPrefix: string;
    currencyRate: number | undefined;
}

/** 0 = Deleted 1 = Completed 2 = CancellationPolicy 3 = Future 4 = Active */
export enum ReservationStatus {
    Deleted = 0,
    Completed = 1,
    CancellationPolicy = 2,
    Future = 3,
    Active = 4,
}

/** 0 = AuthorizeNet 1 = BrainTree 2 = Stripe 3 = StripeWireTransfer 4 = Marketplace */
export enum PaymentProviderType {
    AuthorizeNet = 0,
    BrainTree = 1,
    Stripe = 2,
    StripeWireTransfer = 3,
    Marketplace = 4,
}

export class ReservationMaybeMemberViewModel implements IReservationMaybeMemberViewModel {
    email!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    fullName!: string;

    protected _discriminator: string;

    constructor(data?: IReservationMaybeMemberViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ReservationMaybeMemberViewModel";
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): ReservationMaybeMemberViewModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ReservationMemberViewModel") {
            let result = new ReservationMemberViewModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReservationOwnerViewModel") {
            let result = new ReservationOwnerViewModel();
            result.init(data);
            return result;
        }
        let result = new ReservationMaybeMemberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IReservationMaybeMemberViewModel {
    email: string;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string;
}

export class ReservationMemberViewModel extends ReservationMaybeMemberViewModel implements IReservationMemberViewModel {
    id!: string;
    imageUrl!: string | undefined;
    company!: string | undefined;
    externalAccountId!: string | undefined;

    constructor(data?: IReservationMemberViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ReservationMemberViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.imageUrl = _data["imageUrl"];
            this.company = _data["company"];
            this.externalAccountId = _data["externalAccountId"];
        }
    }

    static fromJS(data: any): ReservationMemberViewModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ReservationOwnerViewModel") {
            let result = new ReservationOwnerViewModel();
            result.init(data);
            return result;
        }
        let result = new ReservationMemberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageUrl"] = this.imageUrl;
        data["company"] = this.company;
        data["externalAccountId"] = this.externalAccountId;
        super.toJSON(data);
        return data;
    }
}

export interface IReservationMemberViewModel extends IReservationMaybeMemberViewModel {
    id: string;
    imageUrl: string | undefined;
    company: string | undefined;
    externalAccountId: string | undefined;
}

export class ReservationOwnerViewModel extends ReservationMemberViewModel implements IReservationOwnerViewModel {
    enterpriseAccountName!: string | undefined;

    constructor(data?: IReservationOwnerViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ReservationOwnerViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enterpriseAccountName = _data["enterpriseAccountName"];
        }
    }

    static fromJS(data: any): ReservationOwnerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationOwnerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseAccountName"] = this.enterpriseAccountName;
        super.toJSON(data);
        return data;
    }
}

export interface IReservationOwnerViewModel extends IReservationMemberViewModel {
    enterpriseAccountName: string | undefined;
}

export class ReservationOverview implements IReservationOverview {
    date!: string;
    hourlyReservationsCount!: number;
    monthlyReservationsCount!: number;
    hourlySpent!: number;
    monthlySpent!: number;
    totalSpent!: number;

    constructor(data?: IReservationOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.hourlyReservationsCount = _data["hourlyReservationsCount"];
            this.monthlyReservationsCount = _data["monthlyReservationsCount"];
            this.hourlySpent = _data["hourlySpent"];
            this.monthlySpent = _data["monthlySpent"];
            this.totalSpent = _data["totalSpent"];
        }
    }

    static fromJS(data: any): ReservationOverview {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["hourlyReservationsCount"] = this.hourlyReservationsCount;
        data["monthlyReservationsCount"] = this.monthlyReservationsCount;
        data["hourlySpent"] = this.hourlySpent;
        data["monthlySpent"] = this.monthlySpent;
        data["totalSpent"] = this.totalSpent;
        return data;
    }
}

export interface IReservationOverview {
    date: string;
    hourlyReservationsCount: number;
    monthlyReservationsCount: number;
    hourlySpent: number;
    monthlySpent: number;
    totalSpent: number;
}

/** 0 = None 1 = Hourly 2 = Monthly 3 = Both */
export enum HourlyMonthly {
    None = 0,
    Hourly = 1,
    Monthly = 2,
    Both = 3,
}

/** 0 = CSV 1 = XLSX */
export enum DownloadFileFormat {
    CSV = 0,
    XLSX = 1,
}

export class ActivityReservationReportStatus implements IActivityReservationReportStatus {
    id!: string;
    status!: string;
    createDate!: string;
    parameters!: string | undefined;
    downloadReady!: boolean;

    constructor(data?: IActivityReservationReportStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.createDate = _data["createDate"];
            this.parameters = _data["parameters"];
            this.downloadReady = _data["downloadReady"];
        }
    }

    static fromJS(data: any): ActivityReservationReportStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReservationReportStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["createDate"] = this.createDate;
        data["parameters"] = this.parameters;
        data["downloadReady"] = this.downloadReady;
        return data;
    }
}

export interface IActivityReservationReportStatus {
    id: string;
    status: string;
    createDate: string;
    parameters: string | undefined;
    downloadReady: boolean;
}

export class ActivityReview implements IActivityReview {
    reviewId!: string;
    created!: string;
    memberId!: string;
    memberFullName!: string | undefined;
    memberEmail!: string | undefined;
    teamId!: string | undefined;
    teamName!: string | undefined;
    workspaceId!: string | undefined;
    locationName!: string | undefined;
    stars!: number;
    comment!: string | undefined;

    constructor(data?: IActivityReview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.reviewId = _data["reviewId"];
            this.created = _data["created"];
            this.memberId = _data["memberId"];
            this.memberFullName = _data["memberFullName"];
            this.memberEmail = _data["memberEmail"];
            this.teamId = _data["teamId"];
            this.teamName = _data["teamName"];
            this.workspaceId = _data["workspaceId"];
            this.locationName = _data["locationName"];
            this.stars = _data["stars"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ActivityReview {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewId"] = this.reviewId;
        data["created"] = this.created;
        data["memberId"] = this.memberId;
        data["memberFullName"] = this.memberFullName;
        data["memberEmail"] = this.memberEmail;
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["workspaceId"] = this.workspaceId;
        data["locationName"] = this.locationName;
        data["stars"] = this.stars;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IActivityReview {
    reviewId: string;
    created: string;
    memberId: string;
    memberFullName: string | undefined;
    memberEmail: string | undefined;
    teamId: string | undefined;
    teamName: string | undefined;
    workspaceId: string | undefined;
    locationName: string | undefined;
    stars: number;
    comment: string | undefined;
}

export class ReviewOverview implements IReviewOverview {
    date!: string;
    reviewCount!: number;

    constructor(data?: IReviewOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.reviewCount = _data["reviewCount"];
        }
    }

    static fromJS(data: any): ReviewOverview {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["reviewCount"] = this.reviewCount;
        return data;
    }
}

export interface IReviewOverview {
    date: string;
    reviewCount: number;
}

export class ActivityReviewDetails extends ActivityReview implements IActivityReviewDetails {
    cityAddress!: string | undefined;
    reservationDate!: string;
    source!: VenueSource;

    constructor(data?: IActivityReviewDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cityAddress = _data["cityAddress"];
            this.reservationDate = _data["reservationDate"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ActivityReviewDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReviewDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityAddress"] = this.cityAddress;
        data["reservationDate"] = this.reservationDate;
        data["source"] = this.source;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityReviewDetails extends IActivityReview {
    cityAddress: string | undefined;
    reservationDate: string;
    source: VenueSource;
}

/** 0 = SYS 1 = BulkCreate 2 = ColliersIntegration 3 = WeWork 4 = Boxer 5 = Regus 6 = VenueGroupImport 7 = OfficeRnDHybrid 8 = WeWorkIndia */
export enum VenueSource {
    SYS = 0,
    BulkCreate = 1,
    ColliersIntegration = 2,
    WeWork = 3,
    Boxer = 4,
    Regus = 5,
    VenueGroupImport = 6,
    OfficeRnDHybrid = 7,
    WeWorkIndia = 8,
}

export class SearchOverview implements ISearchOverview {
    date!: string;
    searchesCount!: number;

    constructor(data?: ISearchOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.searchesCount = _data["searchesCount"];
        }
    }

    static fromJS(data: any): SearchOverview {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["searchesCount"] = this.searchesCount;
        return data;
    }
}

export interface ISearchOverview {
    date: string;
    searchesCount: number;
}

export class ActivitySearch implements IActivitySearch {
    searchId!: string;
    executedTime!: string;
    memberId!: string;
    memberFullName!: string | undefined;
    memberEmail!: string | undefined;
    teamId!: string | undefined;
    teamName!: string | undefined;
    searchLocation!: string | undefined;
    reservationMethod!: WorkspaceReservationMethod | undefined;
    minCapacity!: number | undefined;
    maxCapacity!: number | undefined;
    searchSpaceType!: SpaceType;
    resultsNumber!: number;
    spaceTypesString!: string | undefined;
    device!: SearchDeviceType;

    constructor(data?: IActivitySearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.searchId = _data["searchId"];
            this.executedTime = _data["executedTime"];
            this.memberId = _data["memberId"];
            this.memberFullName = _data["memberFullName"];
            this.memberEmail = _data["memberEmail"];
            this.teamId = _data["teamId"];
            this.teamName = _data["teamName"];
            this.searchLocation = _data["searchLocation"];
            this.reservationMethod = _data["reservationMethod"];
            this.minCapacity = _data["minCapacity"];
            this.maxCapacity = _data["maxCapacity"];
            this.searchSpaceType = _data["searchSpaceType"];
            this.resultsNumber = _data["resultsNumber"];
            this.spaceTypesString = _data["spaceTypesString"];
            this.device = _data["device"];
        }
    }

    static fromJS(data: any): ActivitySearch {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchId"] = this.searchId;
        data["executedTime"] = this.executedTime;
        data["memberId"] = this.memberId;
        data["memberFullName"] = this.memberFullName;
        data["memberEmail"] = this.memberEmail;
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["searchLocation"] = this.searchLocation;
        data["reservationMethod"] = this.reservationMethod;
        data["minCapacity"] = this.minCapacity;
        data["maxCapacity"] = this.maxCapacity;
        data["searchSpaceType"] = this.searchSpaceType;
        data["resultsNumber"] = this.resultsNumber;
        data["spaceTypesString"] = this.spaceTypesString;
        data["device"] = this.device;
        return data;
    }
}

export interface IActivitySearch {
    searchId: string;
    executedTime: string;
    memberId: string;
    memberFullName: string | undefined;
    memberEmail: string | undefined;
    teamId: string | undefined;
    teamName: string | undefined;
    searchLocation: string | undefined;
    reservationMethod: WorkspaceReservationMethod | undefined;
    minCapacity: number | undefined;
    maxCapacity: number | undefined;
    searchSpaceType: SpaceType;
    resultsNumber: number;
    spaceTypesString: string | undefined;
    device: SearchDeviceType;
}

/** 0 = Unknown 1 = WebUI 2 = Worker 3 = IOS 4 = Android 5 = Api */
export enum SearchDeviceType {
    Unknown = 0,
    WebUI = 1,
    Worker = 2,
    IOS = 3,
    Android = 4,
    Api = 5,
}

export class ActivitySearchDetails implements IActivitySearchDetails {
    searchId!: string;
    executedTime!: string;
    memberId!: string;
    memberFullName!: string | undefined;
    memberEmail!: string | undefined;
    teamId!: string | undefined;
    teamName!: string | undefined;
    searchLocation!: string | undefined;
    filterSettings!: ActivitySearchFilterSettingsDetails | undefined;
    searchResults!: ActivitySearchResultDetails[] | undefined;
    resultsNumber!: number;
    ipAddress!: string | undefined;
    searchedFromLat!: number | undefined;
    searchedFromLong!: number | undefined;
    device!: SearchDeviceType;
    userAgent!: string | undefined;
    sourceType!: SavedSearchSourceType | undefined;

    constructor(data?: IActivitySearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.searchId = _data["searchId"];
            this.executedTime = _data["executedTime"];
            this.memberId = _data["memberId"];
            this.memberFullName = _data["memberFullName"];
            this.memberEmail = _data["memberEmail"];
            this.teamId = _data["teamId"];
            this.teamName = _data["teamName"];
            this.searchLocation = _data["searchLocation"];
            this.filterSettings = _data["filterSettings"] ? ActivitySearchFilterSettingsDetails.fromJS(_data["filterSettings"]) : <any>undefined;
            if (Array.isArray(_data["searchResults"])) {
                this.searchResults = [] as any;
                for (let item of _data["searchResults"])
                    this.searchResults!.push(ActivitySearchResultDetails.fromJS(item));
            }
            this.resultsNumber = _data["resultsNumber"];
            this.ipAddress = _data["ipAddress"];
            this.searchedFromLat = _data["searchedFromLat"];
            this.searchedFromLong = _data["searchedFromLong"];
            this.device = _data["device"];
            this.userAgent = _data["userAgent"];
            this.sourceType = _data["sourceType"];
        }
    }

    static fromJS(data: any): ActivitySearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchId"] = this.searchId;
        data["executedTime"] = this.executedTime;
        data["memberId"] = this.memberId;
        data["memberFullName"] = this.memberFullName;
        data["memberEmail"] = this.memberEmail;
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["searchLocation"] = this.searchLocation;
        data["filterSettings"] = this.filterSettings ? this.filterSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.searchResults)) {
            data["searchResults"] = [];
            for (let item of this.searchResults)
                data["searchResults"].push(item.toJSON());
        }
        data["resultsNumber"] = this.resultsNumber;
        data["ipAddress"] = this.ipAddress;
        data["searchedFromLat"] = this.searchedFromLat;
        data["searchedFromLong"] = this.searchedFromLong;
        data["device"] = this.device;
        data["userAgent"] = this.userAgent;
        data["sourceType"] = this.sourceType;
        return data;
    }
}

export interface IActivitySearchDetails {
    searchId: string;
    executedTime: string;
    memberId: string;
    memberFullName: string | undefined;
    memberEmail: string | undefined;
    teamId: string | undefined;
    teamName: string | undefined;
    searchLocation: string | undefined;
    filterSettings: ActivitySearchFilterSettingsDetails | undefined;
    searchResults: ActivitySearchResultDetails[] | undefined;
    resultsNumber: number;
    ipAddress: string | undefined;
    searchedFromLat: number | undefined;
    searchedFromLong: number | undefined;
    device: SearchDeviceType;
    userAgent: string | undefined;
    sourceType: SavedSearchSourceType | undefined;
}

export class ActivitySearchFilterSettingsDetails implements IActivitySearchFilterSettingsDetails {
    latitude!: number;
    longitude!: number;
    specificity!: LocationAccuracy;
    distance!: number;
    exactDate!: string | undefined;
    exactTime!: string | undefined;
    duration!: number;
    minPrice!: number | undefined;
    maxPrice!: number | undefined;
    searchSpaceType!: SpaceType;
    minCapacity!: number | undefined;
    maxCapacity!: number | undefined;
    venueId!: string | undefined;
    venueGroupId!: string | undefined;
    reservationMethod!: WorkspaceReservationMethod | undefined;
    minSize!: number | undefined;
    maxSize!: number | undefined;
    onlyNewWorkspaces!: boolean;
    sourceType!: SavedSearchSourceType | undefined;
    venueName!: string | undefined;
    venueAddress!: string | undefined;
    amenityStrings!: string[] | undefined;
    neighborhoodStrings!: string[] | undefined;
    spaceTypesString!: string | undefined;

    constructor(data?: IActivitySearchFilterSettingsDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.specificity = _data["specificity"];
            this.distance = _data["distance"];
            this.exactDate = _data["exactDate"];
            this.exactTime = _data["exactTime"];
            this.duration = _data["duration"];
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
            this.searchSpaceType = _data["searchSpaceType"];
            this.minCapacity = _data["minCapacity"];
            this.maxCapacity = _data["maxCapacity"];
            this.venueId = _data["venueId"];
            this.venueGroupId = _data["venueGroupId"];
            this.reservationMethod = _data["reservationMethod"];
            this.minSize = _data["minSize"];
            this.maxSize = _data["maxSize"];
            this.onlyNewWorkspaces = _data["onlyNewWorkspaces"];
            this.sourceType = _data["sourceType"];
            this.venueName = _data["venueName"];
            this.venueAddress = _data["venueAddress"];
            if (Array.isArray(_data["amenityStrings"])) {
                this.amenityStrings = [] as any;
                for (let item of _data["amenityStrings"])
                    this.amenityStrings!.push(item);
            }
            if (Array.isArray(_data["neighborhoodStrings"])) {
                this.neighborhoodStrings = [] as any;
                for (let item of _data["neighborhoodStrings"])
                    this.neighborhoodStrings!.push(item);
            }
            this.spaceTypesString = _data["spaceTypesString"];
        }
    }

    static fromJS(data: any): ActivitySearchFilterSettingsDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySearchFilterSettingsDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["specificity"] = this.specificity;
        data["distance"] = this.distance;
        data["exactDate"] = this.exactDate;
        data["exactTime"] = this.exactTime;
        data["duration"] = this.duration;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        data["searchSpaceType"] = this.searchSpaceType;
        data["minCapacity"] = this.minCapacity;
        data["maxCapacity"] = this.maxCapacity;
        data["venueId"] = this.venueId;
        data["venueGroupId"] = this.venueGroupId;
        data["reservationMethod"] = this.reservationMethod;
        data["minSize"] = this.minSize;
        data["maxSize"] = this.maxSize;
        data["onlyNewWorkspaces"] = this.onlyNewWorkspaces;
        data["sourceType"] = this.sourceType;
        data["venueName"] = this.venueName;
        data["venueAddress"] = this.venueAddress;
        if (Array.isArray(this.amenityStrings)) {
            data["amenityStrings"] = [];
            for (let item of this.amenityStrings)
                data["amenityStrings"].push(item);
        }
        if (Array.isArray(this.neighborhoodStrings)) {
            data["neighborhoodStrings"] = [];
            for (let item of this.neighborhoodStrings)
                data["neighborhoodStrings"].push(item);
        }
        data["spaceTypesString"] = this.spaceTypesString;
        return data;
    }
}

export interface IActivitySearchFilterSettingsDetails {
    latitude: number;
    longitude: number;
    specificity: LocationAccuracy;
    distance: number;
    exactDate: string | undefined;
    exactTime: string | undefined;
    duration: number;
    minPrice: number | undefined;
    maxPrice: number | undefined;
    searchSpaceType: SpaceType;
    minCapacity: number | undefined;
    maxCapacity: number | undefined;
    venueId: string | undefined;
    venueGroupId: string | undefined;
    reservationMethod: WorkspaceReservationMethod | undefined;
    minSize: number | undefined;
    maxSize: number | undefined;
    onlyNewWorkspaces: boolean;
    sourceType: SavedSearchSourceType | undefined;
    venueName: string | undefined;
    venueAddress: string | undefined;
    amenityStrings: string[] | undefined;
    neighborhoodStrings: string[] | undefined;
    spaceTypesString: string | undefined;
}

/** 0 = Unknown 1 = CountryLevel 2 = StateLevel 3 = CityLevel 4 = PostalCodeLevel 5 = StreetLevel 6 = AddressLevel */
export enum LocationAccuracy {
    Unknown = 0,
    CountryLevel = 1,
    StateLevel = 2,
    CityLevel = 3,
    PostalCodeLevel = 4,
    StreetLevel = 5,
    AddressLevel = 6,
}

/** 0 = Unknown 1 = Onboarding 2 = SavedSearch 3 = CreateAlertNoResults 4 = TourRequest 5 = NeighborhoodRequest 6 = CityRequest 7 = WorkspaceRequest 8 = HomepageConcierge 9 = MyLiquidspaceConcierge 10 = WorkspaceTypeRequest 11 = NeighborhoodFollowRequest 12 = MessageHost 13 = CheckAvailability 14 = ColliersConcierge 15 = WashingtonREIT 16 = Brandywine 17 = AvisonYoung 18 = VenueHostReferral 19 = BrandedPortal 20 = RequestForPorposal 21 = AffiliateUserInvite 22 = DealProposal 23 = AltSpaceRequest 24 = CollectionConcierge 25 = GuestOnboarding 26 = EmbeddedConcierge 27 = Membership 28 = NotifyMe */
export enum SavedSearchSourceType {
    Unknown = 0,
    Onboarding = 1,
    SavedSearch = 2,
    CreateAlertNoResults = 3,
    TourRequest = 4,
    NeighborhoodRequest = 5,
    CityRequest = 6,
    WorkspaceRequest = 7,
    HomepageConcierge = 8,
    MyLiquidspaceConcierge = 9,
    WorkspaceTypeRequest = 10,
    NeighborhoodFollowRequest = 11,
    MessageHost = 12,
    CheckAvailability = 13,
    ColliersConcierge = 14,
    WashingtonREIT = 15,
    Brandywine = 16,
    AvisonYoung = 17,
    VenueHostReferral = 18,
    BrandedPortal = 19,
    RequestForPorposal = 20,
    AffiliateUserInvite = 21,
    DealProposal = 22,
    AltSpaceRequest = 23,
    CollectionConcierge = 24,
    GuestOnboarding = 25,
    EmbeddedConcierge = 26,
    Membership = 27,
    NotifyMe = 28,
}

export class IndividualSearchReportResult implements IIndividualSearchReportResult {
    workspaceId!: string;
    venueId!: string;
    position!: number;
    bestMatchScore!: number;
    price!: number;
    rating!: number;

    constructor(data?: IIndividualSearchReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.venueId = _data["venueId"];
            this.position = _data["position"];
            this.bestMatchScore = _data["bestMatchScore"];
            this.price = _data["price"];
            this.rating = _data["rating"];
        }
    }

    static fromJS(data: any): IndividualSearchReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualSearchReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["venueId"] = this.venueId;
        data["position"] = this.position;
        data["bestMatchScore"] = this.bestMatchScore;
        data["price"] = this.price;
        data["rating"] = this.rating;
        return data;
    }
}

export interface IIndividualSearchReportResult {
    workspaceId: string;
    venueId: string;
    position: number;
    bestMatchScore: number;
    price: number;
    rating: number;
}

export class ActivitySearchResultDetails extends IndividualSearchReportResult implements IActivitySearchResultDetails {
    venueName!: string | undefined;
    venueAddress!: string | undefined;

    constructor(data?: IActivitySearchResultDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.venueName = _data["venueName"];
            this.venueAddress = _data["venueAddress"];
        }
    }

    static fromJS(data: any): ActivitySearchResultDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySearchResultDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueName"] = this.venueName;
        data["venueAddress"] = this.venueAddress;
        super.toJSON(data);
        return data;
    }
}

export interface IActivitySearchResultDetails extends IIndividualSearchReportResult {
    venueName: string | undefined;
    venueAddress: string | undefined;
}

export class BrandedOptionsModel implements IBrandedOptionsModel {
    portalOptions!: BrandedPortalOptionsModel;
    emailOptions!: BrandedEmailOptionsModel;
    onboardingOptions!: BrandedOnboardingOptionsModel;
    locationOptions!: BrandedLocationOptionsModel;
    bannerOptions!: BrandedBannerOptionsModel;
    headerImage!: string | undefined;
    emailHeaderImage!: string | undefined;
    onboardingImage!: string | undefined;
    mapPinImage!: string | undefined;
    mapPinImageId!: string | undefined;

    constructor(data?: IBrandedOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.portalOptions = _data["portalOptions"] ? BrandedPortalOptionsModel.fromJS(_data["portalOptions"]) : <any>undefined;
            this.emailOptions = _data["emailOptions"] ? BrandedEmailOptionsModel.fromJS(_data["emailOptions"]) : <any>undefined;
            this.onboardingOptions = _data["onboardingOptions"] ? BrandedOnboardingOptionsModel.fromJS(_data["onboardingOptions"]) : <any>undefined;
            this.locationOptions = _data["locationOptions"] ? BrandedLocationOptionsModel.fromJS(_data["locationOptions"]) : <any>undefined;
            this.bannerOptions = _data["bannerOptions"] ? BrandedBannerOptionsModel.fromJS(_data["bannerOptions"]) : <any>undefined;
            this.headerImage = _data["headerImage"];
            this.emailHeaderImage = _data["emailHeaderImage"];
            this.onboardingImage = _data["onboardingImage"];
            this.mapPinImage = _data["mapPinImage"];
            this.mapPinImageId = _data["mapPinImageId"];
        }
    }

    static fromJS(data: any): BrandedOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandedOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalOptions"] = this.portalOptions ? this.portalOptions.toJSON() : <any>undefined;
        data["emailOptions"] = this.emailOptions ? this.emailOptions.toJSON() : <any>undefined;
        data["onboardingOptions"] = this.onboardingOptions ? this.onboardingOptions.toJSON() : <any>undefined;
        data["locationOptions"] = this.locationOptions ? this.locationOptions.toJSON() : <any>undefined;
        data["bannerOptions"] = this.bannerOptions ? this.bannerOptions.toJSON() : <any>undefined;
        data["headerImage"] = this.headerImage;
        data["emailHeaderImage"] = this.emailHeaderImage;
        data["onboardingImage"] = this.onboardingImage;
        data["mapPinImage"] = this.mapPinImage;
        data["mapPinImageId"] = this.mapPinImageId;
        return data;
    }
}

export interface IBrandedOptionsModel {
    portalOptions: BrandedPortalOptionsModel;
    emailOptions: BrandedEmailOptionsModel;
    onboardingOptions: BrandedOnboardingOptionsModel;
    locationOptions: BrandedLocationOptionsModel;
    bannerOptions: BrandedBannerOptionsModel;
    headerImage: string | undefined;
    emailHeaderImage: string | undefined;
    onboardingImage: string | undefined;
    mapPinImage: string | undefined;
    mapPinImageId: string | undefined;
}

export class BrandedPortalOptionsModel implements IBrandedPortalOptionsModel {
    title!: string | undefined;
    subtitle!: string | undefined;
    explainerText!: string | undefined;
    markets!: BrandedMarketModel[];
    enable!: boolean;
    portalType!: BrandedPortalType;
    forceSignIn!: boolean;
    url!: string | undefined;
    isHeaderTransparent!: boolean;
    referralEmail!: string | undefined;

    constructor(data?: IBrandedPortalOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.explainerText = _data["explainerText"];
            if (Array.isArray(_data["markets"])) {
                this.markets = [] as any;
                for (let item of _data["markets"])
                    this.markets!.push(BrandedMarketModel.fromJS(item));
            }
            this.enable = _data["enable"];
            this.portalType = _data["portalType"];
            this.forceSignIn = _data["forceSignIn"];
            this.url = _data["url"];
            this.isHeaderTransparent = _data["isHeaderTransparent"];
            this.referralEmail = _data["referralEmail"];
        }
    }

    static fromJS(data: any): BrandedPortalOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandedPortalOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["explainerText"] = this.explainerText;
        if (Array.isArray(this.markets)) {
            data["markets"] = [];
            for (let item of this.markets)
                data["markets"].push(item.toJSON());
        }
        data["enable"] = this.enable;
        data["portalType"] = this.portalType;
        data["forceSignIn"] = this.forceSignIn;
        data["url"] = this.url;
        data["isHeaderTransparent"] = this.isHeaderTransparent;
        data["referralEmail"] = this.referralEmail;
        return data;
    }
}

export interface IBrandedPortalOptionsModel {
    title: string | undefined;
    subtitle: string | undefined;
    explainerText: string | undefined;
    markets: BrandedMarketModel[];
    enable: boolean;
    portalType: BrandedPortalType;
    forceSignIn: boolean;
    url: string | undefined;
    isHeaderTransparent: boolean;
    referralEmail: string | undefined;
}

export class BrandedMarketModel implements IBrandedMarketModel {
    name!: string | undefined;
    venueGroupId!: string | undefined;

    constructor(data?: IBrandedMarketModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.venueGroupId = _data["venueGroupId"];
        }
    }

    static fromJS(data: any): BrandedMarketModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandedMarketModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["venueGroupId"] = this.venueGroupId;
        return data;
    }
}

export interface IBrandedMarketModel {
    name: string | undefined;
    venueGroupId: string | undefined;
}

/** 0 = Portfolio 1 = Mobility 2 = PortfolioMobility 3 = Mobility2 4 = Mobility3 */
export enum BrandedPortalType {
    Portfolio = 0,
    Mobility = 1,
    PortfolioMobility = 2,
    Mobility2 = 3,
    Mobility3 = 4,
}

export class BrandedEmailOptionsModel implements IBrandedEmailOptionsModel {
    enable!: boolean;
    from!: string | undefined;
    programName!: string | undefined;
    customEmailCss!: string | undefined;
    customInviteMessage!: string | undefined;
    venueGroupId!: string | undefined;

    constructor(data?: IBrandedEmailOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
            this.from = _data["from"];
            this.programName = _data["programName"];
            this.customEmailCss = _data["customEmailCss"];
            this.customInviteMessage = _data["customInviteMessage"];
            this.venueGroupId = _data["venueGroupId"];
        }
    }

    static fromJS(data: any): BrandedEmailOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandedEmailOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        data["from"] = this.from;
        data["programName"] = this.programName;
        data["customEmailCss"] = this.customEmailCss;
        data["customInviteMessage"] = this.customInviteMessage;
        data["venueGroupId"] = this.venueGroupId;
        return data;
    }
}

export interface IBrandedEmailOptionsModel {
    enable: boolean;
    from: string | undefined;
    programName: string | undefined;
    customEmailCss: string | undefined;
    customInviteMessage: string | undefined;
    venueGroupId: string | undefined;
}

export class BrandedOnboardingOptionsModel implements IBrandedOnboardingOptionsModel {
    message!: string | undefined;
    title!: string | undefined;
    content!: string | undefined;
    useExistingUrl!: boolean;
    url!: string | undefined;
    videoUrl!: string | undefined;

    constructor(data?: IBrandedOnboardingOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.useExistingUrl = _data["useExistingUrl"];
            this.url = _data["url"];
            this.videoUrl = _data["videoUrl"];
        }
    }

    static fromJS(data: any): BrandedOnboardingOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandedOnboardingOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["title"] = this.title;
        data["content"] = this.content;
        data["useExistingUrl"] = this.useExistingUrl;
        data["url"] = this.url;
        data["videoUrl"] = this.videoUrl;
        return data;
    }
}

export interface IBrandedOnboardingOptionsModel {
    message: string | undefined;
    title: string | undefined;
    content: string | undefined;
    useExistingUrl: boolean;
    url: string | undefined;
    videoUrl: string | undefined;
}

export class BrandedLocationOptionsModel implements IBrandedLocationOptionsModel {
    hqPinLabel!: string | undefined;
    hqPinColor!: string | undefined;
    hqPinColorHover!: string | undefined;

    constructor(data?: IBrandedLocationOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.hqPinLabel = _data["hqPinLabel"];
            this.hqPinColor = _data["hqPinColor"];
            this.hqPinColorHover = _data["hqPinColorHover"];
        }
    }

    static fromJS(data: any): BrandedLocationOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandedLocationOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hqPinLabel"] = this.hqPinLabel;
        data["hqPinColor"] = this.hqPinColor;
        data["hqPinColorHover"] = this.hqPinColorHover;
        return data;
    }
}

export interface IBrandedLocationOptionsModel {
    hqPinLabel: string | undefined;
    hqPinColor: string | undefined;
    hqPinColorHover: string | undefined;
}

export class BrandedBannerOptionsModel implements IBrandedBannerOptionsModel {
    title!: string | undefined;
    subtitle!: string | undefined;
    popupTitle!: string | undefined;
    popupContent!: string | undefined;
    enable!: boolean;
    forcePopup!: boolean;

    constructor(data?: IBrandedBannerOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.popupTitle = _data["popupTitle"];
            this.popupContent = _data["popupContent"];
            this.enable = _data["enable"];
            this.forcePopup = _data["forcePopup"];
        }
    }

    static fromJS(data: any): BrandedBannerOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandedBannerOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["popupTitle"] = this.popupTitle;
        data["popupContent"] = this.popupContent;
        data["enable"] = this.enable;
        data["forcePopup"] = this.forcePopup;
        return data;
    }
}

export interface IBrandedBannerOptionsModel {
    title: string | undefined;
    subtitle: string | undefined;
    popupTitle: string | undefined;
    popupContent: string | undefined;
    enable: boolean;
    forcePopup: boolean;
}

export class ContentItemModel implements IContentItemModel {
    id!: string;
    type!: ContentType;
    subject!: string;
    status!: ContentStatus;
    content!: string | undefined;

    constructor(data?: IContentItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.subject = _data["subject"];
            this.status = _data["status"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ContentItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContentItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["subject"] = this.subject;
        data["status"] = this.status;
        data["content"] = this.content;
        return data;
    }
}

export interface IContentItemModel {
    id: string;
    type: ContentType;
    subject: string;
    status: ContentStatus;
    content: string | undefined;
}

/** 0 = QuestionAnswer */
export enum ContentType {
    QuestionAnswer = 0,
}

/** 0 = Hidden 1 = Visible */
export enum ContentStatus {
    Hidden = 0,
    Visible = 1,
}

export class ContentItemAddModel implements IContentItemAddModel {
    type!: ContentType;
    subject!: string;
    status!: ContentStatus;
    content!: string | undefined;

    constructor(data?: IContentItemAddModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.subject = _data["subject"];
            this.status = _data["status"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ContentItemAddModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContentItemAddModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["subject"] = this.subject;
        data["status"] = this.status;
        data["content"] = this.content;
        return data;
    }
}

export interface IContentItemAddModel {
    type: ContentType;
    subject: string;
    status: ContentStatus;
    content: string | undefined;
}

export class DashboardViewModel implements IDashboardViewModel {
    lastUpdateDate!: string;
    spend!: CostInfoModel[];
    reservationCount!: number;
    topSpenders!: DashboardSpender[];
    reservationLocations!: DashboardReservationLocation[];
    pendingMembersCount!: number;
    activeMembersCount!: number;
    ratingsCount!: number;
    ratingsAverage!: number | undefined;
    engagedMembersCount!: number;
    engagedPercent!: number | undefined;
    teamsStats!: DashboardTeamStatsViewModel[];
    reviews!: DashboardReviewInfo[];
    performance!: { [key: string]: number; };

    constructor(data?: IDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.lastUpdateDate = _data["lastUpdateDate"];
            if (Array.isArray(_data["spend"])) {
                this.spend = [] as any;
                for (let item of _data["spend"])
                    this.spend!.push(CostInfoModel.fromJS(item));
            }
            this.reservationCount = _data["reservationCount"];
            if (Array.isArray(_data["topSpenders"])) {
                this.topSpenders = [] as any;
                for (let item of _data["topSpenders"])
                    this.topSpenders!.push(DashboardSpender.fromJS(item));
            }
            if (Array.isArray(_data["reservationLocations"])) {
                this.reservationLocations = [] as any;
                for (let item of _data["reservationLocations"])
                    this.reservationLocations!.push(DashboardReservationLocation.fromJS(item));
            }
            this.pendingMembersCount = _data["pendingMembersCount"];
            this.activeMembersCount = _data["activeMembersCount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsAverage = _data["ratingsAverage"];
            this.engagedMembersCount = _data["engagedMembersCount"];
            this.engagedPercent = _data["engagedPercent"];
            if (Array.isArray(_data["teamsStats"])) {
                this.teamsStats = [] as any;
                for (let item of _data["teamsStats"])
                    this.teamsStats!.push(DashboardTeamStatsViewModel.fromJS(item));
            }
            if (Array.isArray(_data["reviews"])) {
                this.reviews = [] as any;
                for (let item of _data["reviews"])
                    this.reviews!.push(DashboardReviewInfo.fromJS(item));
            }
            if (_data["performance"]) {
                this.performance = {} as any;
                for (let key in _data["performance"]) {
                    if (_data["performance"].hasOwnProperty(key))
                        (<any>this.performance)![key] = _data["performance"][key];
                }
            }
        }
    }

    static fromJS(data: any): DashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastUpdateDate"] = this.lastUpdateDate;
        if (Array.isArray(this.spend)) {
            data["spend"] = [];
            for (let item of this.spend)
                data["spend"].push(item.toJSON());
        }
        data["reservationCount"] = this.reservationCount;
        if (Array.isArray(this.topSpenders)) {
            data["topSpenders"] = [];
            for (let item of this.topSpenders)
                data["topSpenders"].push(item.toJSON());
        }
        if (Array.isArray(this.reservationLocations)) {
            data["reservationLocations"] = [];
            for (let item of this.reservationLocations)
                data["reservationLocations"].push(item.toJSON());
        }
        data["pendingMembersCount"] = this.pendingMembersCount;
        data["activeMembersCount"] = this.activeMembersCount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsAverage"] = this.ratingsAverage;
        data["engagedMembersCount"] = this.engagedMembersCount;
        data["engagedPercent"] = this.engagedPercent;
        if (Array.isArray(this.teamsStats)) {
            data["teamsStats"] = [];
            for (let item of this.teamsStats)
                data["teamsStats"].push(item.toJSON());
        }
        if (Array.isArray(this.reviews)) {
            data["reviews"] = [];
            for (let item of this.reviews)
                data["reviews"].push(item.toJSON());
        }
        if (this.performance) {
            data["performance"] = {};
            for (let key in this.performance) {
                if (this.performance.hasOwnProperty(key))
                    (<any>data["performance"])[key] = (<any>this.performance)[key];
            }
        }
        return data;
    }
}

export interface IDashboardViewModel {
    lastUpdateDate: string;
    spend: CostInfoModel[];
    reservationCount: number;
    topSpenders: DashboardSpender[];
    reservationLocations: DashboardReservationLocation[];
    pendingMembersCount: number;
    activeMembersCount: number;
    ratingsCount: number;
    ratingsAverage: number | undefined;
    engagedMembersCount: number;
    engagedPercent: number | undefined;
    teamsStats: DashboardTeamStatsViewModel[];
    reviews: DashboardReviewInfo[];
    performance: { [key: string]: number; };
}

export class DashboardSpender implements IDashboardSpender {
    memberId!: string;
    fullName!: string | undefined;
    teamId!: string;
    teamName!: string | undefined;
    reservationsCount!: number;
    totalSpend!: number;

    constructor(data?: IDashboardSpender) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.fullName = _data["fullName"];
            this.teamId = _data["teamId"];
            this.teamName = _data["teamName"];
            this.reservationsCount = _data["reservationsCount"];
            this.totalSpend = _data["totalSpend"];
        }
    }

    static fromJS(data: any): DashboardSpender {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSpender();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["fullName"] = this.fullName;
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["reservationsCount"] = this.reservationsCount;
        data["totalSpend"] = this.totalSpend;
        return data;
    }
}

export interface IDashboardSpender {
    memberId: string;
    fullName: string | undefined;
    teamId: string;
    teamName: string | undefined;
    reservationsCount: number;
    totalSpend: number;
}

export class DashboardReservationLocation implements IDashboardReservationLocation {
    venueId!: string;
    venueName!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    url!: string | undefined;
    spend!: CostInfo | undefined;
    reservationsCount!: number;
    activeReservationInfo!: DashboardReservationInfo[] | undefined;

    constructor(data?: IDashboardReservationLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.url = _data["url"];
            this.spend = _data["spend"] ? CostInfo.fromJS(_data["spend"]) : <any>undefined;
            this.reservationsCount = _data["reservationsCount"];
            if (Array.isArray(_data["activeReservationInfo"])) {
                this.activeReservationInfo = [] as any;
                for (let item of _data["activeReservationInfo"])
                    this.activeReservationInfo!.push(DashboardReservationInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardReservationLocation {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardReservationLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["url"] = this.url;
        data["spend"] = this.spend ? this.spend.toJSON() : <any>undefined;
        data["reservationsCount"] = this.reservationsCount;
        if (Array.isArray(this.activeReservationInfo)) {
            data["activeReservationInfo"] = [];
            for (let item of this.activeReservationInfo)
                data["activeReservationInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardReservationLocation {
    venueId: string;
    venueName: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    url: string | undefined;
    spend: CostInfo | undefined;
    reservationsCount: number;
    activeReservationInfo: DashboardReservationInfo[] | undefined;
}

export class CostInfo implements ICostInfo {
    amount!: number;
    currency!: CurrencyType;
    currencyRate!: number | undefined;
    currencyPrefix!: string;

    constructor(data?: ICostInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.currencyRate = _data["currencyRate"];
            this.currencyPrefix = _data["currencyPrefix"];
        }
    }

    static fromJS(data: any): CostInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CostInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["currencyRate"] = this.currencyRate;
        data["currencyPrefix"] = this.currencyPrefix;
        return data;
    }
}

export interface ICostInfo {
    amount: number;
    currency: CurrencyType;
    currencyRate: number | undefined;
    currencyPrefix: string;
}

export class DashboardReservationInfo implements IDashboardReservationInfo {
    memberId!: string;
    memberName!: string | undefined;
    type!: WorkspaceReservationMethod;

    constructor(data?: IDashboardReservationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.memberName = _data["memberName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DashboardReservationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardReservationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["memberName"] = this.memberName;
        data["type"] = this.type;
        return data;
    }
}

export interface IDashboardReservationInfo {
    memberId: string;
    memberName: string | undefined;
    type: WorkspaceReservationMethod;
}

export class DashboardTeamStatsViewModel implements IDashboardTeamStatsViewModel {
    id!: string;
    name!: string | undefined;
    totalInvited!: number;
    totalJoined!: number;
    adoption!: number;
    totalBooked!: number;
    engagement!: number;
    totalDedicated!: TeamCostInfo[];
    totalOnDemand!: TeamCostInfo[];
    invitedBooked!: number;
    currencies!: CurrencyType[];

    constructor(data?: IDashboardTeamStatsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.totalInvited = _data["totalInvited"];
            this.totalJoined = _data["totalJoined"];
            this.adoption = _data["adoption"];
            this.totalBooked = _data["totalBooked"];
            this.engagement = _data["engagement"];
            if (Array.isArray(_data["totalDedicated"])) {
                this.totalDedicated = [] as any;
                for (let item of _data["totalDedicated"])
                    this.totalDedicated!.push(TeamCostInfo.fromJS(item));
            }
            if (Array.isArray(_data["totalOnDemand"])) {
                this.totalOnDemand = [] as any;
                for (let item of _data["totalOnDemand"])
                    this.totalOnDemand!.push(TeamCostInfo.fromJS(item));
            }
            this.invitedBooked = _data["invitedBooked"];
            if (Array.isArray(_data["currencies"])) {
                this.currencies = [] as any;
                for (let item of _data["currencies"])
                    this.currencies!.push(item);
            }
        }
    }

    static fromJS(data: any): DashboardTeamStatsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTeamStatsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["totalInvited"] = this.totalInvited;
        data["totalJoined"] = this.totalJoined;
        data["adoption"] = this.adoption;
        data["totalBooked"] = this.totalBooked;
        data["engagement"] = this.engagement;
        if (Array.isArray(this.totalDedicated)) {
            data["totalDedicated"] = [];
            for (let item of this.totalDedicated)
                data["totalDedicated"].push(item.toJSON());
        }
        if (Array.isArray(this.totalOnDemand)) {
            data["totalOnDemand"] = [];
            for (let item of this.totalOnDemand)
                data["totalOnDemand"].push(item.toJSON());
        }
        data["invitedBooked"] = this.invitedBooked;
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item);
        }
        return data;
    }
}

export interface IDashboardTeamStatsViewModel {
    id: string;
    name: string | undefined;
    totalInvited: number;
    totalJoined: number;
    adoption: number;
    totalBooked: number;
    engagement: number;
    totalDedicated: TeamCostInfo[];
    totalOnDemand: TeamCostInfo[];
    invitedBooked: number;
    currencies: CurrencyType[];
}

export class TeamCostInfo extends CostInfo implements ITeamCostInfo {
    amountUSD!: number;
    count!: number;

    constructor(data?: ITeamCostInfo) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amountUSD = _data["amountUSD"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): TeamCostInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TeamCostInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountUSD"] = this.amountUSD;
        data["count"] = this.count;
        super.toJSON(data);
        return data;
    }
}

export interface ITeamCostInfo extends ICostInfo {
    amountUSD: number;
    count: number;
}

export class DashboardReviewInfo implements IDashboardReviewInfo {
    id!: string;
    fullName!: string | undefined;
    teamName!: string | undefined;
    created!: string;
    stars!: number;
    comment!: string | undefined;
    workspaceId!: string;

    constructor(data?: IDashboardReviewInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.teamName = _data["teamName"];
            this.created = _data["created"];
            this.stars = _data["stars"];
            this.comment = _data["comment"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): DashboardReviewInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardReviewInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["teamName"] = this.teamName;
        data["created"] = this.created;
        data["stars"] = this.stars;
        data["comment"] = this.comment;
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

export interface IDashboardReviewInfo {
    id: string;
    fullName: string | undefined;
    teamName: string | undefined;
    created: string;
    stars: number;
    comment: string | undefined;
    workspaceId: string;
}

export class EnrollmentSettingsModel implements IEnrollmentSettingsModel {
    enableAutoEnrollment!: boolean;
    autoEnrollmentMemberGroupId!: string | undefined;
    restrictByEmailDomain!: boolean;
    emailDomains!: string[];

    constructor(data?: IEnrollmentSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.enableAutoEnrollment = _data["enableAutoEnrollment"];
            this.autoEnrollmentMemberGroupId = _data["autoEnrollmentMemberGroupId"];
            this.restrictByEmailDomain = _data["restrictByEmailDomain"];
            if (Array.isArray(_data["emailDomains"])) {
                this.emailDomains = [] as any;
                for (let item of _data["emailDomains"])
                    this.emailDomains!.push(item);
            }
        }
    }

    static fromJS(data: any): EnrollmentSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableAutoEnrollment"] = this.enableAutoEnrollment;
        data["autoEnrollmentMemberGroupId"] = this.autoEnrollmentMemberGroupId;
        data["restrictByEmailDomain"] = this.restrictByEmailDomain;
        if (Array.isArray(this.emailDomains)) {
            data["emailDomains"] = [];
            for (let item of this.emailDomains)
                data["emailDomains"].push(item);
        }
        return data;
    }
}

export interface IEnrollmentSettingsModel {
    enableAutoEnrollment: boolean;
    autoEnrollmentMemberGroupId: string | undefined;
    restrictByEmailDomain: boolean;
    emailDomains: string[];
}

export class AccountAdminInfoViewModel implements IAccountAdminInfoViewModel {
    memberId!: string;
    fullName!: string;
    email!: string;
    created!: string | undefined;
    role!: string;
    imageUrl!: string | undefined;

    constructor(data?: IAccountAdminInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.created = _data["created"];
            this.role = _data["role"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): AccountAdminInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAdminInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["created"] = this.created;
        data["role"] = this.role;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IAccountAdminInfoViewModel {
    memberId: string;
    fullName: string;
    email: string;
    created: string | undefined;
    role: string;
    imageUrl: string | undefined;
}

export class AddAccountAdminModel implements IAddAccountAdminModel {
    email!: string;

    constructor(data?: IAddAccountAdminModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AddAccountAdminModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddAccountAdminModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IAddAccountAdminModel {
    email: string;
}

export class EnterpriseAccountApiClientListItemViewModel implements IEnterpriseAccountApiClientListItemViewModel {
    clientId!: string;
    subscriptionKey!: string | undefined;
    name!: string | undefined;

    constructor(data?: IEnterpriseAccountApiClientListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.subscriptionKey = _data["subscriptionKey"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnterpriseAccountApiClientListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountApiClientListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["subscriptionKey"] = this.subscriptionKey;
        data["name"] = this.name;
        return data;
    }
}

export interface IEnterpriseAccountApiClientListItemViewModel {
    clientId: string;
    subscriptionKey: string | undefined;
    name: string | undefined;
}

export class EditableEnterpriseAccountApiClientViewModel implements IEditableEnterpriseAccountApiClientViewModel {
    clientId!: string;
    clientSecret!: string;
    subscriptionKey!: string | undefined;
    description!: string | undefined;
    name!: string | undefined;
    allowedGrantTypes!: string[];
    allowedScopes!: string[];
    allowedImpersonationScopes!: string[];

    constructor(data?: IEditableEnterpriseAccountApiClientViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.subscriptionKey = _data["subscriptionKey"];
            this.description = _data["description"];
            this.name = _data["name"];
            if (Array.isArray(_data["allowedGrantTypes"])) {
                this.allowedGrantTypes = [] as any;
                for (let item of _data["allowedGrantTypes"])
                    this.allowedGrantTypes!.push(item);
            }
            if (Array.isArray(_data["allowedScopes"])) {
                this.allowedScopes = [] as any;
                for (let item of _data["allowedScopes"])
                    this.allowedScopes!.push(item);
            }
            if (Array.isArray(_data["allowedImpersonationScopes"])) {
                this.allowedImpersonationScopes = [] as any;
                for (let item of _data["allowedImpersonationScopes"])
                    this.allowedImpersonationScopes!.push(item);
            }
        }
    }

    static fromJS(data: any): EditableEnterpriseAccountApiClientViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditableEnterpriseAccountApiClientViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["subscriptionKey"] = this.subscriptionKey;
        data["description"] = this.description;
        data["name"] = this.name;
        if (Array.isArray(this.allowedGrantTypes)) {
            data["allowedGrantTypes"] = [];
            for (let item of this.allowedGrantTypes)
                data["allowedGrantTypes"].push(item);
        }
        if (Array.isArray(this.allowedScopes)) {
            data["allowedScopes"] = [];
            for (let item of this.allowedScopes)
                data["allowedScopes"].push(item);
        }
        if (Array.isArray(this.allowedImpersonationScopes)) {
            data["allowedImpersonationScopes"] = [];
            for (let item of this.allowedImpersonationScopes)
                data["allowedImpersonationScopes"].push(item);
        }
        return data;
    }
}

export interface IEditableEnterpriseAccountApiClientViewModel {
    clientId: string;
    clientSecret: string;
    subscriptionKey: string | undefined;
    description: string | undefined;
    name: string | undefined;
    allowedGrantTypes: string[];
    allowedScopes: string[];
    allowedImpersonationScopes: string[];
}

export class EnterpriseAccountBillingModel implements IEnterpriseAccountBillingModel {
    id!: string;
    billingDate!: string;
    invoiceId!: string | undefined;
    invoicePdfUrl!: string | undefined;
    billableUsersCount!: number;
    billingItems!: EnterpriseAccountBillingItemModel[];
    status!: EnterpriseAccountBillingStatus;

    constructor(data?: IEnterpriseAccountBillingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billingDate = _data["billingDate"];
            this.invoiceId = _data["invoiceId"];
            this.invoicePdfUrl = _data["invoicePdfUrl"];
            this.billableUsersCount = _data["billableUsersCount"];
            if (Array.isArray(_data["billingItems"])) {
                this.billingItems = [] as any;
                for (let item of _data["billingItems"])
                    this.billingItems!.push(EnterpriseAccountBillingItemModel.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EnterpriseAccountBillingModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountBillingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billingDate"] = this.billingDate;
        data["invoiceId"] = this.invoiceId;
        data["invoicePdfUrl"] = this.invoicePdfUrl;
        data["billableUsersCount"] = this.billableUsersCount;
        if (Array.isArray(this.billingItems)) {
            data["billingItems"] = [];
            for (let item of this.billingItems)
                data["billingItems"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IEnterpriseAccountBillingModel {
    id: string;
    billingDate: string;
    invoiceId: string | undefined;
    invoicePdfUrl: string | undefined;
    billableUsersCount: number;
    billingItems: EnterpriseAccountBillingItemModel[];
    status: EnterpriseAccountBillingStatus;
}

export class EnterpriseAccountBillingItemModel implements IEnterpriseAccountBillingItemModel {
    feeType!: EnterpriseAccountFeeType;
    periodStartDate!: string;
    periodEndDate!: string;
    description!: string | undefined;
    costPerUnit!: number;
    units!: number;
    currency!: CurrencyType;

    constructor(data?: IEnterpriseAccountBillingItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.feeType = _data["feeType"];
            this.periodStartDate = _data["periodStartDate"];
            this.periodEndDate = _data["periodEndDate"];
            this.description = _data["description"];
            this.costPerUnit = _data["costPerUnit"];
            this.units = _data["units"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): EnterpriseAccountBillingItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountBillingItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeType"] = this.feeType;
        data["periodStartDate"] = this.periodStartDate;
        data["periodEndDate"] = this.periodEndDate;
        data["description"] = this.description;
        data["costPerUnit"] = this.costPerUnit;
        data["units"] = this.units;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IEnterpriseAccountBillingItemModel {
    feeType: EnterpriseAccountFeeType;
    periodStartDate: string;
    periodEndDate: string;
    description: string | undefined;
    costPerUnit: number;
    units: number;
    currency: CurrencyType;
}

/** 0 = PlatformFee 1 = UserFee 2 = ProfessionalServices 3 = HqHub 4 = Other 5 = Credit */
export enum EnterpriseAccountFeeType {
    PlatformFee = 0,
    UserFee = 1,
    ProfessionalServices = 2,
    HqHub = 3,
    Other = 4,
    Credit = 5,
}

/** 0 = Unknown 1 = Scheduled 2 = Due 3 = Overdue 4 = Complete 5 = ProcessingError 6 = Cancelled */
export enum EnterpriseAccountBillingStatus {
    Unknown = 0,
    Scheduled = 1,
    Due = 2,
    Overdue = 3,
    Complete = 4,
    ProcessingError = 5,
    Cancelled = 6,
}

export class EnterpriseAccountBillingCreateRequest implements IEnterpriseAccountBillingCreateRequest {
    billingDate!: string;
    billableUsersCount!: number;
    billingItems!: EnterpriseAccountBillingItemModel[];

    constructor(data?: IEnterpriseAccountBillingCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.billingDate = _data["billingDate"];
            this.billableUsersCount = _data["billableUsersCount"];
            if (Array.isArray(_data["billingItems"])) {
                this.billingItems = [] as any;
                for (let item of _data["billingItems"])
                    this.billingItems!.push(EnterpriseAccountBillingItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnterpriseAccountBillingCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountBillingCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingDate"] = this.billingDate;
        data["billableUsersCount"] = this.billableUsersCount;
        if (Array.isArray(this.billingItems)) {
            data["billingItems"] = [];
            for (let item of this.billingItems)
                data["billingItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEnterpriseAccountBillingCreateRequest {
    billingDate: string;
    billableUsersCount: number;
    billingItems: EnterpriseAccountBillingItemModel[];
}

export class AccountInfoViewModel implements IAccountInfoViewModel {
    id!: string;
    name!: string;
    portalUrl!: string | undefined;
    logoUrl!: string | undefined;
    portalType!: BrandedPortalType;
    emailDomains!: string[];
    isMarketplaceAccount!: boolean;
    socialCollaborationPortalEnabled!: boolean;
    marketplaceEffectiveDate!: string | undefined;
    invoiceGenerationStatus!: InvoiceGenerationStatus;

    constructor(data?: IAccountInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.portalUrl = _data["portalUrl"];
            this.logoUrl = _data["logoUrl"];
            this.portalType = _data["portalType"];
            if (Array.isArray(_data["emailDomains"])) {
                this.emailDomains = [] as any;
                for (let item of _data["emailDomains"])
                    this.emailDomains!.push(item);
            }
            this.isMarketplaceAccount = _data["isMarketplaceAccount"];
            this.socialCollaborationPortalEnabled = _data["socialCollaborationPortalEnabled"];
            this.marketplaceEffectiveDate = _data["marketplaceEffectiveDate"];
            this.invoiceGenerationStatus = _data["invoiceGenerationStatus"];
        }
    }

    static fromJS(data: any): AccountInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["portalUrl"] = this.portalUrl;
        data["logoUrl"] = this.logoUrl;
        data["portalType"] = this.portalType;
        if (Array.isArray(this.emailDomains)) {
            data["emailDomains"] = [];
            for (let item of this.emailDomains)
                data["emailDomains"].push(item);
        }
        data["isMarketplaceAccount"] = this.isMarketplaceAccount;
        data["socialCollaborationPortalEnabled"] = this.socialCollaborationPortalEnabled;
        data["marketplaceEffectiveDate"] = this.marketplaceEffectiveDate;
        data["invoiceGenerationStatus"] = this.invoiceGenerationStatus;
        return data;
    }
}

export interface IAccountInfoViewModel {
    id: string;
    name: string;
    portalUrl: string | undefined;
    logoUrl: string | undefined;
    portalType: BrandedPortalType;
    emailDomains: string[];
    isMarketplaceAccount: boolean;
    socialCollaborationPortalEnabled: boolean;
    marketplaceEffectiveDate: string | undefined;
    invoiceGenerationStatus: InvoiceGenerationStatus;
}

/** 0 = Paused 1 = Draft 2 = Retired */
export enum InvoiceGenerationStatus {
    Paused = 0,
    Draft = 1,
    Retired = 2,
}

export class EnterpriseAccountListViewModel implements IEnterpriseAccountListViewModel {
    id!: string;
    name!: string;

    protected _discriminator: string;

    constructor(data?: IEnterpriseAccountListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "EnterpriseAccountListViewModel";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnterpriseAccountListViewModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "EnterpriseAccountExtendedListViewModel") {
            let result = new EnterpriseAccountExtendedListViewModel();
            result.init(data);
            return result;
        }
        let result = new EnterpriseAccountListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEnterpriseAccountListViewModel {
    id: string;
    name: string;
}

export class EnterpriseAccountExtendedListViewModel extends EnterpriseAccountListViewModel implements IEnterpriseAccountExtendedListViewModel {
    plan!: EnterpriseAccountPlan;
    status!: EnterpriseAccountStatus;
    demandType!: EnterpriseDemandType;
    classification!: EnterpriseClassification;
    totalAvailableMarket!: number | undefined;
    serviceableAvailableMarket!: number | undefined;
    currentlyAddressableMarket!: number | undefined;

    constructor(data?: IEnterpriseAccountExtendedListViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "EnterpriseAccountExtendedListViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.plan = _data["plan"];
            this.status = _data["status"];
            this.demandType = _data["demandType"];
            this.classification = _data["classification"];
            this.totalAvailableMarket = _data["totalAvailableMarket"];
            this.serviceableAvailableMarket = _data["serviceableAvailableMarket"];
            this.currentlyAddressableMarket = _data["currentlyAddressableMarket"];
        }
    }

    static fromJS(data: any): EnterpriseAccountExtendedListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountExtendedListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plan"] = this.plan;
        data["status"] = this.status;
        data["demandType"] = this.demandType;
        data["classification"] = this.classification;
        data["totalAvailableMarket"] = this.totalAvailableMarket;
        data["serviceableAvailableMarket"] = this.serviceableAvailableMarket;
        data["currentlyAddressableMarket"] = this.currentlyAddressableMarket;
        super.toJSON(data);
        return data;
    }
}

export interface IEnterpriseAccountExtendedListViewModel extends IEnterpriseAccountListViewModel {
    plan: EnterpriseAccountPlan;
    status: EnterpriseAccountStatus;
    demandType: EnterpriseDemandType;
    classification: EnterpriseClassification;
    totalAvailableMarket: number | undefined;
    serviceableAvailableMarket: number | undefined;
    currentlyAddressableMarket: number | undefined;
}

/** 0 = Basic 1 = Plus 2 = Premium 3 = PremiumPilot 4 = Team 5 = Business 6 = Enterprise */
export enum EnterpriseAccountPlan {
    Basic = 0,
    Plus = 1,
    Premium = 2,
    PremiumPilot = 3,
    Team = 4,
    Business = 5,
    Enterprise = 6,
}

/** 0 = Demo 1 = Proposed 2 = Setup 3 = Active 4 = Inactive 5 = Suspended 6 = Retired 7 = Pilot */
export enum EnterpriseAccountStatus {
    Demo = 0,
    Proposed = 1,
    Setup = 2,
    Active = 3,
    Inactive = 4,
    Suspended = 5,
    Retired = 6,
    Pilot = 7,
}

/** 0 = Unknown 1 = OnDemand 2 = Dedicated 3 = OnDemandAndDedicated */
export enum EnterpriseDemandType {
    Unknown = 0,
    OnDemand = 1,
    Dedicated = 2,
    OnDemandAndDedicated = 3,
}

/** 0 = Unknown 1 = Tier1 2 = Tier2 3 = Tier3 4 = Tier4 */
export enum EnterpriseClassification {
    Unknown = 0,
    Tier1 = 1,
    Tier2 = 2,
    Tier3 = 3,
    Tier4 = 4,
}

export class TeamInfoViewModel implements ITeamInfoViewModel {
    id!: string;
    name!: string | undefined;
    ownerName!: string | undefined;
    modifiedDate!: string | undefined;
    memberCount!: number;
    isActive!: boolean;

    constructor(data?: ITeamInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ownerName = _data["ownerName"];
            this.modifiedDate = _data["modifiedDate"];
            this.memberCount = _data["memberCount"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TeamInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ownerName"] = this.ownerName;
        data["modifiedDate"] = this.modifiedDate;
        data["memberCount"] = this.memberCount;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITeamInfoViewModel {
    id: string;
    name: string | undefined;
    ownerName: string | undefined;
    modifiedDate: string | undefined;
    memberCount: number;
    isActive: boolean;
}

export class TeamListItemViewModel implements ITeamListItemViewModel {
    id!: string;
    name!: string;

    constructor(data?: ITeamListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TeamListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITeamListItemViewModel {
    id: string;
    name: string;
}

export class AccountModel implements IAccountModel {
    id!: string;
    name!: string;
    description!: string | undefined;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    simpleAddress1!: string | undefined;
    simpleAddress2!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zip!: string | undefined;
    country!: string | undefined;
    salesRepEmail!: string | undefined;
    liquidSpaceAccountManager!: string | undefined;
    status!: EnterpriseAccountStatus;

    constructor(data?: IAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.simpleAddress1 = _data["simpleAddress1"];
            this.simpleAddress2 = _data["simpleAddress2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.country = _data["country"];
            this.salesRepEmail = _data["salesRepEmail"];
            this.liquidSpaceAccountManager = _data["liquidSpaceAccountManager"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["simpleAddress1"] = this.simpleAddress1;
        data["simpleAddress2"] = this.simpleAddress2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["country"] = this.country;
        data["salesRepEmail"] = this.salesRepEmail;
        data["liquidSpaceAccountManager"] = this.liquidSpaceAccountManager;
        data["status"] = this.status;
        return data;
    }
}

export interface IAccountModel {
    id: string;
    name: string;
    description: string | undefined;
    contactName: string | undefined;
    contactEmail: string | undefined;
    simpleAddress1: string | undefined;
    simpleAddress2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    country: string | undefined;
    salesRepEmail: string | undefined;
    liquidSpaceAccountManager: string | undefined;
    status: EnterpriseAccountStatus;
}

export class EnterpriseAccountSettingsModel implements IEnterpriseAccountSettingsModel {
    id!: string;
    name!: string;
    description!: string | undefined;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    simpleAddress1!: string | undefined;
    simpleAddress2!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zip!: string | undefined;
    country!: string | undefined;
    status!: EnterpriseAccountStatus;
    salesRepEmail!: string;
    liquidSpaceAccountManager!: string | undefined;
    liquidSpaceTransactionManager!: string | undefined;
    securityContact!: string | undefined;
    plan!: EnterpriseAccountPlan;
    classification!: EnterpriseClassification;
    memberLimit!: number;
    teamLimit!: number;
    activeDate!: string | undefined;
    subscriptionCost!: string | undefined;
    subscriptionTerm!: number | undefined;
    socialActivityEnabled!: boolean;
    socialCollaborationPortalEnabled!: boolean;
    enhancedReservationRemindersEnabled!: boolean;
    emailDomains!: string | undefined;
    totalAvailableMarket!: number | undefined;
    serviceableAvailableMarket!: number | undefined;
    currentlyAddressableMarket!: number | undefined;
    demandType!: EnterpriseDemandType;
    isMarketplaceAccount!: boolean;
    displayExtendedNetwork!: DisplayExtendedNetwork;
    campaignOptions!: CampaignOptionsModel;
    financeContacts!: string[];
    billingPeriod!: EnterpriseAccountBillingPeriod;
    platformFee!: number | undefined;
    userFee!: number | undefined;
    enableBilling!: boolean;
    billingStartDate!: string | undefined;
    billingEndDate!: string | undefined;
    liquidSpaceTutorials!: boolean;
    purchaseOrderNumber!: string | undefined;
    serviceChargeEnabled!: boolean;
    enableWireTransferPayments!: boolean;
    marketplaceInvoiceStatus!: InvoiceGenerationStatus;
    marketplaceEffectiveDate!: string | undefined;
    marketplaceTargetBalance!: number | undefined;
    marketplacePaymentTerm!: PaymentTerm;
    financeNotesInternal!: string | undefined;
    billingPaymentTerm!: PaymentTerm | undefined;
    customerProfileId!: string | undefined;

    constructor(data?: IEnterpriseAccountSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.simpleAddress1 = _data["simpleAddress1"];
            this.simpleAddress2 = _data["simpleAddress2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.country = _data["country"];
            this.status = _data["status"];
            this.salesRepEmail = _data["salesRepEmail"];
            this.liquidSpaceAccountManager = _data["liquidSpaceAccountManager"];
            this.liquidSpaceTransactionManager = _data["liquidSpaceTransactionManager"];
            this.securityContact = _data["securityContact"];
            this.plan = _data["plan"];
            this.classification = _data["classification"];
            this.memberLimit = _data["memberLimit"];
            this.teamLimit = _data["teamLimit"];
            this.activeDate = _data["activeDate"];
            this.subscriptionCost = _data["subscriptionCost"];
            this.subscriptionTerm = _data["subscriptionTerm"];
            this.socialActivityEnabled = _data["socialActivityEnabled"];
            this.socialCollaborationPortalEnabled = _data["socialCollaborationPortalEnabled"];
            this.enhancedReservationRemindersEnabled = _data["enhancedReservationRemindersEnabled"];
            this.emailDomains = _data["emailDomains"];
            this.totalAvailableMarket = _data["totalAvailableMarket"];
            this.serviceableAvailableMarket = _data["serviceableAvailableMarket"];
            this.currentlyAddressableMarket = _data["currentlyAddressableMarket"];
            this.demandType = _data["demandType"];
            this.isMarketplaceAccount = _data["isMarketplaceAccount"];
            this.displayExtendedNetwork = _data["displayExtendedNetwork"];
            this.campaignOptions = _data["campaignOptions"] ? CampaignOptionsModel.fromJS(_data["campaignOptions"]) : <any>undefined;
            if (Array.isArray(_data["financeContacts"])) {
                this.financeContacts = [] as any;
                for (let item of _data["financeContacts"])
                    this.financeContacts!.push(item);
            }
            this.billingPeriod = _data["billingPeriod"];
            this.platformFee = _data["platformFee"];
            this.userFee = _data["userFee"];
            this.enableBilling = _data["enableBilling"];
            this.billingStartDate = _data["billingStartDate"];
            this.billingEndDate = _data["billingEndDate"];
            this.liquidSpaceTutorials = _data["liquidSpaceTutorials"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.serviceChargeEnabled = _data["serviceChargeEnabled"];
            this.enableWireTransferPayments = _data["enableWireTransferPayments"];
            this.marketplaceInvoiceStatus = _data["marketplaceInvoiceStatus"];
            this.marketplaceEffectiveDate = _data["marketplaceEffectiveDate"];
            this.marketplaceTargetBalance = _data["marketplaceTargetBalance"];
            this.marketplacePaymentTerm = _data["marketplacePaymentTerm"];
            this.financeNotesInternal = _data["financeNotesInternal"];
            this.billingPaymentTerm = _data["billingPaymentTerm"];
            this.customerProfileId = _data["customerProfileId"];
        }
    }

    static fromJS(data: any): EnterpriseAccountSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["simpleAddress1"] = this.simpleAddress1;
        data["simpleAddress2"] = this.simpleAddress2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["country"] = this.country;
        data["status"] = this.status;
        data["salesRepEmail"] = this.salesRepEmail;
        data["liquidSpaceAccountManager"] = this.liquidSpaceAccountManager;
        data["liquidSpaceTransactionManager"] = this.liquidSpaceTransactionManager;
        data["securityContact"] = this.securityContact;
        data["plan"] = this.plan;
        data["classification"] = this.classification;
        data["memberLimit"] = this.memberLimit;
        data["teamLimit"] = this.teamLimit;
        data["activeDate"] = this.activeDate;
        data["subscriptionCost"] = this.subscriptionCost;
        data["subscriptionTerm"] = this.subscriptionTerm;
        data["socialActivityEnabled"] = this.socialActivityEnabled;
        data["socialCollaborationPortalEnabled"] = this.socialCollaborationPortalEnabled;
        data["enhancedReservationRemindersEnabled"] = this.enhancedReservationRemindersEnabled;
        data["emailDomains"] = this.emailDomains;
        data["totalAvailableMarket"] = this.totalAvailableMarket;
        data["serviceableAvailableMarket"] = this.serviceableAvailableMarket;
        data["currentlyAddressableMarket"] = this.currentlyAddressableMarket;
        data["demandType"] = this.demandType;
        data["isMarketplaceAccount"] = this.isMarketplaceAccount;
        data["displayExtendedNetwork"] = this.displayExtendedNetwork;
        data["campaignOptions"] = this.campaignOptions ? this.campaignOptions.toJSON() : <any>undefined;
        if (Array.isArray(this.financeContacts)) {
            data["financeContacts"] = [];
            for (let item of this.financeContacts)
                data["financeContacts"].push(item);
        }
        data["billingPeriod"] = this.billingPeriod;
        data["platformFee"] = this.platformFee;
        data["userFee"] = this.userFee;
        data["enableBilling"] = this.enableBilling;
        data["billingStartDate"] = this.billingStartDate;
        data["billingEndDate"] = this.billingEndDate;
        data["liquidSpaceTutorials"] = this.liquidSpaceTutorials;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["serviceChargeEnabled"] = this.serviceChargeEnabled;
        data["enableWireTransferPayments"] = this.enableWireTransferPayments;
        data["marketplaceInvoiceStatus"] = this.marketplaceInvoiceStatus;
        data["marketplaceEffectiveDate"] = this.marketplaceEffectiveDate;
        data["marketplaceTargetBalance"] = this.marketplaceTargetBalance;
        data["marketplacePaymentTerm"] = this.marketplacePaymentTerm;
        data["financeNotesInternal"] = this.financeNotesInternal;
        data["billingPaymentTerm"] = this.billingPaymentTerm;
        data["customerProfileId"] = this.customerProfileId;
        return data;
    }
}

export interface IEnterpriseAccountSettingsModel {
    id: string;
    name: string;
    description: string | undefined;
    contactName: string | undefined;
    contactEmail: string | undefined;
    simpleAddress1: string | undefined;
    simpleAddress2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    country: string | undefined;
    status: EnterpriseAccountStatus;
    salesRepEmail: string;
    liquidSpaceAccountManager: string | undefined;
    liquidSpaceTransactionManager: string | undefined;
    securityContact: string | undefined;
    plan: EnterpriseAccountPlan;
    classification: EnterpriseClassification;
    memberLimit: number;
    teamLimit: number;
    activeDate: string | undefined;
    subscriptionCost: string | undefined;
    subscriptionTerm: number | undefined;
    socialActivityEnabled: boolean;
    socialCollaborationPortalEnabled: boolean;
    enhancedReservationRemindersEnabled: boolean;
    emailDomains: string | undefined;
    totalAvailableMarket: number | undefined;
    serviceableAvailableMarket: number | undefined;
    currentlyAddressableMarket: number | undefined;
    demandType: EnterpriseDemandType;
    isMarketplaceAccount: boolean;
    displayExtendedNetwork: DisplayExtendedNetwork;
    campaignOptions: CampaignOptionsModel;
    financeContacts: string[];
    billingPeriod: EnterpriseAccountBillingPeriod;
    platformFee: number | undefined;
    userFee: number | undefined;
    enableBilling: boolean;
    billingStartDate: string | undefined;
    billingEndDate: string | undefined;
    liquidSpaceTutorials: boolean;
    purchaseOrderNumber: string | undefined;
    serviceChargeEnabled: boolean;
    enableWireTransferPayments: boolean;
    marketplaceInvoiceStatus: InvoiceGenerationStatus;
    marketplaceEffectiveDate: string | undefined;
    marketplaceTargetBalance: number | undefined;
    marketplacePaymentTerm: PaymentTerm;
    financeNotesInternal: string | undefined;
    billingPaymentTerm: PaymentTerm | undefined;
    customerProfileId: string | undefined;
}

/** 0 = None 1 = OnDemand 2 = Dedicated 3 = Both */
export enum DisplayExtendedNetwork {
    None = 0,
    OnDemand = 1,
    Dedicated = 2,
    Both = 3,
}

export class CampaignOptionsModel implements ICampaignOptionsModel {
    campaignVideoEnabled!: boolean;
    loomVideoUrl!: string | undefined;

    constructor(data?: ICampaignOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.campaignVideoEnabled = _data["campaignVideoEnabled"];
            this.loomVideoUrl = _data["loomVideoUrl"];
        }
    }

    static fromJS(data: any): CampaignOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignVideoEnabled"] = this.campaignVideoEnabled;
        data["loomVideoUrl"] = this.loomVideoUrl;
        return data;
    }
}

export interface ICampaignOptionsModel {
    campaignVideoEnabled: boolean;
    loomVideoUrl: string | undefined;
}

/** 0 = Monthly 1 = Annual */
export enum EnterpriseAccountBillingPeriod {
    Monthly = 0,
    Annual = 1,
}

/** 0 = Net15 1 = Net30 2 = Net45 3 = Net60 */
export enum PaymentTerm {
    Net15 = 0,
    Net30 = 1,
    Net45 = 2,
    Net60 = 3,
}

export class EventHistoryModel implements IEventHistoryModel {
    id!: string;
    typedObjectId!: string;
    type!: EventHistoryType;
    state!: EventHistoryState;
    created!: string;
    message!: string;
    authorEmail!: string | undefined;

    constructor(data?: IEventHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typedObjectId = _data["typedObjectId"];
            this.type = _data["type"];
            this.state = _data["state"];
            this.created = _data["created"];
            this.message = _data["message"];
            this.authorEmail = _data["authorEmail"];
        }
    }

    static fromJS(data: any): EventHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new EventHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typedObjectId"] = this.typedObjectId;
        data["type"] = this.type;
        data["state"] = this.state;
        data["created"] = this.created;
        data["message"] = this.message;
        data["authorEmail"] = this.authorEmail;
        return data;
    }
}

export interface IEventHistoryModel {
    id: string;
    typedObjectId: string;
    type: EventHistoryType;
    state: EventHistoryState;
    created: string;
    message: string;
    authorEmail: string | undefined;
}

/** 0 = Member 1 = Venue 2 = EnterpriseAccount */
export enum EventHistoryType {
    Member = 0,
    Venue = 1,
    EnterpriseAccount = 2,
}

/** 0 = Note 1 = StatusChange 2 = EventEdited 3 = EventDeleted 4 = MembershipStatusChange 5 = LiquidspaceProStatusChange 6 = AccountCreated 7 = AccountEdited 8 = AdminAdded 9 = AdminRemoved 10 = VideoWatchedInterested 11 = VideoWatchedNotInterested */
export enum EventHistoryState {
    Note = 0,
    StatusChange = 1,
    EventEdited = 2,
    EventDeleted = 3,
    MembershipStatusChange = 4,
    LiquidspaceProStatusChange = 5,
    AccountCreated = 6,
    AccountEdited = 7,
    AdminAdded = 8,
    AdminRemoved = 9,
    VideoWatchedInterested = 10,
    VideoWatchedNotInterested = 11,
}

export class EnterpriseAccountHeadquarterViewModel implements IEnterpriseAccountHeadquarterViewModel {
    name!: string;
    venueId!: string;
    geofence!: GeofenceViewModel;
    customCTA!: CustomCTAViewModel;

    constructor(data?: IEnterpriseAccountHeadquarterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.venueId = _data["venueId"];
            this.geofence = _data["geofence"] ? GeofenceViewModel.fromJS(_data["geofence"]) : <any>undefined;
            this.customCTA = _data["customCTA"] ? CustomCTAViewModel.fromJS(_data["customCTA"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EnterpriseAccountHeadquarterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountHeadquarterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["venueId"] = this.venueId;
        data["geofence"] = this.geofence ? this.geofence.toJSON() : <any>undefined;
        data["customCTA"] = this.customCTA ? this.customCTA.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnterpriseAccountHeadquarterViewModel {
    name: string;
    venueId: string;
    geofence: GeofenceViewModel;
    customCTA: CustomCTAViewModel;
}

export class GeofenceViewModel implements IGeofenceViewModel {
    enabled!: boolean;
    radiusMiles!: number;
    message!: string | undefined;

    constructor(data?: IGeofenceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.radiusMiles = _data["radiusMiles"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): GeofenceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["radiusMiles"] = this.radiusMiles;
        data["message"] = this.message;
        return data;
    }
}

export interface IGeofenceViewModel {
    enabled: boolean;
    radiusMiles: number;
    message: string | undefined;
}

export class CustomCTAViewModel implements ICustomCTAViewModel {
    enabled!: boolean;
    text!: string | undefined;
    url!: string | undefined;

    constructor(data?: ICustomCTAViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.text = _data["text"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CustomCTAViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomCTAViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["text"] = this.text;
        data["url"] = this.url;
        return data;
    }
}

export interface ICustomCTAViewModel {
    enabled: boolean;
    text: string | undefined;
    url: string | undefined;
}

export class TeamMemberInfoViewModel implements ITeamMemberInfoViewModel {
    memberId!: string;
    fullName!: string;
    email!: string;
    created!: string | undefined;
    notes!: string;
    status!: EnterpriseAccountInvitationStatus;
    teamId!: string;
    teamName!: string;
    homeBase!: string | undefined;
    isSuspended!: boolean;

    constructor(data?: ITeamMemberInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.created = _data["created"];
            this.notes = _data["notes"];
            this.status = _data["status"];
            this.teamId = _data["teamId"];
            this.teamName = _data["teamName"];
            this.homeBase = _data["homeBase"];
            this.isSuspended = _data["isSuspended"];
        }
    }

    static fromJS(data: any): TeamMemberInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["created"] = this.created;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["homeBase"] = this.homeBase;
        data["isSuspended"] = this.isSuspended;
        return data;
    }
}

export interface ITeamMemberInfoViewModel {
    memberId: string;
    fullName: string;
    email: string;
    created: string | undefined;
    notes: string;
    status: EnterpriseAccountInvitationStatus;
    teamId: string;
    teamName: string;
    homeBase: string | undefined;
    isSuspended: boolean;
}

/** 0 = None 1 = Invited 2 = Active 3 = Suspended 4 = Removed 5 = Pending */
export enum EnterpriseAccountInvitationStatus {
    None = 0,
    Invited = 1,
    Active = 2,
    Suspended = 3,
    Removed = 4,
    Pending = 5,
}

export class TeamMemberViewModel implements ITeamMemberViewModel {
    /** Member ID */
    id!: string;
    fullName!: string;
    email!: string | undefined;
    createdDate!: string | undefined;
    notes!: string | undefined;
    status!: EnterpriseAccountInvitationStatus;
    memberGroupStatus!: MemberGroupInvitationStatus;
    title!: string | undefined;
    phoneNumber!: string | undefined;
    geoCity!: string | undefined;
    geoCountry!: string | undefined;
    picture!: string | undefined;
    team!: string | undefined;
    externalAccountId!: string | undefined;
    costCenter!: string | undefined;
    company!: string | undefined;
    teamId!: string;
    joinedDate!: string | undefined;
    lastActivityDate!: string | undefined;
    locations!: OnDemandLocationViewModel[];
    extendedSearchOptions!: ExtendedSearchOptionsModel | undefined;
    searchSettings!: { [key in keyof typeof SearchSettingsEnum]?: boolean; };
    country!: string | undefined;

    constructor(data?: ITeamMemberViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.createdDate = _data["createdDate"];
            this.notes = _data["notes"];
            this.status = _data["status"];
            this.memberGroupStatus = _data["memberGroupStatus"];
            this.title = _data["title"];
            this.phoneNumber = _data["phoneNumber"];
            this.geoCity = _data["geoCity"];
            this.geoCountry = _data["geoCountry"];
            this.picture = _data["picture"];
            this.team = _data["team"];
            this.externalAccountId = _data["externalAccountId"];
            this.costCenter = _data["costCenter"];
            this.company = _data["company"];
            this.teamId = _data["teamId"];
            this.joinedDate = _data["joinedDate"];
            this.lastActivityDate = _data["lastActivityDate"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(OnDemandLocationViewModel.fromJS(item));
            }
            this.extendedSearchOptions = _data["extendedSearchOptions"] ? ExtendedSearchOptionsModel.fromJS(_data["extendedSearchOptions"]) : <any>undefined;
            if (_data["searchSettings"]) {
                this.searchSettings = {} as any;
                for (let key in _data["searchSettings"]) {
                    if (_data["searchSettings"].hasOwnProperty(key))
                        (<any>this.searchSettings)![key] = _data["searchSettings"][key];
                }
            }
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): TeamMemberViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["createdDate"] = this.createdDate;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["memberGroupStatus"] = this.memberGroupStatus;
        data["title"] = this.title;
        data["phoneNumber"] = this.phoneNumber;
        data["geoCity"] = this.geoCity;
        data["geoCountry"] = this.geoCountry;
        data["picture"] = this.picture;
        data["team"] = this.team;
        data["externalAccountId"] = this.externalAccountId;
        data["costCenter"] = this.costCenter;
        data["company"] = this.company;
        data["teamId"] = this.teamId;
        data["joinedDate"] = this.joinedDate;
        data["lastActivityDate"] = this.lastActivityDate;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["extendedSearchOptions"] = this.extendedSearchOptions ? this.extendedSearchOptions.toJSON() : <any>undefined;
        if (this.searchSettings) {
            data["searchSettings"] = {};
            for (let key in this.searchSettings) {
                if (this.searchSettings.hasOwnProperty(key))
                    (<any>data["searchSettings"])[key] = (<any>this.searchSettings)[key];
            }
        }
        data["country"] = this.country;
        return data;
    }
}

export interface ITeamMemberViewModel {
    /** Member ID */
    id: string;
    fullName: string;
    email: string | undefined;
    createdDate: string | undefined;
    notes: string | undefined;
    status: EnterpriseAccountInvitationStatus;
    memberGroupStatus: MemberGroupInvitationStatus;
    title: string | undefined;
    phoneNumber: string | undefined;
    geoCity: string | undefined;
    geoCountry: string | undefined;
    picture: string | undefined;
    team: string | undefined;
    externalAccountId: string | undefined;
    costCenter: string | undefined;
    company: string | undefined;
    teamId: string;
    joinedDate: string | undefined;
    lastActivityDate: string | undefined;
    locations: OnDemandLocationViewModel[];
    extendedSearchOptions: ExtendedSearchOptionsModel | undefined;
    searchSettings: { [key in keyof typeof SearchSettingsEnum]?: boolean; };
    country: string | undefined;
}

/** 0 = Pending 1 = Active -1 = None */
export enum MemberGroupInvitationStatus {
    Pending = 0,
    Active = 1,
    None = -1,
}

export class OnDemandLocationViewModel implements IOnDemandLocationViewModel {
    locationType!: EnterpriseLocationType;
    id!: string;
    description!: string;
    locationId!: string;
    name!: string;
    city!: string | undefined;
    state!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    isGeofenceEnabled!: boolean;
    geofenceRadiusMiles!: number | undefined;

    constructor(data?: IOnDemandLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.locationType = _data["locationType"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.isGeofenceEnabled = _data["isGeofenceEnabled"];
            this.geofenceRadiusMiles = _data["geofenceRadiusMiles"];
        }
    }

    static fromJS(data: any): OnDemandLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OnDemandLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationType"] = this.locationType;
        data["id"] = this.id;
        data["description"] = this.description;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["state"] = this.state;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["isGeofenceEnabled"] = this.isGeofenceEnabled;
        data["geofenceRadiusMiles"] = this.geofenceRadiusMiles;
        return data;
    }
}

export interface IOnDemandLocationViewModel {
    locationType: EnterpriseLocationType;
    id: string;
    description: string;
    locationId: string;
    name: string;
    city: string | undefined;
    state: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    isGeofenceEnabled: boolean;
    geofenceRadiusMiles: number | undefined;
}

/** 0 = Headquarter 1 = PreferredLocations */
export enum EnterpriseLocationType {
    Headquarter = 0,
    PreferredLocations = 1,
}

export class ExtendedSearchOptionsModel implements IExtendedSearchOptionsModel {
    reservationMethod!: WorkspaceReservationMethod | undefined;
    spaceTypes!: SpaceType;
    minPrice!: number | undefined;
    maxPrice!: number | undefined;
    liquidSpacePro!: boolean;
    immutableOptions!: ForceableExtendedSearchOptionsProperties[];
    location!: string | undefined;
    workspaceCapacity!: number | undefined;
    reservationLengthMinutes!: number | undefined;
    startTime!: string | undefined;
    hourlySpaceTypesWithoutTrainingArray!: SpaceType[];
    monthlySpaceTypesWithoutDesksArray!: SpaceType[];

    constructor(data?: IExtendedSearchOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.reservationMethod = _data["reservationMethod"];
            this.spaceTypes = _data["spaceTypes"];
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
            this.liquidSpacePro = _data["liquidSpacePro"];
            if (Array.isArray(_data["immutableOptions"])) {
                this.immutableOptions = [] as any;
                for (let item of _data["immutableOptions"])
                    this.immutableOptions!.push(item);
            }
            this.location = _data["location"];
            this.workspaceCapacity = _data["workspaceCapacity"];
            this.reservationLengthMinutes = _data["reservationLengthMinutes"];
            this.startTime = _data["startTime"];
            if (Array.isArray(_data["hourlySpaceTypesWithoutTrainingArray"])) {
                this.hourlySpaceTypesWithoutTrainingArray = [] as any;
                for (let item of _data["hourlySpaceTypesWithoutTrainingArray"])
                    this.hourlySpaceTypesWithoutTrainingArray!.push(item);
            }
            if (Array.isArray(_data["monthlySpaceTypesWithoutDesksArray"])) {
                this.monthlySpaceTypesWithoutDesksArray = [] as any;
                for (let item of _data["monthlySpaceTypesWithoutDesksArray"])
                    this.monthlySpaceTypesWithoutDesksArray!.push(item);
            }
        }
    }

    static fromJS(data: any): ExtendedSearchOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedSearchOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationMethod"] = this.reservationMethod;
        data["spaceTypes"] = this.spaceTypes;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        data["liquidSpacePro"] = this.liquidSpacePro;
        if (Array.isArray(this.immutableOptions)) {
            data["immutableOptions"] = [];
            for (let item of this.immutableOptions)
                data["immutableOptions"].push(item);
        }
        data["location"] = this.location;
        data["workspaceCapacity"] = this.workspaceCapacity;
        data["reservationLengthMinutes"] = this.reservationLengthMinutes;
        data["startTime"] = this.startTime;
        if (Array.isArray(this.hourlySpaceTypesWithoutTrainingArray)) {
            data["hourlySpaceTypesWithoutTrainingArray"] = [];
            for (let item of this.hourlySpaceTypesWithoutTrainingArray)
                data["hourlySpaceTypesWithoutTrainingArray"].push(item);
        }
        if (Array.isArray(this.monthlySpaceTypesWithoutDesksArray)) {
            data["monthlySpaceTypesWithoutDesksArray"] = [];
            for (let item of this.monthlySpaceTypesWithoutDesksArray)
                data["monthlySpaceTypesWithoutDesksArray"].push(item);
        }
        return data;
    }
}

export interface IExtendedSearchOptionsModel {
    reservationMethod: WorkspaceReservationMethod | undefined;
    spaceTypes: SpaceType;
    minPrice: number | undefined;
    maxPrice: number | undefined;
    liquidSpacePro: boolean;
    immutableOptions: ForceableExtendedSearchOptionsProperties[];
    location: string | undefined;
    workspaceCapacity: number | undefined;
    reservationLengthMinutes: number | undefined;
    startTime: string | undefined;
    hourlySpaceTypesWithoutTrainingArray: SpaceType[];
    monthlySpaceTypesWithoutDesksArray: SpaceType[];
}

/** 0 = ReservationMethod 1 = SpaceTypes 2 = MinPrice 3 = MaxPrice 4 = LiquidSpacePro */
export enum ForceableExtendedSearchOptionsProperties {
    ReservationMethod = 0,
    SpaceTypes = 1,
    MinPrice = 2,
    MaxPrice = 3,
    LiquidSpacePro = 4,
}

/** 0 = PreferredVenue 1 = PreferredVenueImmutableOnSRP 2 = PreferredCollections 3 = Extended */
export enum SearchSettingsEnum {
    PreferredVenue = 0,
    PreferredVenueImmutableOnSRP = 1,
    PreferredCollections = 2,
    Extended = 3,
}

export class MemberAutocomplete implements IMemberAutocomplete {
    id!: string;
    email!: string;

    constructor(data?: IMemberAutocomplete) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): MemberAutocomplete {
        data = typeof data === 'object' ? data : {};
        let result = new MemberAutocomplete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        return data;
    }
}

export interface IMemberAutocomplete {
    id: string;
    email: string;
}

export class TeamMemberSpendResponse implements ITeamMemberSpendResponse {
    totalUSD!: number;
    percentOfMonthlyBudget!: number | undefined;
    percentOfMonthlyMemberBudget!: number | undefined;
    month!: string;

    constructor(data?: ITeamMemberSpendResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.totalUSD = _data["totalUSD"];
            this.percentOfMonthlyBudget = _data["percentOfMonthlyBudget"];
            this.percentOfMonthlyMemberBudget = _data["percentOfMonthlyMemberBudget"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): TeamMemberSpendResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberSpendResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalUSD"] = this.totalUSD;
        data["percentOfMonthlyBudget"] = this.percentOfMonthlyBudget;
        data["percentOfMonthlyMemberBudget"] = this.percentOfMonthlyMemberBudget;
        data["month"] = this.month;
        return data;
    }
}

export interface ITeamMemberSpendResponse {
    totalUSD: number;
    percentOfMonthlyBudget: number | undefined;
    percentOfMonthlyMemberBudget: number | undefined;
    month: string;
}

export class TeamMemberRatingCounters implements ITeamMemberRatingCounters {
    count!: number;
    average!: number | undefined;

    constructor(data?: ITeamMemberRatingCounters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.average = _data["average"];
        }
    }

    static fromJS(data: any): TeamMemberRatingCounters {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberRatingCounters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["average"] = this.average;
        return data;
    }
}

export interface ITeamMemberRatingCounters {
    count: number;
    average: number | undefined;
}

export class TeamMemberActivity implements ITeamMemberActivity {
    createTime!: string;
    text!: string | undefined;
    id!: string;

    constructor(data?: ITeamMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.createTime = _data["createTime"];
            this.text = _data["text"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TeamMemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime;
        data["text"] = this.text;
        data["id"] = this.id;
        return data;
    }
}

export interface ITeamMemberActivity {
    createTime: string;
    text: string | undefined;
    id: string;
}

export class TeamMemberBudgetViewModel implements ITeamMemberBudgetViewModel {
    teamSettings!: TeamMemberBudgetSettingsViewModel;
    memberSettings!: TeamMemberBudgetSettingsViewModel;

    constructor(data?: ITeamMemberBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.teamSettings = _data["teamSettings"] ? TeamMemberBudgetSettingsViewModel.fromJS(_data["teamSettings"]) : <any>undefined;
            this.memberSettings = _data["memberSettings"] ? TeamMemberBudgetSettingsViewModel.fromJS(_data["memberSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TeamMemberBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamSettings"] = this.teamSettings ? this.teamSettings.toJSON() : <any>undefined;
        data["memberSettings"] = this.memberSettings ? this.memberSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITeamMemberBudgetViewModel {
    teamSettings: TeamMemberBudgetSettingsViewModel;
    memberSettings: TeamMemberBudgetSettingsViewModel;
}

export class TeamMemberBudgetSettingsViewModel implements ITeamMemberBudgetSettingsViewModel {
    allowExceedBudgetLimits!: boolean | undefined;
    /** Max budget per day per member */
    maxDailyMemberBudget!: number | undefined;
    /** Max budget per month per member */
    maxMonthlyMemberBudget!: number | undefined;
    /** Max budget per month per team */
    maxMonthlyTeamBudget!: number | undefined;
    /** Per-reservation Hourly Desk budget */
    maxHourlyDeskBudget!: number | undefined;
    /** Per-reservation Hourly Meeting budget */
    maxHourlyMeetingRoomBudget!: number | undefined;
    /** Per-reservation Hourly Office budget */
    maxHourlyOfficeBudget!: number | undefined;
    /** Per-reservation Hourly EventSpace budget */
    maxHourlyEventSpaceBudget!: number | undefined;

    constructor(data?: ITeamMemberBudgetSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.allowExceedBudgetLimits = _data["allowExceedBudgetLimits"];
            this.maxDailyMemberBudget = _data["maxDailyMemberBudget"];
            this.maxMonthlyMemberBudget = _data["maxMonthlyMemberBudget"];
            this.maxMonthlyTeamBudget = _data["maxMonthlyTeamBudget"];
            this.maxHourlyDeskBudget = _data["maxHourlyDeskBudget"];
            this.maxHourlyMeetingRoomBudget = _data["maxHourlyMeetingRoomBudget"];
            this.maxHourlyOfficeBudget = _data["maxHourlyOfficeBudget"];
            this.maxHourlyEventSpaceBudget = _data["maxHourlyEventSpaceBudget"];
        }
    }

    static fromJS(data: any): TeamMemberBudgetSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberBudgetSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowExceedBudgetLimits"] = this.allowExceedBudgetLimits;
        data["maxDailyMemberBudget"] = this.maxDailyMemberBudget;
        data["maxMonthlyMemberBudget"] = this.maxMonthlyMemberBudget;
        data["maxMonthlyTeamBudget"] = this.maxMonthlyTeamBudget;
        data["maxHourlyDeskBudget"] = this.maxHourlyDeskBudget;
        data["maxHourlyMeetingRoomBudget"] = this.maxHourlyMeetingRoomBudget;
        data["maxHourlyOfficeBudget"] = this.maxHourlyOfficeBudget;
        data["maxHourlyEventSpaceBudget"] = this.maxHourlyEventSpaceBudget;
        return data;
    }
}

export interface ITeamMemberBudgetSettingsViewModel {
    allowExceedBudgetLimits: boolean | undefined;
    /** Max budget per day per member */
    maxDailyMemberBudget: number | undefined;
    /** Max budget per month per member */
    maxMonthlyMemberBudget: number | undefined;
    /** Max budget per month per team */
    maxMonthlyTeamBudget: number | undefined;
    /** Per-reservation Hourly Desk budget */
    maxHourlyDeskBudget: number | undefined;
    /** Per-reservation Hourly Meeting budget */
    maxHourlyMeetingRoomBudget: number | undefined;
    /** Per-reservation Hourly Office budget */
    maxHourlyOfficeBudget: number | undefined;
    /** Per-reservation Hourly EventSpace budget */
    maxHourlyEventSpaceBudget: number | undefined;
}

export class PaymentProfileSettingsViewModel implements IPaymentProfileSettingsViewModel {
    enable!: boolean;
    paymentProfileId!: string | undefined;

    constructor(data?: IPaymentProfileSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
            this.paymentProfileId = _data["paymentProfileId"];
        }
    }

    static fromJS(data: any): PaymentProfileSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProfileSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        data["paymentProfileId"] = this.paymentProfileId;
        return data;
    }
}

export interface IPaymentProfileSettingsViewModel {
    enable: boolean;
    paymentProfileId: string | undefined;
}

export class EnterprisePortalSignupInfoViewModel implements IEnterprisePortalSignupInfoViewModel {
    email!: string;
    memberId!: string | undefined;
    isActiveAndOnboarded!: boolean;
    firstName!: string | undefined;
    fullName!: string | undefined;
    ssoRequired!: boolean;
    ssoUrl!: string | undefined;
    /** Also means that user onboarded and active */
    singInRequired!: boolean;
    isAuthorized!: boolean;
    /** Always true for VerifySignup */
    verificationCompleted!: boolean;

    constructor(data?: IEnterprisePortalSignupInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.memberId = _data["memberId"];
            this.isActiveAndOnboarded = _data["isActiveAndOnboarded"];
            this.firstName = _data["firstName"];
            this.fullName = _data["fullName"];
            this.ssoRequired = _data["ssoRequired"];
            this.ssoUrl = _data["ssoUrl"];
            this.singInRequired = _data["singInRequired"];
            this.isAuthorized = _data["isAuthorized"];
            this.verificationCompleted = _data["verificationCompleted"];
        }
    }

    static fromJS(data: any): EnterprisePortalSignupInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterprisePortalSignupInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["memberId"] = this.memberId;
        data["isActiveAndOnboarded"] = this.isActiveAndOnboarded;
        data["firstName"] = this.firstName;
        data["fullName"] = this.fullName;
        data["ssoRequired"] = this.ssoRequired;
        data["ssoUrl"] = this.ssoUrl;
        data["singInRequired"] = this.singInRequired;
        data["isAuthorized"] = this.isAuthorized;
        data["verificationCompleted"] = this.verificationCompleted;
        return data;
    }
}

export interface IEnterprisePortalSignupInfoViewModel {
    email: string;
    memberId: string | undefined;
    isActiveAndOnboarded: boolean;
    firstName: string | undefined;
    fullName: string | undefined;
    ssoRequired: boolean;
    ssoUrl: string | undefined;
    /** Also means that user onboarded and active */
    singInRequired: boolean;
    isAuthorized: boolean;
    /** Always true for VerifySignup */
    verificationCompleted: boolean;
}

export class EnterprisePortalRegisterRequest implements IEnterprisePortalRegisterRequest {
    fullName!: string | undefined;
    email!: string;
    phoneNumber!: string | undefined;
    password!: string | undefined;

    constructor(data?: IEnterprisePortalRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): EnterprisePortalRegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnterprisePortalRegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        return data;
    }
}

export interface IEnterprisePortalRegisterRequest {
    fullName: string | undefined;
    email: string;
    phoneNumber: string | undefined;
    password: string | undefined;
}

export class EnterpriseAccountMembersImportResponse implements IEnterpriseAccountMembersImportResponse {
    toProcess!: number;
    processed!: number;
    importId!: string;
    isCompleted!: boolean;

    constructor(data?: IEnterpriseAccountMembersImportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.toProcess = _data["toProcess"];
            this.processed = _data["processed"];
            this.importId = _data["importId"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): EnterpriseAccountMembersImportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountMembersImportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toProcess"] = this.toProcess;
        data["processed"] = this.processed;
        data["importId"] = this.importId;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IEnterpriseAccountMembersImportResponse {
    toProcess: number;
    processed: number;
    importId: string;
    isCompleted: boolean;
}

export class BaseReservationViewModel implements IBaseReservationViewModel {
    /** Reservation ID. May be fake one for recurrent occurence. */
    id!: string;
    /** Parent reservation ID for recurrent occurence; Reservation ID in other case. */
    idForLink!: string;
    occurrenceDate!: string | undefined;
    applyDate!: string | undefined;
    deleted!: boolean;
    startTime!: string;
    endTime!: string;
    quantity!: number;
    /** In months */
    term!: number | undefined;
    finishDate!: string | undefined;
    recurrencePattern!: string | undefined;
    recurrenceExcludedDates!: string[];
    status!: ReservationStatus;
    spaceType!: SpaceType;
    reservationState!: ReservationState;
    reservationMethod!: ReservationMethod;
    bookingMethod!: BookingMethod | undefined;
    ownerId!: string;
    organizer!: ReservationMemberViewModel | undefined;
    title!: string;
    cancellationPolicy!: CancellationPolicy;
    amenities!: VenueAmenityViewModel[];
    invitees!: ReservationMaybeMemberViewModel[];
    reservationOperations!: ReservationOperationsAvailability | undefined;
    price!: CostInfoModel | undefined;
    costSummary!: CostSummaryViewModel | undefined;
    paymentHistory!: PaymentInformationViewModel[];
    paymentMethod!: PaymentMethodDescriptor | undefined;
    paymentMethodType!: PaymentMethod;
    promotion!: ReservationPromotion | undefined;
    venueId!: string;
    venueUrl!: string;
    workspaceId!: string;
    workspaceName!: string;
    picture!: string | undefined;
    workspaceCapacity!: number;
    workspaceUrl!: string;
    spaceTypeForCapacity!: string;
    hourlyRequestToBook!: HourlyRequestToBookMemberModel | undefined;
    isAutoRenew!: boolean;
    notes!: string | undefined;
    enableWireTransferPayments!: boolean;
    integrationReferences!: ReservationIntegrationReferences | undefined;
    bookingReason!: string | undefined;
    socialVisibility!: SocialVisibility | undefined;

    constructor(data?: IBaseReservationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idForLink = _data["idForLink"];
            this.occurrenceDate = _data["occurrenceDate"];
            this.applyDate = _data["applyDate"];
            this.deleted = _data["deleted"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.quantity = _data["quantity"];
            this.term = _data["term"];
            this.finishDate = _data["finishDate"];
            this.recurrencePattern = _data["recurrencePattern"];
            if (Array.isArray(_data["recurrenceExcludedDates"])) {
                this.recurrenceExcludedDates = [] as any;
                for (let item of _data["recurrenceExcludedDates"])
                    this.recurrenceExcludedDates!.push(item);
            }
            this.status = _data["status"];
            this.spaceType = _data["spaceType"];
            this.reservationState = _data["reservationState"];
            this.reservationMethod = _data["reservationMethod"];
            this.bookingMethod = _data["bookingMethod"];
            this.ownerId = _data["ownerId"];
            this.organizer = _data["organizer"] ? ReservationMemberViewModel.fromJS(_data["organizer"]) : <any>undefined;
            this.title = _data["title"];
            this.cancellationPolicy = _data["cancellationPolicy"];
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities!.push(VenueAmenityViewModel.fromJS(item));
            }
            if (Array.isArray(_data["invitees"])) {
                this.invitees = [] as any;
                for (let item of _data["invitees"])
                    this.invitees!.push(ReservationMaybeMemberViewModel.fromJS(item));
            }
            this.reservationOperations = _data["reservationOperations"] ? ReservationOperationsAvailability.fromJS(_data["reservationOperations"]) : <any>undefined;
            this.price = _data["price"] ? CostInfoModel.fromJS(_data["price"]) : <any>undefined;
            this.costSummary = _data["costSummary"] ? CostSummaryViewModel.fromJS(_data["costSummary"]) : <any>undefined;
            if (Array.isArray(_data["paymentHistory"])) {
                this.paymentHistory = [] as any;
                for (let item of _data["paymentHistory"])
                    this.paymentHistory!.push(PaymentInformationViewModel.fromJS(item));
            }
            this.paymentMethod = _data["paymentMethod"] ? PaymentMethodDescriptor.fromJS(_data["paymentMethod"]) : <any>undefined;
            this.paymentMethodType = _data["paymentMethodType"];
            this.promotion = _data["promotion"] ? ReservationPromotion.fromJS(_data["promotion"]) : <any>undefined;
            this.venueId = _data["venueId"];
            this.venueUrl = _data["venueUrl"];
            this.workspaceId = _data["workspaceId"];
            this.workspaceName = _data["workspaceName"];
            this.picture = _data["picture"];
            this.workspaceCapacity = _data["workspaceCapacity"];
            this.workspaceUrl = _data["workspaceUrl"];
            this.spaceTypeForCapacity = _data["spaceTypeForCapacity"];
            this.hourlyRequestToBook = _data["hourlyRequestToBook"] ? HourlyRequestToBookMemberModel.fromJS(_data["hourlyRequestToBook"]) : <any>undefined;
            this.isAutoRenew = _data["isAutoRenew"];
            this.notes = _data["notes"];
            this.enableWireTransferPayments = _data["enableWireTransferPayments"];
            this.integrationReferences = _data["integrationReferences"] ? ReservationIntegrationReferences.fromJS(_data["integrationReferences"]) : <any>undefined;
            this.bookingReason = _data["bookingReason"];
            this.socialVisibility = _data["socialVisibility"];
        }
    }

    static fromJS(data: any): BaseReservationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseReservationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idForLink"] = this.idForLink;
        data["occurrenceDate"] = this.occurrenceDate;
        data["applyDate"] = this.applyDate;
        data["deleted"] = this.deleted;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["quantity"] = this.quantity;
        data["term"] = this.term;
        data["finishDate"] = this.finishDate;
        data["recurrencePattern"] = this.recurrencePattern;
        if (Array.isArray(this.recurrenceExcludedDates)) {
            data["recurrenceExcludedDates"] = [];
            for (let item of this.recurrenceExcludedDates)
                data["recurrenceExcludedDates"].push(item);
        }
        data["status"] = this.status;
        data["spaceType"] = this.spaceType;
        data["reservationState"] = this.reservationState;
        data["reservationMethod"] = this.reservationMethod;
        data["bookingMethod"] = this.bookingMethod;
        data["ownerId"] = this.ownerId;
        data["organizer"] = this.organizer ? this.organizer.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["cancellationPolicy"] = this.cancellationPolicy;
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item.toJSON());
        }
        if (Array.isArray(this.invitees)) {
            data["invitees"] = [];
            for (let item of this.invitees)
                data["invitees"].push(item.toJSON());
        }
        data["reservationOperations"] = this.reservationOperations ? this.reservationOperations.toJSON() : <any>undefined;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["costSummary"] = this.costSummary ? this.costSummary.toJSON() : <any>undefined;
        if (Array.isArray(this.paymentHistory)) {
            data["paymentHistory"] = [];
            for (let item of this.paymentHistory)
                data["paymentHistory"].push(item.toJSON());
        }
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["paymentMethodType"] = this.paymentMethodType;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["venueId"] = this.venueId;
        data["venueUrl"] = this.venueUrl;
        data["workspaceId"] = this.workspaceId;
        data["workspaceName"] = this.workspaceName;
        data["picture"] = this.picture;
        data["workspaceCapacity"] = this.workspaceCapacity;
        data["workspaceUrl"] = this.workspaceUrl;
        data["spaceTypeForCapacity"] = this.spaceTypeForCapacity;
        data["hourlyRequestToBook"] = this.hourlyRequestToBook ? this.hourlyRequestToBook.toJSON() : <any>undefined;
        data["isAutoRenew"] = this.isAutoRenew;
        data["notes"] = this.notes;
        data["enableWireTransferPayments"] = this.enableWireTransferPayments;
        data["integrationReferences"] = this.integrationReferences ? this.integrationReferences.toJSON() : <any>undefined;
        data["bookingReason"] = this.bookingReason;
        data["socialVisibility"] = this.socialVisibility;
        return data;
    }
}

export interface IBaseReservationViewModel {
    /** Reservation ID. May be fake one for recurrent occurence. */
    id: string;
    /** Parent reservation ID for recurrent occurence; Reservation ID in other case. */
    idForLink: string;
    occurrenceDate: string | undefined;
    applyDate: string | undefined;
    deleted: boolean;
    startTime: string;
    endTime: string;
    quantity: number;
    /** In months */
    term: number | undefined;
    finishDate: string | undefined;
    recurrencePattern: string | undefined;
    recurrenceExcludedDates: string[];
    status: ReservationStatus;
    spaceType: SpaceType;
    reservationState: ReservationState;
    reservationMethod: ReservationMethod;
    bookingMethod: BookingMethod | undefined;
    ownerId: string;
    organizer: ReservationMemberViewModel | undefined;
    title: string;
    cancellationPolicy: CancellationPolicy;
    amenities: VenueAmenityViewModel[];
    invitees: ReservationMaybeMemberViewModel[];
    reservationOperations: ReservationOperationsAvailability | undefined;
    price: CostInfoModel | undefined;
    costSummary: CostSummaryViewModel | undefined;
    paymentHistory: PaymentInformationViewModel[];
    paymentMethod: PaymentMethodDescriptor | undefined;
    paymentMethodType: PaymentMethod;
    promotion: ReservationPromotion | undefined;
    venueId: string;
    venueUrl: string;
    workspaceId: string;
    workspaceName: string;
    picture: string | undefined;
    workspaceCapacity: number;
    workspaceUrl: string;
    spaceTypeForCapacity: string;
    hourlyRequestToBook: HourlyRequestToBookMemberModel | undefined;
    isAutoRenew: boolean;
    notes: string | undefined;
    enableWireTransferPayments: boolean;
    integrationReferences: ReservationIntegrationReferences | undefined;
    bookingReason: string | undefined;
    socialVisibility: SocialVisibility | undefined;
}

export class TeamMemberReservation extends BaseReservationViewModel implements ITeamMemberReservation {
    venueName!: string;
    address!: string;
    latitude!: number | undefined;
    longitude!: number | undefined;
    venueAverageRating!: number;
    venueRatingCount!: number;
    entryInformation!: string;
    venueHostName!: string | undefined;
    venueHostLastName!: string | undefined;
    venueHostPhone!: string | undefined;
    reviewId!: string | undefined;
    memberStars!: number | undefined;
    memberReviewText!: string | undefined;
    memberReviewName!: string | undefined;
    isToday!: boolean;

    constructor(data?: ITeamMemberReservation) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.venueName = _data["venueName"];
            this.address = _data["address"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.venueAverageRating = _data["venueAverageRating"];
            this.venueRatingCount = _data["venueRatingCount"];
            this.entryInformation = _data["entryInformation"];
            this.venueHostName = _data["venueHostName"];
            this.venueHostLastName = _data["venueHostLastName"];
            this.venueHostPhone = _data["venueHostPhone"];
            this.reviewId = _data["reviewId"];
            this.memberStars = _data["memberStars"];
            this.memberReviewText = _data["memberReviewText"];
            this.memberReviewName = _data["memberReviewName"];
            this.isToday = _data["isToday"];
        }
    }

    static fromJS(data: any): TeamMemberReservation {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberReservation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueName"] = this.venueName;
        data["address"] = this.address;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["venueAverageRating"] = this.venueAverageRating;
        data["venueRatingCount"] = this.venueRatingCount;
        data["entryInformation"] = this.entryInformation;
        data["venueHostName"] = this.venueHostName;
        data["venueHostLastName"] = this.venueHostLastName;
        data["venueHostPhone"] = this.venueHostPhone;
        data["reviewId"] = this.reviewId;
        data["memberStars"] = this.memberStars;
        data["memberReviewText"] = this.memberReviewText;
        data["memberReviewName"] = this.memberReviewName;
        data["isToday"] = this.isToday;
        super.toJSON(data);
        return data;
    }
}

export interface ITeamMemberReservation extends IBaseReservationViewModel {
    venueName: string;
    address: string;
    latitude: number | undefined;
    longitude: number | undefined;
    venueAverageRating: number;
    venueRatingCount: number;
    entryInformation: string;
    venueHostName: string | undefined;
    venueHostLastName: string | undefined;
    venueHostPhone: string | undefined;
    reviewId: string | undefined;
    memberStars: number | undefined;
    memberReviewText: string | undefined;
    memberReviewName: string | undefined;
    isToday: boolean;
}

/** 0 = Future 1 = UpcomingSoon 2 = CheckedIn 3 = CheckedOut 4 = RunningLate 5 = OnMyWay 6 = Declined 7 = Extended 100 = None */
export enum ReservationState {
    Future = 0,
    UpcomingSoon = 1,
    CheckedIn = 2,
    CheckedOut = 3,
    RunningLate = 4,
    OnMyWay = 5,
    Declined = 6,
    Extended = 7,
    None = 100,
}

/** 0 = FlexibleCancellation 1 = NoCancellation 2 = Moderate7 3 = Moderate14 4 = Extended 5 = Regus */
export enum CancellationPolicy {
    FlexibleCancellation = 0,
    NoCancellation = 1,
    Moderate7 = 2,
    Moderate14 = 3,
    Extended = 4,
    Regus = 5,
}

/** Model of configured venue amenity */
export class VenueAmenityViewModel implements IVenueAmenityViewModel {
    amenityId!: string;
    type!: VenueAmenityType;
    name!: string;
    description!: string | undefined;
    instruction!: string | undefined;
    hasPrice!: boolean;
    isWorkspace!: boolean;
    imageUrl!: string | undefined;
    paid!: boolean;

    constructor(data?: IVenueAmenityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.amenityId = _data["amenityId"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.instruction = _data["instruction"];
            this.hasPrice = _data["hasPrice"];
            this.isWorkspace = _data["isWorkspace"];
            this.imageUrl = _data["imageUrl"];
            this.paid = _data["paid"];
        }
    }

    static fromJS(data: any): VenueAmenityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueAmenityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amenityId"] = this.amenityId;
        data["type"] = this.type;
        data["name"] = this.name;
        data["description"] = this.description;
        data["instruction"] = this.instruction;
        data["hasPrice"] = this.hasPrice;
        data["isWorkspace"] = this.isWorkspace;
        data["imageUrl"] = this.imageUrl;
        data["paid"] = this.paid;
        return data;
    }
}

/** Model of configured venue amenity */
export interface IVenueAmenityViewModel {
    amenityId: string;
    type: VenueAmenityType;
    name: string;
    description: string | undefined;
    instruction: string | undefined;
    hasPrice: boolean;
    isWorkspace: boolean;
    imageUrl: string | undefined;
    paid: boolean;
}

/** 0 = Unknown 1 = Requestable 2 = Included */
export enum VenueAmenityType {
    Unknown = 0,
    Requestable = 1,
    Included = 2,
}

export class ReservationOperationsAvailability implements IReservationOperationsAvailability {
    editAllowed!: boolean;
    cancelAllowed!: boolean;
    checkInAllowed!: boolean;
    checkOutAllowed!: boolean;
    doNotRenewAllowed!: boolean;
    extendAllowed!: boolean;
    inviteAllowed!: boolean;
    startDateTimeEditAllowed!: boolean;

    constructor(data?: IReservationOperationsAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.editAllowed = _data["editAllowed"];
            this.cancelAllowed = _data["cancelAllowed"];
            this.checkInAllowed = _data["checkInAllowed"];
            this.checkOutAllowed = _data["checkOutAllowed"];
            this.doNotRenewAllowed = _data["doNotRenewAllowed"];
            this.extendAllowed = _data["extendAllowed"];
            this.inviteAllowed = _data["inviteAllowed"];
            this.startDateTimeEditAllowed = _data["startDateTimeEditAllowed"];
        }
    }

    static fromJS(data: any): ReservationOperationsAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationOperationsAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editAllowed"] = this.editAllowed;
        data["cancelAllowed"] = this.cancelAllowed;
        data["checkInAllowed"] = this.checkInAllowed;
        data["checkOutAllowed"] = this.checkOutAllowed;
        data["doNotRenewAllowed"] = this.doNotRenewAllowed;
        data["extendAllowed"] = this.extendAllowed;
        data["inviteAllowed"] = this.inviteAllowed;
        data["startDateTimeEditAllowed"] = this.startDateTimeEditAllowed;
        return data;
    }
}

export interface IReservationOperationsAvailability {
    editAllowed: boolean;
    cancelAllowed: boolean;
    checkInAllowed: boolean;
    checkOutAllowed: boolean;
    doNotRenewAllowed: boolean;
    extendAllowed: boolean;
    inviteAllowed: boolean;
    startDateTimeEditAllowed: boolean;
}

export class CostSummaryViewModel implements ICostSummaryViewModel {
    total!: number;
    salesPrice!: number;
    salesTax!: number;
    setupFee!: number;
    deposit!: number;
    amountPaid!: number;
    incidentalsTotal!: number;
    incidentalsTax!: number;
    paymentMethod!: string;
    currencyPrefix!: string;
    isLastMonthIncidentalsPayment!: boolean;
    refundType!: RefundType | undefined;

    constructor(data?: ICostSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.salesPrice = _data["salesPrice"];
            this.salesTax = _data["salesTax"];
            this.setupFee = _data["setupFee"];
            this.deposit = _data["deposit"];
            this.amountPaid = _data["amountPaid"];
            this.incidentalsTotal = _data["incidentalsTotal"];
            this.incidentalsTax = _data["incidentalsTax"];
            this.paymentMethod = _data["paymentMethod"];
            this.currencyPrefix = _data["currencyPrefix"];
            this.isLastMonthIncidentalsPayment = _data["isLastMonthIncidentalsPayment"];
            this.refundType = _data["refundType"];
        }
    }

    static fromJS(data: any): CostSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CostSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["salesPrice"] = this.salesPrice;
        data["salesTax"] = this.salesTax;
        data["setupFee"] = this.setupFee;
        data["deposit"] = this.deposit;
        data["amountPaid"] = this.amountPaid;
        data["incidentalsTotal"] = this.incidentalsTotal;
        data["incidentalsTax"] = this.incidentalsTax;
        data["paymentMethod"] = this.paymentMethod;
        data["currencyPrefix"] = this.currencyPrefix;
        data["isLastMonthIncidentalsPayment"] = this.isLastMonthIncidentalsPayment;
        data["refundType"] = this.refundType;
        return data;
    }
}

export interface ICostSummaryViewModel {
    total: number;
    salesPrice: number;
    salesTax: number;
    setupFee: number;
    deposit: number;
    amountPaid: number;
    incidentalsTotal: number;
    incidentalsTax: number;
    paymentMethod: string;
    currencyPrefix: string;
    isLastMonthIncidentalsPayment: boolean;
    refundType: RefundType | undefined;
}

/** 0 = FullRefund 1 = MonthlyRate 2 = Incidentals 3 = Deposit 4 = SetupFee 5 = EditFee 6 = SalesTax 7 = HourlySalesPrice 8 = ServiceCharge */
export enum RefundType {
    FullRefund = 0,
    MonthlyRate = 1,
    Incidentals = 2,
    Deposit = 3,
    SetupFee = 4,
    EditFee = 5,
    SalesTax = 6,
    HourlySalesPrice = 7,
    ServiceCharge = 8,
}

export class PaymentInformationViewModel implements IPaymentInformationViewModel {
    date!: string;
    amount!: number;
    status!: string;
    transactionId!: string;
    paymentId!: string;
    currency!: CurrencyType;
    last4Digits!: string;
    displayAmount!: string;

    constructor(data?: IPaymentInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.transactionId = _data["transactionId"];
            this.paymentId = _data["paymentId"];
            this.currency = _data["currency"];
            this.last4Digits = _data["last4Digits"];
            this.displayAmount = _data["displayAmount"];
        }
    }

    static fromJS(data: any): PaymentInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["transactionId"] = this.transactionId;
        data["paymentId"] = this.paymentId;
        data["currency"] = this.currency;
        data["last4Digits"] = this.last4Digits;
        data["displayAmount"] = this.displayAmount;
        return data;
    }
}

export interface IPaymentInformationViewModel {
    date: string;
    amount: number;
    status: string;
    transactionId: string;
    paymentId: string;
    currency: CurrencyType;
    last4Digits: string;
    displayAmount: string;
}

export class PaymentMethodDescriptor implements IPaymentMethodDescriptor {
    /** Id and type of paying entity
Should be provided for centralized billing */
    payableKey!: PayableKey | undefined;
    paymentProvider!: PaymentProviderType;
    customerProfileId!: string;
    paymentProfileId!: string | undefined;
    deviceData!: string | undefined;

    constructor(data?: IPaymentMethodDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.payableKey = _data["payableKey"] ? PayableKey.fromJS(_data["payableKey"]) : <any>undefined;
            this.paymentProvider = _data["paymentProvider"];
            this.customerProfileId = _data["customerProfileId"];
            this.paymentProfileId = _data["paymentProfileId"];
            this.deviceData = _data["deviceData"];
        }
    }

    static fromJS(data: any): PaymentMethodDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payableKey"] = this.payableKey ? this.payableKey.toJSON() : <any>undefined;
        data["paymentProvider"] = this.paymentProvider;
        data["customerProfileId"] = this.customerProfileId;
        data["paymentProfileId"] = this.paymentProfileId;
        data["deviceData"] = this.deviceData;
        return data;
    }
}

export interface IPaymentMethodDescriptor {
    /** Id and type of paying entity
Should be provided for centralized billing */
    payableKey: PayableKey | undefined;
    paymentProvider: PaymentProviderType;
    customerProfileId: string;
    paymentProfileId: string | undefined;
    deviceData: string | undefined;
}

export class PayableKey implements IPayableKey {
    id!: string;
    payableType!: PayableType;

    constructor(data?: IPayableKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payableType = _data["payableType"];
        }
    }

    static fromJS(data: any): PayableKey {
        data = typeof data === 'object' ? data : {};
        let result = new PayableKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payableType"] = this.payableType;
        return data;
    }
}

export interface IPayableKey {
    id: string;
    payableType: PayableType;
}

/** 0 = Member 1 = MemberGroup 2 = Organization 3 = EnterpriseAccount */
export enum PayableType {
    Member = 0,
    MemberGroup = 1,
    Organization = 2,
    EnterpriseAccount = 3,
}

/** 0 = VenueBilled 1 = CreditCard */
export enum PaymentMethod {
    VenueBilled = 0,
    CreditCard = 1,
}

export class ReservationPromotion implements IReservationPromotion {
    code!: string | undefined;
    additionalInfo!: string | undefined;

    constructor(data?: IReservationPromotion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.additionalInfo = _data["additionalInfo"];
        }
    }

    static fromJS(data: any): ReservationPromotion {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPromotion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["additionalInfo"] = this.additionalInfo;
        return data;
    }
}

export interface IReservationPromotion {
    code: string | undefined;
    additionalInfo: string | undefined;
}

export class HourlyRequestToBookMemberModel implements IHourlyRequestToBookMemberModel {
    id!: string;
    status!: HourlyRequestToBookStatus;

    constructor(data?: IHourlyRequestToBookMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HourlyRequestToBookMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new HourlyRequestToBookMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IHourlyRequestToBookMemberModel {
    id: string;
    status: HourlyRequestToBookStatus;
}

/** 0 = Unknown 1 = Pending 2 = Approved 3 = CancelledByHost 4 = CancelledByGuest 5 = CancelledNoResponse 6 = Paused */
export enum HourlyRequestToBookStatus {
    Unknown = 0,
    Pending = 1,
    Approved = 2,
    CancelledByHost = 3,
    CancelledByGuest = 4,
    CancelledNoResponse = 5,
    Paused = 6,
}

/** 0 = All 1 = Future 2 = Past */
export enum ReservationTimeType {
    All = 0,
    Future = 1,
    Past = 2,
}

export class TeamMemberReservationCounters implements ITeamMemberReservationCounters {
    total!: number;
    active!: number;

    constructor(data?: ITeamMemberReservationCounters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): TeamMemberReservationCounters {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberReservationCounters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["active"] = this.active;
        return data;
    }
}

export interface ITeamMemberReservationCounters {
    total: number;
    active: number;
}

export class ExportEnterpriseAccountStatus implements IExportEnterpriseAccountStatus {
    id!: string;
    status!: ImportExportStatus;
    createDate!: string;
    authorId!: string | undefined;
    authorEmail!: string | undefined;
    exceptionMessage!: string | undefined;
    spreadsheetUrl!: string | undefined;

    constructor(data?: IExportEnterpriseAccountStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.createDate = _data["createDate"];
            this.authorId = _data["authorId"];
            this.authorEmail = _data["authorEmail"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.spreadsheetUrl = _data["spreadsheetUrl"];
        }
    }

    static fromJS(data: any): ExportEnterpriseAccountStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ExportEnterpriseAccountStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["createDate"] = this.createDate;
        data["authorId"] = this.authorId;
        data["authorEmail"] = this.authorEmail;
        data["exceptionMessage"] = this.exceptionMessage;
        data["spreadsheetUrl"] = this.spreadsheetUrl;
        return data;
    }
}

export interface IExportEnterpriseAccountStatus {
    id: string;
    status: ImportExportStatus;
    createDate: string;
    authorId: string | undefined;
    authorEmail: string | undefined;
    exceptionMessage: string | undefined;
    spreadsheetUrl: string | undefined;
}

/** 0 = Started 1 = Processing 2 = Completed 3 = Failed 4 = MonitoringTeminated */
export enum ImportExportStatus {
    Started = 0,
    Processing = 1,
    Completed = 2,
    Failed = 3,
    MonitoringTeminated = 4,
}

export class EnterpriseAccountsImportViewModel implements IEnterpriseAccountsImportViewModel {
    spreadsheetUrl!: string | undefined;
    notificationEmails!: string[];

    constructor(data?: IEnterpriseAccountsImportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.spreadsheetUrl = _data["spreadsheetUrl"];
            if (Array.isArray(_data["notificationEmails"])) {
                this.notificationEmails = [] as any;
                for (let item of _data["notificationEmails"])
                    this.notificationEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): EnterpriseAccountsImportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountsImportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spreadsheetUrl"] = this.spreadsheetUrl;
        if (Array.isArray(this.notificationEmails)) {
            data["notificationEmails"] = [];
            for (let item of this.notificationEmails)
                data["notificationEmails"].push(item);
        }
        return data;
    }
}

export interface IEnterpriseAccountsImportViewModel {
    spreadsheetUrl: string | undefined;
    notificationEmails: string[];
}

export class ImportEnterpriseAccountStatus implements IImportEnterpriseAccountStatus {
    id!: string;
    status!: ImportExportStatus;
    createDate!: string;
    authorId!: string | undefined;
    authorEmail!: string | undefined;
    exceptionMessage!: string | undefined;
    spreadsheetUrl!: string | undefined;

    constructor(data?: IImportEnterpriseAccountStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.createDate = _data["createDate"];
            this.authorId = _data["authorId"];
            this.authorEmail = _data["authorEmail"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.spreadsheetUrl = _data["spreadsheetUrl"];
        }
    }

    static fromJS(data: any): ImportEnterpriseAccountStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEnterpriseAccountStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["createDate"] = this.createDate;
        data["authorId"] = this.authorId;
        data["authorEmail"] = this.authorEmail;
        data["exceptionMessage"] = this.exceptionMessage;
        data["spreadsheetUrl"] = this.spreadsheetUrl;
        return data;
    }
}

export interface IImportEnterpriseAccountStatus {
    id: string;
    status: ImportExportStatus;
    createDate: string;
    authorId: string | undefined;
    authorEmail: string | undefined;
    exceptionMessage: string | undefined;
    spreadsheetUrl: string | undefined;
}

export class ImportEnterpriseAccountStatusDetails extends ImportEnterpriseAccountStatus implements IImportEnterpriseAccountStatusDetails {
    statuses!: { [key: string]: ImportEnterpriseAccountResultViewModel; };

    constructor(data?: IImportEnterpriseAccountStatusDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["statuses"]) {
                this.statuses = {} as any;
                for (let key in _data["statuses"]) {
                    if (_data["statuses"].hasOwnProperty(key))
                        (<any>this.statuses)![key] = _data["statuses"][key] ? ImportEnterpriseAccountResultViewModel.fromJS(_data["statuses"][key]) : new ImportEnterpriseAccountResultViewModel();
                }
            }
        }
    }

    static fromJS(data: any): ImportEnterpriseAccountStatusDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEnterpriseAccountStatusDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.statuses) {
            data["statuses"] = {};
            for (let key in this.statuses) {
                if (this.statuses.hasOwnProperty(key))
                    (<any>data["statuses"])[key] = this.statuses[key] ? this.statuses[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IImportEnterpriseAccountStatusDetails extends IImportEnterpriseAccountStatus {
    statuses: { [key: string]: ImportEnterpriseAccountResultViewModel; };
}

export class ImportEnterpriseAccountResultViewModel implements IImportEnterpriseAccountResultViewModel {
    status!: ImportExportStatus;
    messages!: ImportEnterpriseAccountMessageViewModel[];

    constructor(data?: IImportEnterpriseAccountResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ImportEnterpriseAccountMessageViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportEnterpriseAccountResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEnterpriseAccountResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportEnterpriseAccountResultViewModel {
    status: ImportExportStatus;
    messages: ImportEnterpriseAccountMessageViewModel[];
}

export class ImportEnterpriseAccountMessageViewModel implements IImportEnterpriseAccountMessageViewModel {
    dateTime!: string;
    text!: string | undefined;
    logLevel!: LSLogLevel;
    stackTrace!: string | undefined;

    constructor(data?: IImportEnterpriseAccountMessageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"];
            this.text = _data["text"];
            this.logLevel = _data["logLevel"];
            this.stackTrace = _data["stackTrace"];
        }
    }

    static fromJS(data: any): ImportEnterpriseAccountMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEnterpriseAccountMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime;
        data["text"] = this.text;
        data["logLevel"] = this.logLevel;
        data["stackTrace"] = this.stackTrace;
        return data;
    }
}

export interface IImportEnterpriseAccountMessageViewModel {
    dateTime: string;
    text: string | undefined;
    logLevel: LSLogLevel;
    stackTrace: string | undefined;
}

/** 0 = Undefined 1 = Critical 2 = Error 3 = Warning 4 = Info 5 = Trace */
export enum LSLogLevel {
    Undefined = 0,
    Critical = 1,
    Error = 2,
    Warning = 3,
    Info = 4,
    Trace = 5,
}

export class EnterpriseDemoRequest extends RecaptchaRequestBase implements IEnterpriseDemoRequest {
    mode!: EnterpriseDemoRequestMode;
    fullName!: string;
    email!: string;
    phoneNumber!: string | undefined;
    company!: string;
    companySize!: CompanySize | undefined;
    plan!: EnterpriseAccountPlan | undefined;
    solution!: SolutionType | undefined;
    question!: string;
    hubspotUTK!: string | undefined;
    referrerQuery!: string | undefined;
    interestReason!: InterestReason | undefined;

    constructor(data?: IEnterpriseDemoRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mode = _data["mode"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.company = _data["company"];
            this.companySize = _data["companySize"];
            this.plan = _data["plan"];
            this.solution = _data["solution"];
            this.question = _data["question"];
            this.hubspotUTK = _data["hubspotUTK"];
            this.referrerQuery = _data["referrerQuery"];
            this.interestReason = _data["interestReason"];
        }
    }

    static fromJS(data: any): EnterpriseDemoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseDemoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["company"] = this.company;
        data["companySize"] = this.companySize;
        data["plan"] = this.plan;
        data["solution"] = this.solution;
        data["question"] = this.question;
        data["hubspotUTK"] = this.hubspotUTK;
        data["referrerQuery"] = this.referrerQuery;
        data["interestReason"] = this.interestReason;
        super.toJSON(data);
        return data;
    }
}

export interface IEnterpriseDemoRequest extends IRecaptchaRequestBase {
    mode: EnterpriseDemoRequestMode;
    fullName: string;
    email: string;
    phoneNumber: string | undefined;
    company: string;
    companySize: CompanySize | undefined;
    plan: EnterpriseAccountPlan | undefined;
    solution: SolutionType | undefined;
    question: string;
    hubspotUTK: string | undefined;
    referrerQuery: string | undefined;
    interestReason: InterestReason | undefined;
}

/** 0 = HP 1 = Enterprise 2 = Workplace 3 = WorkplaceInline 4 = CareersInline 5 = HybridAnywhere 6 = Pricing 7 = HIW 8 = CS 9 = FOS 10 = HQB 11 = DS 12 = DI 13 = SC 14 = DOS 15 = FAQ 16 = IP 17 = FAS 18 = MO 19 = PMAI 20 = LC */
export enum EnterpriseDemoRequestMode {
    HP = 0,
    Enterprise = 1,
    Workplace = 2,
    WorkplaceInline = 3,
    CareersInline = 4,
    HybridAnywhere = 5,
    Pricing = 6,
    HIW = 7,
    CS = 8,
    FOS = 9,
    HQB = 10,
    DS = 11,
    DI = 12,
    SC = 13,
    DOS = 14,
    FAQ = 15,
    IP = 16,
    FAS = 17,
    MO = 18,
    PMAI = 19,
    LC = 20,
}

/** 0 = Small 1 = Medium 2 = Large 3 = ExtraLarge */
export enum CompanySize {
    Small = 0,
    Medium = 1,
    Large = 2,
    ExtraLarge = 3,
}

/** 0 = Enterprise 1 = Business 2 = Team 3 = Individual 4 = Host */
export enum SolutionType {
    Enterprise = 0,
    Business = 1,
    Team = 2,
    Individual = 3,
    Host = 4,
}

/** 0 = Book 1 = Demo 2 = List 3 = Assessment 4 = FlexAdvisory 5 = AltSpace 6 = ROI 7 = Other */
export enum InterestReason {
    Book = 0,
    Demo = 1,
    List = 2,
    Assessment = 3,
    FlexAdvisory = 4,
    AltSpace = 5,
    ROI = 6,
    Other = 7,
}

export class LiquidspaceProRequest implements ILiquidspaceProRequest {
    fullName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    companyName!: string;
    locationsCount!: number;
    comment!: string | undefined;

    constructor(data?: ILiquidspaceProRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.companyName = _data["companyName"];
            this.locationsCount = _data["locationsCount"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): LiquidspaceProRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LiquidspaceProRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["companyName"] = this.companyName;
        data["locationsCount"] = this.locationsCount;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ILiquidspaceProRequest {
    fullName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    companyName: string;
    locationsCount: number;
    comment: string | undefined;
}

export class OfficeRnDHybridSyncResult implements IOfficeRnDHybridSyncResult {
    messages!: string[];

    constructor(data?: IOfficeRnDHybridSyncResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
        }
    }

    static fromJS(data: any): OfficeRnDHybridSyncResult {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRnDHybridSyncResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        return data;
    }
}

export interface IOfficeRnDHybridSyncResult {
    messages: string[];
}

export class EnterpriseAccountIntegrationSlackConfig implements IEnterpriseAccountIntegrationSlackConfig {
    appId!: string;

    constructor(data?: IEnterpriseAccountIntegrationSlackConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
        }
    }

    static fromJS(data: any): EnterpriseAccountIntegrationSlackConfig {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountIntegrationSlackConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        return data;
    }
}

export interface IEnterpriseAccountIntegrationSlackConfig {
    appId: string;
}

export class DedicatedLocationViewModel implements IDedicatedLocationViewModel {
    id!: string;
    startDate!: string;
    finishDate!: string | undefined;
    venueName!: string;
    workspaceName!: string;
    ownerName!: string;
    monthlyRate!: CostInfoModel | undefined;
    paymentProvider!: PaymentProviderType;
    status!: ReservationStatus;
    venueId!: string;
    reservation!: TeamMemberReservation;
    ownerId!: string;

    constructor(data?: IDedicatedLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"];
            this.finishDate = _data["finishDate"];
            this.venueName = _data["venueName"];
            this.workspaceName = _data["workspaceName"];
            this.ownerName = _data["ownerName"];
            this.monthlyRate = _data["monthlyRate"] ? CostInfoModel.fromJS(_data["monthlyRate"]) : <any>undefined;
            this.paymentProvider = _data["paymentProvider"];
            this.status = _data["status"];
            this.venueId = _data["venueId"];
            this.reservation = _data["reservation"] ? TeamMemberReservation.fromJS(_data["reservation"]) : <any>undefined;
            this.ownerId = _data["ownerId"];
        }
    }

    static fromJS(data: any): DedicatedLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DedicatedLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate;
        data["finishDate"] = this.finishDate;
        data["venueName"] = this.venueName;
        data["workspaceName"] = this.workspaceName;
        data["ownerName"] = this.ownerName;
        data["monthlyRate"] = this.monthlyRate ? this.monthlyRate.toJSON() : <any>undefined;
        data["paymentProvider"] = this.paymentProvider;
        data["status"] = this.status;
        data["venueId"] = this.venueId;
        data["reservation"] = this.reservation ? this.reservation.toJSON() : <any>undefined;
        data["ownerId"] = this.ownerId;
        return data;
    }
}

export interface IDedicatedLocationViewModel {
    id: string;
    startDate: string;
    finishDate: string | undefined;
    venueName: string;
    workspaceName: string;
    ownerName: string;
    monthlyRate: CostInfoModel | undefined;
    paymentProvider: PaymentProviderType;
    status: ReservationStatus;
    venueId: string;
    reservation: TeamMemberReservation;
    ownerId: string;
}

export class VenueListItemViewModel implements IVenueListItemViewModel {
    id!: string;
    name!: string;

    constructor(data?: IVenueListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VenueListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVenueListItemViewModel {
    id: string;
    name: string;
}

export class VenueGroupListItemViewModel implements IVenueGroupListItemViewModel {
    id!: string;
    name!: string;

    constructor(data?: IVenueGroupListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VenueGroupListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVenueGroupListItemViewModel {
    id: string;
    name: string;
}

export class EnterpriseAccountCollectionViewModel implements IEnterpriseAccountCollectionViewModel {
    name!: string;
    venueGroupId!: string;

    constructor(data?: IEnterpriseAccountCollectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.venueGroupId = _data["venueGroupId"];
        }
    }

    static fromJS(data: any): EnterpriseAccountCollectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAccountCollectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["venueGroupId"] = this.venueGroupId;
        return data;
    }
}

export interface IEnterpriseAccountCollectionViewModel {
    name: string;
    venueGroupId: string;
}

export class BrandsViewModel implements IBrandsViewModel {
    access!: BrandsAccess;
    brands!: BrandViewModel[];

    constructor(data?: IBrandsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.access = _data["access"];
            if (Array.isArray(_data["brands"])) {
                this.brands = [] as any;
                for (let item of _data["brands"])
                    this.brands!.push(BrandViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BrandsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBrandsViewModel {
    access: BrandsAccess;
    brands: BrandViewModel[];
}

/** 0 = Open 1 = Limited 2 = None */
export enum BrandsAccess {
    Open = 0,
    Limited = 1,
    None = 2,
}

export class BrandViewModel implements IBrandViewModel {
    id!: string;
    name!: string | undefined;
    locationCount!: number;
    enabled!: boolean;

    constructor(data?: IBrandViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locationCount = _data["locationCount"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): BrandViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationCount"] = this.locationCount;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IBrandViewModel {
    id: string;
    name: string | undefined;
    locationCount: number;
    enabled: boolean;
}

export class BrandsOptionsViewModel implements IBrandsOptionsViewModel {
    access!: BrandsAccess;
    disabledVenueGroupIds!: string[];

    constructor(data?: IBrandsOptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.access = _data["access"];
            if (Array.isArray(_data["disabledVenueGroupIds"])) {
                this.disabledVenueGroupIds = [] as any;
                for (let item of _data["disabledVenueGroupIds"])
                    this.disabledVenueGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BrandsOptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandsOptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        if (Array.isArray(this.disabledVenueGroupIds)) {
            data["disabledVenueGroupIds"] = [];
            for (let item of this.disabledVenueGroupIds)
                data["disabledVenueGroupIds"].push(item);
        }
        return data;
    }
}

export interface IBrandsOptionsViewModel {
    access: BrandsAccess;
    disabledVenueGroupIds: string[];
}

export class EnterpriseUserInfoViewModel implements IEnterpriseUserInfoViewModel {
    teamId!: string | undefined;
    invitationStatus!: MemberGroupInvitationStatus | undefined;
    homeBaseSearchId!: string | undefined;
    homeBaseSearchAddress!: string | undefined;
    homeBaseSearchType!: SavedSearchSourceType;

    constructor(data?: IEnterpriseUserInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.invitationStatus = _data["invitationStatus"];
            this.homeBaseSearchId = _data["homeBaseSearchId"];
            this.homeBaseSearchAddress = _data["homeBaseSearchAddress"];
            this.homeBaseSearchType = _data["homeBaseSearchType"];
        }
    }

    static fromJS(data: any): EnterpriseUserInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseUserInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["invitationStatus"] = this.invitationStatus;
        data["homeBaseSearchId"] = this.homeBaseSearchId;
        data["homeBaseSearchAddress"] = this.homeBaseSearchAddress;
        data["homeBaseSearchType"] = this.homeBaseSearchType;
        return data;
    }
}

export interface IEnterpriseUserInfoViewModel {
    teamId: string | undefined;
    invitationStatus: MemberGroupInvitationStatus | undefined;
    homeBaseSearchId: string | undefined;
    homeBaseSearchAddress: string | undefined;
    homeBaseSearchType: SavedSearchSourceType;
}

export class CollectionViewModel implements ICollectionViewModel {
    name!: string;
    venues!: VenueSearchResult[];
    imageUrl!: string | undefined;
    id!: string;
    venueGroupId!: string;
    workspaceTypesFormatted!: string[];

    constructor(data?: ICollectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["venues"])) {
                this.venues = [] as any;
                for (let item of _data["venues"])
                    this.venues!.push(VenueSearchResult.fromJS(item));
            }
            this.imageUrl = _data["imageUrl"];
            this.id = _data["id"];
            this.venueGroupId = _data["venueGroupId"];
            if (Array.isArray(_data["workspaceTypesFormatted"])) {
                this.workspaceTypesFormatted = [] as any;
                for (let item of _data["workspaceTypesFormatted"])
                    this.workspaceTypesFormatted!.push(item);
            }
        }
    }

    static fromJS(data: any): CollectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.venues)) {
            data["venues"] = [];
            for (let item of this.venues)
                data["venues"].push(item.toJSON());
        }
        data["imageUrl"] = this.imageUrl;
        data["id"] = this.id;
        data["venueGroupId"] = this.venueGroupId;
        if (Array.isArray(this.workspaceTypesFormatted)) {
            data["workspaceTypesFormatted"] = [];
            for (let item of this.workspaceTypesFormatted)
                data["workspaceTypesFormatted"].push(item);
        }
        return data;
    }
}

export interface ICollectionViewModel {
    name: string;
    venues: VenueSearchResult[];
    imageUrl: string | undefined;
    id: string;
    venueGroupId: string;
    workspaceTypesFormatted: string[];
}

export class ContentItemViewModel implements IContentItemViewModel {
    subject!: string;
    content!: string;

    constructor(data?: IContentItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ContentItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContentItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["content"] = this.content;
        return data;
    }
}

export interface IContentItemViewModel {
    subject: string;
    content: string;
}

export class OnboardingContentViewModel implements IOnboardingContentViewModel {
    url!: string | undefined;
    message!: string;
    title!: string;
    content!: string;
    videoUrl!: string;
    loomVideoUrl!: string | undefined;
    isDefaultBackground!: boolean;

    constructor(data?: IOnboardingContentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.message = _data["message"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.videoUrl = _data["videoUrl"];
            this.loomVideoUrl = _data["loomVideoUrl"];
            this.isDefaultBackground = _data["isDefaultBackground"];
        }
    }

    static fromJS(data: any): OnboardingContentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingContentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["message"] = this.message;
        data["title"] = this.title;
        data["content"] = this.content;
        data["videoUrl"] = this.videoUrl;
        data["loomVideoUrl"] = this.loomVideoUrl;
        data["isDefaultBackground"] = this.isDefaultBackground;
        return data;
    }
}

export interface IOnboardingContentViewModel {
    url: string | undefined;
    message: string;
    title: string;
    content: string;
    videoUrl: string;
    loomVideoUrl: string | undefined;
    isDefaultBackground: boolean;
}

export class PortalReviews implements IPortalReviews {
    reviews!: RatingViewModel[];
    colleaguesWithReviewCount!: number;

    constructor(data?: IPortalReviews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reviews"])) {
                this.reviews = [] as any;
                for (let item of _data["reviews"])
                    this.reviews!.push(RatingViewModel.fromJS(item));
            }
            this.colleaguesWithReviewCount = _data["colleaguesWithReviewCount"];
        }
    }

    static fromJS(data: any): PortalReviews {
        data = typeof data === 'object' ? data : {};
        let result = new PortalReviews();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reviews)) {
            data["reviews"] = [];
            for (let item of this.reviews)
                data["reviews"].push(item.toJSON());
        }
        data["colleaguesWithReviewCount"] = this.colleaguesWithReviewCount;
        return data;
    }
}

export interface IPortalReviews {
    reviews: RatingViewModel[];
    colleaguesWithReviewCount: number;
}

export class RatingViewModel implements IRatingViewModel {
    stars!: number;
    date!: string;
    memberFullName!: string | undefined;
    memberTitle!: string | undefined;
    memberPicture!: string | undefined;
    reviewText!: string | undefined;
    venueName!: string;
    workspaceName!: string;
    venueAddress!: string;
    workspacePicture!: string | undefined;
    id!: string;
    workspaceUrl!: string;

    constructor(data?: IRatingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.stars = _data["stars"];
            this.date = _data["date"];
            this.memberFullName = _data["memberFullName"];
            this.memberTitle = _data["memberTitle"];
            this.memberPicture = _data["memberPicture"];
            this.reviewText = _data["reviewText"];
            this.venueName = _data["venueName"];
            this.workspaceName = _data["workspaceName"];
            this.venueAddress = _data["venueAddress"];
            this.workspacePicture = _data["workspacePicture"];
            this.id = _data["id"];
            this.workspaceUrl = _data["workspaceUrl"];
        }
    }

    static fromJS(data: any): RatingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RatingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stars"] = this.stars;
        data["date"] = this.date;
        data["memberFullName"] = this.memberFullName;
        data["memberTitle"] = this.memberTitle;
        data["memberPicture"] = this.memberPicture;
        data["reviewText"] = this.reviewText;
        data["venueName"] = this.venueName;
        data["workspaceName"] = this.workspaceName;
        data["venueAddress"] = this.venueAddress;
        data["workspacePicture"] = this.workspacePicture;
        data["id"] = this.id;
        data["workspaceUrl"] = this.workspaceUrl;
        return data;
    }
}

export interface IRatingViewModel {
    stars: number;
    date: string;
    memberFullName: string | undefined;
    memberTitle: string | undefined;
    memberPicture: string | undefined;
    reviewText: string | undefined;
    venueName: string;
    workspaceName: string;
    venueAddress: string;
    workspacePicture: string | undefined;
    id: string;
    workspaceUrl: string;
}

export class SupportRequest implements ISupportRequest {
    message!: string;

    constructor(data?: ISupportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SupportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SupportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface ISupportRequest {
    message: string;
}

export class QuestionRequest implements IQuestionRequest {
    fullName!: string;
    email!: string;
    phoneNumber!: string | undefined;
    message!: string;

    constructor(data?: IQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): QuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["message"] = this.message;
        return data;
    }
}

export interface IQuestionRequest {
    fullName: string;
    email: string;
    phoneNumber: string | undefined;
    message: string;
}

export class MemberViewModel implements IMemberViewModel {
    id!: string;
    email!: string;
    name!: string | undefined;

    constructor(data?: IMemberViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MemberViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        return data;
    }
}

export interface IMemberViewModel {
    id: string;
    email: string;
    name: string | undefined;
}

export class EnterpriseUserHomebaseViewModel implements IEnterpriseUserHomebaseViewModel {
    searchId!: string;
    address!: string | undefined;
    type!: SavedSearchSourceType;
    countryCode!: string | undefined;
    countryName!: string | undefined;

    constructor(data?: IEnterpriseUserHomebaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.searchId = _data["searchId"];
            this.address = _data["address"];
            this.type = _data["type"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): EnterpriseUserHomebaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseUserHomebaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchId"] = this.searchId;
        data["address"] = this.address;
        data["type"] = this.type;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface IEnterpriseUserHomebaseViewModel {
    searchId: string;
    address: string | undefined;
    type: SavedSearchSourceType;
    countryCode: string | undefined;
    countryName: string | undefined;
}

export class BrandedBannerViewModel implements IBrandedBannerViewModel {
    title!: string | undefined;
    subtitle!: string | undefined;
    popupTitle!: string | undefined;
    popupContent!: string | undefined;
    enable!: boolean;
    forcePopup!: boolean;
    popupHash!: number;

    constructor(data?: IBrandedBannerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.popupTitle = _data["popupTitle"];
            this.popupContent = _data["popupContent"];
            this.enable = _data["enable"];
            this.forcePopup = _data["forcePopup"];
            this.popupHash = _data["popupHash"];
        }
    }

    static fromJS(data: any): BrandedBannerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrandedBannerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["popupTitle"] = this.popupTitle;
        data["popupContent"] = this.popupContent;
        data["enable"] = this.enable;
        data["forcePopup"] = this.forcePopup;
        data["popupHash"] = this.popupHash;
        return data;
    }
}

export interface IBrandedBannerViewModel {
    title: string | undefined;
    subtitle: string | undefined;
    popupTitle: string | undefined;
    popupContent: string | undefined;
    enable: boolean;
    forcePopup: boolean;
    popupHash: number;
}

export class MessageTargetAutocompleteItem implements IMessageTargetAutocompleteItem {
    targetId!: string;
    fullName!: string | undefined;
    imageUrl!: string | undefined;
    email!: string | undefined;

    constructor(data?: IMessageTargetAutocompleteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.targetId = _data["targetId"];
            this.fullName = _data["fullName"];
            this.imageUrl = _data["imageUrl"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): MessageTargetAutocompleteItem {
        data = typeof data === 'object' ? data : {};
        let result = new MessageTargetAutocompleteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetId"] = this.targetId;
        data["fullName"] = this.fullName;
        data["imageUrl"] = this.imageUrl;
        data["email"] = this.email;
        return data;
    }
}

export interface IMessageTargetAutocompleteItem {
    targetId: string;
    fullName: string | undefined;
    imageUrl: string | undefined;
    email: string | undefined;
}

export class DayActivityViewModel implements IDayActivityViewModel {
    date!: string;
    member!: ReservationMemberViewModel | undefined;
    coworkers!: ReservationMemberViewModel[];
    venueActivities!: DayVenueActivityViewModel[];
    memberActivities!: DayVenueActivityViewModel[];

    constructor(data?: IDayActivityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.member = _data["member"] ? ReservationMemberViewModel.fromJS(_data["member"]) : <any>undefined;
            if (Array.isArray(_data["coworkers"])) {
                this.coworkers = [] as any;
                for (let item of _data["coworkers"])
                    this.coworkers!.push(ReservationMemberViewModel.fromJS(item));
            }
            if (Array.isArray(_data["venueActivities"])) {
                this.venueActivities = [] as any;
                for (let item of _data["venueActivities"])
                    this.venueActivities!.push(DayVenueActivityViewModel.fromJS(item));
            }
            if (Array.isArray(_data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of _data["memberActivities"])
                    this.memberActivities!.push(DayVenueActivityViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DayActivityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DayActivityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        if (Array.isArray(this.coworkers)) {
            data["coworkers"] = [];
            for (let item of this.coworkers)
                data["coworkers"].push(item.toJSON());
        }
        if (Array.isArray(this.venueActivities)) {
            data["venueActivities"] = [];
            for (let item of this.venueActivities)
                data["venueActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDayActivityViewModel {
    date: string;
    member: ReservationMemberViewModel | undefined;
    coworkers: ReservationMemberViewModel[];
    venueActivities: DayVenueActivityViewModel[];
    memberActivities: DayVenueActivityViewModel[];
}

export class DayVenueActivityViewModel implements IDayVenueActivityViewModel {
    venueId!: string | undefined;
    imageUrl!: string | undefined;
    venueName!: string | undefined;
    venueAddress!: string | undefined;
    startDate!: string;
    endDate!: string | undefined;
    reservationType!: WorkspaceReservationMethod;
    spaceName!: string | undefined;
    spaceType!: string | undefined;
    coworkers!: ActivityMaybeMemberViewModel[];
    /** Reservation ID or Parent Reservation ID for recurrent reservation occurence */
    reservationId!: string;
    occurrenceDate!: string | undefined;
    hasMultipleSpace!: boolean;

    constructor(data?: IDayVenueActivityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.imageUrl = _data["imageUrl"];
            this.venueName = _data["venueName"];
            this.venueAddress = _data["venueAddress"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.reservationType = _data["reservationType"];
            this.spaceName = _data["spaceName"];
            this.spaceType = _data["spaceType"];
            if (Array.isArray(_data["coworkers"])) {
                this.coworkers = [] as any;
                for (let item of _data["coworkers"])
                    this.coworkers!.push(ActivityMaybeMemberViewModel.fromJS(item));
            }
            this.reservationId = _data["reservationId"];
            this.occurrenceDate = _data["occurrenceDate"];
            this.hasMultipleSpace = _data["hasMultipleSpace"];
        }
    }

    static fromJS(data: any): DayVenueActivityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DayVenueActivityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["imageUrl"] = this.imageUrl;
        data["venueName"] = this.venueName;
        data["venueAddress"] = this.venueAddress;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["reservationType"] = this.reservationType;
        data["spaceName"] = this.spaceName;
        data["spaceType"] = this.spaceType;
        if (Array.isArray(this.coworkers)) {
            data["coworkers"] = [];
            for (let item of this.coworkers)
                data["coworkers"].push(item.toJSON());
        }
        data["reservationId"] = this.reservationId;
        data["occurrenceDate"] = this.occurrenceDate;
        data["hasMultipleSpace"] = this.hasMultipleSpace;
        return data;
    }
}

export interface IDayVenueActivityViewModel {
    venueId: string | undefined;
    imageUrl: string | undefined;
    venueName: string | undefined;
    venueAddress: string | undefined;
    startDate: string;
    endDate: string | undefined;
    reservationType: WorkspaceReservationMethod;
    spaceName: string | undefined;
    spaceType: string | undefined;
    coworkers: ActivityMaybeMemberViewModel[];
    /** Reservation ID or Parent Reservation ID for recurrent reservation occurence */
    reservationId: string;
    occurrenceDate: string | undefined;
    hasMultipleSpace: boolean;
}

export class ActivityMaybeMemberViewModel implements IActivityMaybeMemberViewModel {
    firstName!: string | undefined;
    lastName!: string | undefined;
    fullName!: string;
    email!: string;
    spaceName!: string;

    protected _discriminator: string;

    constructor(data?: IActivityMaybeMemberViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ActivityMaybeMemberViewModel";
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.spaceName = _data["spaceName"];
        }
    }

    static fromJS(data: any): ActivityMaybeMemberViewModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ActivityMemberViewModel") {
            let result = new ActivityMemberViewModel();
            result.init(data);
            return result;
        }
        let result = new ActivityMaybeMemberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["spaceName"] = this.spaceName;
        return data;
    }
}

export interface IActivityMaybeMemberViewModel {
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string;
    email: string;
    spaceName: string;
}

export class ActivityMemberViewModel extends ActivityMaybeMemberViewModel implements IActivityMemberViewModel {
    id!: string;
    imageUrl!: string | undefined;
    company!: string | undefined;

    constructor(data?: IActivityMemberViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ActivityMemberViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.imageUrl = _data["imageUrl"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): ActivityMemberViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityMemberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageUrl"] = this.imageUrl;
        data["company"] = this.company;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityMemberViewModel extends IActivityMaybeMemberViewModel {
    id: string;
    imageUrl: string | undefined;
    company: string | undefined;
}

export class SSOSettingsModel implements ISSOSettingsModel {
    enableSSO!: boolean;
    ssoTargetUrl!: string | undefined;
    ssoTargetLogoutUrl!: string | undefined;
    certificate!: string | undefined;
    certificateThumbprint!: string | undefined;
    sessionExpirationMinutes!: number;
    authenticationContext!: string | undefined;
    authenticationContextComparison!: string | undefined;
    skipAuthenticationContextComparison!: boolean;
    skipAssertionConsumerServiceURL!: boolean;
    samlManageGroupMembership!: boolean;
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    clientToken!: string | undefined;
    scimCreateUsers!: boolean;
    scimManageGroupMembership!: boolean;
    syncScimProcessing!: boolean;
    availableAuthenticationContexts!: string[];
    availableAuthenticationComparisons!: string[];
    emailDomains!: string[];
    consumerEndpoint!: string | undefined;

    constructor(data?: ISSOSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.enableSSO = _data["enableSSO"];
            this.ssoTargetUrl = _data["ssoTargetUrl"];
            this.ssoTargetLogoutUrl = _data["ssoTargetLogoutUrl"];
            this.certificate = _data["certificate"];
            this.certificateThumbprint = _data["certificateThumbprint"];
            this.sessionExpirationMinutes = _data["sessionExpirationMinutes"];
            this.authenticationContext = _data["authenticationContext"];
            this.authenticationContextComparison = _data["authenticationContextComparison"];
            this.skipAuthenticationContextComparison = _data["skipAuthenticationContextComparison"];
            this.skipAssertionConsumerServiceURL = _data["skipAssertionConsumerServiceURL"];
            this.samlManageGroupMembership = _data["samlManageGroupMembership"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.clientToken = _data["clientToken"];
            this.scimCreateUsers = _data["scimCreateUsers"];
            this.scimManageGroupMembership = _data["scimManageGroupMembership"];
            this.syncScimProcessing = _data["syncScimProcessing"];
            if (Array.isArray(_data["availableAuthenticationContexts"])) {
                this.availableAuthenticationContexts = [] as any;
                for (let item of _data["availableAuthenticationContexts"])
                    this.availableAuthenticationContexts!.push(item);
            }
            if (Array.isArray(_data["availableAuthenticationComparisons"])) {
                this.availableAuthenticationComparisons = [] as any;
                for (let item of _data["availableAuthenticationComparisons"])
                    this.availableAuthenticationComparisons!.push(item);
            }
            if (Array.isArray(_data["emailDomains"])) {
                this.emailDomains = [] as any;
                for (let item of _data["emailDomains"])
                    this.emailDomains!.push(item);
            }
            this.consumerEndpoint = _data["consumerEndpoint"];
        }
    }

    static fromJS(data: any): SSOSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SSOSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableSSO"] = this.enableSSO;
        data["ssoTargetUrl"] = this.ssoTargetUrl;
        data["ssoTargetLogoutUrl"] = this.ssoTargetLogoutUrl;
        data["certificate"] = this.certificate;
        data["certificateThumbprint"] = this.certificateThumbprint;
        data["sessionExpirationMinutes"] = this.sessionExpirationMinutes;
        data["authenticationContext"] = this.authenticationContext;
        data["authenticationContextComparison"] = this.authenticationContextComparison;
        data["skipAuthenticationContextComparison"] = this.skipAuthenticationContextComparison;
        data["skipAssertionConsumerServiceURL"] = this.skipAssertionConsumerServiceURL;
        data["samlManageGroupMembership"] = this.samlManageGroupMembership;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["clientToken"] = this.clientToken;
        data["scimCreateUsers"] = this.scimCreateUsers;
        data["scimManageGroupMembership"] = this.scimManageGroupMembership;
        data["syncScimProcessing"] = this.syncScimProcessing;
        if (Array.isArray(this.availableAuthenticationContexts)) {
            data["availableAuthenticationContexts"] = [];
            for (let item of this.availableAuthenticationContexts)
                data["availableAuthenticationContexts"].push(item);
        }
        if (Array.isArray(this.availableAuthenticationComparisons)) {
            data["availableAuthenticationComparisons"] = [];
            for (let item of this.availableAuthenticationComparisons)
                data["availableAuthenticationComparisons"].push(item);
        }
        if (Array.isArray(this.emailDomains)) {
            data["emailDomains"] = [];
            for (let item of this.emailDomains)
                data["emailDomains"].push(item);
        }
        data["consumerEndpoint"] = this.consumerEndpoint;
        return data;
    }
}

export interface ISSOSettingsModel {
    enableSSO: boolean;
    ssoTargetUrl: string | undefined;
    ssoTargetLogoutUrl: string | undefined;
    certificate: string | undefined;
    certificateThumbprint: string | undefined;
    sessionExpirationMinutes: number;
    authenticationContext: string | undefined;
    authenticationContextComparison: string | undefined;
    skipAuthenticationContextComparison: boolean;
    skipAssertionConsumerServiceURL: boolean;
    samlManageGroupMembership: boolean;
    clientId: string | undefined;
    clientSecret: string | undefined;
    clientToken: string | undefined;
    scimCreateUsers: boolean;
    scimManageGroupMembership: boolean;
    syncScimProcessing: boolean;
    availableAuthenticationContexts: string[];
    availableAuthenticationComparisons: string[];
    emailDomains: string[];
    consumerEndpoint: string | undefined;
}

export class CommandProgressModel implements ICommandProgressModel {
    completed!: boolean;
    status!: string;

    constructor(data?: ICommandProgressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.completed = _data["completed"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CommandProgressModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommandProgressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completed"] = this.completed;
        data["status"] = this.status;
        return data;
    }
}

export interface ICommandProgressModel {
    completed: boolean;
    status: string;
}

export class TeamViewModel implements ITeamViewModel {
    id!: string;
    headquarters!: Headquarter[];
    paymentMethodList!: PaymentMethodListViewModel;
    enterpriseAccountId!: string;
    ownerEmail!: string;
    name!: string;
    notificationEmails!: string[];
    isActive!: boolean;
    adminEmails!: string[];
    /** Max budget per day per member */
    maxDailyMemberBudget!: number | undefined;
    /** Max budget per month per team */
    maxMonthlyTeamBudget!: number | undefined;
    /** Max budget per month per member */
    maxMonthlyMemberBudget!: number | undefined;
    /** Per-reservation Hourly Desk budget */
    maxHourlyDeskBudget!: number | undefined;
    /** Per-reservation Hourly Meeting budget */
    maxHourlyMeetingRoomBudget!: number | undefined;
    /** Per-reservation Hourly Office budget */
    maxHourlyOfficeBudget!: number | undefined;
    /** Per-reservation Hourly EventSpace budget */
    maxHourlyEventSpaceBudget!: number | undefined;
    disableCCEntry!: boolean;
    requireBookingReason!: boolean;
    bookingReasons!: string[];
    /** Treat last item from BookingReasons list as Prompt for custon user-provided booking reason */
    allowCustomBookingReason!: boolean;
    searchSettings!: { [key in keyof typeof SearchSettingsEnum]?: boolean; };
    extendedSearchOptions!: ExtendedSearchOptionsModel;
    bannerOptions!: BrandedBannerOptionsModel;
    defaultCollectionIds!: string[];
    allowExceedBudgetLimits!: boolean | undefined;

    constructor(data?: ITeamViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["headquarters"])) {
                this.headquarters = [] as any;
                for (let item of _data["headquarters"])
                    this.headquarters!.push(Headquarter.fromJS(item));
            }
            this.paymentMethodList = _data["paymentMethodList"] ? PaymentMethodListViewModel.fromJS(_data["paymentMethodList"]) : <any>undefined;
            this.enterpriseAccountId = _data["enterpriseAccountId"];
            this.ownerEmail = _data["ownerEmail"];
            this.name = _data["name"];
            if (Array.isArray(_data["notificationEmails"])) {
                this.notificationEmails = [] as any;
                for (let item of _data["notificationEmails"])
                    this.notificationEmails!.push(item);
            }
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["adminEmails"])) {
                this.adminEmails = [] as any;
                for (let item of _data["adminEmails"])
                    this.adminEmails!.push(item);
            }
            this.maxDailyMemberBudget = _data["maxDailyMemberBudget"];
            this.maxMonthlyTeamBudget = _data["maxMonthlyTeamBudget"];
            this.maxMonthlyMemberBudget = _data["maxMonthlyMemberBudget"];
            this.maxHourlyDeskBudget = _data["maxHourlyDeskBudget"];
            this.maxHourlyMeetingRoomBudget = _data["maxHourlyMeetingRoomBudget"];
            this.maxHourlyOfficeBudget = _data["maxHourlyOfficeBudget"];
            this.maxHourlyEventSpaceBudget = _data["maxHourlyEventSpaceBudget"];
            this.disableCCEntry = _data["disableCCEntry"];
            this.requireBookingReason = _data["requireBookingReason"];
            if (Array.isArray(_data["bookingReasons"])) {
                this.bookingReasons = [] as any;
                for (let item of _data["bookingReasons"])
                    this.bookingReasons!.push(item);
            }
            this.allowCustomBookingReason = _data["allowCustomBookingReason"];
            if (_data["searchSettings"]) {
                this.searchSettings = {} as any;
                for (let key in _data["searchSettings"]) {
                    if (_data["searchSettings"].hasOwnProperty(key))
                        (<any>this.searchSettings)![key] = _data["searchSettings"][key];
                }
            }
            this.extendedSearchOptions = _data["extendedSearchOptions"] ? ExtendedSearchOptionsModel.fromJS(_data["extendedSearchOptions"]) : <any>undefined;
            this.bannerOptions = _data["bannerOptions"] ? BrandedBannerOptionsModel.fromJS(_data["bannerOptions"]) : <any>undefined;
            if (Array.isArray(_data["defaultCollectionIds"])) {
                this.defaultCollectionIds = [] as any;
                for (let item of _data["defaultCollectionIds"])
                    this.defaultCollectionIds!.push(item);
            }
            this.allowExceedBudgetLimits = _data["allowExceedBudgetLimits"];
        }
    }

    static fromJS(data: any): TeamViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.headquarters)) {
            data["headquarters"] = [];
            for (let item of this.headquarters)
                data["headquarters"].push(item.toJSON());
        }
        data["paymentMethodList"] = this.paymentMethodList ? this.paymentMethodList.toJSON() : <any>undefined;
        data["enterpriseAccountId"] = this.enterpriseAccountId;
        data["ownerEmail"] = this.ownerEmail;
        data["name"] = this.name;
        if (Array.isArray(this.notificationEmails)) {
            data["notificationEmails"] = [];
            for (let item of this.notificationEmails)
                data["notificationEmails"].push(item);
        }
        data["isActive"] = this.isActive;
        if (Array.isArray(this.adminEmails)) {
            data["adminEmails"] = [];
            for (let item of this.adminEmails)
                data["adminEmails"].push(item);
        }
        data["maxDailyMemberBudget"] = this.maxDailyMemberBudget;
        data["maxMonthlyTeamBudget"] = this.maxMonthlyTeamBudget;
        data["maxMonthlyMemberBudget"] = this.maxMonthlyMemberBudget;
        data["maxHourlyDeskBudget"] = this.maxHourlyDeskBudget;
        data["maxHourlyMeetingRoomBudget"] = this.maxHourlyMeetingRoomBudget;
        data["maxHourlyOfficeBudget"] = this.maxHourlyOfficeBudget;
        data["maxHourlyEventSpaceBudget"] = this.maxHourlyEventSpaceBudget;
        data["disableCCEntry"] = this.disableCCEntry;
        data["requireBookingReason"] = this.requireBookingReason;
        if (Array.isArray(this.bookingReasons)) {
            data["bookingReasons"] = [];
            for (let item of this.bookingReasons)
                data["bookingReasons"].push(item);
        }
        data["allowCustomBookingReason"] = this.allowCustomBookingReason;
        if (this.searchSettings) {
            data["searchSettings"] = {};
            for (let key in this.searchSettings) {
                if (this.searchSettings.hasOwnProperty(key))
                    (<any>data["searchSettings"])[key] = (<any>this.searchSettings)[key];
            }
        }
        data["extendedSearchOptions"] = this.extendedSearchOptions ? this.extendedSearchOptions.toJSON() : <any>undefined;
        data["bannerOptions"] = this.bannerOptions ? this.bannerOptions.toJSON() : <any>undefined;
        if (Array.isArray(this.defaultCollectionIds)) {
            data["defaultCollectionIds"] = [];
            for (let item of this.defaultCollectionIds)
                data["defaultCollectionIds"].push(item);
        }
        data["allowExceedBudgetLimits"] = this.allowExceedBudgetLimits;
        return data;
    }
}

export interface ITeamViewModel {
    id: string;
    headquarters: Headquarter[];
    paymentMethodList: PaymentMethodListViewModel;
    enterpriseAccountId: string;
    ownerEmail: string;
    name: string;
    notificationEmails: string[];
    isActive: boolean;
    adminEmails: string[];
    /** Max budget per day per member */
    maxDailyMemberBudget: number | undefined;
    /** Max budget per month per team */
    maxMonthlyTeamBudget: number | undefined;
    /** Max budget per month per member */
    maxMonthlyMemberBudget: number | undefined;
    /** Per-reservation Hourly Desk budget */
    maxHourlyDeskBudget: number | undefined;
    /** Per-reservation Hourly Meeting budget */
    maxHourlyMeetingRoomBudget: number | undefined;
    /** Per-reservation Hourly Office budget */
    maxHourlyOfficeBudget: number | undefined;
    /** Per-reservation Hourly EventSpace budget */
    maxHourlyEventSpaceBudget: number | undefined;
    disableCCEntry: boolean;
    requireBookingReason: boolean;
    bookingReasons: string[];
    /** Treat last item from BookingReasons list as Prompt for custon user-provided booking reason */
    allowCustomBookingReason: boolean;
    searchSettings: { [key in keyof typeof SearchSettingsEnum]?: boolean; };
    extendedSearchOptions: ExtendedSearchOptionsModel;
    bannerOptions: BrandedBannerOptionsModel;
    defaultCollectionIds: string[];
    allowExceedBudgetLimits: boolean | undefined;
}

export class Headquarter implements IHeadquarter {
    id!: string;
    venueId!: string;
    venueGroupId!: string;
    address!: string | undefined;
    longitude!: number;
    latitude!: number;
    bestMatchPoints!: number;
    title!: string | undefined;
    rank!: number;

    constructor(data?: IHeadquarter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.venueId = _data["venueId"];
            this.venueGroupId = _data["venueGroupId"];
            this.address = _data["address"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.bestMatchPoints = _data["bestMatchPoints"];
            this.title = _data["title"];
            this.rank = _data["rank"];
        }
    }

    static fromJS(data: any): Headquarter {
        data = typeof data === 'object' ? data : {};
        let result = new Headquarter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["venueId"] = this.venueId;
        data["venueGroupId"] = this.venueGroupId;
        data["address"] = this.address;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["bestMatchPoints"] = this.bestMatchPoints;
        data["title"] = this.title;
        data["rank"] = this.rank;
        return data;
    }
}

export interface IHeadquarter {
    id: string;
    venueId: string;
    venueGroupId: string;
    address: string | undefined;
    longitude: number;
    latitude: number;
    bestMatchPoints: number;
    title: string | undefined;
    rank: number;
}

export class PaymentMethodListViewModel implements IPaymentMethodListViewModel {
    paymentMethods!: PaymentMethodViewModel[];
    centralizedPaymentMethods!: CentralizedPaymentMethodViewModel[];
    paymentMethodConfiguration!: PaymentMethodConfigurationModel;

    constructor(data?: IPaymentMethodListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of _data["paymentMethods"])
                    this.paymentMethods!.push(PaymentMethodViewModel.fromJS(item));
            }
            if (Array.isArray(_data["centralizedPaymentMethods"])) {
                this.centralizedPaymentMethods = [] as any;
                for (let item of _data["centralizedPaymentMethods"])
                    this.centralizedPaymentMethods!.push(CentralizedPaymentMethodViewModel.fromJS(item));
            }
            this.paymentMethodConfiguration = _data["paymentMethodConfiguration"] ? PaymentMethodConfigurationModel.fromJS(_data["paymentMethodConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentMethodListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.centralizedPaymentMethods)) {
            data["centralizedPaymentMethods"] = [];
            for (let item of this.centralizedPaymentMethods)
                data["centralizedPaymentMethods"].push(item.toJSON());
        }
        data["paymentMethodConfiguration"] = this.paymentMethodConfiguration ? this.paymentMethodConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaymentMethodListViewModel {
    paymentMethods: PaymentMethodViewModel[];
    centralizedPaymentMethods: CentralizedPaymentMethodViewModel[];
    paymentMethodConfiguration: PaymentMethodConfigurationModel;
}

export abstract class PaymentMethodViewModel implements IPaymentMethodViewModel {
    paymentProfileId!: string;
    customerProfileId!: string;
    paymentProvider!: PaymentProviderType;
    isDefault!: boolean;
    description!: string | undefined;

    protected _discriminator: string;

    constructor(data?: IPaymentMethodViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "PaymentMethodViewModel";
    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfileId = _data["paymentProfileId"];
            this.customerProfileId = _data["customerProfileId"];
            this.paymentProvider = _data["paymentProvider"];
            this.isDefault = _data["isDefault"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PaymentMethodViewModel {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "CreditCard") {
            let result = new CreditCardPaymentMethodViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "BankAccount") {
            let result = new BankAccountPaymentMethodViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "Marketplace") {
            let result = new MarketplacePaymentMethodViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "WireTransfer") {
            let result = new WireTransferPaymentMethodViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "Centralized") {
            let result = new CentralizedPaymentMethodViewModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PaymentMethodViewModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this._discriminator;
        data["paymentProfileId"] = this.paymentProfileId;
        data["customerProfileId"] = this.customerProfileId;
        data["paymentProvider"] = this.paymentProvider;
        data["isDefault"] = this.isDefault;
        data["description"] = this.description;
        return data;
    }
}

export interface IPaymentMethodViewModel {
    paymentProfileId: string;
    customerProfileId: string;
    paymentProvider: PaymentProviderType;
    isDefault: boolean;
    description: string | undefined;
}

export class CreditCardPaymentMethodViewModel extends PaymentMethodViewModel implements ICreditCardPaymentMethodViewModel {
    last4!: string;
    maskedNumber!: string;
    fullName!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    country!: string | undefined;
    state!: string | undefined;
    zip!: string | undefined;
    creditCardType!: CreditCardTypeType | undefined;
    cardType!: string | undefined;
    expirationMonth!: number | undefined;
    expirationYear!: number | undefined;
    expirationDateRaw!: string | undefined;
    isExpired!: boolean;

    constructor(data?: ICreditCardPaymentMethodViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "CreditCard";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.last4 = _data["last4"];
            this.maskedNumber = _data["maskedNumber"];
            this.fullName = _data["fullName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.creditCardType = _data["creditCardType"];
            this.cardType = _data["cardType"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
            this.expirationDateRaw = _data["expirationDateRaw"];
            this.isExpired = _data["isExpired"];
        }
    }

    static fromJS(data: any): CreditCardPaymentMethodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardPaymentMethodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last4"] = this.last4;
        data["maskedNumber"] = this.maskedNumber;
        data["fullName"] = this.fullName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["creditCardType"] = this.creditCardType;
        data["cardType"] = this.cardType;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        data["expirationDateRaw"] = this.expirationDateRaw;
        data["isExpired"] = this.isExpired;
        super.toJSON(data);
        return data;
    }
}

export interface ICreditCardPaymentMethodViewModel extends IPaymentMethodViewModel {
    last4: string;
    maskedNumber: string;
    fullName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    country: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    creditCardType: CreditCardTypeType | undefined;
    cardType: string | undefined;
    expirationMonth: number | undefined;
    expirationYear: number | undefined;
    expirationDateRaw: string | undefined;
    isExpired: boolean;
}

/** 0 = Visa 1 = MasterCard 2 = Discover 3 = Amex */
export enum CreditCardTypeType {
    Visa = 0,
    MasterCard = 1,
    Discover = 2,
    Amex = 3,
}

export class BankAccountPaymentMethodViewModel extends PaymentMethodViewModel implements IBankAccountPaymentMethodViewModel {
    last4!: string;
    bankName!: string | undefined;
    isVerified!: boolean;

    constructor(data?: IBankAccountPaymentMethodViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "BankAccount";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.last4 = _data["last4"];
            this.bankName = _data["bankName"];
            this.isVerified = _data["isVerified"];
        }
    }

    static fromJS(data: any): BankAccountPaymentMethodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountPaymentMethodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last4"] = this.last4;
        data["bankName"] = this.bankName;
        data["isVerified"] = this.isVerified;
        super.toJSON(data);
        return data;
    }
}

export interface IBankAccountPaymentMethodViewModel extends IPaymentMethodViewModel {
    last4: string;
    bankName: string | undefined;
    isVerified: boolean;
}

export class MarketplacePaymentMethodViewModel extends PaymentMethodViewModel implements IMarketplacePaymentMethodViewModel {

    constructor(data?: IMarketplacePaymentMethodViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "Marketplace";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MarketplacePaymentMethodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplacePaymentMethodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMarketplacePaymentMethodViewModel extends IPaymentMethodViewModel {
}

export class WireTransferPaymentMethodViewModel extends PaymentMethodViewModel implements IWireTransferPaymentMethodViewModel {

    constructor(data?: IWireTransferPaymentMethodViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "WireTransfer";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): WireTransferPaymentMethodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WireTransferPaymentMethodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IWireTransferPaymentMethodViewModel extends IPaymentMethodViewModel {
}

export class CentralizedPaymentMethodViewModel extends PaymentMethodViewModel implements ICentralizedPaymentMethodViewModel {
    payableKey!: PayableKey;
    centralizedName!: string;
    isExpired!: boolean;
    /** Points to the parent entity that may contain general payment methods. */
    parentPayableKey!: PayableKey | undefined;

    constructor(data?: ICentralizedPaymentMethodViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "Centralized";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payableKey = _data["payableKey"] ? PayableKey.fromJS(_data["payableKey"]) : <any>undefined;
            this.centralizedName = _data["centralizedName"];
            this.isExpired = _data["isExpired"];
            this.parentPayableKey = _data["parentPayableKey"] ? PayableKey.fromJS(_data["parentPayableKey"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CentralizedPaymentMethodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CentralizedPaymentMethodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payableKey"] = this.payableKey ? this.payableKey.toJSON() : <any>undefined;
        data["centralizedName"] = this.centralizedName;
        data["isExpired"] = this.isExpired;
        data["parentPayableKey"] = this.parentPayableKey ? this.parentPayableKey.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICentralizedPaymentMethodViewModel extends IPaymentMethodViewModel {
    payableKey: PayableKey;
    centralizedName: string;
    isExpired: boolean;
    /** Points to the parent entity that may contain general payment methods. */
    parentPayableKey: PayableKey | undefined;
}

export class PaymentMethodConfigurationModel implements IPaymentMethodConfigurationModel {
    canDeleteBankAccount!: boolean;
    enableACHPayments!: boolean;
    ccEntryDisabled!: boolean;
    enableWireTransferPayments!: boolean;

    constructor(data?: IPaymentMethodConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.canDeleteBankAccount = _data["canDeleteBankAccount"];
            this.enableACHPayments = _data["enableACHPayments"];
            this.ccEntryDisabled = _data["ccEntryDisabled"];
            this.enableWireTransferPayments = _data["enableWireTransferPayments"];
        }
    }

    static fromJS(data: any): PaymentMethodConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canDeleteBankAccount"] = this.canDeleteBankAccount;
        data["enableACHPayments"] = this.enableACHPayments;
        data["ccEntryDisabled"] = this.ccEntryDisabled;
        data["enableWireTransferPayments"] = this.enableWireTransferPayments;
        return data;
    }
}

export interface IPaymentMethodConfigurationModel {
    canDeleteBankAccount: boolean;
    enableACHPayments: boolean;
    ccEntryDisabled: boolean;
    enableWireTransferPayments: boolean;
}

export class TeamAddViewModel implements ITeamAddViewModel {
    accountId!: string;
    name!: string;

    constructor(data?: ITeamAddViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TeamAddViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamAddViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITeamAddViewModel {
    accountId: string;
    name: string;
}

/** Team member model */
export class TeamMemberAddViewModel implements ITeamMemberAddViewModel {
    email!: string;
    title!: string | undefined;
    phoneNumber!: string | undefined;
    company!: string | undefined;
    geoCity!: string | undefined;
    geoCountry!: string | undefined;
    externalAccountId!: string | undefined;
    costCenter!: string | undefined;
    fullName!: string;
    notes!: string | undefined;
    /** Message text that wil be added to invitation email. */
    message!: string;

    constructor(data?: ITeamMemberAddViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.title = _data["title"];
            this.phoneNumber = _data["phoneNumber"];
            this.company = _data["company"];
            this.geoCity = _data["geoCity"];
            this.geoCountry = _data["geoCountry"];
            this.externalAccountId = _data["externalAccountId"];
            this.costCenter = _data["costCenter"];
            this.fullName = _data["fullName"];
            this.notes = _data["notes"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TeamMemberAddViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberAddViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["title"] = this.title;
        data["phoneNumber"] = this.phoneNumber;
        data["company"] = this.company;
        data["geoCity"] = this.geoCity;
        data["geoCountry"] = this.geoCountry;
        data["externalAccountId"] = this.externalAccountId;
        data["costCenter"] = this.costCenter;
        data["fullName"] = this.fullName;
        data["notes"] = this.notes;
        data["message"] = this.message;
        return data;
    }
}

/** Team member model */
export interface ITeamMemberAddViewModel {
    email: string;
    title: string | undefined;
    phoneNumber: string | undefined;
    company: string | undefined;
    geoCity: string | undefined;
    geoCountry: string | undefined;
    externalAccountId: string | undefined;
    costCenter: string | undefined;
    fullName: string;
    notes: string | undefined;
    /** Message text that wil be added to invitation email. */
    message: string;
}

export class TeamMembersAddViewModel implements ITeamMembersAddViewModel {
    memberIds!: string[];
    message!: string;
    suppressInviteEmail!: boolean | undefined;

    constructor(data?: ITeamMembersAddViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberIds"])) {
                this.memberIds = [] as any;
                for (let item of _data["memberIds"])
                    this.memberIds!.push(item);
            }
            this.message = _data["message"];
            this.suppressInviteEmail = _data["suppressInviteEmail"];
        }
    }

    static fromJS(data: any): TeamMembersAddViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMembersAddViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberIds)) {
            data["memberIds"] = [];
            for (let item of this.memberIds)
                data["memberIds"].push(item);
        }
        data["message"] = this.message;
        data["suppressInviteEmail"] = this.suppressInviteEmail;
        return data;
    }
}

export interface ITeamMembersAddViewModel {
    memberIds: string[];
    message: string;
    suppressInviteEmail: boolean | undefined;
}

export class LocationViewModel implements ILocationViewModel {
    formattedAddress!: string;
    addressComponents!: AddressComponentViewModel[];
    types!: string[] | undefined;
    latitude!: number;
    longitude!: number;
    viewport!: LocationBoundsViewModel;

    constructor(data?: ILocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.formattedAddress = _data["formattedAddress"];
            if (Array.isArray(_data["addressComponents"])) {
                this.addressComponents = [] as any;
                for (let item of _data["addressComponents"])
                    this.addressComponents!.push(AddressComponentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.viewport = _data["viewport"] ? LocationBoundsViewModel.fromJS(_data["viewport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formattedAddress"] = this.formattedAddress;
        if (Array.isArray(this.addressComponents)) {
            data["addressComponents"] = [];
            for (let item of this.addressComponents)
                data["addressComponents"].push(item.toJSON());
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["viewport"] = this.viewport ? this.viewport.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILocationViewModel {
    formattedAddress: string;
    addressComponents: AddressComponentViewModel[];
    types: string[] | undefined;
    latitude: number;
    longitude: number;
    viewport: LocationBoundsViewModel;
}

export class AddressComponentViewModel implements IAddressComponentViewModel {
    shortText!: string | undefined;
    longText!: string | undefined;
    types!: string[];

    constructor(data?: IAddressComponentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.shortText = _data["shortText"];
            this.longText = _data["longText"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): AddressComponentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressComponentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortText"] = this.shortText;
        data["longText"] = this.longText;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface IAddressComponentViewModel {
    shortText: string | undefined;
    longText: string | undefined;
    types: string[];
}

export class LocationBoundsViewModel implements ILocationBoundsViewModel {
    /** Max values for regions of interest */
    northEast!: LocationPointViewModel;
    /** Min values for regions of interest */
    southWest!: LocationPointViewModel;

    constructor(data?: ILocationBoundsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.northEast = _data["northEast"] ? LocationPointViewModel.fromJS(_data["northEast"]) : <any>undefined;
            this.southWest = _data["southWest"] ? LocationPointViewModel.fromJS(_data["southWest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationBoundsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationBoundsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["northEast"] = this.northEast ? this.northEast.toJSON() : <any>undefined;
        data["southWest"] = this.southWest ? this.southWest.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILocationBoundsViewModel {
    /** Max values for regions of interest */
    northEast: LocationPointViewModel;
    /** Min values for regions of interest */
    southWest: LocationPointViewModel;
}

export class LocationPointViewModel implements ILocationPointViewModel {
    latitude!: number;
    longitude!: number;

    constructor(data?: ILocationPointViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): LocationPointViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPointViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ILocationPointViewModel {
    latitude: number;
    longitude: number;
}

export class GeocodeRequestModel implements IGeocodeRequestModel {
    address!: string;

    constructor(data?: IGeocodeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): GeocodeRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeocodeRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        return data;
    }
}

export interface IGeocodeRequestModel {
    address: string;
}

export class PlacePredictionViewModel implements IPlacePredictionViewModel {
    placeId!: string;
    /** AKA Description */
    text!: string;
    mainText!: string;
    secondaryText!: string;
    types!: string[];

    constructor(data?: IPlacePredictionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.text = _data["text"];
            this.mainText = _data["mainText"];
            this.secondaryText = _data["secondaryText"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): PlacePredictionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlacePredictionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["text"] = this.text;
        data["mainText"] = this.mainText;
        data["secondaryText"] = this.secondaryText;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface IPlacePredictionViewModel {
    placeId: string;
    /** AKA Description */
    text: string;
    mainText: string;
    secondaryText: string;
    types: string[];
}

export class PlacePredictionsRequestViewModel implements IPlacePredictionsRequestViewModel {
    input!: string;
    sessionToken!: string | undefined;
    countries!: string[] | undefined;
    allowInternational!: boolean;

    constructor(data?: IPlacePredictionsRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.input = _data["input"];
            this.sessionToken = _data["sessionToken"];
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            this.allowInternational = _data["allowInternational"];
        }
    }

    static fromJS(data: any): PlacePredictionsRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlacePredictionsRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["input"] = this.input;
        data["sessionToken"] = this.sessionToken;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        data["allowInternational"] = this.allowInternational;
        return data;
    }
}

export interface IPlacePredictionsRequestViewModel {
    input: string;
    sessionToken: string | undefined;
    countries: string[] | undefined;
    allowInternational: boolean;
}

export class AcceptRequest implements IAcceptRequest {
    liquidSpaceCost!: number | undefined;
    message!: string | undefined;

    constructor(data?: IAcceptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.liquidSpaceCost = _data["liquidSpaceCost"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AcceptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liquidSpaceCost"] = this.liquidSpaceCost;
        data["message"] = this.message;
        return data;
    }
}

export interface IAcceptRequest {
    liquidSpaceCost: number | undefined;
    message: string | undefined;
}

export class DeclineRequest implements IDeclineRequest {
    liquidSpaceCost!: number | undefined;
    message!: string | undefined;

    constructor(data?: IDeclineRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.liquidSpaceCost = _data["liquidSpaceCost"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DeclineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liquidSpaceCost"] = this.liquidSpaceCost;
        data["message"] = this.message;
        return data;
    }
}

export interface IDeclineRequest {
    liquidSpaceCost: number | undefined;
    message: string | undefined;
}

export class ReservationRequestDetailsModel implements IReservationRequestDetailsModel {
    id!: string;
    createTime!: string;
    expirationTimeUTC!: string | undefined;
    venueId!: string;
    venueName!: string;
    address!: string;
    workspaceName!: string;
    startTime!: string;
    endTime!: string;
    payment!: string | undefined;
    owner!: ReservationOwnerViewModel | undefined;
    amenities!: ReservationAmenityModel[];
    inviteesNamesString!: string;
    status!: HourlyRequestToBookStatus;
    responder!: string;
    responseTime!: string;
    recurrencePatternText!: string | undefined;
    currencyPrefix!: string | undefined;

    constructor(data?: IReservationRequestDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createTime = _data["createTime"];
            this.expirationTimeUTC = _data["expirationTimeUTC"];
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
            this.address = _data["address"];
            this.workspaceName = _data["workspaceName"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.payment = _data["payment"];
            this.owner = _data["owner"] ? ReservationOwnerViewModel.fromJS(_data["owner"]) : <any>undefined;
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities!.push(ReservationAmenityModel.fromJS(item));
            }
            this.inviteesNamesString = _data["inviteesNamesString"];
            this.status = _data["status"];
            this.responder = _data["responder"];
            this.responseTime = _data["responseTime"];
            this.recurrencePatternText = _data["recurrencePatternText"];
            this.currencyPrefix = _data["currencyPrefix"];
        }
    }

    static fromJS(data: any): ReservationRequestDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationRequestDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createTime"] = this.createTime;
        data["expirationTimeUTC"] = this.expirationTimeUTC;
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        data["address"] = this.address;
        data["workspaceName"] = this.workspaceName;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["payment"] = this.payment;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item.toJSON());
        }
        data["inviteesNamesString"] = this.inviteesNamesString;
        data["status"] = this.status;
        data["responder"] = this.responder;
        data["responseTime"] = this.responseTime;
        data["recurrencePatternText"] = this.recurrencePatternText;
        data["currencyPrefix"] = this.currencyPrefix;
        return data;
    }
}

export interface IReservationRequestDetailsModel {
    id: string;
    createTime: string;
    expirationTimeUTC: string | undefined;
    venueId: string;
    venueName: string;
    address: string;
    workspaceName: string;
    startTime: string;
    endTime: string;
    payment: string | undefined;
    owner: ReservationOwnerViewModel | undefined;
    amenities: ReservationAmenityModel[];
    inviteesNamesString: string;
    status: HourlyRequestToBookStatus;
    responder: string;
    responseTime: string;
    recurrencePatternText: string | undefined;
    currencyPrefix: string | undefined;
}

export class ReservationAmenityModel implements IReservationAmenityModel {
    name!: string;
    requestable!: boolean;

    constructor(data?: IReservationAmenityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.requestable = _data["requestable"];
        }
    }

    static fromJS(data: any): ReservationAmenityModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationAmenityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["requestable"] = this.requestable;
        return data;
    }
}

export interface IReservationAmenityModel {
    name: string;
    requestable: boolean;
}

export class MarketplaceCustomerProfileModel implements IMarketplaceCustomerProfileModel {
    paymentProfileIdPrefix!: string | undefined;

    constructor(data?: IMarketplaceCustomerProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfileIdPrefix = _data["paymentProfileIdPrefix"];
        }
    }

    static fromJS(data: any): MarketplaceCustomerProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceCustomerProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfileIdPrefix"] = this.paymentProfileIdPrefix;
        return data;
    }
}

export interface IMarketplaceCustomerProfileModel {
    paymentProfileIdPrefix: string | undefined;
}

export class PaymentMethodResponse extends ResponseWrapper implements IPaymentMethodResponse {
    paymentProfile!: PaymentMethodViewModel | undefined;

    constructor(data?: IPaymentMethodResponse) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentProfile = _data["paymentProfile"] ? PaymentMethodViewModel.fromJS(_data["paymentProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentMethodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentMethodResponse extends IResponseWrapper {
    paymentProfile: PaymentMethodViewModel | undefined;
}

export class MarketplacePaymentProfileCreateRequest implements IMarketplacePaymentProfileCreateRequest {
    paymentProfileIdPrefix!: string | undefined;

    constructor(data?: IMarketplacePaymentProfileCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfileIdPrefix = _data["paymentProfileIdPrefix"];
        }
    }

    static fromJS(data: any): MarketplacePaymentProfileCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplacePaymentProfileCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfileIdPrefix"] = this.paymentProfileIdPrefix;
        return data;
    }
}

export interface IMarketplacePaymentProfileCreateRequest {
    paymentProfileIdPrefix: string | undefined;
}

export class MemberListItemViewModel implements IMemberListItemViewModel {
    id!: string;
    email!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    imageUrl!: string | undefined;
    status!: string;

    constructor(data?: IMemberListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.imageUrl = _data["imageUrl"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MemberListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["imageUrl"] = this.imageUrl;
        data["status"] = this.status;
        return data;
    }
}

export interface IMemberListItemViewModel {
    id: string;
    email: string;
    firstName: string | undefined;
    lastName: string | undefined;
    imageUrl: string | undefined;
    status: string;
}

/** 0 = MobileUser 1 = SuperUser 2 = VenueAdmin 3 = MemberGroupAdmin 4 = ReportUser 5 = SysAdmin 6 = OrganizationAdmin 7 = CalendarAdmin 8 = ServiceAccount 9 = AffiliateUser 10 = ListingBroker 11 = SalesRep 12 = SalesOperations 13 = EnterpriseAccountAdmin 14 = VenueGroupAdmin 15 = EnterpriseAccountApiClient */
export enum MemberRole {
    MobileUser = 0,
    SuperUser = 1,
    VenueAdmin = 2,
    MemberGroupAdmin = 3,
    ReportUser = 4,
    SysAdmin = 5,
    OrganizationAdmin = 6,
    CalendarAdmin = 7,
    ServiceAccount = 8,
    AffiliateUser = 9,
    ListingBroker = 10,
    SalesRep = 11,
    SalesOperations = 12,
    EnterpriseAccountAdmin = 13,
    VenueGroupAdmin = 14,
    EnterpriseAccountApiClient = 15,
}

export class OrganizerViewModel implements IOrganizerViewModel {
    id!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    imageUrl!: string | undefined;

    constructor(data?: IOrganizerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): OrganizerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IOrganizerViewModel {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    imageUrl: string | undefined;
}

export class BookingReasonViewModel implements IBookingReasonViewModel {
    requireReason!: boolean;
    reasons!: string[];
    allowCustomReason!: boolean;

    constructor(data?: IBookingReasonViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.requireReason = _data["requireReason"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
            this.allowCustomReason = _data["allowCustomReason"];
        }
    }

    static fromJS(data: any): BookingReasonViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookingReasonViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireReason"] = this.requireReason;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        data["allowCustomReason"] = this.allowCustomReason;
        return data;
    }
}

export interface IBookingReasonViewModel {
    requireReason: boolean;
    reasons: string[];
    allowCustomReason: boolean;
}

export class MemberProfileViewModel implements IMemberProfileViewModel {
    memberId!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    phoneNumber!: string | undefined;
    email!: string | undefined;
    title!: string | undefined;
    imageUrl!: string | undefined;
    averageRating!: number | undefined;
    ratingCount!: number;

    constructor(data?: IMemberProfileViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.title = _data["title"];
            this.imageUrl = _data["imageUrl"];
            this.averageRating = _data["averageRating"];
            this.ratingCount = _data["ratingCount"];
        }
    }

    static fromJS(data: any): MemberProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["title"] = this.title;
        data["imageUrl"] = this.imageUrl;
        data["averageRating"] = this.averageRating;
        data["ratingCount"] = this.ratingCount;
        return data;
    }
}

export interface IMemberProfileViewModel {
    memberId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    title: string | undefined;
    imageUrl: string | undefined;
    averageRating: number | undefined;
    ratingCount: number;
}

export class MemberPicture implements IMemberPicture {
    memberId!: string;
    url!: string | undefined;

    constructor(data?: IMemberPicture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): MemberPicture {
        data = typeof data === 'object' ? data : {};
        let result = new MemberPicture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["url"] = this.url;
        return data;
    }
}

export interface IMemberPicture {
    memberId: string;
    url: string | undefined;
}

export class PaymentMethodRequest implements IPaymentMethodRequest {
    payableKey!: PayableKey;
    provider!: PaymentProviderType;

    constructor(data?: IPaymentMethodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.payableKey = _data["payableKey"] ? PayableKey.fromJS(_data["payableKey"]) : <any>undefined;
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): PaymentMethodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payableKey"] = this.payableKey ? this.payableKey.toJSON() : <any>undefined;
        data["provider"] = this.provider;
        return data;
    }
}

export interface IPaymentMethodRequest {
    payableKey: PayableKey;
    provider: PaymentProviderType;
}

export class UpdatePaymentMethodDescriptionRequest extends PaymentMethodRequest implements IUpdatePaymentMethodDescriptionRequest {
    description!: string | undefined;

    constructor(data?: IUpdatePaymentMethodDescriptionRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdatePaymentMethodDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentMethodDescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePaymentMethodDescriptionRequest extends IPaymentMethodRequest {
    description: string | undefined;
}

export abstract class CreditCardRequest extends RecaptchaRequestBase implements ICreditCardRequest {
    creditCardData!: CreditCardData;

    protected _discriminator: string;

    constructor(data?: ICreditCardRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "CreditCardRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.creditCardData = _data["creditCardData"] ? CreditCardData.fromJS(_data["creditCardData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreditCardRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "CreditCardAuthorizedRequest") {
            let result = new CreditCardAuthorizedRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CreditCardAnonymousRequest") {
            let result = new CreditCardAnonymousRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CreditCardRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["creditCardData"] = this.creditCardData ? this.creditCardData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreditCardRequest extends IRecaptchaRequestBase {
    creditCardData: CreditCardData;
}

export class CreditCardData implements ICreditCardData {
    paymentMethodNonce!: string;
    deviceData!: string | undefined;
    fullName!: string;
    address!: string;
    city!: string;
    state!: string;
    country!: string;

    constructor(data?: ICreditCardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethodNonce = _data["paymentMethodNonce"];
            this.deviceData = _data["deviceData"];
            this.fullName = _data["fullName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): CreditCardData {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodNonce"] = this.paymentMethodNonce;
        data["deviceData"] = this.deviceData;
        data["fullName"] = this.fullName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        return data;
    }
}

export interface ICreditCardData {
    paymentMethodNonce: string;
    deviceData: string | undefined;
    fullName: string;
    address: string;
    city: string;
    state: string;
    country: string;
}

export class CreditCardAuthorizedRequest extends CreditCardRequest implements ICreditCardAuthorizedRequest {
    payableKey!: PayableKey;

    constructor(data?: ICreditCardAuthorizedRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "CreditCardAuthorizedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payableKey = _data["payableKey"] ? PayableKey.fromJS(_data["payableKey"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreditCardAuthorizedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardAuthorizedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payableKey"] = this.payableKey ? this.payableKey.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreditCardAuthorizedRequest extends ICreditCardRequest {
    payableKey: PayableKey;
}

export class CreditCardAnonymousRequest extends CreditCardRequest implements ICreditCardAnonymousRequest {
    email!: string;

    constructor(data?: ICreditCardAnonymousRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "CreditCardAnonymousRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreditCardAnonymousRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardAnonymousRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        super.toJSON(data);
        return data;
    }
}

export interface ICreditCardAnonymousRequest extends ICreditCardRequest {
    email: string;
}

export class ExchangePlaidTokenRequest implements IExchangePlaidTokenRequest {
    payableKey!: PayableKey | undefined;
    publicToken!: string | undefined;
    accountId!: string | undefined;

    constructor(data?: IExchangePlaidTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.payableKey = _data["payableKey"] ? PayableKey.fromJS(_data["payableKey"]) : <any>undefined;
            this.publicToken = _data["publicToken"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): ExchangePlaidTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangePlaidTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payableKey"] = this.payableKey ? this.payableKey.toJSON() : <any>undefined;
        data["publicToken"] = this.publicToken;
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IExchangePlaidTokenRequest {
    payableKey: PayableKey | undefined;
    publicToken: string | undefined;
    accountId: string | undefined;
}

export class CreatePlaidLinkTokenRequest implements ICreatePlaidLinkTokenRequest {
    payableKey!: PayableKey | undefined;

    constructor(data?: ICreatePlaidLinkTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.payableKey = _data["payableKey"] ? PayableKey.fromJS(_data["payableKey"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePlaidLinkTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlaidLinkTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payableKey"] = this.payableKey ? this.payableKey.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePlaidLinkTokenRequest {
    payableKey: PayableKey | undefined;
}

export class CountryStateCodesRepsonse implements ICountryStateCodesRepsonse {
    countryCodes!: { [key: string]: string; };
    stateCodes!: { [key: string]: { [key: string]: string; }; };

    constructor(data?: ICountryStateCodesRepsonse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (_data["countryCodes"]) {
                this.countryCodes = {} as any;
                for (let key in _data["countryCodes"]) {
                    if (_data["countryCodes"].hasOwnProperty(key))
                        (<any>this.countryCodes)![key] = _data["countryCodes"][key];
                }
            }
            if (_data["stateCodes"]) {
                this.stateCodes = {} as any;
                for (let key in _data["stateCodes"]) {
                    if (_data["stateCodes"].hasOwnProperty(key))
                        (<any>this.stateCodes)![key] = _data["stateCodes"][key] !== undefined ? _data["stateCodes"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): CountryStateCodesRepsonse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryStateCodesRepsonse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.countryCodes) {
            data["countryCodes"] = {};
            for (let key in this.countryCodes) {
                if (this.countryCodes.hasOwnProperty(key))
                    (<any>data["countryCodes"])[key] = (<any>this.countryCodes)[key];
            }
        }
        if (this.stateCodes) {
            data["stateCodes"] = {};
            for (let key in this.stateCodes) {
                if (this.stateCodes.hasOwnProperty(key))
                    (<any>data["stateCodes"])[key] = (<any>this.stateCodes)[key];
            }
        }
        return data;
    }
}

export interface ICountryStateCodesRepsonse {
    countryCodes: { [key: string]: string; };
    stateCodes: { [key: string]: { [key: string]: string; }; };
}

export class PictureViewModel implements IPictureViewModel {
    pictureId!: string;
    pictureOwnerId!: string;
    pictureUrls!: PictureURLViewModel[];
    imageTagConstant!: ImageTagConstants;
    pictureType!: PictureTypeEnum;
    url!: string | undefined;

    constructor(data?: IPictureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.pictureId = _data["pictureId"];
            this.pictureOwnerId = _data["pictureOwnerId"];
            if (Array.isArray(_data["pictureUrls"])) {
                this.pictureUrls = [] as any;
                for (let item of _data["pictureUrls"])
                    this.pictureUrls!.push(PictureURLViewModel.fromJS(item));
            }
            this.imageTagConstant = _data["imageTagConstant"];
            this.pictureType = _data["pictureType"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): PictureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PictureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureId"] = this.pictureId;
        data["pictureOwnerId"] = this.pictureOwnerId;
        if (Array.isArray(this.pictureUrls)) {
            data["pictureUrls"] = [];
            for (let item of this.pictureUrls)
                data["pictureUrls"].push(item.toJSON());
        }
        data["imageTagConstant"] = this.imageTagConstant;
        data["pictureType"] = this.pictureType;
        data["url"] = this.url;
        return data;
    }
}

export interface IPictureViewModel {
    pictureId: string;
    pictureOwnerId: string;
    pictureUrls: PictureURLViewModel[];
    imageTagConstant: ImageTagConstants;
    pictureType: PictureTypeEnum;
    url: string | undefined;
}

export class PictureURLViewModel implements IPictureURLViewModel {
    id!: string;
    tags!: string;

    constructor(data?: IPictureURLViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): PictureURLViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PictureURLViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tags"] = this.tags;
        return data;
    }
}

export interface IPictureURLViewModel {
    id: string;
    tags: string;
}

/** 0 = Logo 1 = Logo100 2 = Help 3 = Favorite 4 = UserPicture 5 = AdCampaignPicture 6 = HeroPicture 7 = Gallery 8 = Cover 9 = PublisherLogo 10 = VenueFloorPlan 11 = AmenityIcon 12 = AmenityPaidIcon 13 = IOSAmenityIcon 14 = IOSAmenityPaidIcon 15 = AndroidAmenityIcon 16 = AndroidAmenityPaidIcon 17 = CityPageHero 18 = Neighborhood 19 = CompanyLogo 20 = ProfilePageCover 21 = Unassigned 22 = EmailLogo 101 = ExteriorEntrance 102 = Entrance 103 = BuildingLobby 104 = Reception 105 = VenueLobby 201 = FullView 202 = SideView 203 = RoomHighlight 204 = Drawing 205 = MessageAttachment 206 = OnboardingImage 207 = MapPin 208 = ReservationCard 209 = MeetingRoom 210 = DayOffice 211 = DayDesk */
export enum ImageTagConstants {
    Logo = 0,
    Logo100 = 1,
    Help = 2,
    Favorite = 3,
    UserPicture = 4,
    AdCampaignPicture = 5,
    HeroPicture = 6,
    Gallery = 7,
    Cover = 8,
    PublisherLogo = 9,
    VenueFloorPlan = 10,
    AmenityIcon = 11,
    AmenityPaidIcon = 12,
    IOSAmenityIcon = 13,
    IOSAmenityPaidIcon = 14,
    AndroidAmenityIcon = 15,
    AndroidAmenityPaidIcon = 16,
    CityPageHero = 17,
    Neighborhood = 18,
    CompanyLogo = 19,
    ProfilePageCover = 20,
    Unassigned = 21,
    EmailLogo = 22,
    ExteriorEntrance = 101,
    Entrance = 102,
    BuildingLobby = 103,
    Reception = 104,
    VenueLobby = 105,
    FullView = 201,
    SideView = 202,
    RoomHighlight = 203,
    Drawing = 204,
    MessageAttachment = 205,
    OnboardingImage = 206,
    MapPin = 207,
    ReservationCard = 208,
    MeetingRoom = 209,
    DayOffice = 210,
    DayDesk = 211,
}

/** 0 = Venue 1 = WorkSpace 2 = Member 3 = AdCampaign 4 = VenueCampaign 5 = MemberGroup 6 = FeaturedCampaign 7 = BrowseCity 8 = Announcement 9 = AnnouncementButton 10 = PublisherLogo 11 = AmenityIcon 12 = CityPage 13 = Neighborhood 14 = CompanyLogo 15 = ProfilePageCover 16 = EnterpriseAccount 17 = VenueGroup */
export enum PictureTypeEnum {
    Venue = 0,
    WorkSpace = 1,
    Member = 2,
    AdCampaign = 3,
    VenueCampaign = 4,
    MemberGroup = 5,
    FeaturedCampaign = 6,
    BrowseCity = 7,
    Announcement = 8,
    AnnouncementButton = 9,
    PublisherLogo = 10,
    AmenityIcon = 11,
    CityPage = 12,
    Neighborhood = 13,
    CompanyLogo = 14,
    ProfilePageCover = 15,
    EnterpriseAccount = 16,
    VenueGroup = 17,
}

export class AverageRatingModel implements IAverageRatingModel {
    count!: number;
    average!: number;

    constructor(data?: IAverageRatingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.average = _data["average"];
        }
    }

    static fromJS(data: any): AverageRatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new AverageRatingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["average"] = this.average;
        return data;
    }
}

export interface IAverageRatingModel {
    count: number;
    average: number;
}

export class RatingUpsertModel implements IRatingUpsertModel {
    id!: string | undefined;
    memberId!: string;
    workspaceId!: string;
    venueId!: string;
    stars!: number;
    text!: string | undefined;
    reservationId!: string;
    name!: string | undefined;
    messageToSupport!: string | undefined;
    sequrityCode!: string | undefined;

    constructor(data?: IRatingUpsertModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.workspaceId = _data["workspaceId"];
            this.venueId = _data["venueId"];
            this.stars = _data["stars"];
            this.text = _data["text"];
            this.reservationId = _data["reservationId"];
            this.name = _data["name"];
            this.messageToSupport = _data["messageToSupport"];
            this.sequrityCode = _data["sequrityCode"];
        }
    }

    static fromJS(data: any): RatingUpsertModel {
        data = typeof data === 'object' ? data : {};
        let result = new RatingUpsertModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["workspaceId"] = this.workspaceId;
        data["venueId"] = this.venueId;
        data["stars"] = this.stars;
        data["text"] = this.text;
        data["reservationId"] = this.reservationId;
        data["name"] = this.name;
        data["messageToSupport"] = this.messageToSupport;
        data["sequrityCode"] = this.sequrityCode;
        return data;
    }
}

export interface IRatingUpsertModel {
    id: string | undefined;
    memberId: string;
    workspaceId: string;
    venueId: string;
    stars: number;
    text: string | undefined;
    reservationId: string;
    name: string | undefined;
    messageToSupport: string | undefined;
    sequrityCode: string | undefined;
}

export class HourlyReservation implements IHourlyReservation {
    reservationId!: string;
    guestId!: string;
    confirmationStatus!: VenueConfirmationStatus;
    urgencyStatus!: HourlyReservationUrgencyStatus;
    reservationStart!: string;
    venueName!: string | undefined;
    spaceName!: string | undefined;
    spaceType!: SpaceType;
    spaceTypeString!: string | undefined;
    spaceCapacity!: number;
    reservationPrice!: number;
    attendeeCount!: number;
    venueCity!: string | undefined;
    venueState!: string | undefined;
    venueCountry!: string | undefined;
    venuePhoneNumber!: string | undefined;
    venueOwnerEmail!: string | undefined;
    venueHostEmail!: string | undefined;
    guestName!: string | undefined;
    guestCompany!: string | undefined;
    enterprisePlan!: EnterpriseAccountPlan | undefined;
    integrations!: IntegrationTypeEnum[];
    numberOfCompletedReservationsInThePast30DaysForVenue!: number;
    numberOfCompletedReservationsInThePast90DaysForVenue!: number;
    numberOfCanceledReservationsInThePast90DaysForVenue!: number;
    numberOfReviews!: number;
    venuePhoneNumberFormatted!: string | undefined;
    reservationCreatedTimestamp!: string;
    venueOwnerId!: string;
    venueId!: string;
    debug!: string;

    constructor(data?: IHourlyReservation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.guestId = _data["guestId"];
            this.confirmationStatus = _data["confirmationStatus"];
            this.urgencyStatus = _data["urgencyStatus"];
            this.reservationStart = _data["reservationStart"];
            this.venueName = _data["venueName"];
            this.spaceName = _data["spaceName"];
            this.spaceType = _data["spaceType"];
            this.spaceTypeString = _data["spaceTypeString"];
            this.spaceCapacity = _data["spaceCapacity"];
            this.reservationPrice = _data["reservationPrice"];
            this.attendeeCount = _data["attendeeCount"];
            this.venueCity = _data["venueCity"];
            this.venueState = _data["venueState"];
            this.venueCountry = _data["venueCountry"];
            this.venuePhoneNumber = _data["venuePhoneNumber"];
            this.venueOwnerEmail = _data["venueOwnerEmail"];
            this.venueHostEmail = _data["venueHostEmail"];
            this.guestName = _data["guestName"];
            this.guestCompany = _data["guestCompany"];
            this.enterprisePlan = _data["enterprisePlan"];
            if (Array.isArray(_data["integrations"])) {
                this.integrations = [] as any;
                for (let item of _data["integrations"])
                    this.integrations!.push(item);
            }
            this.numberOfCompletedReservationsInThePast30DaysForVenue = _data["numberOfCompletedReservationsInThePast30DaysForVenue"];
            this.numberOfCompletedReservationsInThePast90DaysForVenue = _data["numberOfCompletedReservationsInThePast90DaysForVenue"];
            this.numberOfCanceledReservationsInThePast90DaysForVenue = _data["numberOfCanceledReservationsInThePast90DaysForVenue"];
            this.numberOfReviews = _data["numberOfReviews"];
            this.venuePhoneNumberFormatted = _data["venuePhoneNumberFormatted"];
            this.reservationCreatedTimestamp = _data["reservationCreatedTimestamp"];
            this.venueOwnerId = _data["venueOwnerId"];
            this.venueId = _data["venueId"];
            this.debug = _data["debug"];
        }
    }

    static fromJS(data: any): HourlyReservation {
        data = typeof data === 'object' ? data : {};
        let result = new HourlyReservation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["guestId"] = this.guestId;
        data["confirmationStatus"] = this.confirmationStatus;
        data["urgencyStatus"] = this.urgencyStatus;
        data["reservationStart"] = this.reservationStart;
        data["venueName"] = this.venueName;
        data["spaceName"] = this.spaceName;
        data["spaceType"] = this.spaceType;
        data["spaceTypeString"] = this.spaceTypeString;
        data["spaceCapacity"] = this.spaceCapacity;
        data["reservationPrice"] = this.reservationPrice;
        data["attendeeCount"] = this.attendeeCount;
        data["venueCity"] = this.venueCity;
        data["venueState"] = this.venueState;
        data["venueCountry"] = this.venueCountry;
        data["venuePhoneNumber"] = this.venuePhoneNumber;
        data["venueOwnerEmail"] = this.venueOwnerEmail;
        data["venueHostEmail"] = this.venueHostEmail;
        data["guestName"] = this.guestName;
        data["guestCompany"] = this.guestCompany;
        data["enterprisePlan"] = this.enterprisePlan;
        if (Array.isArray(this.integrations)) {
            data["integrations"] = [];
            for (let item of this.integrations)
                data["integrations"].push(item);
        }
        data["numberOfCompletedReservationsInThePast30DaysForVenue"] = this.numberOfCompletedReservationsInThePast30DaysForVenue;
        data["numberOfCompletedReservationsInThePast90DaysForVenue"] = this.numberOfCompletedReservationsInThePast90DaysForVenue;
        data["numberOfCanceledReservationsInThePast90DaysForVenue"] = this.numberOfCanceledReservationsInThePast90DaysForVenue;
        data["numberOfReviews"] = this.numberOfReviews;
        data["venuePhoneNumberFormatted"] = this.venuePhoneNumberFormatted;
        data["reservationCreatedTimestamp"] = this.reservationCreatedTimestamp;
        data["venueOwnerId"] = this.venueOwnerId;
        data["venueId"] = this.venueId;
        data["debug"] = this.debug;
        return data;
    }
}

export interface IHourlyReservation {
    reservationId: string;
    guestId: string;
    confirmationStatus: VenueConfirmationStatus;
    urgencyStatus: HourlyReservationUrgencyStatus;
    reservationStart: string;
    venueName: string | undefined;
    spaceName: string | undefined;
    spaceType: SpaceType;
    spaceTypeString: string | undefined;
    spaceCapacity: number;
    reservationPrice: number;
    attendeeCount: number;
    venueCity: string | undefined;
    venueState: string | undefined;
    venueCountry: string | undefined;
    venuePhoneNumber: string | undefined;
    venueOwnerEmail: string | undefined;
    venueHostEmail: string | undefined;
    guestName: string | undefined;
    guestCompany: string | undefined;
    enterprisePlan: EnterpriseAccountPlan | undefined;
    integrations: IntegrationTypeEnum[];
    numberOfCompletedReservationsInThePast30DaysForVenue: number;
    numberOfCompletedReservationsInThePast90DaysForVenue: number;
    numberOfCanceledReservationsInThePast90DaysForVenue: number;
    numberOfReviews: number;
    venuePhoneNumberFormatted: string | undefined;
    reservationCreatedTimestamp: string;
    venueOwnerId: string;
    venueId: string;
    debug: string;
}

/** 0 = Unconfirmed 1 = Pending 2 = Confirmed */
export enum VenueConfirmationStatus {
    Unconfirmed = 0,
    Pending = 1,
    Confirmed = 2,
}

/** 0 = Urgent 1 = High 2 = Medium 3 = Low */
export enum HourlyReservationUrgencyStatus {
    Urgent = 0,
    High = 1,
    Medium = 2,
    Low = 3,
}

/** 0 = MSExchange 1 = MStar 2 = ServCorp 3 = RJMetis 4 = IntelligentOffice 5 = GCal 6 = OfficeRnDFlex 7 = MSGraph 8 = Deskimo 9 = WeWorkIndia */
export enum IntegrationTypeEnum {
    MSExchange = 0,
    MStar = 1,
    ServCorp = 2,
    RJMetis = 3,
    IntelligentOffice = 4,
    GCal = 5,
    OfficeRnDFlex = 6,
    MSGraph = 7,
    Deskimo = 8,
    WeWorkIndia = 9,
}

export class SearchMetrics implements ISearchMetrics {
    dailyCTR!: DailyCTR[];
    stateCTR!: StateCTR[];

    constructor(data?: ISearchMetrics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dailyCTR"])) {
                this.dailyCTR = [] as any;
                for (let item of _data["dailyCTR"])
                    this.dailyCTR!.push(DailyCTR.fromJS(item));
            }
            if (Array.isArray(_data["stateCTR"])) {
                this.stateCTR = [] as any;
                for (let item of _data["stateCTR"])
                    this.stateCTR!.push(StateCTR.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchMetrics {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMetrics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailyCTR)) {
            data["dailyCTR"] = [];
            for (let item of this.dailyCTR)
                data["dailyCTR"].push(item.toJSON());
        }
        if (Array.isArray(this.stateCTR)) {
            data["stateCTR"] = [];
            for (let item of this.stateCTR)
                data["stateCTR"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchMetrics {
    dailyCTR: DailyCTR[];
    stateCTR: StateCTR[];
}

export class DailyCTR implements IDailyCTR {
    date!: string;
    stats!: SearchStats;

    constructor(data?: IDailyCTR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.stats = _data["stats"] ? SearchStats.fromJS(_data["stats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DailyCTR {
        data = typeof data === 'object' ? data : {};
        let result = new DailyCTR();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDailyCTR {
    date: string;
    stats: SearchStats;
}

export class SearchStats implements ISearchStats {
    searches!: number;
    hits!: number;
    reservations!: number;
    totalPrice!: number;

    constructor(data?: ISearchStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.searches = _data["searches"];
            this.hits = _data["hits"];
            this.reservations = _data["reservations"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): SearchStats {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searches"] = this.searches;
        data["hits"] = this.hits;
        data["reservations"] = this.reservations;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface ISearchStats {
    searches: number;
    hits: number;
    reservations: number;
    totalPrice: number;
}

export class StateCTR implements IStateCTR {
    state!: string | undefined;
    stats!: SearchStats;
    venues!: number;

    constructor(data?: IStateCTR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.stats = _data["stats"] ? SearchStats.fromJS(_data["stats"]) : <any>undefined;
            this.venues = _data["venues"];
        }
    }

    static fromJS(data: any): StateCTR {
        data = typeof data === 'object' ? data : {};
        let result = new StateCTR();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        data["venues"] = this.venues;
        return data;
    }
}

export interface IStateCTR {
    state: string | undefined;
    stats: SearchStats;
    venues: number;
}

export class SMStats implements ISMStats {
    totalSearches!: number;
    totalReservations!: number;
    totalPrice!: number;

    constructor(data?: ISMStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.totalSearches = _data["totalSearches"];
            this.totalReservations = _data["totalReservations"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): SMStats {
        data = typeof data === 'object' ? data : {};
        let result = new SMStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSearches"] = this.totalSearches;
        data["totalReservations"] = this.totalReservations;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface ISMStats {
    totalSearches: number;
    totalReservations: number;
    totalPrice: number;
}

export class SlackToken implements ISlackToken {
    id!: string;
    /** Slack App Id.
https://api.slack.com/apps */
    appId!: string;
    /** Is installed at Slack Enterprise level */
    isEnterpriseInstall!: boolean;
    /** Slack Enterprise ID */
    enterpriseId!: string | undefined;
    /** Slack Team ID */
    teamId!: string | undefined;
    userId!: string;
    botId!: string;
    timestamp!: string;
    accessToken!: string;
    refreshToken!: string | undefined;
    /** Relative to Timestamp */
    expiresIn!: number | undefined;
    /** Id */
    enterpriseAccountId!: string;

    constructor(data?: ISlackToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appId = _data["appId"];
            this.isEnterpriseInstall = _data["isEnterpriseInstall"];
            this.enterpriseId = _data["enterpriseId"];
            this.teamId = _data["teamId"];
            this.userId = _data["userId"];
            this.botId = _data["botId"];
            this.timestamp = _data["timestamp"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expiresIn = _data["expiresIn"];
            this.enterpriseAccountId = _data["enterpriseAccountId"];
        }
    }

    static fromJS(data: any): SlackToken {
        data = typeof data === 'object' ? data : {};
        let result = new SlackToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appId"] = this.appId;
        data["isEnterpriseInstall"] = this.isEnterpriseInstall;
        data["enterpriseId"] = this.enterpriseId;
        data["teamId"] = this.teamId;
        data["userId"] = this.userId;
        data["botId"] = this.botId;
        data["timestamp"] = this.timestamp;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expiresIn"] = this.expiresIn;
        data["enterpriseAccountId"] = this.enterpriseAccountId;
        return data;
    }
}

export interface ISlackToken {
    id: string;
    /** Slack App Id.
https://api.slack.com/apps */
    appId: string;
    /** Is installed at Slack Enterprise level */
    isEnterpriseInstall: boolean;
    /** Slack Enterprise ID */
    enterpriseId: string | undefined;
    /** Slack Team ID */
    teamId: string | undefined;
    userId: string;
    botId: string;
    timestamp: string;
    accessToken: string;
    refreshToken: string | undefined;
    /** Relative to Timestamp */
    expiresIn: number | undefined;
    /** Id */
    enterpriseAccountId: string;
}

/** 0 = None 1 = SpaceNoLongerAvailable 2 = GuestNotFit 3 = MyReasonIsNotListed 4 = FoundDifferentSpace 5 = HostUnresponsive */
export enum TourCancelReason {
    None = 0,
    SpaceNoLongerAvailable = 1,
    GuestNotFit = 2,
    MyReasonIsNotListed = 3,
    FoundDifferentSpace = 4,
    HostUnresponsive = 5,
}

export class SuggestTourViewModel implements ISuggestTourViewModel {
    memberId!: string;
    venueId!: string;
    workspaceId!: string;
    chainId!: string;
    tourDate!: string | undefined;
    tourTime!: string | undefined;
    workflowId!: string | undefined;
    message!: string | undefined;

    constructor(data?: ISuggestTourViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.venueId = _data["venueId"];
            this.workspaceId = _data["workspaceId"];
            this.chainId = _data["chainId"];
            this.tourDate = _data["tourDate"];
            this.tourTime = _data["tourTime"];
            this.workflowId = _data["workflowId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SuggestTourViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestTourViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["venueId"] = this.venueId;
        data["workspaceId"] = this.workspaceId;
        data["chainId"] = this.chainId;
        data["tourDate"] = this.tourDate;
        data["tourTime"] = this.tourTime;
        data["workflowId"] = this.workflowId;
        data["message"] = this.message;
        return data;
    }
}

export interface ISuggestTourViewModel {
    memberId: string;
    venueId: string;
    workspaceId: string;
    chainId: string;
    tourDate: string | undefined;
    tourTime: string | undefined;
    workflowId: string | undefined;
    message: string | undefined;
}

export class ExportVenueGroupStatus implements IExportVenueGroupStatus {
    id!: string;
    status!: ImportExportStatus;
    createDate!: string;
    authorId!: string | undefined;
    authorEmail!: string | undefined;
    exceptionMessage!: string | undefined;
    spreadsheetUrl!: string | undefined;

    constructor(data?: IExportVenueGroupStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.createDate = _data["createDate"];
            this.authorId = _data["authorId"];
            this.authorEmail = _data["authorEmail"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.spreadsheetUrl = _data["spreadsheetUrl"];
        }
    }

    static fromJS(data: any): ExportVenueGroupStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ExportVenueGroupStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["createDate"] = this.createDate;
        data["authorId"] = this.authorId;
        data["authorEmail"] = this.authorEmail;
        data["exceptionMessage"] = this.exceptionMessage;
        data["spreadsheetUrl"] = this.spreadsheetUrl;
        return data;
    }
}

export interface IExportVenueGroupStatus {
    id: string;
    status: ImportExportStatus;
    createDate: string;
    authorId: string | undefined;
    authorEmail: string | undefined;
    exceptionMessage: string | undefined;
    spreadsheetUrl: string | undefined;
}

export class VenueGroupImportViewModel implements IVenueGroupImportViewModel {
    spreadsheetUrl!: string | undefined;
    notificationEmails!: string[];

    constructor(data?: IVenueGroupImportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.spreadsheetUrl = _data["spreadsheetUrl"];
            if (Array.isArray(_data["notificationEmails"])) {
                this.notificationEmails = [] as any;
                for (let item of _data["notificationEmails"])
                    this.notificationEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): VenueGroupImportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupImportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spreadsheetUrl"] = this.spreadsheetUrl;
        if (Array.isArray(this.notificationEmails)) {
            data["notificationEmails"] = [];
            for (let item of this.notificationEmails)
                data["notificationEmails"].push(item);
        }
        return data;
    }
}

export interface IVenueGroupImportViewModel {
    spreadsheetUrl: string | undefined;
    notificationEmails: string[];
}

export class ImportVenueGroupStatus implements IImportVenueGroupStatus {
    id!: string;
    status!: ImportExportStatus;
    createDate!: string;
    authorId!: string | undefined;
    authorEmail!: string | undefined;
    exceptionMessage!: string | undefined;
    spreadsheetUrl!: string | undefined;
    importType!: ImportType;
    isAutomated!: boolean;

    constructor(data?: IImportVenueGroupStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.createDate = _data["createDate"];
            this.authorId = _data["authorId"];
            this.authorEmail = _data["authorEmail"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.spreadsheetUrl = _data["spreadsheetUrl"];
            this.importType = _data["importType"];
            this.isAutomated = _data["isAutomated"];
        }
    }

    static fromJS(data: any): ImportVenueGroupStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ImportVenueGroupStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["createDate"] = this.createDate;
        data["authorId"] = this.authorId;
        data["authorEmail"] = this.authorEmail;
        data["exceptionMessage"] = this.exceptionMessage;
        data["spreadsheetUrl"] = this.spreadsheetUrl;
        data["importType"] = this.importType;
        data["isAutomated"] = this.isAutomated;
        return data;
    }
}

export interface IImportVenueGroupStatus {
    id: string;
    status: ImportExportStatus;
    createDate: string;
    authorId: string | undefined;
    authorEmail: string | undefined;
    exceptionMessage: string | undefined;
    spreadsheetUrl: string | undefined;
    importType: ImportType;
    isAutomated: boolean;
}

/** 0 = ListingsLite 1 = Regus 2 = WeWorkIndia */
export enum ImportType {
    ListingsLite = 0,
    Regus = 1,
    WeWorkIndia = 2,
}

export class ImportVenueGroupStatusDetails extends ImportVenueGroupStatus implements IImportVenueGroupStatusDetails {
    results!: ImportVenueGroupResultViewModel[];

    constructor(data?: IImportVenueGroupStatusDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ImportVenueGroupResultViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportVenueGroupStatusDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ImportVenueGroupStatusDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IImportVenueGroupStatusDetails extends IImportVenueGroupStatus {
    results: ImportVenueGroupResultViewModel[];
}

export class ImportVenueGroupResultViewModel implements IImportVenueGroupResultViewModel {
    venueId!: string;
    _LogHtml!: string | undefined;
    status!: ImportExportStatus;
    rowId!: number;
    log!: ImportVenueLogEntryViewModel[];

    constructor(data?: IImportVenueGroupResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this._LogHtml = _data["_LogHtml"];
            this.status = _data["status"];
            this.rowId = _data["rowId"];
            if (Array.isArray(_data["log"])) {
                this.log = [] as any;
                for (let item of _data["log"])
                    this.log!.push(ImportVenueLogEntryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportVenueGroupResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportVenueGroupResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["_LogHtml"] = this._LogHtml;
        data["status"] = this.status;
        data["rowId"] = this.rowId;
        if (Array.isArray(this.log)) {
            data["log"] = [];
            for (let item of this.log)
                data["log"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportVenueGroupResultViewModel {
    venueId: string;
    _LogHtml: string | undefined;
    status: ImportExportStatus;
    rowId: number;
    log: ImportVenueLogEntryViewModel[];
}

export class ImportVenueLogEntryViewModel implements IImportVenueLogEntryViewModel {
    html!: string;
    logLevel!: LSLogLevel;

    constructor(data?: IImportVenueLogEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.html = _data["html"];
            this.logLevel = _data["logLevel"];
        }
    }

    static fromJS(data: any): ImportVenueLogEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportVenueLogEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["html"] = this.html;
        data["logLevel"] = this.logLevel;
        return data;
    }
}

export interface IImportVenueLogEntryViewModel {
    html: string;
    logLevel: LSLogLevel;
}

export class ImportVenueGroupPerformanceCounters implements IImportVenueGroupPerformanceCounters {
    aggregatedCounters!: { [key in keyof typeof ListingLitePerformanceCounterType]?: number; };
    countersPerVenue!: ImportVenuePerformanceCounters[];

    constructor(data?: IImportVenueGroupPerformanceCounters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (_data["aggregatedCounters"]) {
                this.aggregatedCounters = {} as any;
                for (let key in _data["aggregatedCounters"]) {
                    if (_data["aggregatedCounters"].hasOwnProperty(key))
                        (<any>this.aggregatedCounters)![key] = _data["aggregatedCounters"][key];
                }
            }
            if (Array.isArray(_data["countersPerVenue"])) {
                this.countersPerVenue = [] as any;
                for (let item of _data["countersPerVenue"])
                    this.countersPerVenue!.push(ImportVenuePerformanceCounters.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportVenueGroupPerformanceCounters {
        data = typeof data === 'object' ? data : {};
        let result = new ImportVenueGroupPerformanceCounters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.aggregatedCounters) {
            data["aggregatedCounters"] = {};
            for (let key in this.aggregatedCounters) {
                if (this.aggregatedCounters.hasOwnProperty(key))
                    (<any>data["aggregatedCounters"])[key] = (<any>this.aggregatedCounters)[key];
            }
        }
        if (Array.isArray(this.countersPerVenue)) {
            data["countersPerVenue"] = [];
            for (let item of this.countersPerVenue)
                data["countersPerVenue"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportVenueGroupPerformanceCounters {
    aggregatedCounters: { [key in keyof typeof ListingLitePerformanceCounterType]?: number; };
    countersPerVenue: ImportVenuePerformanceCounters[];
}

/** 1 = VenueUpsert 2 = UpsertVenueCompleteFromTemplate 3 = MapToLiquidSpaceVenueTemplate 4 = MapToVenueComplete 5 = CompareTemplates 6 = CompareTemplatesByProperties 7 = PopulateVenueLocationFields 8 = SetupVenueVisas 9 = CreateVenueHooRules 10 = ImportVenuePictures 11 = ImportVenueAmenities 12 = UpsertVenueCommand 13 = RereadVenueComplete 14 = DeleteWorkspaceCompleteFromTemplate 15 = DeleteWorkspaceCompleteFromTemplateCount 16 = UpsertWorkspaceCompleteFromTemplate 17 = ImportWorkspacePictures 18 = ImportWorkspaceAmenities 19 = ImportWorkspacePrices 20 = ImportWorkspaceAvailailityDate 21 = ImportWorkspaceMinimumBookingTerm 22 = ImportWorkspace 23 = ImportWorkspaceCount 24 = SpreadsheetSync 25 = AddingToVenueGroup 26 = SpreadsheetThrottling 27 = Total 28 = ImportVenueAdmin 29 = RegusAPIGetLocation 30 = RegusAPIGetLocationOpenHours 31 = RegusAPIGetSpaces 32 = RegusAPIGetInventoryPricings 33 = RegusMapVenue 34 = RegusMapWorkspaces 35 = RegusNotWebBookableVenueCount */
export enum ListingLitePerformanceCounterType {
    VenueUpsert = 1,
    UpsertVenueCompleteFromTemplate = 2,
    MapToLiquidSpaceVenueTemplate = 3,
    MapToVenueComplete = 4,
    CompareTemplates = 5,
    CompareTemplatesByProperties = 6,
    PopulateVenueLocationFields = 7,
    SetupVenueVisas = 8,
    CreateVenueHooRules = 9,
    ImportVenuePictures = 10,
    ImportVenueAmenities = 11,
    UpsertVenueCommand = 12,
    RereadVenueComplete = 13,
    DeleteWorkspaceCompleteFromTemplate = 14,
    DeleteWorkspaceCompleteFromTemplateCount = 15,
    UpsertWorkspaceCompleteFromTemplate = 16,
    ImportWorkspacePictures = 17,
    ImportWorkspaceAmenities = 18,
    ImportWorkspacePrices = 19,
    ImportWorkspaceAvailailityDate = 20,
    ImportWorkspaceMinimumBookingTerm = 21,
    ImportWorkspace = 22,
    ImportWorkspaceCount = 23,
    SpreadsheetSync = 24,
    AddingToVenueGroup = 25,
    SpreadsheetThrottling = 26,
    Total = 27,
    ImportVenueAdmin = 28,
    RegusAPIGetLocation = 29,
    RegusAPIGetLocationOpenHours = 30,
    RegusAPIGetSpaces = 31,
    RegusAPIGetInventoryPricings = 32,
    RegusMapVenue = 33,
    RegusMapWorkspaces = 34,
    RegusNotWebBookableVenueCount = 35,
}

export class ImportVenuePerformanceCounters implements IImportVenuePerformanceCounters {
    venueId!: string;
    counters!: { [key in keyof typeof ListingLitePerformanceCounterType]?: number; };

    constructor(data?: IImportVenuePerformanceCounters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            if (_data["counters"]) {
                this.counters = {} as any;
                for (let key in _data["counters"]) {
                    if (_data["counters"].hasOwnProperty(key))
                        (<any>this.counters)![key] = _data["counters"][key];
                }
            }
        }
    }

    static fromJS(data: any): ImportVenuePerformanceCounters {
        data = typeof data === 'object' ? data : {};
        let result = new ImportVenuePerformanceCounters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        if (this.counters) {
            data["counters"] = {};
            for (let key in this.counters) {
                if (this.counters.hasOwnProperty(key))
                    (<any>data["counters"])[key] = (<any>this.counters)[key];
            }
        }
        return data;
    }
}

export interface IImportVenuePerformanceCounters {
    venueId: string;
    counters: { [key in keyof typeof ListingLitePerformanceCounterType]?: number; };
}

export class VenueAdminModel implements IVenueAdminModel {
    pictureURLs!: PictureURLViewModel[];
    pictureUrl!: string | undefined;
    isVenueHost!: boolean;
    email!: string;
    phoneNumber!: string;
    firstName!: string;
    lastName!: string;
    company!: string | undefined;
    memberId!: string;
    isNew!: boolean;
    role!: VenueRoleEnum;
    oldPassword!: string;
    newPassword!: string;
    confirmPassword!: string;
    reservationType!: NotificationsReservationType;
    isSmsDeliveryType!: boolean;
    isSmsDeliveryTypeMonthly!: boolean;
    includeTourCalendarFile!: boolean;
    isEmailDeliveryType!: boolean;
    isEmailDeliveryTypeMonthly!: boolean;
    isEmailDeliveryTypeIncidentals!: boolean;
    isEmailDeliveryTypeHourlyRequestToBook!: boolean;
    isInheritedFromVenueGroup!: boolean;

    constructor(data?: IVenueAdminModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pictureURLs"])) {
                this.pictureURLs = [] as any;
                for (let item of _data["pictureURLs"])
                    this.pictureURLs!.push(PictureURLViewModel.fromJS(item));
            }
            this.pictureUrl = _data["pictureUrl"];
            this.isVenueHost = _data["isVenueHost"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.company = _data["company"];
            this.memberId = _data["memberId"];
            this.isNew = _data["isNew"];
            this.role = _data["role"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
            this.reservationType = _data["reservationType"];
            this.isSmsDeliveryType = _data["isSmsDeliveryType"];
            this.isSmsDeliveryTypeMonthly = _data["isSmsDeliveryTypeMonthly"];
            this.includeTourCalendarFile = _data["includeTourCalendarFile"];
            this.isEmailDeliveryType = _data["isEmailDeliveryType"];
            this.isEmailDeliveryTypeMonthly = _data["isEmailDeliveryTypeMonthly"];
            this.isEmailDeliveryTypeIncidentals = _data["isEmailDeliveryTypeIncidentals"];
            this.isEmailDeliveryTypeHourlyRequestToBook = _data["isEmailDeliveryTypeHourlyRequestToBook"];
            this.isInheritedFromVenueGroup = _data["isInheritedFromVenueGroup"];
        }
    }

    static fromJS(data: any): VenueAdminModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueAdminModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pictureURLs)) {
            data["pictureURLs"] = [];
            for (let item of this.pictureURLs)
                data["pictureURLs"].push(item.toJSON());
        }
        data["pictureUrl"] = this.pictureUrl;
        data["isVenueHost"] = this.isVenueHost;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["company"] = this.company;
        data["memberId"] = this.memberId;
        data["isNew"] = this.isNew;
        data["role"] = this.role;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        data["reservationType"] = this.reservationType;
        data["isSmsDeliveryType"] = this.isSmsDeliveryType;
        data["isSmsDeliveryTypeMonthly"] = this.isSmsDeliveryTypeMonthly;
        data["includeTourCalendarFile"] = this.includeTourCalendarFile;
        data["isEmailDeliveryType"] = this.isEmailDeliveryType;
        data["isEmailDeliveryTypeMonthly"] = this.isEmailDeliveryTypeMonthly;
        data["isEmailDeliveryTypeIncidentals"] = this.isEmailDeliveryTypeIncidentals;
        data["isEmailDeliveryTypeHourlyRequestToBook"] = this.isEmailDeliveryTypeHourlyRequestToBook;
        data["isInheritedFromVenueGroup"] = this.isInheritedFromVenueGroup;
        return data;
    }
}

export interface IVenueAdminModel {
    pictureURLs: PictureURLViewModel[];
    pictureUrl: string | undefined;
    isVenueHost: boolean;
    email: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
    company: string | undefined;
    memberId: string;
    isNew: boolean;
    role: VenueRoleEnum;
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
    reservationType: NotificationsReservationType;
    isSmsDeliveryType: boolean;
    isSmsDeliveryTypeMonthly: boolean;
    includeTourCalendarFile: boolean;
    isEmailDeliveryType: boolean;
    isEmailDeliveryTypeMonthly: boolean;
    isEmailDeliveryTypeIncidentals: boolean;
    isEmailDeliveryTypeHourlyRequestToBook: boolean;
    isInheritedFromVenueGroup: boolean;
}

/** 0 = VenueAdmin 1 = VenueOwner 2 = CalendarAdmin 3 = ListingBroker */
export enum VenueRoleEnum {
    VenueAdmin = 0,
    VenueOwner = 1,
    CalendarAdmin = 2,
    ListingBroker = 3,
}

/** 0 = AllReservations 1 = CCBilled 2 = None */
export enum NotificationsReservationType {
    AllReservations = 0,
    CCBilled = 1,
    None = 2,
}

export class PricingRateViewModel implements IPricingRateViewModel {
    id!: string;
    name!: string | undefined;
    venueGroupId!: string;
    effectiveRates!: EffectiveRateViewModel[];
    isMonthly!: boolean;

    constructor(data?: IPricingRateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.venueGroupId = _data["venueGroupId"];
            if (Array.isArray(_data["effectiveRates"])) {
                this.effectiveRates = [] as any;
                for (let item of _data["effectiveRates"])
                    this.effectiveRates!.push(EffectiveRateViewModel.fromJS(item));
            }
            this.isMonthly = _data["isMonthly"];
        }
    }

    static fromJS(data: any): PricingRateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["venueGroupId"] = this.venueGroupId;
        if (Array.isArray(this.effectiveRates)) {
            data["effectiveRates"] = [];
            for (let item of this.effectiveRates)
                data["effectiveRates"].push(item.toJSON());
        }
        data["isMonthly"] = this.isMonthly;
        return data;
    }
}

export interface IPricingRateViewModel {
    id: string;
    name: string | undefined;
    venueGroupId: string;
    effectiveRates: EffectiveRateViewModel[];
    isMonthly: boolean;
}

export class EffectiveRateViewModel implements IEffectiveRateViewModel {
    id!: string;
    flatRatePercent!: number;
    startDate!: string | undefined;
    endDate!: string | undefined;
    pricingTiers!: PricingTier[];

    constructor(data?: IEffectiveRateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.flatRatePercent = _data["flatRatePercent"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            if (Array.isArray(_data["pricingTiers"])) {
                this.pricingTiers = [] as any;
                for (let item of _data["pricingTiers"])
                    this.pricingTiers!.push(PricingTier.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EffectiveRateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EffectiveRateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["flatRatePercent"] = this.flatRatePercent;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        if (Array.isArray(this.pricingTiers)) {
            data["pricingTiers"] = [];
            for (let item of this.pricingTiers)
                data["pricingTiers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEffectiveRateViewModel {
    id: string;
    flatRatePercent: number;
    startDate: string | undefined;
    endDate: string | undefined;
    pricingTiers: PricingTier[];
}

export class PricingTier implements IPricingTier {
    key!: number;
    value!: number;

    constructor(data?: IPricingTier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PricingTier {
        data = typeof data === 'object' ? data : {};
        let result = new PricingTier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IPricingTier {
    key: number;
    value: number;
}

export class VenueGroupReportsViewModel implements IVenueGroupReportsViewModel {
    id!: string;
    downloadReady!: boolean;
    reportType!: string;
    status!: string;
    parameters!: string | undefined;
    createDate!: string;
    scheduled!: boolean;
    name!: string;

    constructor(data?: IVenueGroupReportsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.downloadReady = _data["downloadReady"];
            this.reportType = _data["reportType"];
            this.status = _data["status"];
            this.parameters = _data["parameters"];
            this.createDate = _data["createDate"];
            this.scheduled = _data["scheduled"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VenueGroupReportsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupReportsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["downloadReady"] = this.downloadReady;
        data["reportType"] = this.reportType;
        data["status"] = this.status;
        data["parameters"] = this.parameters;
        data["createDate"] = this.createDate;
        data["scheduled"] = this.scheduled;
        data["name"] = this.name;
        return data;
    }
}

export interface IVenueGroupReportsViewModel {
    id: string;
    downloadReady: boolean;
    reportType: string;
    status: string;
    parameters: string | undefined;
    createDate: string;
    scheduled: boolean;
    name: string;
}

export class VenueGroupMonthlyLeadsReportParamsViewModel implements IVenueGroupMonthlyLeadsReportParamsViewModel {
    venueGroupId!: string;
    from!: string;
    to!: string;

    constructor(data?: IVenueGroupMonthlyLeadsReportParamsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueGroupId = _data["venueGroupId"];
            this.from = _data["from"];
            this.to = _data["to"];
        }
    }

    static fromJS(data: any): VenueGroupMonthlyLeadsReportParamsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupMonthlyLeadsReportParamsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueGroupId"] = this.venueGroupId;
        data["from"] = this.from;
        data["to"] = this.to;
        return data;
    }
}

export interface IVenueGroupMonthlyLeadsReportParamsViewModel {
    venueGroupId: string;
    from: string;
    to: string;
}

export class DataTilesViewModel implements IDataTilesViewModel {
    hourlyRtBCount!: number;
    hourlyCreditCardCount!: number;
    publishedVenuesCount!: number;
    unpulishedVenuesCount!: number;
    hourlyCompletedCount!: number;
    monthlyCompletedCount!: number;
    hourlyRevenue!: string;
    monthlyRevenue!: string;

    constructor(data?: IDataTilesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.hourlyRtBCount = _data["hourlyRtBCount"];
            this.hourlyCreditCardCount = _data["hourlyCreditCardCount"];
            this.publishedVenuesCount = _data["publishedVenuesCount"];
            this.unpulishedVenuesCount = _data["unpulishedVenuesCount"];
            this.hourlyCompletedCount = _data["hourlyCompletedCount"];
            this.monthlyCompletedCount = _data["monthlyCompletedCount"];
            this.hourlyRevenue = _data["hourlyRevenue"];
            this.monthlyRevenue = _data["monthlyRevenue"];
        }
    }

    static fromJS(data: any): DataTilesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataTilesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourlyRtBCount"] = this.hourlyRtBCount;
        data["hourlyCreditCardCount"] = this.hourlyCreditCardCount;
        data["publishedVenuesCount"] = this.publishedVenuesCount;
        data["unpulishedVenuesCount"] = this.unpulishedVenuesCount;
        data["hourlyCompletedCount"] = this.hourlyCompletedCount;
        data["monthlyCompletedCount"] = this.monthlyCompletedCount;
        data["hourlyRevenue"] = this.hourlyRevenue;
        data["monthlyRevenue"] = this.monthlyRevenue;
        return data;
    }
}

export interface IDataTilesViewModel {
    hourlyRtBCount: number;
    hourlyCreditCardCount: number;
    publishedVenuesCount: number;
    unpulishedVenuesCount: number;
    hourlyCompletedCount: number;
    monthlyCompletedCount: number;
    hourlyRevenue: string;
    monthlyRevenue: string;
}

export class HourlyReservationViewModel implements IHourlyReservationViewModel {
    id!: string;
    startDateLocal!: string;
    startDateUtc!: string;
    endDateUtc!: string;
    deleted!: boolean;
    isRecurrent!: boolean;
    venueName!: string;
    workspaceName!: string;
    memberName!: string;
    cost!: string;

    constructor(data?: IHourlyReservationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDateLocal = _data["startDateLocal"];
            this.startDateUtc = _data["startDateUtc"];
            this.endDateUtc = _data["endDateUtc"];
            this.deleted = _data["deleted"];
            this.isRecurrent = _data["isRecurrent"];
            this.venueName = _data["venueName"];
            this.workspaceName = _data["workspaceName"];
            this.memberName = _data["memberName"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): HourlyReservationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HourlyReservationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDateLocal"] = this.startDateLocal;
        data["startDateUtc"] = this.startDateUtc;
        data["endDateUtc"] = this.endDateUtc;
        data["deleted"] = this.deleted;
        data["isRecurrent"] = this.isRecurrent;
        data["venueName"] = this.venueName;
        data["workspaceName"] = this.workspaceName;
        data["memberName"] = this.memberName;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IHourlyReservationViewModel {
    id: string;
    startDateLocal: string;
    startDateUtc: string;
    endDateUtc: string;
    deleted: boolean;
    isRecurrent: boolean;
    venueName: string;
    workspaceName: string;
    memberName: string;
    cost: string;
}

export class VenueGroupReservationsComposer implements IVenueGroupReservationsComposer {
    upcomingReservations!: VenueGroupReservationViewModel[];
    pastReservations!: VenueGroupReservationViewModel[];

    constructor(data?: IVenueGroupReservationsComposer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["upcomingReservations"])) {
                this.upcomingReservations = [] as any;
                for (let item of _data["upcomingReservations"])
                    this.upcomingReservations!.push(VenueGroupReservationViewModel.fromJS(item));
            }
            if (Array.isArray(_data["pastReservations"])) {
                this.pastReservations = [] as any;
                for (let item of _data["pastReservations"])
                    this.pastReservations!.push(VenueGroupReservationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VenueGroupReservationsComposer {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupReservationsComposer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.upcomingReservations)) {
            data["upcomingReservations"] = [];
            for (let item of this.upcomingReservations)
                data["upcomingReservations"].push(item.toJSON());
        }
        if (Array.isArray(this.pastReservations)) {
            data["pastReservations"] = [];
            for (let item of this.pastReservations)
                data["pastReservations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVenueGroupReservationsComposer {
    upcomingReservations: VenueGroupReservationViewModel[];
    pastReservations: VenueGroupReservationViewModel[];
}

export class VenueGroupReservationViewModel implements IVenueGroupReservationViewModel {
    id!: string;
    startTime!: string;
    startTimeLocal!: string;
    isRecurrent!: boolean;
    venueName!: string | undefined;
    workspaceName!: string | undefined;
    memberName!: string | undefined;
    cost!: string | undefined;
    status!: ReservationStatus;

    constructor(data?: IVenueGroupReservationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"];
            this.startTimeLocal = _data["startTimeLocal"];
            this.isRecurrent = _data["isRecurrent"];
            this.venueName = _data["venueName"];
            this.workspaceName = _data["workspaceName"];
            this.memberName = _data["memberName"];
            this.cost = _data["cost"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VenueGroupReservationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupReservationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime;
        data["startTimeLocal"] = this.startTimeLocal;
        data["isRecurrent"] = this.isRecurrent;
        data["venueName"] = this.venueName;
        data["workspaceName"] = this.workspaceName;
        data["memberName"] = this.memberName;
        data["cost"] = this.cost;
        data["status"] = this.status;
        return data;
    }
}

export interface IVenueGroupReservationViewModel {
    id: string;
    startTime: string;
    startTimeLocal: string;
    isRecurrent: boolean;
    venueName: string | undefined;
    workspaceName: string | undefined;
    memberName: string | undefined;
    cost: string | undefined;
    status: ReservationStatus;
}

export class VenueGroupModel implements IVenueGroupModel {
    id!: string;
    name!: string;

    constructor(data?: IVenueGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VenueGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVenueGroupModel {
    id: string;
    name: string;
}

export class HourlyRequestToBookModel implements IHourlyRequestToBookModel {
    id!: string;
    venueName!: string | undefined;
    workspaceName!: string | undefined;
    cost!: string;
    memberName!: string | undefined;
    startTime!: string;
    status!: HourlyRequestToBookStatus;
    isExpiring!: boolean;
    isRecurrent!: boolean;

    constructor(data?: IHourlyRequestToBookModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.venueName = _data["venueName"];
            this.workspaceName = _data["workspaceName"];
            this.cost = _data["cost"];
            this.memberName = _data["memberName"];
            this.startTime = _data["startTime"];
            this.status = _data["status"];
            this.isExpiring = _data["isExpiring"];
            this.isRecurrent = _data["isRecurrent"];
        }
    }

    static fromJS(data: any): HourlyRequestToBookModel {
        data = typeof data === 'object' ? data : {};
        let result = new HourlyRequestToBookModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["venueName"] = this.venueName;
        data["workspaceName"] = this.workspaceName;
        data["cost"] = this.cost;
        data["memberName"] = this.memberName;
        data["startTime"] = this.startTime;
        data["status"] = this.status;
        data["isExpiring"] = this.isExpiring;
        data["isRecurrent"] = this.isRecurrent;
        return data;
    }
}

export interface IHourlyRequestToBookModel {
    id: string;
    venueName: string | undefined;
    workspaceName: string | undefined;
    cost: string;
    memberName: string | undefined;
    startTime: string;
    status: HourlyRequestToBookStatus;
    isExpiring: boolean;
    isRecurrent: boolean;
}

export class VenueGroupVenueListItem implements IVenueGroupVenueListItem {
    id!: string;
    name!: string;
    status!: VenueStatusNew;
    address!: string;

    constructor(data?: IVenueGroupVenueListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): VenueGroupVenueListItem {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupVenueListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["address"] = this.address;
        return data;
    }
}

export interface IVenueGroupVenueListItem {
    id: string;
    name: string;
    status: VenueStatusNew;
    address: string;
}

/** 0 = Unknown 1 = New 2 = Demo 3 = Inactive 4 = Proposed 5 = Pending 6 = Launched 7 = Retired 8 = Limited 9 = Internal 10 = ProposedPrivate 11 = InactiveExpired 12 = InactiveSuspended */
export enum VenueStatusNew {
    Unknown = 0,
    New = 1,
    Demo = 2,
    Inactive = 3,
    Proposed = 4,
    Pending = 5,
    Launched = 6,
    Retired = 7,
    Limited = 8,
    Internal = 9,
    ProposedPrivate = 10,
    InactiveExpired = 11,
    InactiveSuspended = 12,
}

export class VenueGroupBulkAddVenueViewModel implements IVenueGroupBulkAddVenueViewModel {
    id!: string;
    name!: string;
    status!: string;
    address!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IVenueGroupBulkAddVenueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.address = _data["address"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): VenueGroupBulkAddVenueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupBulkAddVenueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["address"] = this.address;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IVenueGroupBulkAddVenueViewModel {
    id: string;
    name: string;
    status: string;
    address: string | undefined;
    isSelected: boolean;
}

/** 0 = Description 1 = ToQualify 2 = ToGet */
export enum VenueGroupVisaType {
    Description = 0,
    ToQualify = 1,
    ToGet = 2,
}

export class VenueGroupBulkData implements IVenueGroupBulkData {
    venueGroupId!: string;
    originationScenario!: DefaultMemberOriginationScenario;
    visaType!: VenueGroupVisaType;
    selectedVenueIds!: string[];

    constructor(data?: IVenueGroupBulkData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueGroupId = _data["venueGroupId"];
            this.originationScenario = _data["originationScenario"];
            this.visaType = _data["visaType"];
            if (Array.isArray(_data["selectedVenueIds"])) {
                this.selectedVenueIds = [] as any;
                for (let item of _data["selectedVenueIds"])
                    this.selectedVenueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): VenueGroupBulkData {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupBulkData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueGroupId"] = this.venueGroupId;
        data["originationScenario"] = this.originationScenario;
        data["visaType"] = this.visaType;
        if (Array.isArray(this.selectedVenueIds)) {
            data["selectedVenueIds"] = [];
            for (let item of this.selectedVenueIds)
                data["selectedVenueIds"].push(item);
        }
        return data;
    }
}

export interface IVenueGroupBulkData {
    venueGroupId: string;
    originationScenario: DefaultMemberOriginationScenario;
    visaType: VenueGroupVisaType;
    selectedVenueIds: string[];
}

/** 0 = None 1 = Venue 2 = LiquidSpace 3 = VenueAdministrator 4 = MonthlyLiquidSpace 5 = Portfolio */
export enum DefaultMemberOriginationScenario {
    None = 0,
    Venue = 1,
    LiquidSpace = 2,
    VenueAdministrator = 3,
    MonthlyLiquidSpace = 4,
    Portfolio = 5,
}

export class KeyValuePairOfGuidAndString implements IKeyValuePairOfGuidAndString {
    key!: string;
    value!: string | undefined;

    constructor(data?: IKeyValuePairOfGuidAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfGuidAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfGuidAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfGuidAndString {
    key: string;
    value: string | undefined;
}

export class VenueGroupSettingsViewModel implements IVenueGroupSettingsViewModel {
    name!: string;
    nameSynonymsString!: string;
    rank!: VenueGroupRank;
    visibility!: VenueGroupVisibility;
    pricingRateId!: string | undefined;
    pricingRateMonthlyId!: string | undefined;
    financeNotes!: string | undefined;
    priceMerchandising!: PriceMerchandising;
    integration!: VenueGroupIntegration;
    enterpriseOnlyVisibility!: boolean;
    conciergeAssistedBookings!: boolean;
    importListingTemplate!: string | undefined;
    importNotificationEmails!: string | undefined;
    forceGrantWithNoApproval!: boolean;
    importEnabled!: boolean;
    lsPartnerSuccess!: string | undefined;
    classification!: VenueGroupClassification;
    skipAutoExpiration!: boolean;
    neighborhoods!: NeighborhoodViewModel[];

    constructor(data?: IVenueGroupSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameSynonymsString = _data["nameSynonymsString"];
            this.rank = _data["rank"];
            this.visibility = _data["visibility"];
            this.pricingRateId = _data["pricingRateId"];
            this.pricingRateMonthlyId = _data["pricingRateMonthlyId"];
            this.financeNotes = _data["financeNotes"];
            this.priceMerchandising = _data["priceMerchandising"];
            this.integration = _data["integration"];
            this.enterpriseOnlyVisibility = _data["enterpriseOnlyVisibility"];
            this.conciergeAssistedBookings = _data["conciergeAssistedBookings"];
            this.importListingTemplate = _data["importListingTemplate"];
            this.importNotificationEmails = _data["importNotificationEmails"];
            this.forceGrantWithNoApproval = _data["forceGrantWithNoApproval"];
            this.importEnabled = _data["importEnabled"];
            this.lsPartnerSuccess = _data["lsPartnerSuccess"];
            this.classification = _data["classification"];
            this.skipAutoExpiration = _data["skipAutoExpiration"];
            if (Array.isArray(_data["neighborhoods"])) {
                this.neighborhoods = [] as any;
                for (let item of _data["neighborhoods"])
                    this.neighborhoods!.push(NeighborhoodViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VenueGroupSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameSynonymsString"] = this.nameSynonymsString;
        data["rank"] = this.rank;
        data["visibility"] = this.visibility;
        data["pricingRateId"] = this.pricingRateId;
        data["pricingRateMonthlyId"] = this.pricingRateMonthlyId;
        data["financeNotes"] = this.financeNotes;
        data["priceMerchandising"] = this.priceMerchandising;
        data["integration"] = this.integration;
        data["enterpriseOnlyVisibility"] = this.enterpriseOnlyVisibility;
        data["conciergeAssistedBookings"] = this.conciergeAssistedBookings;
        data["importListingTemplate"] = this.importListingTemplate;
        data["importNotificationEmails"] = this.importNotificationEmails;
        data["forceGrantWithNoApproval"] = this.forceGrantWithNoApproval;
        data["importEnabled"] = this.importEnabled;
        data["lsPartnerSuccess"] = this.lsPartnerSuccess;
        data["classification"] = this.classification;
        data["skipAutoExpiration"] = this.skipAutoExpiration;
        if (Array.isArray(this.neighborhoods)) {
            data["neighborhoods"] = [];
            for (let item of this.neighborhoods)
                data["neighborhoods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVenueGroupSettingsViewModel {
    name: string;
    nameSynonymsString: string;
    rank: VenueGroupRank;
    visibility: VenueGroupVisibility;
    pricingRateId: string | undefined;
    pricingRateMonthlyId: string | undefined;
    financeNotes: string | undefined;
    priceMerchandising: PriceMerchandising;
    integration: VenueGroupIntegration;
    enterpriseOnlyVisibility: boolean;
    conciergeAssistedBookings: boolean;
    importListingTemplate: string | undefined;
    importNotificationEmails: string | undefined;
    forceGrantWithNoApproval: boolean;
    importEnabled: boolean;
    lsPartnerSuccess: string | undefined;
    classification: VenueGroupClassification;
    skipAutoExpiration: boolean;
    neighborhoods: NeighborhoodViewModel[];
}

/** 1000 = Promotional 2000 = Chain */
export enum VenueGroupRank {
    Promotional = 1000,
    Chain = 2000,
}

/** 0 = Public 1 = Private */
export enum VenueGroupVisibility {
    Public = 0,
    Private = 1,
}

/** 0 = Standard 1 = PriceStartingAt */
export enum PriceMerchandising {
    Standard = 0,
    PriceStartingAt = 1,
}

/** 0 = None 1 = Regus 2 = WeWorkIndia */
export enum VenueGroupIntegration {
    None = 0,
    Regus = 1,
    WeWorkIndia = 2,
}

/** 0 = None 1 = Tier1 2 = Tier2 3 = Tier3 4 = Tier4 5 = Tier5 */
export enum VenueGroupClassification {
    None = 0,
    Tier1 = 1,
    Tier2 = 2,
    Tier3 = 3,
    Tier4 = 4,
    Tier5 = 5,
}

export class NeighborhoodViewModel implements INeighborhoodViewModel {
    id!: string;
    name!: string;
    type!: NeighborhoodType;
    checked!: boolean;

    constructor(data?: INeighborhoodViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): NeighborhoodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NeighborhoodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["checked"] = this.checked;
        return data;
    }
}

export interface INeighborhoodViewModel {
    id: string;
    name: string;
    type: NeighborhoodType;
    checked: boolean;
}

/** 0 = SubMarket 1 = Market 2 = Region */
export enum NeighborhoodType {
    SubMarket = 0,
    Market = 1,
    Region = 2,
}

export class VenueGroupListViewModel implements IVenueGroupListViewModel {
    groupId!: string;
    name!: string;
    rank!: VenueGroupRank;
    qualifyVisas!: number;
    eligibleVisas!: number;

    constructor(data?: IVenueGroupListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.name = _data["name"];
            this.rank = _data["rank"];
            this.qualifyVisas = _data["qualifyVisas"];
            this.eligibleVisas = _data["eligibleVisas"];
        }
    }

    static fromJS(data: any): VenueGroupListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["name"] = this.name;
        data["rank"] = this.rank;
        data["qualifyVisas"] = this.qualifyVisas;
        data["eligibleVisas"] = this.eligibleVisas;
        return data;
    }
}

export interface IVenueGroupListViewModel {
    groupId: string;
    name: string;
    rank: VenueGroupRank;
    qualifyVisas: number;
    eligibleVisas: number;
}

export class VenueGroupVenuesStatementWrapper implements IVenueGroupVenuesStatementWrapper {
    currency!: CurrencyType;
    currencyPrefix!: string;
    venueGroupStatements!: VenueGroupVenuesStatementViewModel[];

    constructor(data?: IVenueGroupVenuesStatementWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.currencyPrefix = _data["currencyPrefix"];
            if (Array.isArray(_data["venueGroupStatements"])) {
                this.venueGroupStatements = [] as any;
                for (let item of _data["venueGroupStatements"])
                    this.venueGroupStatements!.push(VenueGroupVenuesStatementViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VenueGroupVenuesStatementWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupVenuesStatementWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["currencyPrefix"] = this.currencyPrefix;
        if (Array.isArray(this.venueGroupStatements)) {
            data["venueGroupStatements"] = [];
            for (let item of this.venueGroupStatements)
                data["venueGroupStatements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVenueGroupVenuesStatementWrapper {
    currency: CurrencyType;
    currencyPrefix: string;
    venueGroupStatements: VenueGroupVenuesStatementViewModel[];
}

export class VenueGroupVenuesStatementViewModel implements IVenueGroupVenuesStatementViewModel {
    venueGroupId!: string;
    applyDate!: string;
    monthlyReservationCount!: number;
    hourlyReservationCount!: number;
    salesPrice!: number;
    rentPaid!: number;
    monthlyIncidentals!: number;
    hourlyIncedentals!: number;
    totalPaidToVenueHourly!: number;
    totalPaidToVenueMonthly!: number;
    salesPriceLocalCurrency!: number;
    rentPaidLocalCurrency!: number;
    monthlyIncidentalsLocalCurrency!: number;
    hourlyIncedentalsLocalCurrency!: number;
    totalPaidToVenueHourlyLocalCurrency!: number;
    totalPaidToVenueMonthlyLocalCurrency!: number;
    localCurrency!: CurrencyType | undefined;
    isMonthlyGenerated!: boolean;
    spreadsheetDataId!: string;

    constructor(data?: IVenueGroupVenuesStatementViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueGroupId = _data["venueGroupId"];
            this.applyDate = _data["applyDate"];
            this.monthlyReservationCount = _data["monthlyReservationCount"];
            this.hourlyReservationCount = _data["hourlyReservationCount"];
            this.salesPrice = _data["salesPrice"];
            this.rentPaid = _data["rentPaid"];
            this.monthlyIncidentals = _data["monthlyIncidentals"];
            this.hourlyIncedentals = _data["hourlyIncedentals"];
            this.totalPaidToVenueHourly = _data["totalPaidToVenueHourly"];
            this.totalPaidToVenueMonthly = _data["totalPaidToVenueMonthly"];
            this.salesPriceLocalCurrency = _data["salesPriceLocalCurrency"];
            this.rentPaidLocalCurrency = _data["rentPaidLocalCurrency"];
            this.monthlyIncidentalsLocalCurrency = _data["monthlyIncidentalsLocalCurrency"];
            this.hourlyIncedentalsLocalCurrency = _data["hourlyIncedentalsLocalCurrency"];
            this.totalPaidToVenueHourlyLocalCurrency = _data["totalPaidToVenueHourlyLocalCurrency"];
            this.totalPaidToVenueMonthlyLocalCurrency = _data["totalPaidToVenueMonthlyLocalCurrency"];
            this.localCurrency = _data["localCurrency"];
            this.isMonthlyGenerated = _data["isMonthlyGenerated"];
            this.spreadsheetDataId = _data["spreadsheetDataId"];
        }
    }

    static fromJS(data: any): VenueGroupVenuesStatementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupVenuesStatementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueGroupId"] = this.venueGroupId;
        data["applyDate"] = this.applyDate;
        data["monthlyReservationCount"] = this.monthlyReservationCount;
        data["hourlyReservationCount"] = this.hourlyReservationCount;
        data["salesPrice"] = this.salesPrice;
        data["rentPaid"] = this.rentPaid;
        data["monthlyIncidentals"] = this.monthlyIncidentals;
        data["hourlyIncedentals"] = this.hourlyIncedentals;
        data["totalPaidToVenueHourly"] = this.totalPaidToVenueHourly;
        data["totalPaidToVenueMonthly"] = this.totalPaidToVenueMonthly;
        data["salesPriceLocalCurrency"] = this.salesPriceLocalCurrency;
        data["rentPaidLocalCurrency"] = this.rentPaidLocalCurrency;
        data["monthlyIncidentalsLocalCurrency"] = this.monthlyIncidentalsLocalCurrency;
        data["hourlyIncedentalsLocalCurrency"] = this.hourlyIncedentalsLocalCurrency;
        data["totalPaidToVenueHourlyLocalCurrency"] = this.totalPaidToVenueHourlyLocalCurrency;
        data["totalPaidToVenueMonthlyLocalCurrency"] = this.totalPaidToVenueMonthlyLocalCurrency;
        data["localCurrency"] = this.localCurrency;
        data["isMonthlyGenerated"] = this.isMonthlyGenerated;
        data["spreadsheetDataId"] = this.spreadsheetDataId;
        return data;
    }
}

export interface IVenueGroupVenuesStatementViewModel {
    venueGroupId: string;
    applyDate: string;
    monthlyReservationCount: number;
    hourlyReservationCount: number;
    salesPrice: number;
    rentPaid: number;
    monthlyIncidentals: number;
    hourlyIncedentals: number;
    totalPaidToVenueHourly: number;
    totalPaidToVenueMonthly: number;
    salesPriceLocalCurrency: number;
    rentPaidLocalCurrency: number;
    monthlyIncidentalsLocalCurrency: number;
    hourlyIncedentalsLocalCurrency: number;
    totalPaidToVenueHourlyLocalCurrency: number;
    totalPaidToVenueMonthlyLocalCurrency: number;
    localCurrency: CurrencyType | undefined;
    isMonthlyGenerated: boolean;
    spreadsheetDataId: string;
}

export class VenueGroupVisaViewModel implements IVenueGroupVisaViewModel {
    visaId!: string;
    venueId!: string;
    venueName!: string;
    venueStatus!: string;
    visaName!: string;
    venueAddress!: string | undefined;

    constructor(data?: IVenueGroupVisaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.visaId = _data["visaId"];
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
            this.venueStatus = _data["venueStatus"];
            this.visaName = _data["visaName"];
            this.venueAddress = _data["venueAddress"];
        }
    }

    static fromJS(data: any): VenueGroupVisaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupVisaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visaId"] = this.visaId;
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        data["venueStatus"] = this.venueStatus;
        data["visaName"] = this.visaName;
        data["venueAddress"] = this.venueAddress;
        return data;
    }
}

export interface IVenueGroupVisaViewModel {
    visaId: string;
    venueId: string;
    venueName: string;
    venueStatus: string;
    visaName: string;
    venueAddress: string | undefined;
}

export class AddVisaRequest implements IAddVisaRequest {
    visaType!: VenueGroupVisaType;
    visaKind!: VenueGroupVisaKind;
    visaOrMemberGroupId!: string;
    venueId!: string | undefined;

    constructor(data?: IAddVisaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.visaType = _data["visaType"];
            this.visaKind = _data["visaKind"];
            this.visaOrMemberGroupId = _data["visaOrMemberGroupId"];
            this.venueId = _data["venueId"];
        }
    }

    static fromJS(data: any): AddVisaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddVisaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visaType"] = this.visaType;
        data["visaKind"] = this.visaKind;
        data["visaOrMemberGroupId"] = this.visaOrMemberGroupId;
        data["venueId"] = this.venueId;
        return data;
    }
}

export interface IAddVisaRequest {
    visaType: VenueGroupVisaType;
    visaKind: VenueGroupVisaKind;
    visaOrMemberGroupId: string;
    venueId: string | undefined;
}

/** 0 = Visa 1 = MemberGroup */
export enum VenueGroupVisaKind {
    Visa = 0,
    MemberGroup = 1,
}

export abstract class WebhookEvent implements IWebhookEvent {
    enterpriseAccountId!: string;

    protected _discriminator: string;

    constructor(data?: IWebhookEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "WebhookEvent";
    }

    init(_data?: any) {
        if (_data) {
            this.enterpriseAccountId = _data["enterpriseAccountId"];
        }
    }

    static fromJS(data: any): WebhookEvent {
        data = typeof data === 'object' ? data : {};
        if (data["eventType"] === "message") {
            let result = new MessageEvent();
            result.init(data);
            return result;
        }
        if (data["eventType"] === "ReservationEvent") {
            throw new Error("The abstract class 'ReservationEvent' cannot be instantiated.");
        }
        if (data["eventType"] === "reservation.created") {
            let result = new ReservationCreatedEvent();
            result.init(data);
            return result;
        }
        if (data["eventType"] === "reservation.changed") {
            let result = new ReservationChangedEvent();
            result.init(data);
            return result;
        }
        if (data["eventType"] === "reservation.deleted") {
            let result = new ReservationDeletedEvent();
            result.init(data);
            return result;
        }
        if (data["eventType"] === "reservation.abouttostart") {
            let result = new ReservationAboutToStartEvent();
            result.init(data);
            return result;
        }
        if (data["eventType"] === "ReservationRequestEvent") {
            throw new Error("The abstract class 'ReservationRequestEvent' cannot be instantiated.");
        }
        if (data["eventType"] === "reservationrequest.created") {
            let result = new ReservationRequestCreatedEvent();
            result.init(data);
            return result;
        }
        if (data["eventType"] === "reservationrequest.changed") {
            let result = new ReservationRequestChangedEvent();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'WebhookEvent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this._discriminator;
        data["enterpriseAccountId"] = this.enterpriseAccountId;
        return data;
    }
}

export interface IWebhookEvent {
    enterpriseAccountId: string;
}

export class MessageEvent extends WebhookEvent implements IMessageEvent {
    chainId!: string | undefined;
    messageId!: string;
    recipientId!: string;
    recipientEmail!: string;
    senderId!: string;
    senderEmail!: string;
    senderVenueId!: string | undefined;
    senderVenueName!: string | undefined;
    message!: string | undefined;
    url!: string;

    constructor(data?: IMessageEvent) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "message";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chainId = _data["chainId"];
            this.messageId = _data["messageId"];
            this.recipientId = _data["recipientId"];
            this.recipientEmail = _data["recipientEmail"];
            this.senderId = _data["senderId"];
            this.senderEmail = _data["senderEmail"];
            this.senderVenueId = _data["senderVenueId"];
            this.senderVenueName = _data["senderVenueName"];
            this.message = _data["message"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): MessageEvent {
        data = typeof data === 'object' ? data : {};
        let result = new MessageEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chainId"] = this.chainId;
        data["messageId"] = this.messageId;
        data["recipientId"] = this.recipientId;
        data["recipientEmail"] = this.recipientEmail;
        data["senderId"] = this.senderId;
        data["senderEmail"] = this.senderEmail;
        data["senderVenueId"] = this.senderVenueId;
        data["senderVenueName"] = this.senderVenueName;
        data["message"] = this.message;
        data["url"] = this.url;
        super.toJSON(data);
        return data;
    }
}

export interface IMessageEvent extends IWebhookEvent {
    chainId: string | undefined;
    messageId: string;
    recipientId: string;
    recipientEmail: string;
    senderId: string;
    senderEmail: string;
    senderVenueId: string | undefined;
    senderVenueName: string | undefined;
    message: string | undefined;
    url: string;
}

export abstract class ReservationEvent extends WebhookEvent implements IReservationEvent {
    reservationId!: string;
    /** Reservation Owner ID */
    ownerId!: string;
    ownerEmail!: string | undefined;

    constructor(data?: IReservationEvent) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ReservationEvent";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.ownerId = _data["ownerId"];
            this.ownerEmail = _data["ownerEmail"];
        }
    }

    static fromJS(data: any): ReservationEvent {
        data = typeof data === 'object' ? data : {};
        if (data["eventType"] === "reservation.created") {
            let result = new ReservationCreatedEvent();
            result.init(data);
            return result;
        }
        if (data["eventType"] === "reservation.changed") {
            let result = new ReservationChangedEvent();
            result.init(data);
            return result;
        }
        if (data["eventType"] === "reservation.deleted") {
            let result = new ReservationDeletedEvent();
            result.init(data);
            return result;
        }
        if (data["eventType"] === "reservation.abouttostart") {
            let result = new ReservationAboutToStartEvent();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ReservationEvent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["ownerId"] = this.ownerId;
        data["ownerEmail"] = this.ownerEmail;
        super.toJSON(data);
        return data;
    }
}

export interface IReservationEvent extends IWebhookEvent {
    reservationId: string;
    /** Reservation Owner ID */
    ownerId: string;
    ownerEmail: string | undefined;
}

export class ReservationCreatedEvent extends ReservationEvent implements IReservationCreatedEvent {

    constructor(data?: IReservationCreatedEvent) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "reservation.created";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReservationCreatedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationCreatedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReservationCreatedEvent extends IReservationEvent {
}

export class ReservationChangedEvent extends ReservationEvent implements IReservationChangedEvent {

    constructor(data?: IReservationChangedEvent) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "reservation.changed";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReservationChangedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationChangedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReservationChangedEvent extends IReservationEvent {
}

export class ReservationDeletedEvent extends ReservationEvent implements IReservationDeletedEvent {

    constructor(data?: IReservationDeletedEvent) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "reservation.deleted";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReservationDeletedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDeletedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReservationDeletedEvent extends IReservationEvent {
}

export class ReservationAboutToStartEvent extends ReservationEvent implements IReservationAboutToStartEvent {

    constructor(data?: IReservationAboutToStartEvent) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "reservation.abouttostart";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReservationAboutToStartEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationAboutToStartEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReservationAboutToStartEvent extends IReservationEvent {
}

export abstract class ReservationRequestEvent extends WebhookEvent implements IReservationRequestEvent {
    requestId!: string;
    reservationId!: string | undefined;
    ownerId!: string;
    ownerEmail!: string | undefined;

    constructor(data?: IReservationRequestEvent) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ReservationRequestEvent";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestId = _data["requestId"];
            this.reservationId = _data["reservationId"];
            this.ownerId = _data["ownerId"];
            this.ownerEmail = _data["ownerEmail"];
        }
    }

    static fromJS(data: any): ReservationRequestEvent {
        data = typeof data === 'object' ? data : {};
        if (data["eventType"] === "reservationrequest.created") {
            let result = new ReservationRequestCreatedEvent();
            result.init(data);
            return result;
        }
        if (data["eventType"] === "reservationrequest.changed") {
            let result = new ReservationRequestChangedEvent();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ReservationRequestEvent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["reservationId"] = this.reservationId;
        data["ownerId"] = this.ownerId;
        data["ownerEmail"] = this.ownerEmail;
        super.toJSON(data);
        return data;
    }
}

export interface IReservationRequestEvent extends IWebhookEvent {
    requestId: string;
    reservationId: string | undefined;
    ownerId: string;
    ownerEmail: string | undefined;
}

export class ReservationRequestCreatedEvent extends ReservationRequestEvent implements IReservationRequestCreatedEvent {

    constructor(data?: IReservationRequestCreatedEvent) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "reservationrequest.created";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReservationRequestCreatedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationRequestCreatedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReservationRequestCreatedEvent extends IReservationRequestEvent {
}

export class ReservationRequestChangedEvent extends ReservationRequestEvent implements IReservationRequestChangedEvent {

    constructor(data?: IReservationRequestChangedEvent) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "reservationrequest.changed";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReservationRequestChangedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationRequestChangedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReservationRequestChangedEvent extends IReservationRequestEvent {
}

export class WorkspaceScenarioViewModel implements IWorkspaceScenarioViewModel {
    id!: string;
    name!: string;
    reservationMethods!: ReservationMethod[];

    constructor(data?: IWorkspaceScenarioViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["reservationMethods"])) {
                this.reservationMethods = [] as any;
                for (let item of _data["reservationMethods"])
                    this.reservationMethods!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkspaceScenarioViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceScenarioViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.reservationMethods)) {
            data["reservationMethods"] = [];
            for (let item of this.reservationMethods)
                data["reservationMethods"].push(item);
        }
        return data;
    }
}

export interface IWorkspaceScenarioViewModel {
    id: string;
    name: string;
    reservationMethods: ReservationMethod[];
}

/** 0 = Unknown 1 = UnknownMemberNeedVerification 2 = KnownAdminClaimed */
export enum ClaimVenueResult {
    Unknown = 0,
    UnknownMemberNeedVerification = 1,
    KnownAdminClaimed = 2,
}

export class VenuePermissionsViewModel implements IVenuePermissionsViewModel {
    visaId!: string | undefined;
    visaState!: VisaState | undefined;
    allowReservationsWhileVisaPending!: boolean;
    paymentMethod!: PaymentMethod | undefined;
    /** Currently price can be hidden only for VenueBilled visa */
    hidePrice!: boolean;
    isRequestToBook!: boolean;
    isPotentialVisa!: boolean;
    isVenueAdmin!: boolean;
    isCalendarAdmin!: boolean;

    constructor(data?: IVenuePermissionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.visaId = _data["visaId"];
            this.visaState = _data["visaState"];
            this.allowReservationsWhileVisaPending = _data["allowReservationsWhileVisaPending"];
            this.paymentMethod = _data["paymentMethod"];
            this.hidePrice = _data["hidePrice"];
            this.isRequestToBook = _data["isRequestToBook"];
            this.isPotentialVisa = _data["isPotentialVisa"];
            this.isVenueAdmin = _data["isVenueAdmin"];
            this.isCalendarAdmin = _data["isCalendarAdmin"];
        }
    }

    static fromJS(data: any): VenuePermissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenuePermissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visaId"] = this.visaId;
        data["visaState"] = this.visaState;
        data["allowReservationsWhileVisaPending"] = this.allowReservationsWhileVisaPending;
        data["paymentMethod"] = this.paymentMethod;
        data["hidePrice"] = this.hidePrice;
        data["isRequestToBook"] = this.isRequestToBook;
        data["isPotentialVisa"] = this.isPotentialVisa;
        data["isVenueAdmin"] = this.isVenueAdmin;
        data["isCalendarAdmin"] = this.isCalendarAdmin;
        return data;
    }
}

export interface IVenuePermissionsViewModel {
    visaId: string | undefined;
    visaState: VisaState | undefined;
    allowReservationsWhileVisaPending: boolean;
    paymentMethod: PaymentMethod | undefined;
    /** Currently price can be hidden only for VenueBilled visa */
    hidePrice: boolean;
    isRequestToBook: boolean;
    isPotentialVisa: boolean;
    isVenueAdmin: boolean;
    isCalendarAdmin: boolean;
}

/** 0 = Unset 1 = Pending 2 = Granted 3 = Denied */
export enum VisaState {
    Unset = 0,
    Pending = 1,
    Granted = 2,
    Denied = 3,
}

export class VenuePermissionsRequest implements IVenuePermissionsRequest {
    company!: string | undefined;
    phoneNumber!: string | undefined;
    freeFormAnswer!: string | undefined;

    constructor(data?: IVenuePermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.phoneNumber = _data["phoneNumber"];
            this.freeFormAnswer = _data["freeFormAnswer"];
        }
    }

    static fromJS(data: any): VenuePermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VenuePermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["phoneNumber"] = this.phoneNumber;
        data["freeFormAnswer"] = this.freeFormAnswer;
        return data;
    }
}

export interface IVenuePermissionsRequest {
    company: string | undefined;
    phoneNumber: string | undefined;
    freeFormAnswer: string | undefined;
}

export class VenueModel implements IVenueModel {
    id!: string;
    latitude!: number | undefined;
    longitude!: number | undefined;
    name!: string;
    address!: string;
    simpleAddress1!: string;
    simpleAddress2!: string | undefined;
    city!: string;
    state!: string | undefined;
    zip!: string;
    country!: string;
    timeZone!: ZoneInfo | undefined;
    description!: string;
    imageUrls!: string[];
    url!: string;
    workspaceIds!: string[];
    venueMapImageUrl!: string;
    defaultBookingMethod!: BookingMethod;
    defaultBookingMethodHourly!: BookingMethod;
    currency!: CurrencyType;
    averageRating!: number;
    ratingCount!: number;
    healthAndSafetyPolicy!: string | undefined;
    hasLiquidspacePro!: boolean;

    constructor(data?: IVenueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.simpleAddress1 = _data["simpleAddress1"];
            this.simpleAddress2 = _data["simpleAddress2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.country = _data["country"];
            this.timeZone = _data["timeZone"] ? ZoneInfo.fromJS(_data["timeZone"]) : <any>undefined;
            this.description = _data["description"];
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls!.push(item);
            }
            this.url = _data["url"];
            if (Array.isArray(_data["workspaceIds"])) {
                this.workspaceIds = [] as any;
                for (let item of _data["workspaceIds"])
                    this.workspaceIds!.push(item);
            }
            this.venueMapImageUrl = _data["venueMapImageUrl"];
            this.defaultBookingMethod = _data["defaultBookingMethod"];
            this.defaultBookingMethodHourly = _data["defaultBookingMethodHourly"];
            this.currency = _data["currency"];
            this.averageRating = _data["averageRating"];
            this.ratingCount = _data["ratingCount"];
            this.healthAndSafetyPolicy = _data["healthAndSafetyPolicy"];
            this.hasLiquidspacePro = _data["hasLiquidspacePro"];
        }
    }

    static fromJS(data: any): VenueModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["name"] = this.name;
        data["address"] = this.address;
        data["simpleAddress1"] = this.simpleAddress1;
        data["simpleAddress2"] = this.simpleAddress2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["country"] = this.country;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
        data["description"] = this.description;
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        data["url"] = this.url;
        if (Array.isArray(this.workspaceIds)) {
            data["workspaceIds"] = [];
            for (let item of this.workspaceIds)
                data["workspaceIds"].push(item);
        }
        data["venueMapImageUrl"] = this.venueMapImageUrl;
        data["defaultBookingMethod"] = this.defaultBookingMethod;
        data["defaultBookingMethodHourly"] = this.defaultBookingMethodHourly;
        data["currency"] = this.currency;
        data["averageRating"] = this.averageRating;
        data["ratingCount"] = this.ratingCount;
        data["healthAndSafetyPolicy"] = this.healthAndSafetyPolicy;
        data["hasLiquidspacePro"] = this.hasLiquidspacePro;
        return data;
    }
}

export interface IVenueModel {
    id: string;
    latitude: number | undefined;
    longitude: number | undefined;
    name: string;
    address: string;
    simpleAddress1: string;
    simpleAddress2: string | undefined;
    city: string;
    state: string | undefined;
    zip: string;
    country: string;
    timeZone: ZoneInfo | undefined;
    description: string;
    imageUrls: string[];
    url: string;
    workspaceIds: string[];
    venueMapImageUrl: string;
    defaultBookingMethod: BookingMethod;
    defaultBookingMethodHourly: BookingMethod;
    currency: CurrencyType;
    averageRating: number;
    ratingCount: number;
    healthAndSafetyPolicy: string | undefined;
    hasLiquidspacePro: boolean;
}

export class ZoneInfo implements IZoneInfo {
    /** The Windows system time zone identifier for this mapping, such as "Central Standard Time". */
    windowsId!: string;
    /** The territory code. */
    territory!: string;
    /** A read-only non-empty collection of TZDB zone identifiers for this mapping,
such as "America/Chicago" and "America/Matamoros" (both of which are TZDB zones
associated with the "Central Standard Time" Windows system time zone). */
    tzdbIds!: string[];

    constructor(data?: IZoneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.windowsId = _data["windowsId"];
            this.territory = _data["territory"];
            if (Array.isArray(_data["tzdbIds"])) {
                this.tzdbIds = [] as any;
                for (let item of _data["tzdbIds"])
                    this.tzdbIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ZoneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["windowsId"] = this.windowsId;
        data["territory"] = this.territory;
        if (Array.isArray(this.tzdbIds)) {
            data["tzdbIds"] = [];
            for (let item of this.tzdbIds)
                data["tzdbIds"].push(item);
        }
        return data;
    }
}

export interface IZoneInfo {
    /** The Windows system time zone identifier for this mapping, such as "Central Standard Time". */
    windowsId: string;
    /** The territory code. */
    territory: string;
    /** A read-only non-empty collection of TZDB zone identifiers for this mapping,
such as "America/Chicago" and "America/Matamoros" (both of which are TZDB zones
associated with the "Central Standard Time" Windows system time zone). */
    tzdbIds: string[];
}

export class VenueAutocompleteItem implements IVenueAutocompleteItem {
    id!: string;
    name!: string;
    address!: string;

    constructor(data?: IVenueAutocompleteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): VenueAutocompleteItem {
        data = typeof data === 'object' ? data : {};
        let result = new VenueAutocompleteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        return data;
    }
}

export interface IVenueAutocompleteItem {
    id: string;
    name: string;
    address: string;
}

export class VenueHeadquarterDataViewModel implements IVenueHeadquarterDataViewModel {
    enterpriseAccountName!: string;
    hqPinColor!: string;
    hqPinColorHover!: string;
    hqPinLabel!: string;
    hqPinImage!: string | undefined;
    customCTA!: VenueCustomCTAViewModel | undefined;

    constructor(data?: IVenueHeadquarterDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.enterpriseAccountName = _data["enterpriseAccountName"];
            this.hqPinColor = _data["hqPinColor"];
            this.hqPinColorHover = _data["hqPinColorHover"];
            this.hqPinLabel = _data["hqPinLabel"];
            this.hqPinImage = _data["hqPinImage"];
            this.customCTA = _data["customCTA"] ? VenueCustomCTAViewModel.fromJS(_data["customCTA"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VenueHeadquarterDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueHeadquarterDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseAccountName"] = this.enterpriseAccountName;
        data["hqPinColor"] = this.hqPinColor;
        data["hqPinColorHover"] = this.hqPinColorHover;
        data["hqPinLabel"] = this.hqPinLabel;
        data["hqPinImage"] = this.hqPinImage;
        data["customCTA"] = this.customCTA ? this.customCTA.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVenueHeadquarterDataViewModel {
    enterpriseAccountName: string;
    hqPinColor: string;
    hqPinColorHover: string;
    hqPinLabel: string;
    hqPinImage: string | undefined;
    customCTA: VenueCustomCTAViewModel | undefined;
}

export class VenueCustomCTAViewModel implements IVenueCustomCTAViewModel {
    text!: string | undefined;
    url!: string;

    constructor(data?: IVenueCustomCTAViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): VenueCustomCTAViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueCustomCTAViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["url"] = this.url;
        return data;
    }
}

export interface IVenueCustomCTAViewModel {
    text: string | undefined;
    url: string;
}

export class VenueWorkspaceModel implements IVenueWorkspaceModel {
    id!: string;
    name!: string;
    description!: string | undefined;
    url!: string;
    spaceType!: SpaceType;
    spaceTypeFormatted!: string;
    /** Indicates if multiple desks can be booked with 1 reservation */
    multipleDeskBookingAllowed!: boolean;
    capacity!: number;
    reservationMethod!: ReservationMethod;
    bookingMethod!: BookingMethod;
    pricesFormatted!: string;
    imageUrls!: string[];
    cancellationPolicy!: CancellationPolicy;
    /** Minimum number of months that can be booked in mothly space */
    minimumBookingTerm!: number | undefined;
    /** Minimum booking duration (minutes) in hourly spaces */
    minimumBookingDurationMinutes!: number | undefined;
    status!: WorkspaceStatus;
    averageRating!: number | undefined;
    prices!: PriceDisplayModel[];
    hasRegusIntegration!: boolean;
    reservationTimeIncrement!: TimeChunkSize;

    constructor(data?: IVenueWorkspaceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.spaceType = _data["spaceType"];
            this.spaceTypeFormatted = _data["spaceTypeFormatted"];
            this.multipleDeskBookingAllowed = _data["multipleDeskBookingAllowed"];
            this.capacity = _data["capacity"];
            this.reservationMethod = _data["reservationMethod"];
            this.bookingMethod = _data["bookingMethod"];
            this.pricesFormatted = _data["pricesFormatted"];
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls!.push(item);
            }
            this.cancellationPolicy = _data["cancellationPolicy"];
            this.minimumBookingTerm = _data["minimumBookingTerm"];
            this.minimumBookingDurationMinutes = _data["minimumBookingDurationMinutes"];
            this.status = _data["status"];
            this.averageRating = _data["averageRating"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(PriceDisplayModel.fromJS(item));
            }
            this.hasRegusIntegration = _data["hasRegusIntegration"];
            this.reservationTimeIncrement = _data["reservationTimeIncrement"];
        }
    }

    static fromJS(data: any): VenueWorkspaceModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueWorkspaceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["spaceType"] = this.spaceType;
        data["spaceTypeFormatted"] = this.spaceTypeFormatted;
        data["multipleDeskBookingAllowed"] = this.multipleDeskBookingAllowed;
        data["capacity"] = this.capacity;
        data["reservationMethod"] = this.reservationMethod;
        data["bookingMethod"] = this.bookingMethod;
        data["pricesFormatted"] = this.pricesFormatted;
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        data["cancellationPolicy"] = this.cancellationPolicy;
        data["minimumBookingTerm"] = this.minimumBookingTerm;
        data["minimumBookingDurationMinutes"] = this.minimumBookingDurationMinutes;
        data["status"] = this.status;
        data["averageRating"] = this.averageRating;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        data["hasRegusIntegration"] = this.hasRegusIntegration;
        data["reservationTimeIncrement"] = this.reservationTimeIncrement;
        return data;
    }
}

export interface IVenueWorkspaceModel {
    id: string;
    name: string;
    description: string | undefined;
    url: string;
    spaceType: SpaceType;
    spaceTypeFormatted: string;
    /** Indicates if multiple desks can be booked with 1 reservation */
    multipleDeskBookingAllowed: boolean;
    capacity: number;
    reservationMethod: ReservationMethod;
    bookingMethod: BookingMethod;
    pricesFormatted: string;
    imageUrls: string[];
    cancellationPolicy: CancellationPolicy;
    /** Minimum number of months that can be booked in mothly space */
    minimumBookingTerm: number | undefined;
    /** Minimum booking duration (minutes) in hourly spaces */
    minimumBookingDurationMinutes: number | undefined;
    status: WorkspaceStatus;
    averageRating: number | undefined;
    prices: PriceDisplayModel[];
    hasRegusIntegration: boolean;
    reservationTimeIncrement: TimeChunkSize;
}

export class PriceDisplayModel implements IPriceDisplayModel {
    priceDuration!: WorkspacePriceDuration | undefined;
    price!: string | undefined;
    priceAmountDecimal!: number;
    priceAmount!: string | undefined;
    priceDescription!: string | undefined;
    priceAdditionalDescription!: string | undefined;
    delimiter!: string | undefined;
    priceMerchandising!: PriceMerchandising;
    amountBeforeDiscount!: number | undefined;
    amountBeforeDiscountFormatted!: string | undefined;
    discountDescription!: string | undefined;
    discountCode!: string | undefined;

    constructor(data?: IPriceDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.priceDuration = _data["priceDuration"];
            this.price = _data["price"];
            this.priceAmountDecimal = _data["priceAmountDecimal"];
            this.priceAmount = _data["priceAmount"];
            this.priceDescription = _data["priceDescription"];
            this.priceAdditionalDescription = _data["priceAdditionalDescription"];
            this.delimiter = _data["delimiter"];
            this.priceMerchandising = _data["priceMerchandising"];
            this.amountBeforeDiscount = _data["amountBeforeDiscount"];
            this.amountBeforeDiscountFormatted = _data["amountBeforeDiscountFormatted"];
            this.discountDescription = _data["discountDescription"];
            this.discountCode = _data["discountCode"];
        }
    }

    static fromJS(data: any): PriceDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceDuration"] = this.priceDuration;
        data["price"] = this.price;
        data["priceAmountDecimal"] = this.priceAmountDecimal;
        data["priceAmount"] = this.priceAmount;
        data["priceDescription"] = this.priceDescription;
        data["priceAdditionalDescription"] = this.priceAdditionalDescription;
        data["delimiter"] = this.delimiter;
        data["priceMerchandising"] = this.priceMerchandising;
        data["amountBeforeDiscount"] = this.amountBeforeDiscount;
        data["amountBeforeDiscountFormatted"] = this.amountBeforeDiscountFormatted;
        data["discountDescription"] = this.discountDescription;
        data["discountCode"] = this.discountCode;
        return data;
    }
}

export interface IPriceDisplayModel {
    priceDuration: WorkspacePriceDuration | undefined;
    price: string | undefined;
    priceAmountDecimal: number;
    priceAmount: string | undefined;
    priceDescription: string | undefined;
    priceAdditionalDescription: string | undefined;
    delimiter: string | undefined;
    priceMerchandising: PriceMerchandising;
    amountBeforeDiscount: number | undefined;
    amountBeforeDiscountFormatted: string | undefined;
    discountDescription: string | undefined;
    discountCode: string | undefined;
}

/** 15 = QuarterHour 30 = HalfHour 60 = Hour 120 = TwoHours 180 = ThreeHours 240 = HalfDay 480 = Day 43200 = Month 129600 = ThreeMonth 259200 = SixMonth 518400 = Year 1036800 = TwoYear 1555200 = ThreeYear */
export enum WorkspacePriceDuration {
    QuarterHour = 15,
    HalfHour = 30,
    Hour = 60,
    TwoHours = 120,
    ThreeHours = 180,
    HalfDay = 240,
    Day = 480,
    Month = 43200,
    ThreeMonth = 129600,
    SixMonth = 259200,
    Year = 518400,
    TwoYear = 1036800,
    ThreeYear = 1555200,
}

/** 15 = Min15 30 = Min30 60 = Min60 */
export enum TimeChunkSize {
    Min15 = 15,
    Min30 = 30,
    Min60 = 60,
}

export class ReservationCalendarWorkspaceModel implements IReservationCalendarWorkspaceModel {
    workspace!: VenueWorkspaceModel;
    timeChunkStates!: ReservationCalendarTimeChunkStateModel[];

    constructor(data?: IReservationCalendarWorkspaceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.workspace = _data["workspace"] ? VenueWorkspaceModel.fromJS(_data["workspace"]) : <any>undefined;
            if (Array.isArray(_data["timeChunkStates"])) {
                this.timeChunkStates = [] as any;
                for (let item of _data["timeChunkStates"])
                    this.timeChunkStates!.push(ReservationCalendarTimeChunkStateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReservationCalendarWorkspaceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationCalendarWorkspaceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspace"] = this.workspace ? this.workspace.toJSON() : <any>undefined;
        if (Array.isArray(this.timeChunkStates)) {
            data["timeChunkStates"] = [];
            for (let item of this.timeChunkStates)
                data["timeChunkStates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReservationCalendarWorkspaceModel {
    workspace: VenueWorkspaceModel;
    timeChunkStates: ReservationCalendarTimeChunkStateModel[];
}

export class ReservationCalendarTimeChunkStateModel implements IReservationCalendarTimeChunkStateModel {
    time!: string;
    state!: TimeState;

    constructor(data?: IReservationCalendarTimeChunkStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ReservationCalendarTimeChunkStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationCalendarTimeChunkStateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        data["state"] = this.state;
        return data;
    }
}

export interface IReservationCalendarTimeChunkStateModel {
    time: string;
    state: TimeState;
}

/** 0 = Closed 1 = Booked 2 = Available 3 = Own */
export enum TimeState {
    Closed = 0,
    Booked = 1,
    Available = 2,
    Own = 3,
}

export class ClosedDayModel implements IClosedDayModel {
    date!: string;
    unavailabilityReason!: string | undefined;

    constructor(data?: IClosedDayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.unavailabilityReason = _data["unavailabilityReason"];
        }
    }

    static fromJS(data: any): ClosedDayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClosedDayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["unavailabilityReason"] = this.unavailabilityReason;
        return data;
    }
}

export interface IClosedDayModel {
    date: string;
    unavailabilityReason: string | undefined;
}

export class OpenHoursItem implements IOpenHoursItem {
    time!: string;

    constructor(data?: IOpenHoursItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"];
        }
    }

    static fromJS(data: any): OpenHoursItem {
        data = typeof data === 'object' ? data : {};
        let result = new OpenHoursItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        return data;
    }
}

export interface IOpenHoursItem {
    time: string;
}

export class CheckAvailabilityResponse implements ICheckAvailabilityResponse {
    /** Null if date wasn't provided. 
Boolean value indicates if workspace is available for the requested date */
    isAvailable!: boolean | undefined;
    /** Null if there's no available date in a year
First available date from the requested date (or from now if date wasn't provided) */
    nextAvailableDate!: string | undefined;
    /** Dates that are not available for given recurrence pattern. Empty when no pattern is provided */
    recurrenceExcludedDates!: string[];

    constructor(data?: ICheckAvailabilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
            this.nextAvailableDate = _data["nextAvailableDate"];
            if (Array.isArray(_data["recurrenceExcludedDates"])) {
                this.recurrenceExcludedDates = [] as any;
                for (let item of _data["recurrenceExcludedDates"])
                    this.recurrenceExcludedDates!.push(item);
            }
        }
    }

    static fromJS(data: any): CheckAvailabilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckAvailabilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        data["nextAvailableDate"] = this.nextAvailableDate;
        if (Array.isArray(this.recurrenceExcludedDates)) {
            data["recurrenceExcludedDates"] = [];
            for (let item of this.recurrenceExcludedDates)
                data["recurrenceExcludedDates"].push(item);
        }
        return data;
    }
}

export interface ICheckAvailabilityResponse {
    /** Null if date wasn't provided. 
Boolean value indicates if workspace is available for the requested date */
    isAvailable: boolean | undefined;
    /** Null if there's no available date in a year
First available date from the requested date (or from now if date wasn't provided) */
    nextAvailableDate: string | undefined;
    /** Dates that are not available for given recurrence pattern. Empty when no pattern is provided */
    recurrenceExcludedDates: string[];
}

export class CheckAvailabilityRequest implements ICheckAvailabilityRequest {
    reservationDetails!: ReservationDetails | undefined;
    reservationId!: string | undefined;
    occurrenceDate!: string | undefined;

    constructor(data?: ICheckAvailabilityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.reservationDetails = _data["reservationDetails"] ? ReservationDetails.fromJS(_data["reservationDetails"]) : <any>undefined;
            this.reservationId = _data["reservationId"];
            this.occurrenceDate = _data["occurrenceDate"];
        }
    }

    static fromJS(data: any): CheckAvailabilityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckAvailabilityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationDetails"] = this.reservationDetails ? this.reservationDetails.toJSON() : <any>undefined;
        data["reservationId"] = this.reservationId;
        data["occurrenceDate"] = this.occurrenceDate;
        return data;
    }
}

export interface ICheckAvailabilityRequest {
    reservationDetails: ReservationDetails | undefined;
    reservationId: string | undefined;
    occurrenceDate: string | undefined;
}

export class CheckRegusAvailabilityResponse implements ICheckRegusAvailabilityResponse {
    /**          Boolean value indicates if workspace is available for the requested date in Regus
          */
    isAvailable!: boolean;
    /** Null if workspace isn't available in Regus
Reference to the first (best matching?) available workspace in Regus */
    spaceReferenceToken!: string | undefined;

    constructor(data?: ICheckRegusAvailabilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
            this.spaceReferenceToken = _data["spaceReferenceToken"];
        }
    }

    static fromJS(data: any): CheckRegusAvailabilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckRegusAvailabilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        data["spaceReferenceToken"] = this.spaceReferenceToken;
        return data;
    }
}

export interface ICheckRegusAvailabilityResponse {
    /**          Boolean value indicates if workspace is available for the requested date in Regus
          */
    isAvailable: boolean;
    /** Null if workspace isn't available in Regus
Reference to the first (best matching?) available workspace in Regus */
    spaceReferenceToken: string | undefined;
}

export class UserInfoViewModel implements IUserInfoViewModel {
    isAuthenticated!: boolean;
    isSuperUser!: boolean;
    isSystemAdmin!: boolean;
    isVenueAdmin!: boolean;
    isCalendarAdmin!: boolean;
    isMemberGroupAdmin!: boolean;
    isOrganizationAdmin!: boolean;
    isSalesRep!: boolean;
    isAffiliate!: boolean;
    isEnterpriseAccountAdmin!: boolean;
    id!: string;
    fullName!: string | undefined;
    email!: string | undefined;
    encryptedEmail!: string | undefined;
    imageUrl!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    role!: string | undefined;
    manageVenueMode!: ManageVenueMode;
    isVenueAdminMode!: boolean;
    memberType!: string | undefined;
    hasCompletedPortalGuide!: boolean;
    ssoLoginType!: SsoType | undefined;

    constructor(data?: IUserInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.isAuthenticated = _data["isAuthenticated"];
            this.isSuperUser = _data["isSuperUser"];
            this.isSystemAdmin = _data["isSystemAdmin"];
            this.isVenueAdmin = _data["isVenueAdmin"];
            this.isCalendarAdmin = _data["isCalendarAdmin"];
            this.isMemberGroupAdmin = _data["isMemberGroupAdmin"];
            this.isOrganizationAdmin = _data["isOrganizationAdmin"];
            this.isSalesRep = _data["isSalesRep"];
            this.isAffiliate = _data["isAffiliate"];
            this.isEnterpriseAccountAdmin = _data["isEnterpriseAccountAdmin"];
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.encryptedEmail = _data["encryptedEmail"];
            this.imageUrl = _data["imageUrl"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.role = _data["role"];
            this.manageVenueMode = _data["manageVenueMode"];
            this.isVenueAdminMode = _data["isVenueAdminMode"];
            this.memberType = _data["memberType"];
            this.hasCompletedPortalGuide = _data["hasCompletedPortalGuide"];
            this.ssoLoginType = _data["ssoLoginType"];
        }
    }

    static fromJS(data: any): UserInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthenticated"] = this.isAuthenticated;
        data["isSuperUser"] = this.isSuperUser;
        data["isSystemAdmin"] = this.isSystemAdmin;
        data["isVenueAdmin"] = this.isVenueAdmin;
        data["isCalendarAdmin"] = this.isCalendarAdmin;
        data["isMemberGroupAdmin"] = this.isMemberGroupAdmin;
        data["isOrganizationAdmin"] = this.isOrganizationAdmin;
        data["isSalesRep"] = this.isSalesRep;
        data["isAffiliate"] = this.isAffiliate;
        data["isEnterpriseAccountAdmin"] = this.isEnterpriseAccountAdmin;
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["encryptedEmail"] = this.encryptedEmail;
        data["imageUrl"] = this.imageUrl;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["role"] = this.role;
        data["manageVenueMode"] = this.manageVenueMode;
        data["isVenueAdminMode"] = this.isVenueAdminMode;
        data["memberType"] = this.memberType;
        data["hasCompletedPortalGuide"] = this.hasCompletedPortalGuide;
        data["ssoLoginType"] = this.ssoLoginType;
        return data;
    }
}

export interface IUserInfoViewModel {
    isAuthenticated: boolean;
    isSuperUser: boolean;
    isSystemAdmin: boolean;
    isVenueAdmin: boolean;
    isCalendarAdmin: boolean;
    isMemberGroupAdmin: boolean;
    isOrganizationAdmin: boolean;
    isSalesRep: boolean;
    isAffiliate: boolean;
    isEnterpriseAccountAdmin: boolean;
    id: string;
    fullName: string | undefined;
    email: string | undefined;
    encryptedEmail: string | undefined;
    imageUrl: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    role: string | undefined;
    manageVenueMode: ManageVenueMode;
    isVenueAdminMode: boolean;
    memberType: string | undefined;
    hasCompletedPortalGuide: boolean;
    ssoLoginType: SsoType | undefined;
}

/** 0 = Admin 1 = Guest 2 = EnterpriseAccountAdmin */
export enum ManageVenueMode {
    Admin = 0,
    Guest = 1,
    EnterpriseAccountAdmin = 2,
}

export class UserInfoEnterpriseAccountResponse implements IUserInfoEnterpriseAccountResponse {
    userInfoEnterpriseAccountViewModel!: UserInfoEnterpriseAccountViewModel | undefined;

    constructor(data?: IUserInfoEnterpriseAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.userInfoEnterpriseAccountViewModel = _data["userInfoEnterpriseAccountViewModel"] ? UserInfoEnterpriseAccountViewModel.fromJS(_data["userInfoEnterpriseAccountViewModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserInfoEnterpriseAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoEnterpriseAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userInfoEnterpriseAccountViewModel"] = this.userInfoEnterpriseAccountViewModel ? this.userInfoEnterpriseAccountViewModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserInfoEnterpriseAccountResponse {
    userInfoEnterpriseAccountViewModel: UserInfoEnterpriseAccountViewModel | undefined;
}

export class UserInfoEnterpriseAccountViewModel implements IUserInfoEnterpriseAccountViewModel {
    /** Enterprise Account Id */
    id!: string;
    /** Enterprise account name */
    accountName!: string;
    /** Team Id */
    teamId!: string;
    /** Team Name */
    teamName!: string;

    constructor(data?: IUserInfoEnterpriseAccountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountName = _data["accountName"];
            this.teamId = _data["teamId"];
            this.teamName = _data["teamName"];
        }
    }

    static fromJS(data: any): UserInfoEnterpriseAccountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoEnterpriseAccountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        return data;
    }
}

export interface IUserInfoEnterpriseAccountViewModel {
    /** Enterprise Account Id */
    id: string;
    /** Enterprise account name */
    accountName: string;
    /** Team Id */
    teamId: string;
    /** Team Name */
    teamName: string;
}

export class HeaderMenuCountersViewModel implements IHeaderMenuCountersViewModel {
    moreVenuesTotalMessagesCount!: number;
    upcomingReservationsCount!: number;
    newMessagesCount!: number;
    newMessagesForVenues!: { [key: string]: number; };

    constructor(data?: IHeaderMenuCountersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.moreVenuesTotalMessagesCount = _data["moreVenuesTotalMessagesCount"];
            this.upcomingReservationsCount = _data["upcomingReservationsCount"];
            this.newMessagesCount = _data["newMessagesCount"];
            if (_data["newMessagesForVenues"]) {
                this.newMessagesForVenues = {} as any;
                for (let key in _data["newMessagesForVenues"]) {
                    if (_data["newMessagesForVenues"].hasOwnProperty(key))
                        (<any>this.newMessagesForVenues)![key] = _data["newMessagesForVenues"][key];
                }
            }
        }
    }

    static fromJS(data: any): HeaderMenuCountersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderMenuCountersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moreVenuesTotalMessagesCount"] = this.moreVenuesTotalMessagesCount;
        data["upcomingReservationsCount"] = this.upcomingReservationsCount;
        data["newMessagesCount"] = this.newMessagesCount;
        if (this.newMessagesForVenues) {
            data["newMessagesForVenues"] = {};
            for (let key in this.newMessagesForVenues) {
                if (this.newMessagesForVenues.hasOwnProperty(key))
                    (<any>data["newMessagesForVenues"])[key] = (<any>this.newMessagesForVenues)[key];
            }
        }
        return data;
    }
}

export interface IHeaderMenuCountersViewModel {
    moreVenuesTotalMessagesCount: number;
    upcomingReservationsCount: number;
    newMessagesCount: number;
    newMessagesForVenues: { [key: string]: number; };
}

export class MyVenueViewModel implements IMyVenueViewModel {
    venueId!: string;
    venueName!: string;

    constructor(data?: IMyVenueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
        }
    }

    static fromJS(data: any): MyVenueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MyVenueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        return data;
    }
}

export interface IMyVenueViewModel {
    venueId: string;
    venueName: string;
}

/** Represents saved search request */
export class SavedSearchRequest implements ISavedSearchRequest {
    request!: BaseSearchRequest;
    metadata!: SavedSearchRequestMetadata;

    constructor(data?: ISavedSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? BaseSearchRequest.fromJS(_data["request"]) : <any>undefined;
            this.metadata = _data["metadata"] ? SavedSearchRequestMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SavedSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents saved search request */
export interface ISavedSearchRequest {
    request: BaseSearchRequest;
    metadata: SavedSearchRequestMetadata;
}

export class SavedSearchRequestWithId extends SavedSearchRequest implements ISavedSearchRequestWithId {
    id!: string;

    constructor(data?: ISavedSearchRequestWithId) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SavedSearchRequestWithId {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSearchRequestWithId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface ISavedSearchRequestWithId extends ISavedSearchRequest {
    id: string;
}

export abstract class CommonSearchRequest implements ICommonSearchRequest {
    /** Search Type. */
    reservationMethod!: ReservationMethod;
    /** Reservation start time. */
    startTime!: string | undefined;
    /** Optional reservation length parameter. Must be a multiple of 15 minutes. */
    reservationLengthMinutes!: number | undefined;
    /** Space Type */
    spaceTypes!: SpaceType;
    /** Optional Min Price constraint. */
    minPrice!: number | undefined;
    /** Optional Max Price constraint. */
    maxPrice!: number | undefined;
    /** Optional minimum workspace capacity constraint. */
    minCapacity!: number | undefined;
    /** Optional requested amenities list. */
    amenityIds!: string[] | undefined;

    constructor(data?: ICommonSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.reservationMethod = _data["reservationMethod"];
            this.startTime = _data["startTime"];
            this.reservationLengthMinutes = _data["reservationLengthMinutes"];
            this.spaceTypes = _data["spaceTypes"];
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
            this.minCapacity = _data["minCapacity"];
            if (Array.isArray(_data["amenityIds"])) {
                this.amenityIds = [] as any;
                for (let item of _data["amenityIds"])
                    this.amenityIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CommonSearchRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CommonSearchRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationMethod"] = this.reservationMethod;
        data["startTime"] = this.startTime;
        data["reservationLengthMinutes"] = this.reservationLengthMinutes;
        data["spaceTypes"] = this.spaceTypes;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        data["minCapacity"] = this.minCapacity;
        if (Array.isArray(this.amenityIds)) {
            data["amenityIds"] = [];
            for (let item of this.amenityIds)
                data["amenityIds"].push(item);
        }
        return data;
    }
}

export interface ICommonSearchRequest {
    /** Search Type. */
    reservationMethod: ReservationMethod;
    /** Reservation start time. */
    startTime: string | undefined;
    /** Optional reservation length parameter. Must be a multiple of 15 minutes. */
    reservationLengthMinutes: number | undefined;
    /** Space Type */
    spaceTypes: SpaceType;
    /** Optional Min Price constraint. */
    minPrice: number | undefined;
    /** Optional Max Price constraint. */
    maxPrice: number | undefined;
    /** Optional minimum workspace capacity constraint. */
    minCapacity: number | undefined;
    /** Optional requested amenities list. */
    amenityIds: string[] | undefined;
}

/** Root type for JSON inheritance tree */
export abstract class BaseSearchRequest extends CommonSearchRequest implements IBaseSearchRequest {

    protected _discriminator: string;

    constructor(data?: IBaseSearchRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "BaseSearchRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): BaseSearchRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "GeoSearchRequest") {
            let result = new GeoSearchRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CurrentLocationSearchRequest") {
            let result = new CurrentLocationSearchRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FullTextSearchRequest") {
            let result = new FullTextSearchRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenueSearchRequest") {
            let result = new VenueSearchRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenueGroupSearchRequest") {
            let result = new VenueGroupSearchRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LocationSearchRequest") {
            let result = new LocationSearchRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSearchRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        super.toJSON(data);
        return data;
    }
}

/** Root type for JSON inheritance tree */
export interface IBaseSearchRequest extends ICommonSearchRequest {
}

/** Search query by geocoded address */
export class GeoSearchRequest extends BaseSearchRequest implements IGeoSearchRequest {
    /** Address string to geocode */
    address!: string;

    constructor(data?: IGeoSearchRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "GeoSearchRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): GeoSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GeoSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        super.toJSON(data);
        return data;
    }
}

/** Search query by geocoded address */
export interface IGeoSearchRequest extends IBaseSearchRequest {
    /** Address string to geocode */
    address: string;
}

/** Server-side will use client IP-address to make location query. */
export class CurrentLocationSearchRequest extends BaseSearchRequest implements ICurrentLocationSearchRequest {

    constructor(data?: ICurrentLocationSearchRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "CurrentLocationSearchRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CurrentLocationSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentLocationSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Server-side will use client IP-address to make location query. */
export interface ICurrentLocationSearchRequest extends IBaseSearchRequest {
}

/** Full-text search query */
export class FullTextSearchRequest extends BaseSearchRequest implements IFullTextSearchRequest {
    fullTextQuery!: string;

    constructor(data?: IFullTextSearchRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "FullTextSearchRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullTextQuery = _data["fullTextQuery"];
        }
    }

    static fromJS(data: any): FullTextSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FullTextSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullTextQuery"] = this.fullTextQuery;
        super.toJSON(data);
        return data;
    }
}

/** Full-text search query */
export interface IFullTextSearchRequest extends IBaseSearchRequest {
    fullTextQuery: string;
}

/** Request to query specific venue availability */
export class VenueSearchRequest extends BaseSearchRequest implements IVenueSearchRequest {
    /** Venue ID to search within. */
    venueId!: string;

    constructor(data?: IVenueSearchRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "VenueSearchRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.venueId = _data["venueId"];
        }
    }

    static fromJS(data: any): VenueSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VenueSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        super.toJSON(data);
        return data;
    }
}

/** Request to query specific venue availability */
export interface IVenueSearchRequest extends IBaseSearchRequest {
    /** Venue ID to search within. */
    venueId: string;
}

/** Request to query venues from spcifig Venue Group */
export class VenueGroupSearchRequest extends BaseSearchRequest implements IVenueGroupSearchRequest {
    /** Venue Group ID to search within. */
    venueGroupId!: string;

    constructor(data?: IVenueGroupSearchRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "VenueGroupSearchRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.venueGroupId = _data["venueGroupId"];
        }
    }

    static fromJS(data: any): VenueGroupSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueGroupId"] = this.venueGroupId;
        super.toJSON(data);
        return data;
    }
}

/** Request to query venues from spcifig Venue Group */
export interface IVenueGroupSearchRequest extends IBaseSearchRequest {
    /** Venue Group ID to search within. */
    venueGroupId: string;
}

/** Search by latitude and longitude with optional radius */
export class LocationSearchRequest extends BaseSearchRequest implements ILocationSearchRequest {
    latitude!: number;
    longitude!: number;
    /** Search radius. Defaults to 20 miles (41667 meters) */
    radius!: number | undefined;

    constructor(data?: ILocationSearchRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "LocationSearchRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.radius = _data["radius"];
        }
    }

    static fromJS(data: any): LocationSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LocationSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["radius"] = this.radius;
        super.toJSON(data);
        return data;
    }
}

/** Search by latitude and longitude with optional radius */
export interface ILocationSearchRequest extends IBaseSearchRequest {
    latitude: number;
    longitude: number;
    /** Search radius. Defaults to 20 miles (41667 meters) */
    radius: number | undefined;
}

export class SavedSearchRequestMetadata implements ISavedSearchRequestMetadata {
    prdefinedText!: string | undefined;
    sourceType!: SavedSearchSourceType;

    constructor(data?: ISavedSearchRequestMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.prdefinedText = _data["prdefinedText"];
            this.sourceType = _data["sourceType"];
        }
    }

    static fromJS(data: any): SavedSearchRequestMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSearchRequestMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prdefinedText"] = this.prdefinedText;
        data["sourceType"] = this.sourceType;
        return data;
    }
}

export interface ISavedSearchRequestMetadata {
    prdefinedText: string | undefined;
    sourceType: SavedSearchSourceType;
}

export abstract class BaseSearchAutocomplete implements IBaseSearchAutocomplete {

    protected _discriminator: string;

    constructor(data?: IBaseSearchAutocomplete) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "BaseSearchAutocomplete";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseSearchAutocomplete {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "GeoSearchAutocomplete") {
            let result = new GeoSearchAutocomplete();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenueSearchAutocomplete") {
            let result = new VenueSearchAutocomplete();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CollectionSearchAutocomplete") {
            let result = new CollectionSearchAutocomplete();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SavedSearchRequestAutocomplete") {
            let result = new SavedSearchRequestAutocomplete();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenueGroupSearchAutocomplete") {
            let result = new VenueGroupSearchAutocomplete();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSearchAutocomplete' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        return data;
    }
}

export interface IBaseSearchAutocomplete {
}

export class GeoSearchAutocomplete extends BaseSearchAutocomplete implements IGeoSearchAutocomplete {
    /** Location string */
    geoQuery!: string;

    constructor(data?: IGeoSearchAutocomplete) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "GeoSearchAutocomplete";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.geoQuery = _data["geoQuery"];
        }
    }

    static fromJS(data: any): GeoSearchAutocomplete {
        data = typeof data === 'object' ? data : {};
        let result = new GeoSearchAutocomplete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geoQuery"] = this.geoQuery;
        super.toJSON(data);
        return data;
    }
}

export interface IGeoSearchAutocomplete extends IBaseSearchAutocomplete {
    /** Location string */
    geoQuery: string;
}

export class VenueSearchAutocomplete extends BaseSearchAutocomplete implements IVenueSearchAutocomplete {
    /** Venue Name */
    venueName!: string;
    /** Venue ID */
    venueId!: string;
    /** Is venue from preferred list */
    isPreferred!: boolean;

    constructor(data?: IVenueSearchAutocomplete) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "VenueSearchAutocomplete";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.venueName = _data["venueName"];
            this.venueId = _data["venueId"];
            this.isPreferred = _data["isPreferred"];
        }
    }

    static fromJS(data: any): VenueSearchAutocomplete {
        data = typeof data === 'object' ? data : {};
        let result = new VenueSearchAutocomplete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueName"] = this.venueName;
        data["venueId"] = this.venueId;
        data["isPreferred"] = this.isPreferred;
        super.toJSON(data);
        return data;
    }
}

export interface IVenueSearchAutocomplete extends IBaseSearchAutocomplete {
    /** Venue Name */
    venueName: string;
    /** Venue ID */
    venueId: string;
    /** Is venue from preferred list */
    isPreferred: boolean;
}

export class CollectionSearchAutocomplete extends BaseSearchAutocomplete implements ICollectionSearchAutocomplete {
    /** Collection Name */
    collectionName!: string;
    /** Collection ID */
    collectionId!: string;
    /** Number of items in collection */
    favoritesCount!: number;

    constructor(data?: ICollectionSearchAutocomplete) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "CollectionSearchAutocomplete";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.collectionName = _data["collectionName"];
            this.collectionId = _data["collectionId"];
            this.favoritesCount = _data["favoritesCount"];
        }
    }

    static fromJS(data: any): CollectionSearchAutocomplete {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionSearchAutocomplete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionName"] = this.collectionName;
        data["collectionId"] = this.collectionId;
        data["favoritesCount"] = this.favoritesCount;
        super.toJSON(data);
        return data;
    }
}

export interface ICollectionSearchAutocomplete extends IBaseSearchAutocomplete {
    /** Collection Name */
    collectionName: string;
    /** Collection ID */
    collectionId: string;
    /** Number of items in collection */
    favoritesCount: number;
}

export class SavedSearchRequestAutocomplete extends BaseSearchAutocomplete implements ISavedSearchRequestAutocomplete {
    predefinedText!: string | undefined;
    /** SavedSearch ID */
    savedSearchId!: string;

    constructor(data?: ISavedSearchRequestAutocomplete) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "SavedSearchRequestAutocomplete";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.predefinedText = _data["predefinedText"];
            this.savedSearchId = _data["savedSearchId"];
        }
    }

    static fromJS(data: any): SavedSearchRequestAutocomplete {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSearchRequestAutocomplete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predefinedText"] = this.predefinedText;
        data["savedSearchId"] = this.savedSearchId;
        super.toJSON(data);
        return data;
    }
}

export interface ISavedSearchRequestAutocomplete extends IBaseSearchAutocomplete {
    predefinedText: string | undefined;
    /** SavedSearch ID */
    savedSearchId: string;
}

export class VenueGroupSearchAutocomplete extends BaseSearchAutocomplete implements IVenueGroupSearchAutocomplete {
    /** Venue Group Name */
    venueGroupName!: string;
    /** Venue Group ID */
    venueGroupId!: string;
    /** Is Venue Group from preferred list */
    isPreferred!: boolean;
    /** Venue Group icon URL */
    iconUrl!: string | undefined;
    /** Number of venues in group */
    venuesCount!: number;

    constructor(data?: IVenueGroupSearchAutocomplete) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "VenueGroupSearchAutocomplete";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.venueGroupName = _data["venueGroupName"];
            this.venueGroupId = _data["venueGroupId"];
            this.isPreferred = _data["isPreferred"];
            this.iconUrl = _data["iconUrl"];
            this.venuesCount = _data["venuesCount"];
        }
    }

    static fromJS(data: any): VenueGroupSearchAutocomplete {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupSearchAutocomplete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueGroupName"] = this.venueGroupName;
        data["venueGroupId"] = this.venueGroupId;
        data["isPreferred"] = this.isPreferred;
        data["iconUrl"] = this.iconUrl;
        data["venuesCount"] = this.venuesCount;
        super.toJSON(data);
        return data;
    }
}

export interface IVenueGroupSearchAutocomplete extends IBaseSearchAutocomplete {
    /** Venue Group Name */
    venueGroupName: string;
    /** Venue Group ID */
    venueGroupId: string;
    /** Is Venue Group from preferred list */
    isPreferred: boolean;
    /** Venue Group icon URL */
    iconUrl: string | undefined;
    /** Number of venues in group */
    venuesCount: number;
}

export class SearchQueryAutocomplete implements ISearchQueryAutocomplete {
    /** Search location string */
    location!: string | undefined;
    /** optional workspace Type constraint */
    spaceType!: SpaceType | undefined;
    /** Optional minimum workspace capacity constraint */
    minCapacity!: number | undefined;
    /** Optional reservation start date */
    startDate!: string | undefined;

    constructor(data?: ISearchQueryAutocomplete) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.spaceType = _data["spaceType"];
            this.minCapacity = _data["minCapacity"];
            this.startDate = _data["startDate"];
        }
    }

    static fromJS(data: any): SearchQueryAutocomplete {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryAutocomplete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["spaceType"] = this.spaceType;
        data["minCapacity"] = this.minCapacity;
        data["startDate"] = this.startDate;
        return data;
    }
}

export interface ISearchQueryAutocomplete {
    /** Search location string */
    location: string | undefined;
    /** optional workspace Type constraint */
    spaceType: SpaceType | undefined;
    /** Optional minimum workspace capacity constraint */
    minCapacity: number | undefined;
    /** Optional reservation start date */
    startDate: string | undefined;
}

export class VenuesSearchResult implements IVenuesSearchResult {
    geoLocation!: VenuesSearchResultGeoLocation | undefined;
    venues!: VenueSearchResult[];

    constructor(data?: IVenuesSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.geoLocation = _data["geoLocation"] ? VenuesSearchResultGeoLocation.fromJS(_data["geoLocation"]) : <any>undefined;
            if (Array.isArray(_data["venues"])) {
                this.venues = [] as any;
                for (let item of _data["venues"])
                    this.venues!.push(VenueSearchResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VenuesSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new VenuesSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geoLocation"] = this.geoLocation ? this.geoLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.venues)) {
            data["venues"] = [];
            for (let item of this.venues)
                data["venues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVenuesSearchResult {
    geoLocation: VenuesSearchResultGeoLocation | undefined;
    venues: VenueSearchResult[];
}

export class VenuesSearchResultGeoLocation implements IVenuesSearchResultGeoLocation {
    latitude!: number;
    longitude!: number;

    constructor(data?: IVenuesSearchResultGeoLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): VenuesSearchResultGeoLocation {
        data = typeof data === 'object' ? data : {};
        let result = new VenuesSearchResultGeoLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IVenuesSearchResultGeoLocation {
    latitude: number;
    longitude: number;
}

/** Geo or Current Location search request */
export class DefaultSearchRequest extends CommonSearchRequest implements IDefaultSearchRequest {
    /** Address string to geocode */
    address!: string | undefined;

    constructor(data?: IDefaultSearchRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): DefaultSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        super.toJSON(data);
        return data;
    }
}

/** Geo or Current Location search request */
export interface IDefaultSearchRequest extends ICommonSearchRequest {
    /** Address string to geocode */
    address: string | undefined;
}

/** Provides necessary metadata to properly display search UI for current user */
export class SearchConfig implements ISearchConfig {
    /** Immutable search options (usually configured by account admin) */
    immutableOptions!: ExtendedSearchOptionsConfigModel | undefined;
    /** Search geofences */
    geofences!: SearchGeofence[];
    /** LIst of approved member groups */
    approvedMemberGroups!: ApprovedMemberGroup[];
    /** Searchable amenities */
    amenities!: AmenityModel[];

    constructor(data?: ISearchConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.immutableOptions = _data["immutableOptions"] ? ExtendedSearchOptionsConfigModel.fromJS(_data["immutableOptions"]) : <any>undefined;
            if (Array.isArray(_data["geofences"])) {
                this.geofences = [] as any;
                for (let item of _data["geofences"])
                    this.geofences!.push(SearchGeofence.fromJS(item));
            }
            if (Array.isArray(_data["approvedMemberGroups"])) {
                this.approvedMemberGroups = [] as any;
                for (let item of _data["approvedMemberGroups"])
                    this.approvedMemberGroups!.push(ApprovedMemberGroup.fromJS(item));
            }
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities!.push(AmenityModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchConfig {
        data = typeof data === 'object' ? data : {};
        let result = new SearchConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immutableOptions"] = this.immutableOptions ? this.immutableOptions.toJSON() : <any>undefined;
        if (Array.isArray(this.geofences)) {
            data["geofences"] = [];
            for (let item of this.geofences)
                data["geofences"].push(item.toJSON());
        }
        if (Array.isArray(this.approvedMemberGroups)) {
            data["approvedMemberGroups"] = [];
            for (let item of this.approvedMemberGroups)
                data["approvedMemberGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item.toJSON());
        }
        return data;
    }
}

/** Provides necessary metadata to properly display search UI for current user */
export interface ISearchConfig {
    /** Immutable search options (usually configured by account admin) */
    immutableOptions: ExtendedSearchOptionsConfigModel | undefined;
    /** Search geofences */
    geofences: SearchGeofence[];
    /** LIst of approved member groups */
    approvedMemberGroups: ApprovedMemberGroup[];
    /** Searchable amenities */
    amenities: AmenityModel[];
}

export class ExtendedSearchOptionsConfigModel implements IExtendedSearchOptionsConfigModel {
    reservationMethod!: WorkspaceReservationMethod | undefined;
    spaceTypes!: SpaceType;
    minPrice!: number | undefined;
    maxPrice!: number | undefined;
    liquidSpacePro!: boolean;
    immutableOptions!: ForceableExtendedSearchOptionsProperties[];

    constructor(data?: IExtendedSearchOptionsConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.reservationMethod = _data["reservationMethod"];
            this.spaceTypes = _data["spaceTypes"];
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
            this.liquidSpacePro = _data["liquidSpacePro"];
            if (Array.isArray(_data["immutableOptions"])) {
                this.immutableOptions = [] as any;
                for (let item of _data["immutableOptions"])
                    this.immutableOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): ExtendedSearchOptionsConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedSearchOptionsConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationMethod"] = this.reservationMethod;
        data["spaceTypes"] = this.spaceTypes;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        data["liquidSpacePro"] = this.liquidSpacePro;
        if (Array.isArray(this.immutableOptions)) {
            data["immutableOptions"] = [];
            for (let item of this.immutableOptions)
                data["immutableOptions"].push(item);
        }
        return data;
    }
}

export interface IExtendedSearchOptionsConfigModel {
    reservationMethod: WorkspaceReservationMethod | undefined;
    spaceTypes: SpaceType;
    minPrice: number | undefined;
    maxPrice: number | undefined;
    liquidSpacePro: boolean;
    immutableOptions: ForceableExtendedSearchOptionsProperties[];
}

export class SearchGeofence implements ISearchGeofence {
    latitude!: number;
    longitude!: number;
    radiusMeters!: number;
    message!: string;
    venueName!: string;
    venueAddress!: string;
    venueUrl!: string;
    imageUrl!: string;
    venueId!: string;
    customCTA!: SearchGeofenceCustomCTA | undefined;

    constructor(data?: ISearchGeofence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.radiusMeters = _data["radiusMeters"];
            this.message = _data["message"];
            this.venueName = _data["venueName"];
            this.venueAddress = _data["venueAddress"];
            this.venueUrl = _data["venueUrl"];
            this.imageUrl = _data["imageUrl"];
            this.venueId = _data["venueId"];
            this.customCTA = _data["customCTA"] ? SearchGeofenceCustomCTA.fromJS(_data["customCTA"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchGeofence {
        data = typeof data === 'object' ? data : {};
        let result = new SearchGeofence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["radiusMeters"] = this.radiusMeters;
        data["message"] = this.message;
        data["venueName"] = this.venueName;
        data["venueAddress"] = this.venueAddress;
        data["venueUrl"] = this.venueUrl;
        data["imageUrl"] = this.imageUrl;
        data["venueId"] = this.venueId;
        data["customCTA"] = this.customCTA ? this.customCTA.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISearchGeofence {
    latitude: number;
    longitude: number;
    radiusMeters: number;
    message: string;
    venueName: string;
    venueAddress: string;
    venueUrl: string;
    imageUrl: string;
    venueId: string;
    customCTA: SearchGeofenceCustomCTA | undefined;
}

export class SearchGeofenceCustomCTA implements ISearchGeofenceCustomCTA {
    text!: string;
    url!: string;

    constructor(data?: ISearchGeofenceCustomCTA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SearchGeofenceCustomCTA {
        data = typeof data === 'object' ? data : {};
        let result = new SearchGeofenceCustomCTA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["url"] = this.url;
        return data;
    }
}

export interface ISearchGeofenceCustomCTA {
    text: string;
    url: string;
}

export class ApprovedMemberGroup implements IApprovedMemberGroup {
    name!: string | undefined;
    isImmutable!: boolean;
    displayPreferred!: boolean;
    id!: string;

    constructor(data?: IApprovedMemberGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isImmutable = _data["isImmutable"];
            this.displayPreferred = _data["displayPreferred"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApprovedMemberGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovedMemberGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isImmutable"] = this.isImmutable;
        data["displayPreferred"] = this.displayPreferred;
        data["id"] = this.id;
        return data;
    }
}

export interface IApprovedMemberGroup {
    name: string | undefined;
    isImmutable: boolean;
    displayPreferred: boolean;
    id: string;
}

export class AmenityModel implements IAmenityModel {
    id!: string;
    name!: string | undefined;
    hourlyMonthly!: HourlyMonthly;

    constructor(data?: IAmenityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.hourlyMonthly = _data["hourlyMonthly"];
        }
    }

    static fromJS(data: any): AmenityModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmenityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["hourlyMonthly"] = this.hourlyMonthly;
        return data;
    }
}

export interface IAmenityModel {
    id: string;
    name: string | undefined;
    hourlyMonthly: HourlyMonthly;
}

export class RegusBookingService implements IRegusBookingService {
    serviceId!: number;
    name!: string;
    isSelected!: boolean;
    price!: number;

    constructor(data?: IRegusBookingService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.name = _data["name"];
            this.isSelected = _data["isSelected"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): RegusBookingService {
        data = typeof data === 'object' ? data : {};
        let result = new RegusBookingService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["name"] = this.name;
        data["isSelected"] = this.isSelected;
        data["price"] = this.price;
        return data;
    }
}

export interface IRegusBookingService {
    serviceId: number;
    name: string;
    isSelected: boolean;
    price: number;
}

export class RegusBookingServicesRequest implements IRegusBookingServicesRequest {
    serviceIds!: number[];

    constructor(data?: IRegusBookingServicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceIds"])) {
                this.serviceIds = [] as any;
                for (let item of _data["serviceIds"])
                    this.serviceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RegusBookingServicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegusBookingServicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceIds)) {
            data["serviceIds"] = [];
            for (let item of this.serviceIds)
                data["serviceIds"].push(item);
        }
        return data;
    }
}

export interface IRegusBookingServicesRequest {
    serviceIds: number[];
}

export class InviteGuestsViewModel implements IInviteGuestsViewModel {
    reservationId!: string;
    sendInvites!: boolean;
    meetingTitle!: string | undefined;
    securityCode!: string | undefined;
    guests!: Guest[];

    constructor(data?: IInviteGuestsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.sendInvites = _data["sendInvites"];
            this.meetingTitle = _data["meetingTitle"];
            this.securityCode = _data["securityCode"];
            if (Array.isArray(_data["guests"])) {
                this.guests = [] as any;
                for (let item of _data["guests"])
                    this.guests!.push(Guest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InviteGuestsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InviteGuestsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["sendInvites"] = this.sendInvites;
        data["meetingTitle"] = this.meetingTitle;
        data["securityCode"] = this.securityCode;
        if (Array.isArray(this.guests)) {
            data["guests"] = [];
            for (let item of this.guests)
                data["guests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInviteGuestsViewModel {
    reservationId: string;
    sendInvites: boolean;
    meetingTitle: string | undefined;
    securityCode: string | undefined;
    guests: Guest[];
}

export class Guest implements IGuest {
    fullName!: string;
    email!: string;

    constructor(data?: IGuest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Guest {
        data = typeof data === 'object' ? data : {};
        let result = new Guest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        return data;
    }
}

export interface IGuest {
    fullName: string;
    email: string;
}

export class ReservationPager implements IReservationPager {
    /** Total reservations count */
    total!: number;
    /** List of page tokens */
    data!: string[];

    constructor(data?: IReservationPager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): ReservationPager {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IReservationPager {
    /** Total reservations count */
    total: number;
    /** List of page tokens */
    data: string[];
}

export class ReservationPagerRequest implements IReservationPagerRequest {
    /** Type of reservations: All, Future, Past */
    reservationTimeType!: ReservationTimeType;
    /** Member that actually created reservation. Suitable when quering Book-on-bahalf reservations */
    reservationsOwnerId!: string | undefined;
    /** End date */
    reservationEndTimeFilter!: string | undefined;
    /** Start date */
    reservationStartTimeFilter!: string | undefined;
    /** Reservation per page */
    countOnPage!: number;

    constructor(data?: IReservationPagerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.reservationTimeType = _data["reservationTimeType"];
            this.reservationsOwnerId = _data["reservationsOwnerId"];
            this.reservationEndTimeFilter = _data["reservationEndTimeFilter"];
            this.reservationStartTimeFilter = _data["reservationStartTimeFilter"];
            this.countOnPage = _data["countOnPage"];
        }
    }

    static fromJS(data: any): ReservationPagerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPagerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationTimeType"] = this.reservationTimeType;
        data["reservationsOwnerId"] = this.reservationsOwnerId;
        data["reservationEndTimeFilter"] = this.reservationEndTimeFilter;
        data["reservationStartTimeFilter"] = this.reservationStartTimeFilter;
        data["countOnPage"] = this.countOnPage;
        return data;
    }
}

export interface IReservationPagerRequest {
    /** Type of reservations: All, Future, Past */
    reservationTimeType: ReservationTimeType;
    /** Member that actually created reservation. Suitable when quering Book-on-bahalf reservations */
    reservationsOwnerId: string | undefined;
    /** End date */
    reservationEndTimeFilter: string | undefined;
    /** Start date */
    reservationStartTimeFilter: string | undefined;
    /** Reservation per page */
    countOnPage: number;
}

export class EditReservationResponse implements IEditReservationResponse {
    id!: string;
    occurrenceDate!: string | undefined;

    constructor(data?: IEditReservationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.occurrenceDate = _data["occurrenceDate"];
        }
    }

    static fromJS(data: any): EditReservationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditReservationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["occurrenceDate"] = this.occurrenceDate;
        return data;
    }
}

export interface IEditReservationResponse {
    id: string;
    occurrenceDate: string | undefined;
}

export class EditReservationRequest implements IEditReservationRequest {
    patch!: Operation[];
    deviceData!: string | undefined;
    totalPrice!: number | undefined;
    terminateWhenTotalPriceMismatch!: boolean | undefined;
    changeWorkspaceRequest!: ChangeWorkspaceRequest | undefined;
    reservationSourcePage!: string | undefined;

    constructor(data?: IEditReservationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["patch"])) {
                this.patch = [] as any;
                for (let item of _data["patch"])
                    this.patch!.push(Operation.fromJS(item));
            }
            this.deviceData = _data["deviceData"];
            this.totalPrice = _data["totalPrice"];
            this.terminateWhenTotalPriceMismatch = _data["terminateWhenTotalPriceMismatch"];
            this.changeWorkspaceRequest = _data["changeWorkspaceRequest"] ? ChangeWorkspaceRequest.fromJS(_data["changeWorkspaceRequest"]) : <any>undefined;
            this.reservationSourcePage = _data["reservationSourcePage"];
        }
    }

    static fromJS(data: any): EditReservationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditReservationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patch)) {
            data["patch"] = [];
            for (let item of this.patch)
                data["patch"].push(item.toJSON());
        }
        data["deviceData"] = this.deviceData;
        data["totalPrice"] = this.totalPrice;
        data["terminateWhenTotalPriceMismatch"] = this.terminateWhenTotalPriceMismatch;
        data["changeWorkspaceRequest"] = this.changeWorkspaceRequest ? this.changeWorkspaceRequest.toJSON() : <any>undefined;
        data["reservationSourcePage"] = this.reservationSourcePage;
        return data;
    }
}

export interface IEditReservationRequest {
    patch: Operation[];
    deviceData: string | undefined;
    totalPrice: number | undefined;
    terminateWhenTotalPriceMismatch: boolean | undefined;
    changeWorkspaceRequest: ChangeWorkspaceRequest | undefined;
    reservationSourcePage: string | undefined;
}

export class ReservationRaw implements IReservationRaw {
    id!: string;
    ownerId!: string;
    venueId!: string;
    workspaceId!: string;
    startTime!: string;

    constructor(data?: IReservationRaw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerId = _data["ownerId"];
            this.venueId = _data["venueId"];
            this.workspaceId = _data["workspaceId"];
            this.startTime = _data["startTime"];
        }
    }

    static fromJS(data: any): ReservationRaw {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationRaw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerId"] = this.ownerId;
        data["venueId"] = this.venueId;
        data["workspaceId"] = this.workspaceId;
        data["startTime"] = this.startTime;
        return data;
    }
}

export interface IReservationRaw {
    id: string;
    ownerId: string;
    venueId: string;
    workspaceId: string;
    startTime: string;
}

export abstract class ReservationRequest implements IReservationRequest {
    venueId!: string;
    workspaceId!: string;
    name!: string | undefined;
    socialVisibility!: SocialVisibility | undefined;
    /** Admin or SU notes */
    notes!: string | undefined;
    bookingReason!: string | undefined;
    organizer!: ReservationOrganizer;
    amenities!: string[];
    paymentMethod!: PaymentMethodDescriptor | undefined;
    reservationSourcePage!: string | undefined;
    campaignTrackingDetails!: { [key: string]: string; } | undefined;
    totalPrice!: number | undefined;
    terminateWhenTotalPriceMismatch!: boolean | undefined;
    /** Intermidiate data for integrations, i.e. Regus. Ensures that availability and price calculations are consistent between display and submit */
    integrationReferences!: ReservationIntegrationReferences | undefined;

    protected _discriminator: string;

    constructor(data?: IReservationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ReservationRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.workspaceId = _data["workspaceId"];
            this.name = _data["name"];
            this.socialVisibility = _data["socialVisibility"];
            this.notes = _data["notes"];
            this.bookingReason = _data["bookingReason"];
            this.organizer = _data["organizer"] ? ReservationOrganizer.fromJS(_data["organizer"]) : <any>undefined;
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities!.push(item);
            }
            this.paymentMethod = _data["paymentMethod"] ? PaymentMethodDescriptor.fromJS(_data["paymentMethod"]) : <any>undefined;
            this.reservationSourcePage = _data["reservationSourcePage"];
            if (_data["campaignTrackingDetails"]) {
                this.campaignTrackingDetails = {} as any;
                for (let key in _data["campaignTrackingDetails"]) {
                    if (_data["campaignTrackingDetails"].hasOwnProperty(key))
                        (<any>this.campaignTrackingDetails)![key] = _data["campaignTrackingDetails"][key];
                }
            }
            this.totalPrice = _data["totalPrice"];
            this.terminateWhenTotalPriceMismatch = _data["terminateWhenTotalPriceMismatch"];
            this.integrationReferences = _data["integrationReferences"] ? ReservationIntegrationReferences.fromJS(_data["integrationReferences"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReservationRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "HourlyReservationRequest") {
            let result = new HourlyReservationRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DaypassReservationRequest") {
            let result = new DaypassReservationRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MonthlyReservationRequest") {
            let result = new MonthlyReservationRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ReservationRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["venueId"] = this.venueId;
        data["workspaceId"] = this.workspaceId;
        data["name"] = this.name;
        data["socialVisibility"] = this.socialVisibility;
        data["notes"] = this.notes;
        data["bookingReason"] = this.bookingReason;
        data["organizer"] = this.organizer ? this.organizer.toJSON() : <any>undefined;
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item);
        }
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["reservationSourcePage"] = this.reservationSourcePage;
        if (this.campaignTrackingDetails) {
            data["campaignTrackingDetails"] = {};
            for (let key in this.campaignTrackingDetails) {
                if (this.campaignTrackingDetails.hasOwnProperty(key))
                    (<any>data["campaignTrackingDetails"])[key] = (<any>this.campaignTrackingDetails)[key];
            }
        }
        data["totalPrice"] = this.totalPrice;
        data["terminateWhenTotalPriceMismatch"] = this.terminateWhenTotalPriceMismatch;
        data["integrationReferences"] = this.integrationReferences ? this.integrationReferences.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReservationRequest {
    venueId: string;
    workspaceId: string;
    name: string | undefined;
    socialVisibility: SocialVisibility | undefined;
    /** Admin or SU notes */
    notes: string | undefined;
    bookingReason: string | undefined;
    organizer: ReservationOrganizer;
    amenities: string[];
    paymentMethod: PaymentMethodDescriptor | undefined;
    reservationSourcePage: string | undefined;
    campaignTrackingDetails: { [key: string]: string; } | undefined;
    totalPrice: number | undefined;
    terminateWhenTotalPriceMismatch: boolean | undefined;
    /** Intermidiate data for integrations, i.e. Regus. Ensures that availability and price calculations are consistent between display and submit */
    integrationReferences: ReservationIntegrationReferences | undefined;
}

export abstract class ReservationOrganizer implements IReservationOrganizer {
    fullName!: string | undefined;
    phoneNumber!: string | undefined;
    company!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    country!: string | undefined;
    postalCode!: string | undefined;

    protected _discriminator: string;

    constructor(data?: IReservationOrganizer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "ReservationOrganizer";
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.company = _data["company"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): ReservationOrganizer {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "AnonymousReservationOrganizer") {
            let result = new AnonymousReservationOrganizer();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AuthenticatedReservationOrganizer") {
            let result = new AuthenticatedReservationOrganizer();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ReservationOrganizer' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["company"] = this.company;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IReservationOrganizer {
    fullName: string | undefined;
    phoneNumber: string | undefined;
    company: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    postalCode: string | undefined;
}

export class AnonymousReservationOrganizer extends ReservationOrganizer implements IAnonymousReservationOrganizer {
    email!: string;

    constructor(data?: IAnonymousReservationOrganizer) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "AnonymousReservationOrganizer";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AnonymousReservationOrganizer {
        data = typeof data === 'object' ? data : {};
        let result = new AnonymousReservationOrganizer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        super.toJSON(data);
        return data;
    }
}

export interface IAnonymousReservationOrganizer extends IReservationOrganizer {
    email: string;
}

export class AuthenticatedReservationOrganizer extends ReservationOrganizer implements IAuthenticatedReservationOrganizer {
    id!: string;

    constructor(data?: IAuthenticatedReservationOrganizer) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "AuthenticatedReservationOrganizer";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuthenticatedReservationOrganizer {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticatedReservationOrganizer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IAuthenticatedReservationOrganizer extends IReservationOrganizer {
    id: string;
}

export class HourlyReservationRequest extends ReservationRequest implements IHourlyReservationRequest {
    details!: HourlyReservationDetails;
    promotion!: ReservationPromotion | undefined;

    constructor(data?: IHourlyReservationRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "HourlyReservationRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.details = _data["details"] ? HourlyReservationDetails.fromJS(_data["details"]) : <any>undefined;
            this.promotion = _data["promotion"] ? ReservationPromotion.fromJS(_data["promotion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HourlyReservationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HourlyReservationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IHourlyReservationRequest extends IReservationRequest {
    details: HourlyReservationDetails;
    promotion: ReservationPromotion | undefined;
}

export class DaypassReservationRequest extends ReservationRequest implements IDaypassReservationRequest {
    details!: DaypassReservationDetails;
    promotion!: ReservationPromotion | undefined;

    constructor(data?: IDaypassReservationRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "DaypassReservationRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.details = _data["details"] ? DaypassReservationDetails.fromJS(_data["details"]) : <any>undefined;
            this.promotion = _data["promotion"] ? ReservationPromotion.fromJS(_data["promotion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DaypassReservationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DaypassReservationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDaypassReservationRequest extends IReservationRequest {
    details: DaypassReservationDetails;
    promotion: ReservationPromotion | undefined;
}

export class MonthlyReservationRequest extends ReservationRequest implements IMonthlyReservationRequest {
    details!: MonthlyReservationDetails;

    constructor(data?: IMonthlyReservationRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "MonthlyReservationRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.details = _data["details"] ? MonthlyReservationDetails.fromJS(_data["details"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MonthlyReservationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyReservationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMonthlyReservationRequest extends IReservationRequest {
    details: MonthlyReservationDetails;
}

export class CreateReservationResponse implements ICreateReservationResponse {
    id!: string;
    securityCode!: string;

    constructor(data?: ICreateReservationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.securityCode = _data["securityCode"];
        }
    }

    static fromJS(data: any): CreateReservationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReservationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["securityCode"] = this.securityCode;
        return data;
    }
}

export interface ICreateReservationResponse {
    id: string;
    securityCode: string;
}

export class VenueConfirmationViewModel implements IVenueConfirmationViewModel {
    status!: VenueConfirmationStatus;
    date!: string | undefined;
    authorFullName!: string | undefined;
    urgency!: HourlyReservationUrgencyStatus;

    constructor(data?: IVenueConfirmationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.date = _data["date"];
            this.authorFullName = _data["authorFullName"];
            this.urgency = _data["urgency"];
        }
    }

    static fromJS(data: any): VenueConfirmationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueConfirmationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["date"] = this.date;
        data["authorFullName"] = this.authorFullName;
        data["urgency"] = this.urgency;
        return data;
    }
}

export interface IVenueConfirmationViewModel {
    status: VenueConfirmationStatus;
    date: string | undefined;
    authorFullName: string | undefined;
    urgency: HourlyReservationUrgencyStatus;
}

export class PromotionListItemViewModel implements IPromotionListItemViewModel {
    id!: string;
    name!: string;
    description!: string | undefined;
    code!: string;
    redemptionsCount!: number;
    activeDate!: string;
    expirationDate!: string;

    constructor(data?: IPromotionListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.redemptionsCount = _data["redemptionsCount"];
            this.activeDate = _data["activeDate"];
            this.expirationDate = _data["expirationDate"];
        }
    }

    static fromJS(data: any): PromotionListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["code"] = this.code;
        data["redemptionsCount"] = this.redemptionsCount;
        data["activeDate"] = this.activeDate;
        data["expirationDate"] = this.expirationDate;
        return data;
    }
}

export interface IPromotionListItemViewModel {
    id: string;
    name: string;
    description: string | undefined;
    code: string;
    redemptionsCount: number;
    activeDate: string;
    expirationDate: string;
}

export class PromotionSettingsViewModel implements IPromotionSettingsViewModel {
    name!: string;
    code!: string;
    promotionPageLink!: string | undefined;
    description!: string | undefined;
    legalDescription!: string | undefined;
    searchDescription!: string | undefined;
    discountType!: PromotionDiscountType;
    discountAmount!: number;
    isPaidByLiquidspace!: boolean;
    maximumSavings!: number;
    activeDate!: string;
    expirationDate!: string;
    reservationWindowStartTime!: string | undefined;
    reservationWindowEndTime!: string | undefined;
    /** Coupon Cookie Expiration (days) */
    couponCookieExpiration!: number | undefined;
    maxNumberRedemptionsTotal!: number;
    maxNumberRedemptionsPerUser!: number;
    firstTimeUserOnly!: boolean;
    nonOriginatedVenueOnly!: boolean;
    firstTimeVisitNonOriginatedVenue!: boolean;
    creditCardOnly!: boolean;
    creditCardTypes!: CreditCardTypeType[];
    memberInvitedOnly!: boolean;
    /** Valid after member create date (days) */
    daysValidAfterMemberCreation!: number;
    mobileOnly!: boolean;
    membershipPromotionType!: MembershipPromotionType;
    additionalInfoRequired!: boolean;
    additionalInfoPlaceholderText!: string | undefined;
    workspaceScenarioIds!: string[];

    constructor(data?: IPromotionSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.promotionPageLink = _data["promotionPageLink"];
            this.description = _data["description"];
            this.legalDescription = _data["legalDescription"];
            this.searchDescription = _data["searchDescription"];
            this.discountType = _data["discountType"];
            this.discountAmount = _data["discountAmount"];
            this.isPaidByLiquidspace = _data["isPaidByLiquidspace"];
            this.maximumSavings = _data["maximumSavings"];
            this.activeDate = _data["activeDate"];
            this.expirationDate = _data["expirationDate"];
            this.reservationWindowStartTime = _data["reservationWindowStartTime"];
            this.reservationWindowEndTime = _data["reservationWindowEndTime"];
            this.couponCookieExpiration = _data["couponCookieExpiration"];
            this.maxNumberRedemptionsTotal = _data["maxNumberRedemptionsTotal"];
            this.maxNumberRedemptionsPerUser = _data["maxNumberRedemptionsPerUser"];
            this.firstTimeUserOnly = _data["firstTimeUserOnly"];
            this.nonOriginatedVenueOnly = _data["nonOriginatedVenueOnly"];
            this.firstTimeVisitNonOriginatedVenue = _data["firstTimeVisitNonOriginatedVenue"];
            this.creditCardOnly = _data["creditCardOnly"];
            if (Array.isArray(_data["creditCardTypes"])) {
                this.creditCardTypes = [] as any;
                for (let item of _data["creditCardTypes"])
                    this.creditCardTypes!.push(item);
            }
            this.memberInvitedOnly = _data["memberInvitedOnly"];
            this.daysValidAfterMemberCreation = _data["daysValidAfterMemberCreation"];
            this.mobileOnly = _data["mobileOnly"];
            this.membershipPromotionType = _data["membershipPromotionType"];
            this.additionalInfoRequired = _data["additionalInfoRequired"];
            this.additionalInfoPlaceholderText = _data["additionalInfoPlaceholderText"];
            if (Array.isArray(_data["workspaceScenarioIds"])) {
                this.workspaceScenarioIds = [] as any;
                for (let item of _data["workspaceScenarioIds"])
                    this.workspaceScenarioIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PromotionSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["promotionPageLink"] = this.promotionPageLink;
        data["description"] = this.description;
        data["legalDescription"] = this.legalDescription;
        data["searchDescription"] = this.searchDescription;
        data["discountType"] = this.discountType;
        data["discountAmount"] = this.discountAmount;
        data["isPaidByLiquidspace"] = this.isPaidByLiquidspace;
        data["maximumSavings"] = this.maximumSavings;
        data["activeDate"] = this.activeDate;
        data["expirationDate"] = this.expirationDate;
        data["reservationWindowStartTime"] = this.reservationWindowStartTime;
        data["reservationWindowEndTime"] = this.reservationWindowEndTime;
        data["couponCookieExpiration"] = this.couponCookieExpiration;
        data["maxNumberRedemptionsTotal"] = this.maxNumberRedemptionsTotal;
        data["maxNumberRedemptionsPerUser"] = this.maxNumberRedemptionsPerUser;
        data["firstTimeUserOnly"] = this.firstTimeUserOnly;
        data["nonOriginatedVenueOnly"] = this.nonOriginatedVenueOnly;
        data["firstTimeVisitNonOriginatedVenue"] = this.firstTimeVisitNonOriginatedVenue;
        data["creditCardOnly"] = this.creditCardOnly;
        if (Array.isArray(this.creditCardTypes)) {
            data["creditCardTypes"] = [];
            for (let item of this.creditCardTypes)
                data["creditCardTypes"].push(item);
        }
        data["memberInvitedOnly"] = this.memberInvitedOnly;
        data["daysValidAfterMemberCreation"] = this.daysValidAfterMemberCreation;
        data["mobileOnly"] = this.mobileOnly;
        data["membershipPromotionType"] = this.membershipPromotionType;
        data["additionalInfoRequired"] = this.additionalInfoRequired;
        data["additionalInfoPlaceholderText"] = this.additionalInfoPlaceholderText;
        if (Array.isArray(this.workspaceScenarioIds)) {
            data["workspaceScenarioIds"] = [];
            for (let item of this.workspaceScenarioIds)
                data["workspaceScenarioIds"].push(item);
        }
        return data;
    }
}

export interface IPromotionSettingsViewModel {
    name: string;
    code: string;
    promotionPageLink: string | undefined;
    description: string | undefined;
    legalDescription: string | undefined;
    searchDescription: string | undefined;
    discountType: PromotionDiscountType;
    discountAmount: number;
    isPaidByLiquidspace: boolean;
    maximumSavings: number;
    activeDate: string;
    expirationDate: string;
    reservationWindowStartTime: string | undefined;
    reservationWindowEndTime: string | undefined;
    /** Coupon Cookie Expiration (days) */
    couponCookieExpiration: number | undefined;
    maxNumberRedemptionsTotal: number;
    maxNumberRedemptionsPerUser: number;
    firstTimeUserOnly: boolean;
    nonOriginatedVenueOnly: boolean;
    firstTimeVisitNonOriginatedVenue: boolean;
    creditCardOnly: boolean;
    creditCardTypes: CreditCardTypeType[];
    memberInvitedOnly: boolean;
    /** Valid after member create date (days) */
    daysValidAfterMemberCreation: number;
    mobileOnly: boolean;
    membershipPromotionType: MembershipPromotionType;
    additionalInfoRequired: boolean;
    additionalInfoPlaceholderText: string | undefined;
    workspaceScenarioIds: string[];
}

/** 0 = FixedAmount 1 = Percentage */
export enum PromotionDiscountType {
    FixedAmount = 0,
    Percentage = 1,
}

/** 0 = None 1 = HomeVenue 2 = Reciprocal 3 = LiquidSpace */
export enum MembershipPromotionType {
    None = 0,
    HomeVenue = 1,
    Reciprocal = 2,
    LiquidSpace = 3,
}

export class PromotionRedemptionListItemViewModel implements IPromotionRedemptionListItemViewModel {
    redemptionId!: string;
    redemptionDate!: string;
    userGuid!: string;
    reservationId!: string;
    occurrenceDate!: string | undefined;

    constructor(data?: IPromotionRedemptionListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.redemptionId = _data["redemptionId"];
            this.redemptionDate = _data["redemptionDate"];
            this.userGuid = _data["userGuid"];
            this.reservationId = _data["reservationId"];
            this.occurrenceDate = _data["occurrenceDate"];
        }
    }

    static fromJS(data: any): PromotionRedemptionListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionRedemptionListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redemptionId"] = this.redemptionId;
        data["redemptionDate"] = this.redemptionDate;
        data["userGuid"] = this.userGuid;
        data["reservationId"] = this.reservationId;
        data["occurrenceDate"] = this.occurrenceDate;
        return data;
    }
}

export interface IPromotionRedemptionListItemViewModel {
    redemptionId: string;
    redemptionDate: string;
    userGuid: string;
    reservationId: string;
    occurrenceDate: string | undefined;
}

export class PromotionValidationResultViewModel implements IPromotionValidationResultViewModel {
    code!: string | undefined;
    isValid!: boolean;
    errorMessage!: string | undefined;
    additionalInfoRequired!: boolean;
    additionalInfoPlaceholderText!: string | undefined;

    constructor(data?: IPromotionValidationResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.isValid = _data["isValid"];
            this.errorMessage = _data["errorMessage"];
            this.additionalInfoRequired = _data["additionalInfoRequired"];
            this.additionalInfoPlaceholderText = _data["additionalInfoPlaceholderText"];
        }
    }

    static fromJS(data: any): PromotionValidationResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionValidationResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isValid"] = this.isValid;
        data["errorMessage"] = this.errorMessage;
        data["additionalInfoRequired"] = this.additionalInfoRequired;
        data["additionalInfoPlaceholderText"] = this.additionalInfoPlaceholderText;
        return data;
    }
}

export interface IPromotionValidationResultViewModel {
    code: string | undefined;
    isValid: boolean;
    errorMessage: string | undefined;
    additionalInfoRequired: boolean;
    additionalInfoPlaceholderText: string | undefined;
}

export class PromotionMemberGroupListItemViewModel implements IPromotionMemberGroupListItemViewModel {
    id!: string;
    name!: string;

    constructor(data?: IPromotionMemberGroupListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PromotionMemberGroupListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionMemberGroupListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPromotionMemberGroupListItemViewModel {
    id: string;
    name: string;
}

export class PromotionVenueGroupListItemViewModel implements IPromotionVenueGroupListItemViewModel {
    id!: string;
    name!: string;

    constructor(data?: IPromotionVenueGroupListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PromotionVenueGroupListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionVenueGroupListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPromotionVenueGroupListItemViewModel {
    id: string;
    name: string;
}

export class PromotionVenueListItemViewModel implements IPromotionVenueListItemViewModel {
    id!: string;
    fullName!: string;
    address!: string;

    constructor(data?: IPromotionVenueListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): PromotionVenueListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionVenueListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["address"] = this.address;
        return data;
    }
}

export interface IPromotionVenueListItemViewModel {
    id: string;
    fullName: string;
    address: string;
}

export class SendMessageResponse implements ISendMessageResponse {
    message!: MessageViewModel | undefined;
    chain!: MessageChain | undefined;

    constructor(data?: ISendMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] ? MessageViewModel.fromJS(_data["message"]) : <any>undefined;
            this.chain = _data["chain"] ? MessageChain.fromJS(_data["chain"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        data["chain"] = this.chain ? this.chain.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendMessageResponse {
    message: MessageViewModel | undefined;
    chain: MessageChain | undefined;
}

export class MessageViewModel implements IMessageViewModel {
    id!: string;
    deleted!: boolean;
    createTime!: string;
    ownerId!: string;
    targetId!: string;
    chainId!: string | undefined;
    text!: string | undefined;
    read!: boolean;
    subject!: string | undefined;
    venueId!: string | undefined;
    fromVenue!: boolean;
    workspaceId!: string | undefined;
    omitStripSensitiveData!: boolean;
    isMonthly!: boolean;
    messageSource!: MessageSource;
    searchRequestId!: string | undefined;
    hasProposal!: boolean;
    workflowId!: string | undefined;
    attachments!: MessageAttachmentViewModel[] | undefined;
    isModerated!: boolean;
    ownerName!: string | undefined;
    ownerFirstName!: string | undefined;
    ownerImage!: string | undefined;
    isOwn!: boolean;
    displayVenueLink!: boolean;
    hasHiddenText!: boolean;
    isSpaceExpert!: boolean;
    score!: number | undefined;
    cbvScore!: number | undefined;

    constructor(data?: IMessageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deleted = _data["deleted"];
            this.createTime = _data["createTime"];
            this.ownerId = _data["ownerId"];
            this.targetId = _data["targetId"];
            this.chainId = _data["chainId"];
            this.text = _data["text"];
            this.read = _data["read"];
            this.subject = _data["subject"];
            this.venueId = _data["venueId"];
            this.fromVenue = _data["fromVenue"];
            this.workspaceId = _data["workspaceId"];
            this.omitStripSensitiveData = _data["omitStripSensitiveData"];
            this.isMonthly = _data["isMonthly"];
            this.messageSource = _data["messageSource"];
            this.searchRequestId = _data["searchRequestId"];
            this.hasProposal = _data["hasProposal"];
            this.workflowId = _data["workflowId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(MessageAttachmentViewModel.fromJS(item));
            }
            this.isModerated = _data["isModerated"];
            this.ownerName = _data["ownerName"];
            this.ownerFirstName = _data["ownerFirstName"];
            this.ownerImage = _data["ownerImage"];
            this.isOwn = _data["isOwn"];
            this.displayVenueLink = _data["displayVenueLink"];
            this.hasHiddenText = _data["hasHiddenText"];
            this.isSpaceExpert = _data["isSpaceExpert"];
            this.score = _data["score"];
            this.cbvScore = _data["cbvScore"];
        }
    }

    static fromJS(data: any): MessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deleted"] = this.deleted;
        data["createTime"] = this.createTime;
        data["ownerId"] = this.ownerId;
        data["targetId"] = this.targetId;
        data["chainId"] = this.chainId;
        data["text"] = this.text;
        data["read"] = this.read;
        data["subject"] = this.subject;
        data["venueId"] = this.venueId;
        data["fromVenue"] = this.fromVenue;
        data["workspaceId"] = this.workspaceId;
        data["omitStripSensitiveData"] = this.omitStripSensitiveData;
        data["isMonthly"] = this.isMonthly;
        data["messageSource"] = this.messageSource;
        data["searchRequestId"] = this.searchRequestId;
        data["hasProposal"] = this.hasProposal;
        data["workflowId"] = this.workflowId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["isModerated"] = this.isModerated;
        data["ownerName"] = this.ownerName;
        data["ownerFirstName"] = this.ownerFirstName;
        data["ownerImage"] = this.ownerImage;
        data["isOwn"] = this.isOwn;
        data["displayVenueLink"] = this.displayVenueLink;
        data["hasHiddenText"] = this.hasHiddenText;
        data["isSpaceExpert"] = this.isSpaceExpert;
        data["score"] = this.score;
        data["cbvScore"] = this.cbvScore;
        return data;
    }
}

export interface IMessageViewModel {
    id: string;
    deleted: boolean;
    createTime: string;
    ownerId: string;
    targetId: string;
    chainId: string | undefined;
    text: string | undefined;
    read: boolean;
    subject: string | undefined;
    venueId: string | undefined;
    fromVenue: boolean;
    workspaceId: string | undefined;
    omitStripSensitiveData: boolean;
    isMonthly: boolean;
    messageSource: MessageSource;
    searchRequestId: string | undefined;
    hasProposal: boolean;
    workflowId: string | undefined;
    attachments: MessageAttachmentViewModel[] | undefined;
    isModerated: boolean;
    ownerName: string | undefined;
    ownerFirstName: string | undefined;
    ownerImage: string | undefined;
    isOwn: boolean;
    displayVenueLink: boolean;
    hasHiddenText: boolean;
    isSpaceExpert: boolean;
    score: number | undefined;
    cbvScore: number | undefined;
}

/** 0 = NotSpecified 1 = Messenger 2 = XPP 3 = WLP 4 = FurnitureRequest 5 = ShareProfile 6 = UpsertSharedCollection 7 = UpsertProposal 8 = UpsertSearchRequest 9 = InquiryRequest 10 = TourRequest 11 = BookRequest 12 = UpsertTour 13 = UpsertMemberVisaState 14 = MessengerEmailEvent 15 = VenueSubmittedForApproval 16 = SUMobileUsersMessage 17 = CheckAvailability 18 = DeclineProposal 19 = ApproveToBook 20 = VenueSubmittedForLiquidspacePro */
export enum MessageSource {
    NotSpecified = 0,
    Messenger = 1,
    XPP = 2,
    WLP = 3,
    FurnitureRequest = 4,
    ShareProfile = 5,
    UpsertSharedCollection = 6,
    UpsertProposal = 7,
    UpsertSearchRequest = 8,
    InquiryRequest = 9,
    TourRequest = 10,
    BookRequest = 11,
    UpsertTour = 12,
    UpsertMemberVisaState = 13,
    MessengerEmailEvent = 14,
    VenueSubmittedForApproval = 15,
    SUMobileUsersMessage = 16,
    CheckAvailability = 17,
    DeclineProposal = 18,
    ApproveToBook = 19,
    VenueSubmittedForLiquidspacePro = 20,
}

export class MessageAttachmentViewModel implements IMessageAttachmentViewModel {
    id!: string;
    fileName!: string | undefined;
    contentType!: string | undefined;
    previewUrl!: string | undefined;

    constructor(data?: IMessageAttachmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.previewUrl = _data["previewUrl"];
        }
    }

    static fromJS(data: any): MessageAttachmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessageAttachmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["previewUrl"] = this.previewUrl;
        return data;
    }
}

export interface IMessageAttachmentViewModel {
    id: string;
    fileName: string | undefined;
    contentType: string | undefined;
    previewUrl: string | undefined;
}

export class MessageChain implements IMessageChain {
    chainId!: string;
    memberId!: string;
    memberPhoneNumber!: string | undefined;
    memberCompany!: string | undefined;
    memberEnterpriseAccountName!: string | undefined;
    subject!: string;
    messages!: MessageViewModel[];
    messageStatus!: MessageStatus;
    additionalStatus!: string;
    isArchived!: boolean;
    messageRules!: { [key: string]: string; };
    isVenueMode!: boolean;
    senderId!: string;
    senderName!: string;
    senderFirstName!: string;
    senderImage!: string | undefined;
    senderDeleted!: boolean;
    senderIsSpaceExpert!: boolean;
    venueId!: string | undefined;
    venueUrl!: string | undefined;
    venueName!: string | undefined;
    venueToday!: string | undefined;
    monthlyVisaId!: string | undefined;
    xppUrl!: string | undefined;
    workspaceId!: string | undefined;
    workspaceName!: string | undefined;
    workspaceLandingPageUrl!: string | undefined;
    isPeriodWorkspace!: boolean;
    isRequestToBookWorkspace!: boolean;
    isWorkspaceInquire!: boolean;
    workflowId!: string | undefined;
    monthlyMemberVisaState!: VisaState | undefined;
    tour!: TourViewModel | undefined;
    visaRequest!: VisaRequestViewModel | undefined;
    savedSearchDashboardViewModel!: SavedSearchDashboardViewModel | undefined;
    proposalWorkspace!: ProposalWorkspaceViewModel | undefined;
    lastMessageDate!: string | undefined;
    lastMessageDateVTZ!: string | undefined;
    workspaces!: WorkspaceOptionViewModel[];
    readyToBookStep!: number;
    showProposalActions!: boolean;
    requestToBookUrl!: string | undefined;
    scheduleTourUrl!: string | undefined;
    activeVenueTourId!: string | undefined;
    hasMemberEngagedWithVenue!: boolean;

    constructor(data?: IMessageChain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.chainId = _data["chainId"];
            this.memberId = _data["memberId"];
            this.memberPhoneNumber = _data["memberPhoneNumber"];
            this.memberCompany = _data["memberCompany"];
            this.memberEnterpriseAccountName = _data["memberEnterpriseAccountName"];
            this.subject = _data["subject"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageViewModel.fromJS(item));
            }
            this.messageStatus = _data["messageStatus"];
            this.additionalStatus = _data["additionalStatus"];
            this.isArchived = _data["isArchived"];
            if (_data["messageRules"]) {
                this.messageRules = {} as any;
                for (let key in _data["messageRules"]) {
                    if (_data["messageRules"].hasOwnProperty(key))
                        (<any>this.messageRules)![key] = _data["messageRules"][key];
                }
            }
            this.isVenueMode = _data["isVenueMode"];
            this.senderId = _data["senderId"];
            this.senderName = _data["senderName"];
            this.senderFirstName = _data["senderFirstName"];
            this.senderImage = _data["senderImage"];
            this.senderDeleted = _data["senderDeleted"];
            this.senderIsSpaceExpert = _data["senderIsSpaceExpert"];
            this.venueId = _data["venueId"];
            this.venueUrl = _data["venueUrl"];
            this.venueName = _data["venueName"];
            this.venueToday = _data["venueToday"];
            this.monthlyVisaId = _data["monthlyVisaId"];
            this.xppUrl = _data["xppUrl"];
            this.workspaceId = _data["workspaceId"];
            this.workspaceName = _data["workspaceName"];
            this.workspaceLandingPageUrl = _data["workspaceLandingPageUrl"];
            this.isPeriodWorkspace = _data["isPeriodWorkspace"];
            this.isRequestToBookWorkspace = _data["isRequestToBookWorkspace"];
            this.isWorkspaceInquire = _data["isWorkspaceInquire"];
            this.workflowId = _data["workflowId"];
            this.monthlyMemberVisaState = _data["monthlyMemberVisaState"];
            this.tour = _data["tour"] ? TourViewModel.fromJS(_data["tour"]) : <any>undefined;
            this.visaRequest = _data["visaRequest"] ? VisaRequestViewModel.fromJS(_data["visaRequest"]) : <any>undefined;
            this.savedSearchDashboardViewModel = _data["savedSearchDashboardViewModel"] ? SavedSearchDashboardViewModel.fromJS(_data["savedSearchDashboardViewModel"]) : <any>undefined;
            this.proposalWorkspace = _data["proposalWorkspace"] ? ProposalWorkspaceViewModel.fromJS(_data["proposalWorkspace"]) : <any>undefined;
            this.lastMessageDate = _data["lastMessageDate"];
            this.lastMessageDateVTZ = _data["lastMessageDateVTZ"];
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(WorkspaceOptionViewModel.fromJS(item));
            }
            this.readyToBookStep = _data["readyToBookStep"];
            this.showProposalActions = _data["showProposalActions"];
            this.requestToBookUrl = _data["requestToBookUrl"];
            this.scheduleTourUrl = _data["scheduleTourUrl"];
            this.activeVenueTourId = _data["activeVenueTourId"];
            this.hasMemberEngagedWithVenue = _data["hasMemberEngagedWithVenue"];
        }
    }

    static fromJS(data: any): MessageChain {
        data = typeof data === 'object' ? data : {};
        let result = new MessageChain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chainId"] = this.chainId;
        data["memberId"] = this.memberId;
        data["memberPhoneNumber"] = this.memberPhoneNumber;
        data["memberCompany"] = this.memberCompany;
        data["memberEnterpriseAccountName"] = this.memberEnterpriseAccountName;
        data["subject"] = this.subject;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["messageStatus"] = this.messageStatus;
        data["additionalStatus"] = this.additionalStatus;
        data["isArchived"] = this.isArchived;
        if (this.messageRules) {
            data["messageRules"] = {};
            for (let key in this.messageRules) {
                if (this.messageRules.hasOwnProperty(key))
                    (<any>data["messageRules"])[key] = (<any>this.messageRules)[key];
            }
        }
        data["isVenueMode"] = this.isVenueMode;
        data["senderId"] = this.senderId;
        data["senderName"] = this.senderName;
        data["senderFirstName"] = this.senderFirstName;
        data["senderImage"] = this.senderImage;
        data["senderDeleted"] = this.senderDeleted;
        data["senderIsSpaceExpert"] = this.senderIsSpaceExpert;
        data["venueId"] = this.venueId;
        data["venueUrl"] = this.venueUrl;
        data["venueName"] = this.venueName;
        data["venueToday"] = this.venueToday;
        data["monthlyVisaId"] = this.monthlyVisaId;
        data["xppUrl"] = this.xppUrl;
        data["workspaceId"] = this.workspaceId;
        data["workspaceName"] = this.workspaceName;
        data["workspaceLandingPageUrl"] = this.workspaceLandingPageUrl;
        data["isPeriodWorkspace"] = this.isPeriodWorkspace;
        data["isRequestToBookWorkspace"] = this.isRequestToBookWorkspace;
        data["isWorkspaceInquire"] = this.isWorkspaceInquire;
        data["workflowId"] = this.workflowId;
        data["monthlyMemberVisaState"] = this.monthlyMemberVisaState;
        data["tour"] = this.tour ? this.tour.toJSON() : <any>undefined;
        data["visaRequest"] = this.visaRequest ? this.visaRequest.toJSON() : <any>undefined;
        data["savedSearchDashboardViewModel"] = this.savedSearchDashboardViewModel ? this.savedSearchDashboardViewModel.toJSON() : <any>undefined;
        data["proposalWorkspace"] = this.proposalWorkspace ? this.proposalWorkspace.toJSON() : <any>undefined;
        data["lastMessageDate"] = this.lastMessageDate;
        data["lastMessageDateVTZ"] = this.lastMessageDateVTZ;
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        data["readyToBookStep"] = this.readyToBookStep;
        data["showProposalActions"] = this.showProposalActions;
        data["requestToBookUrl"] = this.requestToBookUrl;
        data["scheduleTourUrl"] = this.scheduleTourUrl;
        data["activeVenueTourId"] = this.activeVenueTourId;
        data["hasMemberEngagedWithVenue"] = this.hasMemberEngagedWithVenue;
        return data;
    }
}

export interface IMessageChain {
    chainId: string;
    memberId: string;
    memberPhoneNumber: string | undefined;
    memberCompany: string | undefined;
    memberEnterpriseAccountName: string | undefined;
    subject: string;
    messages: MessageViewModel[];
    messageStatus: MessageStatus;
    additionalStatus: string;
    isArchived: boolean;
    messageRules: { [key: string]: string; };
    isVenueMode: boolean;
    senderId: string;
    senderName: string;
    senderFirstName: string;
    senderImage: string | undefined;
    senderDeleted: boolean;
    senderIsSpaceExpert: boolean;
    venueId: string | undefined;
    venueUrl: string | undefined;
    venueName: string | undefined;
    venueToday: string | undefined;
    monthlyVisaId: string | undefined;
    xppUrl: string | undefined;
    workspaceId: string | undefined;
    workspaceName: string | undefined;
    workspaceLandingPageUrl: string | undefined;
    isPeriodWorkspace: boolean;
    isRequestToBookWorkspace: boolean;
    isWorkspaceInquire: boolean;
    workflowId: string | undefined;
    monthlyMemberVisaState: VisaState | undefined;
    tour: TourViewModel | undefined;
    visaRequest: VisaRequestViewModel | undefined;
    savedSearchDashboardViewModel: SavedSearchDashboardViewModel | undefined;
    proposalWorkspace: ProposalWorkspaceViewModel | undefined;
    lastMessageDate: string | undefined;
    lastMessageDateVTZ: string | undefined;
    workspaces: WorkspaceOptionViewModel[];
    readyToBookStep: number;
    showProposalActions: boolean;
    requestToBookUrl: string | undefined;
    scheduleTourUrl: string | undefined;
    activeVenueTourId: string | undefined;
    hasMemberEngagedWithVenue: boolean;
}

/** 0 = Default 1 = New 2 = BookingApproved 4 = BookingDeclined 8 = Reserved */
export enum MessageStatus {
    Default = 0,
    New = 1,
    BookingApproved = 2,
    BookingDeclined = 4,
    Reserved = 8,
}

export class Tour implements ITour {
    id!: string;
    memberId!: string;
    venueId!: string;
    workspaceId!: string;
    tourStatus!: TourStatus;
    dateTime!: string;
    messengerChainId!: string;
    userInteractionStateWorkflowId!: string | undefined;
    tourCancelReason!: TourCancelReason;
    tourPostCompleteStatus!: TourPostCompleteStatus;
    plannedDesksCountToBook!: number;
    created!: string | undefined;

    constructor(data?: ITour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.venueId = _data["venueId"];
            this.workspaceId = _data["workspaceId"];
            this.tourStatus = _data["tourStatus"];
            this.dateTime = _data["dateTime"];
            this.messengerChainId = _data["messengerChainId"];
            this.userInteractionStateWorkflowId = _data["userInteractionStateWorkflowId"];
            this.tourCancelReason = _data["tourCancelReason"];
            this.tourPostCompleteStatus = _data["tourPostCompleteStatus"];
            this.plannedDesksCountToBook = _data["plannedDesksCountToBook"];
            this.created = _data["created"];
        }
    }

    static fromJS(data: any): Tour {
        data = typeof data === 'object' ? data : {};
        let result = new Tour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["venueId"] = this.venueId;
        data["workspaceId"] = this.workspaceId;
        data["tourStatus"] = this.tourStatus;
        data["dateTime"] = this.dateTime;
        data["messengerChainId"] = this.messengerChainId;
        data["userInteractionStateWorkflowId"] = this.userInteractionStateWorkflowId;
        data["tourCancelReason"] = this.tourCancelReason;
        data["tourPostCompleteStatus"] = this.tourPostCompleteStatus;
        data["plannedDesksCountToBook"] = this.plannedDesksCountToBook;
        data["created"] = this.created;
        return data;
    }
}

export interface ITour {
    id: string;
    memberId: string;
    venueId: string;
    workspaceId: string;
    tourStatus: TourStatus;
    dateTime: string;
    messengerChainId: string;
    userInteractionStateWorkflowId: string | undefined;
    tourCancelReason: TourCancelReason;
    tourPostCompleteStatus: TourPostCompleteStatus;
    plannedDesksCountToBook: number;
    created: string | undefined;
}

export class TourViewModel extends Tour implements ITourViewModel {
    dateTimeUtc!: string;
    requestToBookUrl!: string | undefined;
    workspaceImage!: string | undefined;
    timeZoneAbbreviation!: string | undefined;
    venueMapUrl!: string | undefined;
    workspaceUrl!: string | undefined;
    visaState!: VisaState | undefined;
    bookItUrl!: string | undefined;
    dateTimeVenueTime!: string;
    minDate!: string;
    memberFirstName!: string | undefined;
    workspaceName!: string | undefined;
    venueName!: string | undefined;
    venueAddress!: string | undefined;
    workspaceStatus!: WorkspaceStatus;

    constructor(data?: ITourViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dateTimeUtc = _data["dateTimeUtc"];
            this.requestToBookUrl = _data["requestToBookUrl"];
            this.workspaceImage = _data["workspaceImage"];
            this.timeZoneAbbreviation = _data["timeZoneAbbreviation"];
            this.venueMapUrl = _data["venueMapUrl"];
            this.workspaceUrl = _data["workspaceUrl"];
            this.visaState = _data["visaState"];
            this.bookItUrl = _data["bookItUrl"];
            this.dateTimeVenueTime = _data["dateTimeVenueTime"];
            this.minDate = _data["minDate"];
            this.memberFirstName = _data["memberFirstName"];
            this.workspaceName = _data["workspaceName"];
            this.venueName = _data["venueName"];
            this.venueAddress = _data["venueAddress"];
            this.workspaceStatus = _data["workspaceStatus"];
        }
    }

    static fromJS(data: any): TourViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTimeUtc"] = this.dateTimeUtc;
        data["requestToBookUrl"] = this.requestToBookUrl;
        data["workspaceImage"] = this.workspaceImage;
        data["timeZoneAbbreviation"] = this.timeZoneAbbreviation;
        data["venueMapUrl"] = this.venueMapUrl;
        data["workspaceUrl"] = this.workspaceUrl;
        data["visaState"] = this.visaState;
        data["bookItUrl"] = this.bookItUrl;
        data["dateTimeVenueTime"] = this.dateTimeVenueTime;
        data["minDate"] = this.minDate;
        data["memberFirstName"] = this.memberFirstName;
        data["workspaceName"] = this.workspaceName;
        data["venueName"] = this.venueName;
        data["venueAddress"] = this.venueAddress;
        data["workspaceStatus"] = this.workspaceStatus;
        super.toJSON(data);
        return data;
    }
}

export interface ITourViewModel extends ITour {
    dateTimeUtc: string;
    requestToBookUrl: string | undefined;
    workspaceImage: string | undefined;
    timeZoneAbbreviation: string | undefined;
    venueMapUrl: string | undefined;
    workspaceUrl: string | undefined;
    visaState: VisaState | undefined;
    bookItUrl: string | undefined;
    dateTimeVenueTime: string;
    minDate: string;
    memberFirstName: string | undefined;
    workspaceName: string | undefined;
    venueName: string | undefined;
    venueAddress: string | undefined;
    workspaceStatus: WorkspaceStatus;
}

/** 0 = Requested 1 = ChangedByGuest 2 = ChangedByVenue 3 = Confirmed 4 = CanceledByVenue 5 = CanceledByGuest 6 = Complete 7 = Expired 8 = Suggested */
export enum TourStatus {
    Requested = 0,
    ChangedByGuest = 1,
    ChangedByVenue = 2,
    Confirmed = 3,
    CanceledByVenue = 4,
    CanceledByGuest = 5,
    Complete = 6,
    Expired = 7,
    Suggested = 8,
}

/** 0 = None 1 = ReadyToBook 2 = StillThinking 3 = HostUnresponsive 4 = NotReadyRightNow 5 = BookedAlternate 6 = SpaceNotFit 7 = MyReasonIsNotListed 8 = AlreadyBooked */
export enum TourPostCompleteStatus {
    None = 0,
    ReadyToBook = 1,
    StillThinking = 2,
    HostUnresponsive = 3,
    NotReadyRightNow = 4,
    BookedAlternate = 5,
    SpaceNotFit = 6,
    MyReasonIsNotListed = 7,
    AlreadyBooked = 8,
}

export class VisaRequestViewModel implements IVisaRequestViewModel {
    memberId!: string;
    bookingStartDate!: string | undefined;

    constructor(data?: IVisaRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.bookingStartDate = _data["bookingStartDate"];
        }
    }

    static fromJS(data: any): VisaRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VisaRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["bookingStartDate"] = this.bookingStartDate;
        return data;
    }
}

export interface IVisaRequestViewModel {
    memberId: string;
    bookingStartDate: string | undefined;
}

export class SavedSearchDashboardViewModel implements ISavedSearchDashboardViewModel {
    id!: string;
    memberId!: string;
    memberFirstNameInitial!: string | undefined;
    memberFirstName!: string | undefined;
    memberLastName!: string | undefined;
    memberCompany!: string | undefined;
    memberPictureUrl!: string | undefined;
    spaceType!: string | undefined;
    spaceTypeWithCapacity!: string | undefined;
    capacity!: number | undefined;
    startDateString!: string | undefined;
    stringRepresentation!: string | undefined;
    isDeskSearch!: boolean;
    chainId!: string | undefined;
    messageDateString!: string | undefined;
    messageStatus!: string | undefined;
    reservationMethod!: WorkspaceReservationMethod | undefined;
    neighborhoods!: string[] | undefined;
    createdDateRelative!: string | undefined;
    listingsViewed!: number;
    minPrice!: number | undefined;
    maxPrice!: number | undefined;
    ownedListingsViewed!: SavedSearchListingInfo[] | undefined;
    lastSearchTag!: string | undefined;
    city!: string | undefined;
    isRFP!: boolean;
    rfpCompany!: string | undefined;
    specialRequests!: string | undefined;
    createdDate!: string | undefined;
    neighborhoodIds!: string[] | undefined;
    zipcodes!: string[] | undefined;

    constructor(data?: ISavedSearchDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.memberFirstNameInitial = _data["memberFirstNameInitial"];
            this.memberFirstName = _data["memberFirstName"];
            this.memberLastName = _data["memberLastName"];
            this.memberCompany = _data["memberCompany"];
            this.memberPictureUrl = _data["memberPictureUrl"];
            this.spaceType = _data["spaceType"];
            this.spaceTypeWithCapacity = _data["spaceTypeWithCapacity"];
            this.capacity = _data["capacity"];
            this.startDateString = _data["startDateString"];
            this.stringRepresentation = _data["stringRepresentation"];
            this.isDeskSearch = _data["isDeskSearch"];
            this.chainId = _data["chainId"];
            this.messageDateString = _data["messageDateString"];
            this.messageStatus = _data["messageStatus"];
            this.reservationMethod = _data["reservationMethod"];
            if (Array.isArray(_data["neighborhoods"])) {
                this.neighborhoods = [] as any;
                for (let item of _data["neighborhoods"])
                    this.neighborhoods!.push(item);
            }
            this.createdDateRelative = _data["createdDateRelative"];
            this.listingsViewed = _data["listingsViewed"];
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
            if (Array.isArray(_data["ownedListingsViewed"])) {
                this.ownedListingsViewed = [] as any;
                for (let item of _data["ownedListingsViewed"])
                    this.ownedListingsViewed!.push(SavedSearchListingInfo.fromJS(item));
            }
            this.lastSearchTag = _data["lastSearchTag"];
            this.city = _data["city"];
            this.isRFP = _data["isRFP"];
            this.rfpCompany = _data["rfpCompany"];
            this.specialRequests = _data["specialRequests"];
            this.createdDate = _data["createdDate"];
            if (Array.isArray(_data["neighborhoodIds"])) {
                this.neighborhoodIds = [] as any;
                for (let item of _data["neighborhoodIds"])
                    this.neighborhoodIds!.push(item);
            }
            if (Array.isArray(_data["zipcodes"])) {
                this.zipcodes = [] as any;
                for (let item of _data["zipcodes"])
                    this.zipcodes!.push(item);
            }
        }
    }

    static fromJS(data: any): SavedSearchDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSearchDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["memberFirstNameInitial"] = this.memberFirstNameInitial;
        data["memberFirstName"] = this.memberFirstName;
        data["memberLastName"] = this.memberLastName;
        data["memberCompany"] = this.memberCompany;
        data["memberPictureUrl"] = this.memberPictureUrl;
        data["spaceType"] = this.spaceType;
        data["spaceTypeWithCapacity"] = this.spaceTypeWithCapacity;
        data["capacity"] = this.capacity;
        data["startDateString"] = this.startDateString;
        data["stringRepresentation"] = this.stringRepresentation;
        data["isDeskSearch"] = this.isDeskSearch;
        data["chainId"] = this.chainId;
        data["messageDateString"] = this.messageDateString;
        data["messageStatus"] = this.messageStatus;
        data["reservationMethod"] = this.reservationMethod;
        if (Array.isArray(this.neighborhoods)) {
            data["neighborhoods"] = [];
            for (let item of this.neighborhoods)
                data["neighborhoods"].push(item);
        }
        data["createdDateRelative"] = this.createdDateRelative;
        data["listingsViewed"] = this.listingsViewed;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        if (Array.isArray(this.ownedListingsViewed)) {
            data["ownedListingsViewed"] = [];
            for (let item of this.ownedListingsViewed)
                data["ownedListingsViewed"].push(item.toJSON());
        }
        data["lastSearchTag"] = this.lastSearchTag;
        data["city"] = this.city;
        data["isRFP"] = this.isRFP;
        data["rfpCompany"] = this.rfpCompany;
        data["specialRequests"] = this.specialRequests;
        data["createdDate"] = this.createdDate;
        if (Array.isArray(this.neighborhoodIds)) {
            data["neighborhoodIds"] = [];
            for (let item of this.neighborhoodIds)
                data["neighborhoodIds"].push(item);
        }
        if (Array.isArray(this.zipcodes)) {
            data["zipcodes"] = [];
            for (let item of this.zipcodes)
                data["zipcodes"].push(item);
        }
        return data;
    }
}

export interface ISavedSearchDashboardViewModel {
    id: string;
    memberId: string;
    memberFirstNameInitial: string | undefined;
    memberFirstName: string | undefined;
    memberLastName: string | undefined;
    memberCompany: string | undefined;
    memberPictureUrl: string | undefined;
    spaceType: string | undefined;
    spaceTypeWithCapacity: string | undefined;
    capacity: number | undefined;
    startDateString: string | undefined;
    stringRepresentation: string | undefined;
    isDeskSearch: boolean;
    chainId: string | undefined;
    messageDateString: string | undefined;
    messageStatus: string | undefined;
    reservationMethod: WorkspaceReservationMethod | undefined;
    neighborhoods: string[] | undefined;
    createdDateRelative: string | undefined;
    listingsViewed: number;
    minPrice: number | undefined;
    maxPrice: number | undefined;
    ownedListingsViewed: SavedSearchListingInfo[] | undefined;
    lastSearchTag: string | undefined;
    city: string | undefined;
    isRFP: boolean;
    rfpCompany: string | undefined;
    specialRequests: string | undefined;
    createdDate: string | undefined;
    neighborhoodIds: string[] | undefined;
    zipcodes: string[] | undefined;
}

export class SavedSearchListingInfo implements ISavedSearchListingInfo {
    id!: string;
    name!: string | undefined;
    url!: string | undefined;

    constructor(data?: ISavedSearchListingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SavedSearchListingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSearchListingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface ISavedSearchListingInfo {
    id: string;
    name: string | undefined;
    url: string | undefined;
}

export class WorkspaceOptionViewModel implements IWorkspaceOptionViewModel {
    workspaceId!: string;
    scenario!: string | undefined;
    name!: string | undefined;
    venueName!: string | undefined;
    imageUrl!: string | undefined;
    capacity!: number;
    workspaceType!: string | undefined;
    priceDisplay!: string | undefined;
    wlpUrl!: string | undefined;
    workspaceStatus!: string | undefined;
    desksAvailabilityStatusForProposals!: string | undefined;
    isMultipleDeskBookingAllowedForWorkspace!: boolean;
    depositMode!: DepositMode | undefined;
    setupFee!: number;
    isBooked!: boolean | undefined;
    cancellationPolicy!: CancellationPolicy;
    monthlyPrice!: number | undefined;

    constructor(data?: IWorkspaceOptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.scenario = _data["scenario"];
            this.name = _data["name"];
            this.venueName = _data["venueName"];
            this.imageUrl = _data["imageUrl"];
            this.capacity = _data["capacity"];
            this.workspaceType = _data["workspaceType"];
            this.priceDisplay = _data["priceDisplay"];
            this.wlpUrl = _data["wlpUrl"];
            this.workspaceStatus = _data["workspaceStatus"];
            this.desksAvailabilityStatusForProposals = _data["desksAvailabilityStatusForProposals"];
            this.isMultipleDeskBookingAllowedForWorkspace = _data["isMultipleDeskBookingAllowedForWorkspace"];
            this.depositMode = _data["depositMode"];
            this.setupFee = _data["setupFee"];
            this.isBooked = _data["isBooked"];
            this.cancellationPolicy = _data["cancellationPolicy"];
            this.monthlyPrice = _data["monthlyPrice"];
        }
    }

    static fromJS(data: any): WorkspaceOptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceOptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["scenario"] = this.scenario;
        data["name"] = this.name;
        data["venueName"] = this.venueName;
        data["imageUrl"] = this.imageUrl;
        data["capacity"] = this.capacity;
        data["workspaceType"] = this.workspaceType;
        data["priceDisplay"] = this.priceDisplay;
        data["wlpUrl"] = this.wlpUrl;
        data["workspaceStatus"] = this.workspaceStatus;
        data["desksAvailabilityStatusForProposals"] = this.desksAvailabilityStatusForProposals;
        data["isMultipleDeskBookingAllowedForWorkspace"] = this.isMultipleDeskBookingAllowedForWorkspace;
        data["depositMode"] = this.depositMode;
        data["setupFee"] = this.setupFee;
        data["isBooked"] = this.isBooked;
        data["cancellationPolicy"] = this.cancellationPolicy;
        data["monthlyPrice"] = this.monthlyPrice;
        return data;
    }
}

export interface IWorkspaceOptionViewModel {
    workspaceId: string;
    scenario: string | undefined;
    name: string | undefined;
    venueName: string | undefined;
    imageUrl: string | undefined;
    capacity: number;
    workspaceType: string | undefined;
    priceDisplay: string | undefined;
    wlpUrl: string | undefined;
    workspaceStatus: string | undefined;
    desksAvailabilityStatusForProposals: string | undefined;
    isMultipleDeskBookingAllowedForWorkspace: boolean;
    depositMode: DepositMode | undefined;
    setupFee: number;
    isBooked: boolean | undefined;
    cancellationPolicy: CancellationPolicy;
    monthlyPrice: number | undefined;
}

export class ProposalWorkspaceViewModel extends WorkspaceOptionViewModel implements IProposalWorkspaceViewModel {
    proposalId!: string;
    proposalStatus!: ProposalStatus;
    proposalCreated!: string;

    constructor(data?: IProposalWorkspaceViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.proposalId = _data["proposalId"];
            this.proposalStatus = _data["proposalStatus"];
            this.proposalCreated = _data["proposalCreated"];
        }
    }

    static fromJS(data: any): ProposalWorkspaceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalWorkspaceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalId"] = this.proposalId;
        data["proposalStatus"] = this.proposalStatus;
        data["proposalCreated"] = this.proposalCreated;
        super.toJSON(data);
        return data;
    }
}

export interface IProposalWorkspaceViewModel extends IWorkspaceOptionViewModel {
    proposalId: string;
    proposalStatus: ProposalStatus;
    proposalCreated: string;
}

/** 0 = Created 1 = Declined 2 = Expired 3 = Replied 4 = Accepted 5 = Signed 6 = Changed */
export enum ProposalStatus {
    Created = 0,
    Declined = 1,
    Expired = 2,
    Replied = 3,
    Accepted = 4,
    Signed = 5,
    Changed = 6,
}

/** 0 = NoDeposit 1 = Month 2 = TwoMonths */
export enum DepositMode {
    NoDeposit = 0,
    Month = 1,
    TwoMonths = 2,
}

export class MessengerBaseViewModel implements IMessengerBaseViewModel {
    ownerId!: string;
    ownerName!: string | undefined;
    ownerFirstName!: string | undefined;
    ownerImage!: string | undefined;
    ownerDisplay!: boolean;

    constructor(data?: IMessengerBaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.ownerName = _data["ownerName"];
            this.ownerFirstName = _data["ownerFirstName"];
            this.ownerImage = _data["ownerImage"];
            this.ownerDisplay = _data["ownerDisplay"];
        }
    }

    static fromJS(data: any): MessengerBaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessengerBaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        data["ownerFirstName"] = this.ownerFirstName;
        data["ownerImage"] = this.ownerImage;
        data["ownerDisplay"] = this.ownerDisplay;
        return data;
    }
}

export interface IMessengerBaseViewModel {
    ownerId: string;
    ownerName: string | undefined;
    ownerFirstName: string | undefined;
    ownerImage: string | undefined;
    ownerDisplay: boolean;
}

export class MemberMessagesModel extends MessengerBaseViewModel implements IMemberMessagesModel {
    messageChains!: MessageChain[] | undefined;
    messageTargets!: MessageTargetViewModel[] | undefined;
    messageTargetsCount!: number;
    newMessagesCount!: number;
    unrespondedMessagesCount!: number;
    selectedChainId!: string | undefined;
    venueId!: string | undefined;
    composeTargetId!: string;
    composeTargetName!: string | undefined;
    composeTargetVenueId!: string | undefined;
    composeSubject!: string | undefined;
    composeBody!: string | undefined;
    isAdmin!: boolean;
    canFollow!: boolean;
    hasSavedSearch!: boolean;
    shareProfileLink!: string | undefined;
    preferedSearchUrl!: string | undefined;
    messagesFilter!: MessagesFilter | undefined;
    isHourlyOnlyVenue!: boolean;
    showVenueResponseRate!: boolean;
    hasMessageChains!: boolean;
    pendingVisaRequestCount!: number;
    unconfirmedToursCount!: number;
    avgLeadResponseMinutes!: number;
    avgLeadResponseRate!: number;
    leadRequestTotal!: number;
    responsivenessDisplayAfterAmount!: number;
    isSuperUser!: boolean;
    messengerAction!: MessengerAction;

    constructor(data?: IMemberMessagesModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["messageChains"])) {
                this.messageChains = [] as any;
                for (let item of _data["messageChains"])
                    this.messageChains!.push(MessageChain.fromJS(item));
            }
            if (Array.isArray(_data["messageTargets"])) {
                this.messageTargets = [] as any;
                for (let item of _data["messageTargets"])
                    this.messageTargets!.push(MessageTargetViewModel.fromJS(item));
            }
            this.messageTargetsCount = _data["messageTargetsCount"];
            this.newMessagesCount = _data["newMessagesCount"];
            this.unrespondedMessagesCount = _data["unrespondedMessagesCount"];
            this.selectedChainId = _data["selectedChainId"];
            this.venueId = _data["venueId"];
            this.composeTargetId = _data["composeTargetId"];
            this.composeTargetName = _data["composeTargetName"];
            this.composeTargetVenueId = _data["composeTargetVenueId"];
            this.composeSubject = _data["composeSubject"];
            this.composeBody = _data["composeBody"];
            this.isAdmin = _data["isAdmin"];
            this.canFollow = _data["canFollow"];
            this.hasSavedSearch = _data["hasSavedSearch"];
            this.shareProfileLink = _data["shareProfileLink"];
            this.preferedSearchUrl = _data["preferedSearchUrl"];
            this.messagesFilter = _data["messagesFilter"] ? MessagesFilter.fromJS(_data["messagesFilter"]) : <any>undefined;
            this.isHourlyOnlyVenue = _data["isHourlyOnlyVenue"];
            this.showVenueResponseRate = _data["showVenueResponseRate"];
            this.hasMessageChains = _data["hasMessageChains"];
            this.pendingVisaRequestCount = _data["pendingVisaRequestCount"];
            this.unconfirmedToursCount = _data["unconfirmedToursCount"];
            this.avgLeadResponseMinutes = _data["avgLeadResponseMinutes"];
            this.avgLeadResponseRate = _data["avgLeadResponseRate"];
            this.leadRequestTotal = _data["leadRequestTotal"];
            this.responsivenessDisplayAfterAmount = _data["responsivenessDisplayAfterAmount"];
            this.isSuperUser = _data["isSuperUser"];
            this.messengerAction = _data["messengerAction"];
        }
    }

    static fromJS(data: any): MemberMessagesModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberMessagesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageChains)) {
            data["messageChains"] = [];
            for (let item of this.messageChains)
                data["messageChains"].push(item.toJSON());
        }
        if (Array.isArray(this.messageTargets)) {
            data["messageTargets"] = [];
            for (let item of this.messageTargets)
                data["messageTargets"].push(item.toJSON());
        }
        data["messageTargetsCount"] = this.messageTargetsCount;
        data["newMessagesCount"] = this.newMessagesCount;
        data["unrespondedMessagesCount"] = this.unrespondedMessagesCount;
        data["selectedChainId"] = this.selectedChainId;
        data["venueId"] = this.venueId;
        data["composeTargetId"] = this.composeTargetId;
        data["composeTargetName"] = this.composeTargetName;
        data["composeTargetVenueId"] = this.composeTargetVenueId;
        data["composeSubject"] = this.composeSubject;
        data["composeBody"] = this.composeBody;
        data["isAdmin"] = this.isAdmin;
        data["canFollow"] = this.canFollow;
        data["hasSavedSearch"] = this.hasSavedSearch;
        data["shareProfileLink"] = this.shareProfileLink;
        data["preferedSearchUrl"] = this.preferedSearchUrl;
        data["messagesFilter"] = this.messagesFilter ? this.messagesFilter.toJSON() : <any>undefined;
        data["isHourlyOnlyVenue"] = this.isHourlyOnlyVenue;
        data["showVenueResponseRate"] = this.showVenueResponseRate;
        data["hasMessageChains"] = this.hasMessageChains;
        data["pendingVisaRequestCount"] = this.pendingVisaRequestCount;
        data["unconfirmedToursCount"] = this.unconfirmedToursCount;
        data["avgLeadResponseMinutes"] = this.avgLeadResponseMinutes;
        data["avgLeadResponseRate"] = this.avgLeadResponseRate;
        data["leadRequestTotal"] = this.leadRequestTotal;
        data["responsivenessDisplayAfterAmount"] = this.responsivenessDisplayAfterAmount;
        data["isSuperUser"] = this.isSuperUser;
        data["messengerAction"] = this.messengerAction;
        super.toJSON(data);
        return data;
    }
}

export interface IMemberMessagesModel extends IMessengerBaseViewModel {
    messageChains: MessageChain[] | undefined;
    messageTargets: MessageTargetViewModel[] | undefined;
    messageTargetsCount: number;
    newMessagesCount: number;
    unrespondedMessagesCount: number;
    selectedChainId: string | undefined;
    venueId: string | undefined;
    composeTargetId: string;
    composeTargetName: string | undefined;
    composeTargetVenueId: string | undefined;
    composeSubject: string | undefined;
    composeBody: string | undefined;
    isAdmin: boolean;
    canFollow: boolean;
    hasSavedSearch: boolean;
    shareProfileLink: string | undefined;
    preferedSearchUrl: string | undefined;
    messagesFilter: MessagesFilter | undefined;
    isHourlyOnlyVenue: boolean;
    showVenueResponseRate: boolean;
    hasMessageChains: boolean;
    pendingVisaRequestCount: number;
    unconfirmedToursCount: number;
    avgLeadResponseMinutes: number;
    avgLeadResponseRate: number;
    leadRequestTotal: number;
    responsivenessDisplayAfterAmount: number;
    isSuperUser: boolean;
    messengerAction: MessengerAction;
}

export class MessageTargetViewModel implements IMessageTargetViewModel {
    imageUrl!: string | undefined;
    imageDefaults!: string | undefined;
    displayName!: string | undefined;
    displayLink!: string | undefined;
    composeTargetId!: string;
    reasonHtml!: string | undefined;
    address!: string | undefined;
    ctaText!: string | undefined;
    venueId!: string | undefined;
    isSpaceExpert!: boolean;

    constructor(data?: IMessageTargetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"];
            this.imageDefaults = _data["imageDefaults"];
            this.displayName = _data["displayName"];
            this.displayLink = _data["displayLink"];
            this.composeTargetId = _data["composeTargetId"];
            this.reasonHtml = _data["reasonHtml"];
            this.address = _data["address"];
            this.ctaText = _data["ctaText"];
            this.venueId = _data["venueId"];
            this.isSpaceExpert = _data["isSpaceExpert"];
        }
    }

    static fromJS(data: any): MessageTargetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessageTargetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["imageDefaults"] = this.imageDefaults;
        data["displayName"] = this.displayName;
        data["displayLink"] = this.displayLink;
        data["composeTargetId"] = this.composeTargetId;
        data["reasonHtml"] = this.reasonHtml;
        data["address"] = this.address;
        data["ctaText"] = this.ctaText;
        data["venueId"] = this.venueId;
        data["isSpaceExpert"] = this.isSpaceExpert;
        return data;
    }
}

export interface IMessageTargetViewModel {
    imageUrl: string | undefined;
    imageDefaults: string | undefined;
    displayName: string | undefined;
    displayLink: string | undefined;
    composeTargetId: string;
    reasonHtml: string | undefined;
    address: string | undefined;
    ctaText: string | undefined;
    venueId: string | undefined;
    isSpaceExpert: boolean;
}

export class MessagesFilter implements IMessagesFilter {
    filter!: MessagesFilterEnum;

    constructor(data?: IMessagesFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): MessagesFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }
}

export interface IMessagesFilter {
    filter: MessagesFilterEnum;
}

/** 0 = AllMessages 1 = Unread 2 = Unresponded 3 = Tours 4 = VisaPending 5 = VisaGranted 6 = Proposals 7 = Archived */
export enum MessagesFilterEnum {
    AllMessages = 0,
    Unread = 1,
    Unresponded = 2,
    Tours = 3,
    VisaPending = 4,
    VisaGranted = 5,
    Proposals = 6,
    Archived = 7,
}

/** 0 = None 1 = ConfirmTour 2 = CancelTour 3 = ChangeTour 4 = AfterTourNotInterested 5 = AfterTourStillThinking 6 = AfterTourReadyToBook 7 = ApproveBooking 8 = DeclineBooking 9 = ScheduleTour 10 = ProposalNotInterested 11 = CreateProposal 12 = NoSpaceToPropose 13 = AfterTourAlreadyBooked 14 = SuggestTour 15 = RequestToBook 16 = BookIt 17 = AfterTourRequestToBook 18 = AfterTourCompleteBooking 19 = TourFeedbackApproveToBook 20 = TourFeedbackReschedule 21 = TourFeedbackDecline */
export enum MessengerAction {
    None = 0,
    ConfirmTour = 1,
    CancelTour = 2,
    ChangeTour = 3,
    AfterTourNotInterested = 4,
    AfterTourStillThinking = 5,
    AfterTourReadyToBook = 6,
    ApproveBooking = 7,
    DeclineBooking = 8,
    ScheduleTour = 9,
    ProposalNotInterested = 10,
    CreateProposal = 11,
    NoSpaceToPropose = 12,
    AfterTourAlreadyBooked = 13,
    SuggestTour = 14,
    RequestToBook = 15,
    BookIt = 16,
    AfterTourRequestToBook = 17,
    AfterTourCompleteBooking = 18,
    TourFeedbackApproveToBook = 19,
    TourFeedbackReschedule = 20,
    TourFeedbackDecline = 21,
}

/** 1 = Member 2 = Venue 4 = MemberGroup 8 = VenueGroup */
export enum EntityType {
    Member = 1,
    Venue = 2,
    MemberGroup = 4,
    VenueGroup = 8,
}

export class MemberGroupViewModel implements IMemberGroupViewModel {
    id!: string;
    name!: string | undefined;
    phoneContact!: string | undefined;
    emailContact!: string | undefined;
    website!: string | undefined;
    twitterHandler!: string | undefined;
    headquarters!: MemberGroupHeadquarterViewModel[];
    notificationEmails!: string | undefined;
    ownerEmail!: string | undefined;
    ownerId!: string;
    admins!: MemberListItemViewModel[];
    enterpriseAccountId!: string | undefined;
    bookingDelegates!: MemberListItemViewModel[];
    userType!: MemberGroupUserType;
    enableLiquidSpaceDesks!: boolean;
    enableLiquidSpacePro!: boolean;
    memberGroupType!: MemberGroupType;
    defaultCollectionIds!: string | undefined;
    suppressPromotionalEmails!: boolean;
    suppressInviteEmails!: boolean;
    emailDomains!: string | undefined;
    searchSettings!: { [key in keyof typeof SearchSettingsEnum]?: boolean; };
    extendedSearchOptions!: ExtendedSearchOptionsModel;
    requireApprovalBeforeFollow!: boolean;
    requirePrivateCalendarVisibility!: boolean;
    disableCCEntry!: boolean;
    defaultPromotionId!: string | undefined;
    promotions!: MemberGroupPromotionViewModel[];
    description!: string | undefined;
    brandedLogo!: PictureURLViewModel | undefined;
    crosssiteBrandingType!: CrosssiteBrandingType;
    disableRecurringReservations!: boolean;
    maxDailyBudget!: number | undefined;
    maxMonthlyBudget!: number | undefined;
    maxMonthlyMemberBudget!: number | undefined;
    headerMenuOptionsVisibility!: HeaderMenuOptions;
    leadTrackingMemberGroupId!: string | undefined;
    customCss!: string | undefined;
    portalOptions!: BrandedPortalOptionsModel;
    emailOptions!: BrandedEmailOptionsModel;
    brandedEmailLogo!: PictureURLViewModel | undefined;

    constructor(data?: IMemberGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneContact = _data["phoneContact"];
            this.emailContact = _data["emailContact"];
            this.website = _data["website"];
            this.twitterHandler = _data["twitterHandler"];
            if (Array.isArray(_data["headquarters"])) {
                this.headquarters = [] as any;
                for (let item of _data["headquarters"])
                    this.headquarters!.push(MemberGroupHeadquarterViewModel.fromJS(item));
            }
            this.notificationEmails = _data["notificationEmails"];
            this.ownerEmail = _data["ownerEmail"];
            this.ownerId = _data["ownerId"];
            if (Array.isArray(_data["admins"])) {
                this.admins = [] as any;
                for (let item of _data["admins"])
                    this.admins!.push(MemberListItemViewModel.fromJS(item));
            }
            this.enterpriseAccountId = _data["enterpriseAccountId"];
            if (Array.isArray(_data["bookingDelegates"])) {
                this.bookingDelegates = [] as any;
                for (let item of _data["bookingDelegates"])
                    this.bookingDelegates!.push(MemberListItemViewModel.fromJS(item));
            }
            this.userType = _data["userType"];
            this.enableLiquidSpaceDesks = _data["enableLiquidSpaceDesks"];
            this.enableLiquidSpacePro = _data["enableLiquidSpacePro"];
            this.memberGroupType = _data["memberGroupType"];
            this.defaultCollectionIds = _data["defaultCollectionIds"];
            this.suppressPromotionalEmails = _data["suppressPromotionalEmails"];
            this.suppressInviteEmails = _data["suppressInviteEmails"];
            this.emailDomains = _data["emailDomains"];
            if (_data["searchSettings"]) {
                this.searchSettings = {} as any;
                for (let key in _data["searchSettings"]) {
                    if (_data["searchSettings"].hasOwnProperty(key))
                        (<any>this.searchSettings)![key] = _data["searchSettings"][key];
                }
            }
            this.extendedSearchOptions = _data["extendedSearchOptions"] ? ExtendedSearchOptionsModel.fromJS(_data["extendedSearchOptions"]) : <any>undefined;
            this.requireApprovalBeforeFollow = _data["requireApprovalBeforeFollow"];
            this.requirePrivateCalendarVisibility = _data["requirePrivateCalendarVisibility"];
            this.disableCCEntry = _data["disableCCEntry"];
            this.defaultPromotionId = _data["defaultPromotionId"];
            if (Array.isArray(_data["promotions"])) {
                this.promotions = [] as any;
                for (let item of _data["promotions"])
                    this.promotions!.push(MemberGroupPromotionViewModel.fromJS(item));
            }
            this.description = _data["description"];
            this.brandedLogo = _data["brandedLogo"] ? PictureURLViewModel.fromJS(_data["brandedLogo"]) : <any>undefined;
            this.crosssiteBrandingType = _data["crosssiteBrandingType"];
            this.disableRecurringReservations = _data["disableRecurringReservations"];
            this.maxDailyBudget = _data["maxDailyBudget"];
            this.maxMonthlyBudget = _data["maxMonthlyBudget"];
            this.maxMonthlyMemberBudget = _data["maxMonthlyMemberBudget"];
            this.headerMenuOptionsVisibility = _data["headerMenuOptionsVisibility"];
            this.leadTrackingMemberGroupId = _data["leadTrackingMemberGroupId"];
            this.customCss = _data["customCss"];
            this.portalOptions = _data["portalOptions"] ? BrandedPortalOptionsModel.fromJS(_data["portalOptions"]) : <any>undefined;
            this.emailOptions = _data["emailOptions"] ? BrandedEmailOptionsModel.fromJS(_data["emailOptions"]) : <any>undefined;
            this.brandedEmailLogo = _data["brandedEmailLogo"] ? PictureURLViewModel.fromJS(_data["brandedEmailLogo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MemberGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneContact"] = this.phoneContact;
        data["emailContact"] = this.emailContact;
        data["website"] = this.website;
        data["twitterHandler"] = this.twitterHandler;
        if (Array.isArray(this.headquarters)) {
            data["headquarters"] = [];
            for (let item of this.headquarters)
                data["headquarters"].push(item.toJSON());
        }
        data["notificationEmails"] = this.notificationEmails;
        data["ownerEmail"] = this.ownerEmail;
        data["ownerId"] = this.ownerId;
        if (Array.isArray(this.admins)) {
            data["admins"] = [];
            for (let item of this.admins)
                data["admins"].push(item.toJSON());
        }
        data["enterpriseAccountId"] = this.enterpriseAccountId;
        if (Array.isArray(this.bookingDelegates)) {
            data["bookingDelegates"] = [];
            for (let item of this.bookingDelegates)
                data["bookingDelegates"].push(item.toJSON());
        }
        data["userType"] = this.userType;
        data["enableLiquidSpaceDesks"] = this.enableLiquidSpaceDesks;
        data["enableLiquidSpacePro"] = this.enableLiquidSpacePro;
        data["memberGroupType"] = this.memberGroupType;
        data["defaultCollectionIds"] = this.defaultCollectionIds;
        data["suppressPromotionalEmails"] = this.suppressPromotionalEmails;
        data["suppressInviteEmails"] = this.suppressInviteEmails;
        data["emailDomains"] = this.emailDomains;
        if (this.searchSettings) {
            data["searchSettings"] = {};
            for (let key in this.searchSettings) {
                if (this.searchSettings.hasOwnProperty(key))
                    (<any>data["searchSettings"])[key] = (<any>this.searchSettings)[key];
            }
        }
        data["extendedSearchOptions"] = this.extendedSearchOptions ? this.extendedSearchOptions.toJSON() : <any>undefined;
        data["requireApprovalBeforeFollow"] = this.requireApprovalBeforeFollow;
        data["requirePrivateCalendarVisibility"] = this.requirePrivateCalendarVisibility;
        data["disableCCEntry"] = this.disableCCEntry;
        data["defaultPromotionId"] = this.defaultPromotionId;
        if (Array.isArray(this.promotions)) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["brandedLogo"] = this.brandedLogo ? this.brandedLogo.toJSON() : <any>undefined;
        data["crosssiteBrandingType"] = this.crosssiteBrandingType;
        data["disableRecurringReservations"] = this.disableRecurringReservations;
        data["maxDailyBudget"] = this.maxDailyBudget;
        data["maxMonthlyBudget"] = this.maxMonthlyBudget;
        data["maxMonthlyMemberBudget"] = this.maxMonthlyMemberBudget;
        data["headerMenuOptionsVisibility"] = this.headerMenuOptionsVisibility;
        data["leadTrackingMemberGroupId"] = this.leadTrackingMemberGroupId;
        data["customCss"] = this.customCss;
        data["portalOptions"] = this.portalOptions ? this.portalOptions.toJSON() : <any>undefined;
        data["emailOptions"] = this.emailOptions ? this.emailOptions.toJSON() : <any>undefined;
        data["brandedEmailLogo"] = this.brandedEmailLogo ? this.brandedEmailLogo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMemberGroupViewModel {
    id: string;
    name: string | undefined;
    phoneContact: string | undefined;
    emailContact: string | undefined;
    website: string | undefined;
    twitterHandler: string | undefined;
    headquarters: MemberGroupHeadquarterViewModel[];
    notificationEmails: string | undefined;
    ownerEmail: string | undefined;
    ownerId: string;
    admins: MemberListItemViewModel[];
    enterpriseAccountId: string | undefined;
    bookingDelegates: MemberListItemViewModel[];
    userType: MemberGroupUserType;
    enableLiquidSpaceDesks: boolean;
    enableLiquidSpacePro: boolean;
    memberGroupType: MemberGroupType;
    defaultCollectionIds: string | undefined;
    suppressPromotionalEmails: boolean;
    suppressInviteEmails: boolean;
    emailDomains: string | undefined;
    searchSettings: { [key in keyof typeof SearchSettingsEnum]?: boolean; };
    extendedSearchOptions: ExtendedSearchOptionsModel;
    requireApprovalBeforeFollow: boolean;
    requirePrivateCalendarVisibility: boolean;
    disableCCEntry: boolean;
    defaultPromotionId: string | undefined;
    promotions: MemberGroupPromotionViewModel[];
    description: string | undefined;
    brandedLogo: PictureURLViewModel | undefined;
    crosssiteBrandingType: CrosssiteBrandingType;
    disableRecurringReservations: boolean;
    maxDailyBudget: number | undefined;
    maxMonthlyBudget: number | undefined;
    maxMonthlyMemberBudget: number | undefined;
    headerMenuOptionsVisibility: HeaderMenuOptions;
    leadTrackingMemberGroupId: string | undefined;
    customCss: string | undefined;
    portalOptions: BrandedPortalOptionsModel;
    emailOptions: BrandedEmailOptionsModel;
    brandedEmailLogo: PictureURLViewModel | undefined;
}

export class MemberGroupHeadquarterViewModel implements IMemberGroupHeadquarterViewModel {
    id!: string;
    memberGroupId!: string;
    venueId!: string;
    venueGroupId!: string;
    address!: string | undefined;
    title!: string | undefined;
    venueName!: string | undefined;
    venueGroupName!: string | undefined;

    constructor(data?: IMemberGroupHeadquarterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberGroupId = _data["memberGroupId"];
            this.venueId = _data["venueId"];
            this.venueGroupId = _data["venueGroupId"];
            this.address = _data["address"];
            this.title = _data["title"];
            this.venueName = _data["venueName"];
            this.venueGroupName = _data["venueGroupName"];
        }
    }

    static fromJS(data: any): MemberGroupHeadquarterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberGroupHeadquarterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberGroupId"] = this.memberGroupId;
        data["venueId"] = this.venueId;
        data["venueGroupId"] = this.venueGroupId;
        data["address"] = this.address;
        data["title"] = this.title;
        data["venueName"] = this.venueName;
        data["venueGroupName"] = this.venueGroupName;
        return data;
    }
}

export interface IMemberGroupHeadquarterViewModel {
    id: string;
    memberGroupId: string;
    venueId: string;
    venueGroupId: string;
    address: string | undefined;
    title: string | undefined;
    venueName: string | undefined;
    venueGroupName: string | undefined;
}

/** 0 = Guest 1 = AffiliateUser */
export enum MemberGroupUserType {
    Guest = 0,
    AffiliateUser = 1,
}

/** 0 = Corporate 1 = Promotion 2 = Venue 3 = Event 4 = Mobility */
export enum MemberGroupType {
    Corporate = 0,
    Promotion = 1,
    Venue = 2,
    Event = 3,
    Mobility = 4,
}

export class MemberGroupPromotionViewModel implements IMemberGroupPromotionViewModel {
    id!: string;
    name!: string | undefined;
    discountTypeString!: string | undefined;
    discountAmount!: number;

    constructor(data?: IMemberGroupPromotionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.discountTypeString = _data["discountTypeString"];
            this.discountAmount = _data["discountAmount"];
        }
    }

    static fromJS(data: any): MemberGroupPromotionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberGroupPromotionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["discountTypeString"] = this.discountTypeString;
        data["discountAmount"] = this.discountAmount;
        return data;
    }
}

export interface IMemberGroupPromotionViewModel {
    id: string;
    name: string | undefined;
    discountTypeString: string | undefined;
    discountAmount: number;
}

/** 0 = None 1 = Sessional 2 = OnLogin */
export enum CrosssiteBrandingType {
    None = 0,
    Sessional = 1,
    OnLogin = 2,
}

/** 0 = None 1 = FindSpace 2 = ListSpace 4 = Enterprise 8 = Help 16 = Join 268435455 = All */
export enum HeaderMenuOptions {
    None = 0,
    FindSpace = 1,
    ListSpace = 2,
    Enterprise = 4,
    Help = 8,
    Join = 16,
    All = 268435455,
}

export class MemberGroupListViewModel implements IMemberGroupListViewModel {
    id!: string;
    name!: string;
    enterpriseAccountId!: string | undefined;
    enterpriseAccountName!: string | undefined;
    isEnterpriseAccountDeleted!: boolean | undefined;
    memberCount!: number;

    constructor(data?: IMemberGroupListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enterpriseAccountId = _data["enterpriseAccountId"];
            this.enterpriseAccountName = _data["enterpriseAccountName"];
            this.isEnterpriseAccountDeleted = _data["isEnterpriseAccountDeleted"];
            this.memberCount = _data["memberCount"];
        }
    }

    static fromJS(data: any): MemberGroupListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberGroupListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enterpriseAccountId"] = this.enterpriseAccountId;
        data["enterpriseAccountName"] = this.enterpriseAccountName;
        data["isEnterpriseAccountDeleted"] = this.isEnterpriseAccountDeleted;
        data["memberCount"] = this.memberCount;
        return data;
    }
}

export interface IMemberGroupListViewModel {
    id: string;
    name: string;
    enterpriseAccountId: string | undefined;
    enterpriseAccountName: string | undefined;
    isEnterpriseAccountDeleted: boolean | undefined;
    memberCount: number;
}

export class ManageMemberGroupInvitationPreviewEmailViewModel implements IManageMemberGroupInvitationPreviewEmailViewModel {
    message!: string | undefined;
    fName!: string | undefined;
    lName!: string | undefined;

    constructor(data?: IManageMemberGroupInvitationPreviewEmailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.fName = _data["fName"];
            this.lName = _data["lName"];
        }
    }

    static fromJS(data: any): ManageMemberGroupInvitationPreviewEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManageMemberGroupInvitationPreviewEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["fName"] = this.fName;
        data["lName"] = this.lName;
        return data;
    }
}

export interface IManageMemberGroupInvitationPreviewEmailViewModel {
    message: string | undefined;
    fName: string | undefined;
    lName: string | undefined;
}

export class MarketplaceAccount implements IMarketplaceAccount {
    payableKey!: PayableKey;
    name!: string;
    paymentTerm!: PaymentTerm;
    invoiceStatus!: InvoiceGenerationStatus;
    targetBalance!: number;
    debit!: number;
    credit!: number;
    nextInvoiceDate!: string | undefined;

    constructor(data?: IMarketplaceAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.payableKey = _data["payableKey"] ? PayableKey.fromJS(_data["payableKey"]) : <any>undefined;
            this.name = _data["name"];
            this.paymentTerm = _data["paymentTerm"];
            this.invoiceStatus = _data["invoiceStatus"];
            this.targetBalance = _data["targetBalance"];
            this.debit = _data["debit"];
            this.credit = _data["credit"];
            this.nextInvoiceDate = _data["nextInvoiceDate"];
        }
    }

    static fromJS(data: any): MarketplaceAccount {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payableKey"] = this.payableKey ? this.payableKey.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["paymentTerm"] = this.paymentTerm;
        data["invoiceStatus"] = this.invoiceStatus;
        data["targetBalance"] = this.targetBalance;
        data["debit"] = this.debit;
        data["credit"] = this.credit;
        data["nextInvoiceDate"] = this.nextInvoiceDate;
        return data;
    }
}

export interface IMarketplaceAccount {
    payableKey: PayableKey;
    name: string;
    paymentTerm: PaymentTerm;
    invoiceStatus: InvoiceGenerationStatus;
    targetBalance: number;
    debit: number;
    credit: number;
    nextInvoiceDate: string | undefined;
}

export class MarketplaceTransaction implements IMarketplaceTransaction {
    id!: string;
    customerProfileId!: string;
    paymentProfileId!: string;
    createDate!: string;
    parentId!: string | undefined;
    reservationId!: string | undefined;
    amountInfo!: CostInfo;
    isCredit!: boolean;

    constructor(data?: IMarketplaceTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerProfileId = _data["customerProfileId"];
            this.paymentProfileId = _data["paymentProfileId"];
            this.createDate = _data["createDate"];
            this.parentId = _data["parentId"];
            this.reservationId = _data["reservationId"];
            this.amountInfo = _data["amountInfo"] ? CostInfo.fromJS(_data["amountInfo"]) : <any>undefined;
            this.isCredit = _data["isCredit"];
        }
    }

    static fromJS(data: any): MarketplaceTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerProfileId"] = this.customerProfileId;
        data["paymentProfileId"] = this.paymentProfileId;
        data["createDate"] = this.createDate;
        data["parentId"] = this.parentId;
        data["reservationId"] = this.reservationId;
        data["amountInfo"] = this.amountInfo ? this.amountInfo.toJSON() : <any>undefined;
        data["isCredit"] = this.isCredit;
        return data;
    }
}

export interface IMarketplaceTransaction {
    id: string;
    customerProfileId: string;
    paymentProfileId: string;
    createDate: string;
    parentId: string | undefined;
    reservationId: string | undefined;
    amountInfo: CostInfo;
    isCredit: boolean;
}

export class MarketplaceTransactionWithStartDate implements IMarketplaceTransactionWithStartDate {
    transaction!: MarketplaceTransaction;
    /** Reservation start date in Venue Time Zone */
    startDate!: string | undefined;

    constructor(data?: IMarketplaceTransactionWithStartDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.transaction = _data["transaction"] ? MarketplaceTransaction.fromJS(_data["transaction"]) : <any>undefined;
            this.startDate = _data["startDate"];
        }
    }

    static fromJS(data: any): MarketplaceTransactionWithStartDate {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceTransactionWithStartDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["startDate"] = this.startDate;
        return data;
    }
}

export interface IMarketplaceTransactionWithStartDate {
    transaction: MarketplaceTransaction;
    /** Reservation start date in Venue Time Zone */
    startDate: string | undefined;
}

export class MarketplaceInvoice implements IMarketplaceInvoice {
    id!: string;
    invoiceNumber!: string | undefined;
    sendDate!: string | undefined;
    dueDate!: string | undefined;
    billingDate!: string;
    status!: InvoiceStatus;
    amount!: number;
    items!: MarketplaceInvoiceItem[];
    invoiceUrl!: string | undefined;
    autoGenerated!: boolean;

    constructor(data?: IMarketplaceInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.sendDate = _data["sendDate"];
            this.dueDate = _data["dueDate"];
            this.billingDate = _data["billingDate"];
            this.status = _data["status"];
            this.amount = _data["amount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MarketplaceInvoiceItem.fromJS(item));
            }
            this.invoiceUrl = _data["invoiceUrl"];
            this.autoGenerated = _data["autoGenerated"];
        }
    }

    static fromJS(data: any): MarketplaceInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["sendDate"] = this.sendDate;
        data["dueDate"] = this.dueDate;
        data["billingDate"] = this.billingDate;
        data["status"] = this.status;
        data["amount"] = this.amount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["invoiceUrl"] = this.invoiceUrl;
        data["autoGenerated"] = this.autoGenerated;
        return data;
    }
}

export interface IMarketplaceInvoice {
    id: string;
    invoiceNumber: string | undefined;
    sendDate: string | undefined;
    dueDate: string | undefined;
    billingDate: string;
    status: InvoiceStatus;
    amount: number;
    items: MarketplaceInvoiceItem[];
    invoiceUrl: string | undefined;
    autoGenerated: boolean;
}

/** 0 = Unknown 1 = Scheduled 2 = Draft 3 = Open 4 = Overdue 5 = Paid 6 = Void 7 = ProcessingError */
export enum InvoiceStatus {
    Unknown = 0,
    Scheduled = 1,
    Draft = 2,
    Open = 3,
    Overdue = 4,
    Paid = 5,
    Void = 6,
    ProcessingError = 7,
}

export class MarketplaceInvoiceItem implements IMarketplaceInvoiceItem {
    description!: string | undefined;
    amount!: number;

    constructor(data?: IMarketplaceInvoiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): MarketplaceInvoiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceInvoiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IMarketplaceInvoiceItem {
    description: string | undefined;
    amount: number;
}

export class AddMarketplaceInvoiceRequest implements IAddMarketplaceInvoiceRequest {
    invoiceId!: string;
    periodDate!: string;

    constructor(data?: IAddMarketplaceInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.periodDate = _data["periodDate"];
        }
    }

    static fromJS(data: any): AddMarketplaceInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMarketplaceInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["periodDate"] = this.periodDate;
        return data;
    }
}

export interface IAddMarketplaceInvoiceRequest {
    invoiceId: string;
    periodDate: string;
}

export class VenueSelectorListItem implements IVenueSelectorListItem {
    id!: string;
    name!: string;
    status!: VenueStatusNew;
    openStatus!: VenueOpenStatus;
    icon!: string | undefined;
    imageUrl!: string | undefined;
    vlpUrl!: string;
    address!: string;

    constructor(data?: IVenueSelectorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.openStatus = _data["openStatus"];
            this.icon = _data["icon"];
            this.imageUrl = _data["imageUrl"];
            this.vlpUrl = _data["vlpUrl"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): VenueSelectorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new VenueSelectorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["openStatus"] = this.openStatus;
        data["icon"] = this.icon;
        data["imageUrl"] = this.imageUrl;
        data["vlpUrl"] = this.vlpUrl;
        data["address"] = this.address;
        return data;
    }
}

export interface IVenueSelectorListItem {
    id: string;
    name: string;
    status: VenueStatusNew;
    openStatus: VenueOpenStatus;
    icon: string | undefined;
    imageUrl: string | undefined;
    vlpUrl: string;
    address: string;
}

/** 0 = Unconfirmed 1 = Open 2 = Limited 3 = Closed */
export enum VenueOpenStatus {
    Unconfirmed = 0,
    Open = 1,
    Limited = 2,
    Closed = 3,
}

export class VenueBrief extends VenueSelectorListItem implements IVenueBrief {
    isVenueBrief!: boolean;
    workspaces!: WorkspaceBrief[];
    userIsCalendarAdmin!: boolean;
    userIsAdminOrOwner!: boolean;
    enableWorkspaceAnalytics!: boolean;
    hasVenueReservations!: boolean;
    isSettingsDisabled!: boolean;
    isReferralDisabled!: boolean;
    liquidSpaceProStatus!: LiquidSpaceProStatus;
    venueBasicListingCompleted!: boolean;
    workspaceBasicListingCompleted!: boolean;
    integrationOption!: string;
    hasIntegration!: boolean;
    hasRegusIntegration!: boolean;
    hasDeskimoIntegration!: boolean;
    isOnlinePaymentSupported!: boolean;
    isInternational!: boolean;
    availableWorkspaceStatuses!: WorkspaceStatus[];
    licenseVersion!: LicenseVersion;

    constructor(data?: IVenueBrief) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isVenueBrief = _data["isVenueBrief"];
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(WorkspaceBrief.fromJS(item));
            }
            this.userIsCalendarAdmin = _data["userIsCalendarAdmin"];
            this.userIsAdminOrOwner = _data["userIsAdminOrOwner"];
            this.enableWorkspaceAnalytics = _data["enableWorkspaceAnalytics"];
            this.hasVenueReservations = _data["hasVenueReservations"];
            this.isSettingsDisabled = _data["isSettingsDisabled"];
            this.isReferralDisabled = _data["isReferralDisabled"];
            this.liquidSpaceProStatus = _data["liquidSpaceProStatus"];
            this.venueBasicListingCompleted = _data["venueBasicListingCompleted"];
            this.workspaceBasicListingCompleted = _data["workspaceBasicListingCompleted"];
            this.integrationOption = _data["integrationOption"];
            this.hasIntegration = _data["hasIntegration"];
            this.hasRegusIntegration = _data["hasRegusIntegration"];
            this.hasDeskimoIntegration = _data["hasDeskimoIntegration"];
            this.isOnlinePaymentSupported = _data["isOnlinePaymentSupported"];
            this.isInternational = _data["isInternational"];
            if (Array.isArray(_data["availableWorkspaceStatuses"])) {
                this.availableWorkspaceStatuses = [] as any;
                for (let item of _data["availableWorkspaceStatuses"])
                    this.availableWorkspaceStatuses!.push(item);
            }
            this.licenseVersion = _data["licenseVersion"];
        }
    }

    static fromJS(data: any): VenueBrief {
        data = typeof data === 'object' ? data : {};
        let result = new VenueBrief();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVenueBrief"] = this.isVenueBrief;
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        data["userIsCalendarAdmin"] = this.userIsCalendarAdmin;
        data["userIsAdminOrOwner"] = this.userIsAdminOrOwner;
        data["enableWorkspaceAnalytics"] = this.enableWorkspaceAnalytics;
        data["hasVenueReservations"] = this.hasVenueReservations;
        data["isSettingsDisabled"] = this.isSettingsDisabled;
        data["isReferralDisabled"] = this.isReferralDisabled;
        data["liquidSpaceProStatus"] = this.liquidSpaceProStatus;
        data["venueBasicListingCompleted"] = this.venueBasicListingCompleted;
        data["workspaceBasicListingCompleted"] = this.workspaceBasicListingCompleted;
        data["integrationOption"] = this.integrationOption;
        data["hasIntegration"] = this.hasIntegration;
        data["hasRegusIntegration"] = this.hasRegusIntegration;
        data["hasDeskimoIntegration"] = this.hasDeskimoIntegration;
        data["isOnlinePaymentSupported"] = this.isOnlinePaymentSupported;
        data["isInternational"] = this.isInternational;
        if (Array.isArray(this.availableWorkspaceStatuses)) {
            data["availableWorkspaceStatuses"] = [];
            for (let item of this.availableWorkspaceStatuses)
                data["availableWorkspaceStatuses"].push(item);
        }
        data["licenseVersion"] = this.licenseVersion;
        super.toJSON(data);
        return data;
    }
}

export interface IVenueBrief extends IVenueSelectorListItem {
    isVenueBrief: boolean;
    workspaces: WorkspaceBrief[];
    userIsCalendarAdmin: boolean;
    userIsAdminOrOwner: boolean;
    enableWorkspaceAnalytics: boolean;
    hasVenueReservations: boolean;
    isSettingsDisabled: boolean;
    isReferralDisabled: boolean;
    liquidSpaceProStatus: LiquidSpaceProStatus;
    venueBasicListingCompleted: boolean;
    workspaceBasicListingCompleted: boolean;
    integrationOption: string;
    hasIntegration: boolean;
    hasRegusIntegration: boolean;
    hasDeskimoIntegration: boolean;
    isOnlinePaymentSupported: boolean;
    isInternational: boolean;
    availableWorkspaceStatuses: WorkspaceStatus[];
    licenseVersion: LicenseVersion;
}

export class WorkspaceBrief implements IWorkspaceBrief {
    id!: string;
    name!: string;

    constructor(data?: IWorkspaceBrief) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WorkspaceBrief {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceBrief();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWorkspaceBrief {
    id: string;
    name: string;
}

/** 0 = None 1 = Invited 2 = Pending 3 = Enabled 4 = Disabled */
export enum LiquidSpaceProStatus {
    None = 0,
    Invited = 1,
    Pending = 2,
    Enabled = 3,
    Disabled = 4,
}

/** 0 = Dash1 1 = Dash2 */
export enum LicenseVersion {
    Dash1 = 0,
    Dash2 = 1,
}

export class IntegrationOptionRequest implements IIntegrationOptionRequest {
    name!: string;
    isOtherOption!: boolean;
    supportArticleLink!: string | undefined;

    constructor(data?: IIntegrationOptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isOtherOption = _data["isOtherOption"];
            this.supportArticleLink = _data["supportArticleLink"];
        }
    }

    static fromJS(data: any): IntegrationOptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationOptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isOtherOption"] = this.isOtherOption;
        data["supportArticleLink"] = this.supportArticleLink;
        return data;
    }
}

export interface IIntegrationOptionRequest {
    name: string;
    isOtherOption: boolean;
    supportArticleLink: string | undefined;
}

export class VenueSettingsModel implements IVenueSettingsModel {
    id!: string;
    fullName!: string;
    description!: string | undefined;
    phoneNumber!: string | undefined;
    simpleAddress1!: string | undefined;
    simpleAddress2!: string | undefined;
    city!: string | undefined;
    zip!: string | undefined;
    state!: string | undefined;
    country!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    venueHostGuid!: string;
    streetViewParameters!: StreetViewModel;
    percentageTax!: number | undefined;
    fixedAmountTax!: number | undefined;
    taxApplyType!: VenueTaxApplyType;
    applyTaxToIncidentals!: boolean;
    billingContact!: BillingContactModel;
    hours!: HoursViewModel;
    statusNew!: VenueStatusNew;
    defaultBookingMethod!: BookingMethod;
    defaultBookingMethodHourly!: BookingMethod;
    timeZoneId!: string | undefined;
    licenseVersion!: LicenseVersion;
    enableElectronicSignatures!: boolean;
    seoTitle!: string | undefined;
    seoDescription!: string | undefined;
    inSetupDate!: string | undefined;
    launchedDate!: string | undefined;
    publishedDate!: string | undefined;
    claimSentDate!: string | undefined;
    claimSentFollowupDate!: string | undefined;
    retiredDate!: string | undefined;
    professionalPhotoRank!: PhotoRankEnum;
    professionalPhotoDate!: string | undefined;
    source!: VenueSource;
    classification!: VenueClassification;
    rank!: VenueRank;
    currency!: CurrencyType;
    venueNameSynonymsString!: string | undefined;
    vlpUrlSlug!: string | undefined;
    accountId!: string | undefined;
    enableHostReferral!: boolean;
    referralEmail!: string | undefined;
    proposalCreditsTotalAmount!: number;
    enableWorkspaceAnalytics!: boolean;
    liquidSpaceProStatus!: LiquidSpaceProStatus;
    enableMembership!: boolean;
    enableLeadXMLAttachments!: boolean;
    leadDadiAccountID!: string | undefined;
    externalPropertyId!: string | undefined;
    gCalEndpoint!: GCalEndpoint;
    exchangeUserName!: string | undefined;
    exchangeUserPass!: string | undefined;
    exchangeAddress!: string | undefined;
    exchangeEndpoint!: ExchangeEndpoint;
    ownerIdForExchangeSourcedReservations!: string;
    morningStarURL!: string | undefined;
    morningStarIntegrationUser!: string | undefined;
    morningStarIntegrationPassword!: string | undefined;
    morningStarClientId!: string | undefined;
    morningStarLocationId!: string | undefined;
    morningStarVisaId!: string | undefined;
    morningStarDontSendInvitationEmail!: boolean;
    rjMetisVenueId!: string | undefined;
    rjMetisReservationsOwnerId!: string;
    rjMetisVisaId!: string;
    rjMetisSyncTenants!: boolean;
    evoApiConnectionId!: string;
    ownerIdForIOSourcedReservations!: string;
    ioCenterId!: string | undefined;
    evoClientId!: string | undefined;
    enableMemberClientId!: boolean;
    officeRnDOrganizationId!: string;
    officeRnDOfficeId!: string | undefined;
    officeRnDWebhookSecret!: string | undefined;
    ownerIdForOfficeRnDSourcedReservations!: string;
    officeRnDTeamForLiquidspaceSourcedReservations!: string | undefined;
    officeRnDOwnerForLiquidspaceSourcedReservations!: string | undefined;
    ownerIdForMSGraphSourcedReservations!: string;
    msGraphId!: string | undefined;
    msGraphEmail!: string | undefined;
    deskimoMarketCode!: string | undefined;
    deskimoPropertyReference!: string | undefined;
    ownerIdForDeskimoSourcedReservations!: string | undefined;
    hasIntegration!: boolean;
    venueHasExchangeIntegration!: boolean;
    weWorkIndiaBuildingId!: string | undefined;
    pictureURLs!: PictureURLViewModel[];
    amenities!: VenueAmenitiesModel;
    openStatus!: VenueOpenStatus;
    created!: string;
    claimProfileLink!: string;
    integrationOption!: string | undefined;
    vlpUrl!: string | undefined;
    customLicensePdfTemplate!: string | undefined;

    constructor(data?: IVenueSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.description = _data["description"];
            this.phoneNumber = _data["phoneNumber"];
            this.simpleAddress1 = _data["simpleAddress1"];
            this.simpleAddress2 = _data["simpleAddress2"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.venueHostGuid = _data["venueHostGuid"];
            this.streetViewParameters = _data["streetViewParameters"] ? StreetViewModel.fromJS(_data["streetViewParameters"]) : <any>undefined;
            this.percentageTax = _data["percentageTax"];
            this.fixedAmountTax = _data["fixedAmountTax"];
            this.taxApplyType = _data["taxApplyType"];
            this.applyTaxToIncidentals = _data["applyTaxToIncidentals"];
            this.billingContact = _data["billingContact"] ? BillingContactModel.fromJS(_data["billingContact"]) : <any>undefined;
            this.hours = _data["hours"] ? HoursViewModel.fromJS(_data["hours"]) : <any>undefined;
            this.statusNew = _data["statusNew"];
            this.defaultBookingMethod = _data["defaultBookingMethod"];
            this.defaultBookingMethodHourly = _data["defaultBookingMethodHourly"];
            this.timeZoneId = _data["timeZoneId"];
            this.licenseVersion = _data["licenseVersion"];
            this.enableElectronicSignatures = _data["enableElectronicSignatures"];
            this.seoTitle = _data["seoTitle"];
            this.seoDescription = _data["seoDescription"];
            this.inSetupDate = _data["inSetupDate"];
            this.launchedDate = _data["launchedDate"];
            this.publishedDate = _data["publishedDate"];
            this.claimSentDate = _data["claimSentDate"];
            this.claimSentFollowupDate = _data["claimSentFollowupDate"];
            this.retiredDate = _data["retiredDate"];
            this.professionalPhotoRank = _data["professionalPhotoRank"];
            this.professionalPhotoDate = _data["professionalPhotoDate"];
            this.source = _data["source"];
            this.classification = _data["classification"];
            this.rank = _data["rank"];
            this.currency = _data["currency"];
            this.venueNameSynonymsString = _data["venueNameSynonymsString"];
            this.vlpUrlSlug = _data["vlpUrlSlug"];
            this.accountId = _data["accountId"];
            this.enableHostReferral = _data["enableHostReferral"];
            this.referralEmail = _data["referralEmail"];
            this.proposalCreditsTotalAmount = _data["proposalCreditsTotalAmount"];
            this.enableWorkspaceAnalytics = _data["enableWorkspaceAnalytics"];
            this.liquidSpaceProStatus = _data["liquidSpaceProStatus"];
            this.enableMembership = _data["enableMembership"];
            this.enableLeadXMLAttachments = _data["enableLeadXMLAttachments"];
            this.leadDadiAccountID = _data["leadDadiAccountID"];
            this.externalPropertyId = _data["externalPropertyId"];
            this.gCalEndpoint = _data["gCalEndpoint"];
            this.exchangeUserName = _data["exchangeUserName"];
            this.exchangeUserPass = _data["exchangeUserPass"];
            this.exchangeAddress = _data["exchangeAddress"];
            this.exchangeEndpoint = _data["exchangeEndpoint"];
            this.ownerIdForExchangeSourcedReservations = _data["ownerIdForExchangeSourcedReservations"];
            this.morningStarURL = _data["morningStarURL"];
            this.morningStarIntegrationUser = _data["morningStarIntegrationUser"];
            this.morningStarIntegrationPassword = _data["morningStarIntegrationPassword"];
            this.morningStarClientId = _data["morningStarClientId"];
            this.morningStarLocationId = _data["morningStarLocationId"];
            this.morningStarVisaId = _data["morningStarVisaId"];
            this.morningStarDontSendInvitationEmail = _data["morningStarDontSendInvitationEmail"];
            this.rjMetisVenueId = _data["rjMetisVenueId"];
            this.rjMetisReservationsOwnerId = _data["rjMetisReservationsOwnerId"];
            this.rjMetisVisaId = _data["rjMetisVisaId"];
            this.rjMetisSyncTenants = _data["rjMetisSyncTenants"];
            this.evoApiConnectionId = _data["evoApiConnectionId"];
            this.ownerIdForIOSourcedReservations = _data["ownerIdForIOSourcedReservations"];
            this.ioCenterId = _data["ioCenterId"];
            this.evoClientId = _data["evoClientId"];
            this.enableMemberClientId = _data["enableMemberClientId"];
            this.officeRnDOrganizationId = _data["officeRnDOrganizationId"];
            this.officeRnDOfficeId = _data["officeRnDOfficeId"];
            this.officeRnDWebhookSecret = _data["officeRnDWebhookSecret"];
            this.ownerIdForOfficeRnDSourcedReservations = _data["ownerIdForOfficeRnDSourcedReservations"];
            this.officeRnDTeamForLiquidspaceSourcedReservations = _data["officeRnDTeamForLiquidspaceSourcedReservations"];
            this.officeRnDOwnerForLiquidspaceSourcedReservations = _data["officeRnDOwnerForLiquidspaceSourcedReservations"];
            this.ownerIdForMSGraphSourcedReservations = _data["ownerIdForMSGraphSourcedReservations"];
            this.msGraphId = _data["msGraphId"];
            this.msGraphEmail = _data["msGraphEmail"];
            this.deskimoMarketCode = _data["deskimoMarketCode"];
            this.deskimoPropertyReference = _data["deskimoPropertyReference"];
            this.ownerIdForDeskimoSourcedReservations = _data["ownerIdForDeskimoSourcedReservations"];
            this.hasIntegration = _data["hasIntegration"];
            this.venueHasExchangeIntegration = _data["venueHasExchangeIntegration"];
            this.weWorkIndiaBuildingId = _data["weWorkIndiaBuildingId"];
            if (Array.isArray(_data["pictureURLs"])) {
                this.pictureURLs = [] as any;
                for (let item of _data["pictureURLs"])
                    this.pictureURLs!.push(PictureURLViewModel.fromJS(item));
            }
            this.amenities = _data["amenities"] ? VenueAmenitiesModel.fromJS(_data["amenities"]) : <any>undefined;
            this.openStatus = _data["openStatus"];
            this.created = _data["created"];
            this.claimProfileLink = _data["claimProfileLink"];
            this.integrationOption = _data["integrationOption"];
            this.vlpUrl = _data["vlpUrl"];
            this.customLicensePdfTemplate = _data["customLicensePdfTemplate"];
        }
    }

    static fromJS(data: any): VenueSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["description"] = this.description;
        data["phoneNumber"] = this.phoneNumber;
        data["simpleAddress1"] = this.simpleAddress1;
        data["simpleAddress2"] = this.simpleAddress2;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["state"] = this.state;
        data["country"] = this.country;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["venueHostGuid"] = this.venueHostGuid;
        data["streetViewParameters"] = this.streetViewParameters ? this.streetViewParameters.toJSON() : <any>undefined;
        data["percentageTax"] = this.percentageTax;
        data["fixedAmountTax"] = this.fixedAmountTax;
        data["taxApplyType"] = this.taxApplyType;
        data["applyTaxToIncidentals"] = this.applyTaxToIncidentals;
        data["billingContact"] = this.billingContact ? this.billingContact.toJSON() : <any>undefined;
        data["hours"] = this.hours ? this.hours.toJSON() : <any>undefined;
        data["statusNew"] = this.statusNew;
        data["defaultBookingMethod"] = this.defaultBookingMethod;
        data["defaultBookingMethodHourly"] = this.defaultBookingMethodHourly;
        data["timeZoneId"] = this.timeZoneId;
        data["licenseVersion"] = this.licenseVersion;
        data["enableElectronicSignatures"] = this.enableElectronicSignatures;
        data["seoTitle"] = this.seoTitle;
        data["seoDescription"] = this.seoDescription;
        data["inSetupDate"] = this.inSetupDate;
        data["launchedDate"] = this.launchedDate;
        data["publishedDate"] = this.publishedDate;
        data["claimSentDate"] = this.claimSentDate;
        data["claimSentFollowupDate"] = this.claimSentFollowupDate;
        data["retiredDate"] = this.retiredDate;
        data["professionalPhotoRank"] = this.professionalPhotoRank;
        data["professionalPhotoDate"] = this.professionalPhotoDate;
        data["source"] = this.source;
        data["classification"] = this.classification;
        data["rank"] = this.rank;
        data["currency"] = this.currency;
        data["venueNameSynonymsString"] = this.venueNameSynonymsString;
        data["vlpUrlSlug"] = this.vlpUrlSlug;
        data["accountId"] = this.accountId;
        data["enableHostReferral"] = this.enableHostReferral;
        data["referralEmail"] = this.referralEmail;
        data["proposalCreditsTotalAmount"] = this.proposalCreditsTotalAmount;
        data["enableWorkspaceAnalytics"] = this.enableWorkspaceAnalytics;
        data["liquidSpaceProStatus"] = this.liquidSpaceProStatus;
        data["enableMembership"] = this.enableMembership;
        data["enableLeadXMLAttachments"] = this.enableLeadXMLAttachments;
        data["leadDadiAccountID"] = this.leadDadiAccountID;
        data["externalPropertyId"] = this.externalPropertyId;
        data["gCalEndpoint"] = this.gCalEndpoint;
        data["exchangeUserName"] = this.exchangeUserName;
        data["exchangeUserPass"] = this.exchangeUserPass;
        data["exchangeAddress"] = this.exchangeAddress;
        data["exchangeEndpoint"] = this.exchangeEndpoint;
        data["ownerIdForExchangeSourcedReservations"] = this.ownerIdForExchangeSourcedReservations;
        data["morningStarURL"] = this.morningStarURL;
        data["morningStarIntegrationUser"] = this.morningStarIntegrationUser;
        data["morningStarIntegrationPassword"] = this.morningStarIntegrationPassword;
        data["morningStarClientId"] = this.morningStarClientId;
        data["morningStarLocationId"] = this.morningStarLocationId;
        data["morningStarVisaId"] = this.morningStarVisaId;
        data["morningStarDontSendInvitationEmail"] = this.morningStarDontSendInvitationEmail;
        data["rjMetisVenueId"] = this.rjMetisVenueId;
        data["rjMetisReservationsOwnerId"] = this.rjMetisReservationsOwnerId;
        data["rjMetisVisaId"] = this.rjMetisVisaId;
        data["rjMetisSyncTenants"] = this.rjMetisSyncTenants;
        data["evoApiConnectionId"] = this.evoApiConnectionId;
        data["ownerIdForIOSourcedReservations"] = this.ownerIdForIOSourcedReservations;
        data["ioCenterId"] = this.ioCenterId;
        data["evoClientId"] = this.evoClientId;
        data["enableMemberClientId"] = this.enableMemberClientId;
        data["officeRnDOrganizationId"] = this.officeRnDOrganizationId;
        data["officeRnDOfficeId"] = this.officeRnDOfficeId;
        data["officeRnDWebhookSecret"] = this.officeRnDWebhookSecret;
        data["ownerIdForOfficeRnDSourcedReservations"] = this.ownerIdForOfficeRnDSourcedReservations;
        data["officeRnDTeamForLiquidspaceSourcedReservations"] = this.officeRnDTeamForLiquidspaceSourcedReservations;
        data["officeRnDOwnerForLiquidspaceSourcedReservations"] = this.officeRnDOwnerForLiquidspaceSourcedReservations;
        data["ownerIdForMSGraphSourcedReservations"] = this.ownerIdForMSGraphSourcedReservations;
        data["msGraphId"] = this.msGraphId;
        data["msGraphEmail"] = this.msGraphEmail;
        data["deskimoMarketCode"] = this.deskimoMarketCode;
        data["deskimoPropertyReference"] = this.deskimoPropertyReference;
        data["ownerIdForDeskimoSourcedReservations"] = this.ownerIdForDeskimoSourcedReservations;
        data["hasIntegration"] = this.hasIntegration;
        data["venueHasExchangeIntegration"] = this.venueHasExchangeIntegration;
        data["weWorkIndiaBuildingId"] = this.weWorkIndiaBuildingId;
        if (Array.isArray(this.pictureURLs)) {
            data["pictureURLs"] = [];
            for (let item of this.pictureURLs)
                data["pictureURLs"].push(item.toJSON());
        }
        data["amenities"] = this.amenities ? this.amenities.toJSON() : <any>undefined;
        data["openStatus"] = this.openStatus;
        data["created"] = this.created;
        data["claimProfileLink"] = this.claimProfileLink;
        data["integrationOption"] = this.integrationOption;
        data["vlpUrl"] = this.vlpUrl;
        data["customLicensePdfTemplate"] = this.customLicensePdfTemplate;
        return data;
    }
}

export interface IVenueSettingsModel {
    id: string;
    fullName: string;
    description: string | undefined;
    phoneNumber: string | undefined;
    simpleAddress1: string | undefined;
    simpleAddress2: string | undefined;
    city: string | undefined;
    zip: string | undefined;
    state: string | undefined;
    country: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    venueHostGuid: string;
    streetViewParameters: StreetViewModel;
    percentageTax: number | undefined;
    fixedAmountTax: number | undefined;
    taxApplyType: VenueTaxApplyType;
    applyTaxToIncidentals: boolean;
    billingContact: BillingContactModel;
    hours: HoursViewModel;
    statusNew: VenueStatusNew;
    defaultBookingMethod: BookingMethod;
    defaultBookingMethodHourly: BookingMethod;
    timeZoneId: string | undefined;
    licenseVersion: LicenseVersion;
    enableElectronicSignatures: boolean;
    seoTitle: string | undefined;
    seoDescription: string | undefined;
    inSetupDate: string | undefined;
    launchedDate: string | undefined;
    publishedDate: string | undefined;
    claimSentDate: string | undefined;
    claimSentFollowupDate: string | undefined;
    retiredDate: string | undefined;
    professionalPhotoRank: PhotoRankEnum;
    professionalPhotoDate: string | undefined;
    source: VenueSource;
    classification: VenueClassification;
    rank: VenueRank;
    currency: CurrencyType;
    venueNameSynonymsString: string | undefined;
    vlpUrlSlug: string | undefined;
    accountId: string | undefined;
    enableHostReferral: boolean;
    referralEmail: string | undefined;
    proposalCreditsTotalAmount: number;
    enableWorkspaceAnalytics: boolean;
    liquidSpaceProStatus: LiquidSpaceProStatus;
    enableMembership: boolean;
    enableLeadXMLAttachments: boolean;
    leadDadiAccountID: string | undefined;
    externalPropertyId: string | undefined;
    gCalEndpoint: GCalEndpoint;
    exchangeUserName: string | undefined;
    exchangeUserPass: string | undefined;
    exchangeAddress: string | undefined;
    exchangeEndpoint: ExchangeEndpoint;
    ownerIdForExchangeSourcedReservations: string;
    morningStarURL: string | undefined;
    morningStarIntegrationUser: string | undefined;
    morningStarIntegrationPassword: string | undefined;
    morningStarClientId: string | undefined;
    morningStarLocationId: string | undefined;
    morningStarVisaId: string | undefined;
    morningStarDontSendInvitationEmail: boolean;
    rjMetisVenueId: string | undefined;
    rjMetisReservationsOwnerId: string;
    rjMetisVisaId: string;
    rjMetisSyncTenants: boolean;
    evoApiConnectionId: string;
    ownerIdForIOSourcedReservations: string;
    ioCenterId: string | undefined;
    evoClientId: string | undefined;
    enableMemberClientId: boolean;
    officeRnDOrganizationId: string;
    officeRnDOfficeId: string | undefined;
    officeRnDWebhookSecret: string | undefined;
    ownerIdForOfficeRnDSourcedReservations: string;
    officeRnDTeamForLiquidspaceSourcedReservations: string | undefined;
    officeRnDOwnerForLiquidspaceSourcedReservations: string | undefined;
    ownerIdForMSGraphSourcedReservations: string;
    msGraphId: string | undefined;
    msGraphEmail: string | undefined;
    deskimoMarketCode: string | undefined;
    deskimoPropertyReference: string | undefined;
    ownerIdForDeskimoSourcedReservations: string | undefined;
    hasIntegration: boolean;
    venueHasExchangeIntegration: boolean;
    weWorkIndiaBuildingId: string | undefined;
    pictureURLs: PictureURLViewModel[];
    amenities: VenueAmenitiesModel;
    openStatus: VenueOpenStatus;
    created: string;
    claimProfileLink: string;
    integrationOption: string | undefined;
    vlpUrl: string | undefined;
    customLicensePdfTemplate: string | undefined;
}

export class StreetViewModel implements IStreetViewModel {
    displayStreetView!: boolean;
    position!: PositionModel;
    pointOfView!: PointOfViewModel;
    zoom!: number | undefined;

    constructor(data?: IStreetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.displayStreetView = _data["displayStreetView"];
            this.position = _data["position"] ? PositionModel.fromJS(_data["position"]) : <any>undefined;
            this.pointOfView = _data["pointOfView"] ? PointOfViewModel.fromJS(_data["pointOfView"]) : <any>undefined;
            this.zoom = _data["zoom"];
        }
    }

    static fromJS(data: any): StreetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StreetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayStreetView"] = this.displayStreetView;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["pointOfView"] = this.pointOfView ? this.pointOfView.toJSON() : <any>undefined;
        data["zoom"] = this.zoom;
        return data;
    }
}

export interface IStreetViewModel {
    displayStreetView: boolean;
    position: PositionModel;
    pointOfView: PointOfViewModel;
    zoom: number | undefined;
}

export class PositionModel implements IPositionModel {
    latitude!: number | undefined;
    longitude!: number | undefined;

    constructor(data?: IPositionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): PositionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PositionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IPositionModel {
    latitude: number | undefined;
    longitude: number | undefined;
}

export class PointOfViewModel implements IPointOfViewModel {
    heading!: number | undefined;
    pitch!: number | undefined;

    constructor(data?: IPointOfViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.pitch = _data["pitch"];
        }
    }

    static fromJS(data: any): PointOfViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PointOfViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["pitch"] = this.pitch;
        return data;
    }
}

export interface IPointOfViewModel {
    heading: number | undefined;
    pitch: number | undefined;
}

/** 0 = TaxApplyToDiscountedPrice 1 = TaxApplyToListPrice */
export enum VenueTaxApplyType {
    TaxApplyToDiscountedPrice = 0,
    TaxApplyToListPrice = 1,
}

export class BillingContactModel implements IBillingContactModel {
    id!: string;
    name!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    addresLine1!: string | undefined;
    addresLine2!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zip!: string | undefined;
    country!: string | undefined;
    contactType!: ContactTypeEnum;
    payeeName!: string | undefined;
    sameAddressAsVenue!: boolean;
    billingMethod!: BillingMethod | undefined;
    accountType!: ACHAccountType;
    accountName!: string | undefined;
    routingNumber!: string | undefined;
    bankAccount!: string | undefined;
    payPalEmailAddress!: string | undefined;
    bankName!: string | undefined;
    bankAndBranchNumber!: string | undefined;
    taxId!: string | undefined;

    constructor(data?: IBillingContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.addresLine1 = _data["addresLine1"];
            this.addresLine2 = _data["addresLine2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.country = _data["country"];
            this.contactType = _data["contactType"];
            this.payeeName = _data["payeeName"];
            this.sameAddressAsVenue = _data["sameAddressAsVenue"];
            this.billingMethod = _data["billingMethod"];
            this.accountType = _data["accountType"];
            this.accountName = _data["accountName"];
            this.routingNumber = _data["routingNumber"];
            this.bankAccount = _data["bankAccount"];
            this.payPalEmailAddress = _data["payPalEmailAddress"];
            this.bankName = _data["bankName"];
            this.bankAndBranchNumber = _data["bankAndBranchNumber"];
            this.taxId = _data["taxId"];
        }
    }

    static fromJS(data: any): BillingContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new BillingContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["addresLine1"] = this.addresLine1;
        data["addresLine2"] = this.addresLine2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["country"] = this.country;
        data["contactType"] = this.contactType;
        data["payeeName"] = this.payeeName;
        data["sameAddressAsVenue"] = this.sameAddressAsVenue;
        data["billingMethod"] = this.billingMethod;
        data["accountType"] = this.accountType;
        data["accountName"] = this.accountName;
        data["routingNumber"] = this.routingNumber;
        data["bankAccount"] = this.bankAccount;
        data["payPalEmailAddress"] = this.payPalEmailAddress;
        data["bankName"] = this.bankName;
        data["bankAndBranchNumber"] = this.bankAndBranchNumber;
        data["taxId"] = this.taxId;
        return data;
    }
}

export interface IBillingContactModel {
    id: string;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    addresLine1: string | undefined;
    addresLine2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    country: string | undefined;
    contactType: ContactTypeEnum;
    payeeName: string | undefined;
    sameAddressAsVenue: boolean;
    billingMethod: BillingMethod | undefined;
    accountType: ACHAccountType;
    accountName: string | undefined;
    routingNumber: string | undefined;
    bankAccount: string | undefined;
    payPalEmailAddress: string | undefined;
    bankName: string | undefined;
    bankAndBranchNumber: string | undefined;
    taxId: string | undefined;
}

/** 0 = Billing */
export enum ContactTypeEnum {
    Billing = 0,
}

/** 0 = Check 1 = ACH 1 = BankAccount 2 = Paypal 3 = BankTransfer 4 = None */
export enum BillingMethod {
    Check = 0,
    ACH = 1,
    BankAccount = 1,
    Paypal = 2,
    BankTransfer = 3,
    None = 4,
}

/** 0 = Checking 1 = Savings */
export enum ACHAccountType {
    Checking = 0,
    Savings = 1,
}

export class HoursViewModel implements IHoursViewModel {
    allHolidays!: HolidayViewModel[];
    forDayOfWeek!: HooRuleForDayOfWeekViewModel[];
    forHolidays!: HooRuleForHolidayViewModel[];

    constructor(data?: IHoursViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allHolidays"])) {
                this.allHolidays = [] as any;
                for (let item of _data["allHolidays"])
                    this.allHolidays!.push(HolidayViewModel.fromJS(item));
            }
            if (Array.isArray(_data["forDayOfWeek"])) {
                this.forDayOfWeek = [] as any;
                for (let item of _data["forDayOfWeek"])
                    this.forDayOfWeek!.push(HooRuleForDayOfWeekViewModel.fromJS(item));
            }
            if (Array.isArray(_data["forHolidays"])) {
                this.forHolidays = [] as any;
                for (let item of _data["forHolidays"])
                    this.forHolidays!.push(HooRuleForHolidayViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HoursViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HoursViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allHolidays)) {
            data["allHolidays"] = [];
            for (let item of this.allHolidays)
                data["allHolidays"].push(item.toJSON());
        }
        if (Array.isArray(this.forDayOfWeek)) {
            data["forDayOfWeek"] = [];
            for (let item of this.forDayOfWeek)
                data["forDayOfWeek"].push(item.toJSON());
        }
        if (Array.isArray(this.forHolidays)) {
            data["forHolidays"] = [];
            for (let item of this.forHolidays)
                data["forHolidays"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHoursViewModel {
    allHolidays: HolidayViewModel[];
    forDayOfWeek: HooRuleForDayOfWeekViewModel[];
    forHolidays: HooRuleForHolidayViewModel[];
}

export class HolidayViewModel implements IHolidayViewModel {
    name!: string;
    countries!: string[];
    id!: string;
    dates!: string[];

    constructor(data?: IHolidayViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            this.id = _data["id"];
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(item);
            }
        }
    }

    static fromJS(data: any): HolidayViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        data["id"] = this.id;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item);
        }
        return data;
    }
}

export interface IHolidayViewModel {
    name: string;
    countries: string[];
    id: string;
    dates: string[];
}

export class HooRuleForDayOfWeekViewModel implements IHooRuleForDayOfWeekViewModel {
    dayOfWeek!: DayOfWeek;
    offsetToOpening!: string;
    offsetToClosing!: string;

    constructor(data?: IHooRuleForDayOfWeekViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.offsetToOpening = _data["offsetToOpening"];
            this.offsetToClosing = _data["offsetToClosing"];
        }
    }

    static fromJS(data: any): HooRuleForDayOfWeekViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HooRuleForDayOfWeekViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["offsetToOpening"] = this.offsetToOpening;
        data["offsetToClosing"] = this.offsetToClosing;
        return data;
    }
}

export interface IHooRuleForDayOfWeekViewModel {
    dayOfWeek: DayOfWeek;
    offsetToOpening: string;
    offsetToClosing: string;
}

/** 0 = Sunday 1 = Monday 2 = Tuesday 3 = Wednesday 4 = Thursday 5 = Friday 6 = Saturday */
export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class HooRuleForHolidayViewModel implements IHooRuleForHolidayViewModel {
    holidayId!: string;

    constructor(data?: IHooRuleForHolidayViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.holidayId = _data["holidayId"];
        }
    }

    static fromJS(data: any): HooRuleForHolidayViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HooRuleForHolidayViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayId"] = this.holidayId;
        return data;
    }
}

export interface IHooRuleForHolidayViewModel {
    holidayId: string;
}

/** 0 = None 1 = ProfessionalVenueSourced 2 = ProfessionalLiquidSpaceSourced */
export enum PhotoRankEnum {
    None = 0,
    ProfessionalVenueSourced = 1,
    ProfessionalLiquidSpaceSourced = 2,
}

/** 0 = Unspecified 1 = BusinessCenter 2 = Coworking 3 = Hotel 4 = Library 5 = PrivateOffice 6 = Bank 7 = HighQualityCoworking 8 = HighQualityOBC 9 = OBCInternal 10 = CoworkingInternal 11 = EnterpriseInternal 12 = CommercialOfficeBuilding 13 = ConferenceCenters 14 = RestaurantCafe 15 = CourtReportingLegal 16 = TrainingCenters 17 = Incubator 18 = BusinessClub 19 = Studio 20 = GolfCourse 21 = AthleticClub 22 = CoffeeShop 23 = Museum 24 = MakerSpace 25 = Winery 26 = Government 27 = Church 28 = StrategicPortfolio 29 = Sublease 2147483647 = Other */
export enum VenueClassification {
    Unspecified = 0,
    BusinessCenter = 1,
    Coworking = 2,
    Hotel = 3,
    Library = 4,
    PrivateOffice = 5,
    Bank = 6,
    HighQualityCoworking = 7,
    HighQualityOBC = 8,
    OBCInternal = 9,
    CoworkingInternal = 10,
    EnterpriseInternal = 11,
    CommercialOfficeBuilding = 12,
    ConferenceCenters = 13,
    RestaurantCafe = 14,
    CourtReportingLegal = 15,
    TrainingCenters = 16,
    Incubator = 17,
    BusinessClub = 18,
    Studio = 19,
    GolfCourse = 20,
    AthleticClub = 21,
    CoffeeShop = 22,
    Museum = 23,
    MakerSpace = 24,
    Winery = 25,
    Government = 26,
    Church = 27,
    StrategicPortfolio = 28,
    Sublease = 29,
    Other = 2147483647,
}

/** 0 = LevelZero 1 = Bronze 2 = Gold 3 = Platinum 4 = Titanium */
export enum VenueRank {
    LevelZero = 0,
    Bronze = 1,
    Gold = 2,
    Platinum = 3,
    Titanium = 4,
}

/** 0 = None 1 = GoogleCalendar 2 = HappyDesk 3 = Cobot 4 = NexudusSpaces 5 = YourVirtualButler 6 = Deskworks 7 = Eventboard 8 = OffOps 9 = Robin 10 = Roomzilla 11 = RoomWizard 12 = Other */
export enum GCalEndpoint {
    None = 0,
    GoogleCalendar = 1,
    HappyDesk = 2,
    Cobot = 3,
    NexudusSpaces = 4,
    YourVirtualButler = 5,
    Deskworks = 6,
    Eventboard = 7,
    OffOps = 8,
    Robin = 9,
    Roomzilla = 10,
    RoomWizard = 11,
    Other = 12,
}

/** 0 = None 1 = Outlook 2 = RoomWizard 3 = Crestron 4 = Other */
export enum ExchangeEndpoint {
    None = 0,
    Outlook = 1,
    RoomWizard = 2,
    Crestron = 3,
    Other = 4,
}

export class VenueAmenitiesModel implements IVenueAmenitiesModel {
    customGreeting!: string | undefined;
    entry!: string | undefined;
    healthAndSafetyPolicy!: string | undefined;
    parking!: VenueParkingAmenityModel;
    wiFi!: VenueWiFiAmenityModel;

    constructor(data?: IVenueAmenitiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.customGreeting = _data["customGreeting"];
            this.entry = _data["entry"];
            this.healthAndSafetyPolicy = _data["healthAndSafetyPolicy"];
            this.parking = _data["parking"] ? VenueParkingAmenityModel.fromJS(_data["parking"]) : <any>undefined;
            this.wiFi = _data["wiFi"] ? VenueWiFiAmenityModel.fromJS(_data["wiFi"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VenueAmenitiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueAmenitiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customGreeting"] = this.customGreeting;
        data["entry"] = this.entry;
        data["healthAndSafetyPolicy"] = this.healthAndSafetyPolicy;
        data["parking"] = this.parking ? this.parking.toJSON() : <any>undefined;
        data["wiFi"] = this.wiFi ? this.wiFi.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVenueAmenitiesModel {
    customGreeting: string | undefined;
    entry: string | undefined;
    healthAndSafetyPolicy: string | undefined;
    parking: VenueParkingAmenityModel;
    wiFi: VenueWiFiAmenityModel;
}

export class VenueParkingAmenityModel implements IVenueParkingAmenityModel {
    instructions!: string | undefined;
    parkingType!: ParkingType;
    price!: string | undefined;

    constructor(data?: IVenueParkingAmenityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.instructions = _data["instructions"];
            this.parkingType = _data["parkingType"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): VenueParkingAmenityModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueParkingAmenityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instructions"] = this.instructions;
        data["parkingType"] = this.parkingType;
        data["price"] = this.price;
        return data;
    }
}

export interface IVenueParkingAmenityModel {
    instructions: string | undefined;
    parkingType: ParkingType;
    price: string | undefined;
}

/** 0 = Unknown 1 = FreeParkingOnsite 2 = PaidParkingOnsite 3 = FreeParkingOffsite 4 = PaidParkingOffsite */
export enum ParkingType {
    Unknown = 0,
    FreeParkingOnsite = 1,
    PaidParkingOnsite = 2,
    FreeParkingOffsite = 3,
    PaidParkingOffsite = 4,
}

export class VenueWiFiAmenityModel implements IVenueWiFiAmenityModel {
    description!: string | undefined;
    networkName!: string | undefined;
    password!: string | undefined;

    constructor(data?: IVenueWiFiAmenityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.networkName = _data["networkName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): VenueWiFiAmenityModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueWiFiAmenityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["networkName"] = this.networkName;
        data["password"] = this.password;
        return data;
    }
}

export interface IVenueWiFiAmenityModel {
    description: string | undefined;
    networkName: string | undefined;
    password: string | undefined;
}

export class VenueGroupMembershipModel implements IVenueGroupMembershipModel {
    name!: string;
    groupId!: string;
    visaId!: string;
    visaType!: VenueGroupVisaType;
    venueId!: string;
    hasPricingRateHourly!: boolean;
    hasPricingRateMonthly!: boolean;

    constructor(data?: IVenueGroupMembershipModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.groupId = _data["groupId"];
            this.visaId = _data["visaId"];
            this.visaType = _data["visaType"];
            this.venueId = _data["venueId"];
            this.hasPricingRateHourly = _data["hasPricingRateHourly"];
            this.hasPricingRateMonthly = _data["hasPricingRateMonthly"];
        }
    }

    static fromJS(data: any): VenueGroupMembershipModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueGroupMembershipModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["groupId"] = this.groupId;
        data["visaId"] = this.visaId;
        data["visaType"] = this.visaType;
        data["venueId"] = this.venueId;
        data["hasPricingRateHourly"] = this.hasPricingRateHourly;
        data["hasPricingRateMonthly"] = this.hasPricingRateMonthly;
        return data;
    }
}

export interface IVenueGroupMembershipModel {
    name: string;
    groupId: string;
    visaId: string;
    visaType: VenueGroupVisaType;
    venueId: string;
    hasPricingRateHourly: boolean;
    hasPricingRateMonthly: boolean;
}

export class PriceRateCheckerResponse implements IPriceRateCheckerResponse {
    ratePercent!: number;
    pricingRateName!: string;

    constructor(data?: IPriceRateCheckerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.ratePercent = _data["ratePercent"];
            this.pricingRateName = _data["pricingRateName"];
        }
    }

    static fromJS(data: any): PriceRateCheckerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PriceRateCheckerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ratePercent"] = this.ratePercent;
        data["pricingRateName"] = this.pricingRateName;
        return data;
    }
}

export interface IPriceRateCheckerResponse {
    ratePercent: number;
    pricingRateName: string;
}

/** 0 = Flat 1 = Tiered */
export enum PricingRateType {
    Flat = 0,
    Tiered = 1,
}

export class VerifyVenueParmalinkResult implements IVerifyVenueParmalinkResult {
    success!: boolean;
    urlWithoutHost!: string | undefined;
    url!: string | undefined;
    proposals!: string[];
    permalinkNormalized!: string | undefined;

    constructor(data?: IVerifyVenueParmalinkResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.urlWithoutHost = _data["urlWithoutHost"];
            this.url = _data["url"];
            if (Array.isArray(_data["proposals"])) {
                this.proposals = [] as any;
                for (let item of _data["proposals"])
                    this.proposals!.push(item);
            }
            this.permalinkNormalized = _data["permalinkNormalized"];
        }
    }

    static fromJS(data: any): VerifyVenueParmalinkResult {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyVenueParmalinkResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["urlWithoutHost"] = this.urlWithoutHost;
        data["url"] = this.url;
        if (Array.isArray(this.proposals)) {
            data["proposals"] = [];
            for (let item of this.proposals)
                data["proposals"].push(item);
        }
        data["permalinkNormalized"] = this.permalinkNormalized;
        return data;
    }
}

export interface IVerifyVenueParmalinkResult {
    success: boolean;
    urlWithoutHost: string | undefined;
    url: string | undefined;
    proposals: string[];
    permalinkNormalized: string | undefined;
}

export class VenuePopulationPercentModel implements IVenuePopulationPercentModel {
    percentValues!: { [key in keyof typeof ManageVenueSectionEnum]?: number; };
    percent!: number;
    sectionHasValues!: { [key in keyof typeof ManageVenueSectionEnum]?: boolean; };
    sectionText!: { [key in keyof typeof ManageVenueSectionEnum]?: string; };
    sectionDescription!: { [key in keyof typeof ManageVenueSectionEnum]?: string; };
    completed!: boolean;

    constructor(data?: IVenuePopulationPercentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (_data["percentValues"]) {
                this.percentValues = {} as any;
                for (let key in _data["percentValues"]) {
                    if (_data["percentValues"].hasOwnProperty(key))
                        (<any>this.percentValues)![key] = _data["percentValues"][key];
                }
            }
            this.percent = _data["percent"];
            if (_data["sectionHasValues"]) {
                this.sectionHasValues = {} as any;
                for (let key in _data["sectionHasValues"]) {
                    if (_data["sectionHasValues"].hasOwnProperty(key))
                        (<any>this.sectionHasValues)![key] = _data["sectionHasValues"][key];
                }
            }
            if (_data["sectionText"]) {
                this.sectionText = {} as any;
                for (let key in _data["sectionText"]) {
                    if (_data["sectionText"].hasOwnProperty(key))
                        (<any>this.sectionText)![key] = _data["sectionText"][key];
                }
            }
            if (_data["sectionDescription"]) {
                this.sectionDescription = {} as any;
                for (let key in _data["sectionDescription"]) {
                    if (_data["sectionDescription"].hasOwnProperty(key))
                        (<any>this.sectionDescription)![key] = _data["sectionDescription"][key];
                }
            }
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): VenuePopulationPercentModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenuePopulationPercentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.percentValues) {
            data["percentValues"] = {};
            for (let key in this.percentValues) {
                if (this.percentValues.hasOwnProperty(key))
                    (<any>data["percentValues"])[key] = (<any>this.percentValues)[key];
            }
        }
        data["percent"] = this.percent;
        if (this.sectionHasValues) {
            data["sectionHasValues"] = {};
            for (let key in this.sectionHasValues) {
                if (this.sectionHasValues.hasOwnProperty(key))
                    (<any>data["sectionHasValues"])[key] = (<any>this.sectionHasValues)[key];
            }
        }
        if (this.sectionText) {
            data["sectionText"] = {};
            for (let key in this.sectionText) {
                if (this.sectionText.hasOwnProperty(key))
                    (<any>data["sectionText"])[key] = (<any>this.sectionText)[key];
            }
        }
        if (this.sectionDescription) {
            data["sectionDescription"] = {};
            for (let key in this.sectionDescription) {
                if (this.sectionDescription.hasOwnProperty(key))
                    (<any>data["sectionDescription"])[key] = (<any>this.sectionDescription)[key];
            }
        }
        data["completed"] = this.completed;
        return data;
    }
}

export interface IVenuePopulationPercentModel {
    percentValues: { [key in keyof typeof ManageVenueSectionEnum]?: number; };
    percent: number;
    sectionHasValues: { [key in keyof typeof ManageVenueSectionEnum]?: boolean; };
    sectionText: { [key in keyof typeof ManageVenueSectionEnum]?: string; };
    sectionDescription: { [key in keyof typeof ManageVenueSectionEnum]?: string; };
    completed: boolean;
}

/** 0 = None 1 = Workspaces 2 = HostProfile 3 = Descriptions 4 = Photos 5 = Amenities 6 = Hours 7 = PaymentInfo 8 = Team 9 = SubmitForReview 10 = WelcomeInfo */
export enum ManageVenueSectionEnum {
    None = 0,
    Workspaces = 1,
    HostProfile = 2,
    Descriptions = 3,
    Photos = 4,
    Amenities = 5,
    Hours = 6,
    PaymentInfo = 7,
    Team = 8,
    SubmitForReview = 9,
    WelcomeInfo = 10,
}

export class VenuePropertiesModel implements IVenuePropertiesModel {
    currentVenueScore!: VenueScoreModel;
    previousVenueScore!: VenueScoreModel;
    venueAdmins!: VenueAdminPropertiesModel[];
    lsPartnerSuccess!: string | undefined;
    classification!: VenueGroupClassification;

    constructor(data?: IVenuePropertiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.currentVenueScore = _data["currentVenueScore"] ? VenueScoreModel.fromJS(_data["currentVenueScore"]) : <any>undefined;
            this.previousVenueScore = _data["previousVenueScore"] ? VenueScoreModel.fromJS(_data["previousVenueScore"]) : <any>undefined;
            if (Array.isArray(_data["venueAdmins"])) {
                this.venueAdmins = [] as any;
                for (let item of _data["venueAdmins"])
                    this.venueAdmins!.push(VenueAdminPropertiesModel.fromJS(item));
            }
            this.lsPartnerSuccess = _data["lsPartnerSuccess"];
            this.classification = _data["classification"];
        }
    }

    static fromJS(data: any): VenuePropertiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenuePropertiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentVenueScore"] = this.currentVenueScore ? this.currentVenueScore.toJSON() : <any>undefined;
        data["previousVenueScore"] = this.previousVenueScore ? this.previousVenueScore.toJSON() : <any>undefined;
        if (Array.isArray(this.venueAdmins)) {
            data["venueAdmins"] = [];
            for (let item of this.venueAdmins)
                data["venueAdmins"].push(item.toJSON());
        }
        data["lsPartnerSuccess"] = this.lsPartnerSuccess;
        data["classification"] = this.classification;
        return data;
    }
}

export interface IVenuePropertiesModel {
    currentVenueScore: VenueScoreModel;
    previousVenueScore: VenueScoreModel;
    venueAdmins: VenueAdminPropertiesModel[];
    lsPartnerSuccess: string | undefined;
    classification: VenueGroupClassification;
}

export class VenueScoreModel implements IVenueScoreModel {
    freshness!: number;
    responsiveness!: number;
    conversion!: number;
    reviews!: number;
    total!: number;

    constructor(data?: IVenueScoreModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.freshness = _data["freshness"];
            this.responsiveness = _data["responsiveness"];
            this.conversion = _data["conversion"];
            this.reviews = _data["reviews"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): VenueScoreModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueScoreModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freshness"] = this.freshness;
        data["responsiveness"] = this.responsiveness;
        data["conversion"] = this.conversion;
        data["reviews"] = this.reviews;
        data["total"] = this.total;
        return data;
    }
}

export interface IVenueScoreModel {
    freshness: number;
    responsiveness: number;
    conversion: number;
    reviews: number;
    total: number;
}

export class VenueAdminPropertiesModel implements IVenueAdminPropertiesModel {
    memberId!: string;
    memberLastName!: string | undefined;
    memberFirstName!: string | undefined;
    memberName!: string;
    email!: string;
    role!: VenueRoleEnum;
    lastActivityDate!: string | undefined;

    constructor(data?: IVenueAdminPropertiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.memberLastName = _data["memberLastName"];
            this.memberFirstName = _data["memberFirstName"];
            this.memberName = _data["memberName"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.lastActivityDate = _data["lastActivityDate"];
        }
    }

    static fromJS(data: any): VenueAdminPropertiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueAdminPropertiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["memberLastName"] = this.memberLastName;
        data["memberFirstName"] = this.memberFirstName;
        data["memberName"] = this.memberName;
        data["email"] = this.email;
        data["role"] = this.role;
        data["lastActivityDate"] = this.lastActivityDate;
        return data;
    }
}

export interface IVenueAdminPropertiesModel {
    memberId: string;
    memberLastName: string | undefined;
    memberFirstName: string | undefined;
    memberName: string;
    email: string;
    role: VenueRoleEnum;
    lastActivityDate: string | undefined;
}

/** 1 = PaymentInformation 2 = MeetingRoom 3 = Integration 4 = WelcomeInformation */
export enum ProfileChecklist {
    PaymentInformation = 1,
    MeetingRoom = 2,
    Integration = 3,
    WelcomeInformation = 4,
}

export class VenueEventModel implements IVenueEventModel {
    eventId!: string;
    eventType!: VenueEventType;
    createdVenueTime!: string;
    createdTicks!: string;
    authorEmail!: string | undefined;
    message!: string;

    constructor(data?: IVenueEventModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.eventType = _data["eventType"];
            this.createdVenueTime = _data["createdVenueTime"];
            this.createdTicks = _data["createdTicks"];
            this.authorEmail = _data["authorEmail"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): VenueEventModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueEventModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["eventType"] = this.eventType;
        data["createdVenueTime"] = this.createdVenueTime;
        data["createdTicks"] = this.createdTicks;
        data["authorEmail"] = this.authorEmail;
        data["message"] = this.message;
        return data;
    }
}

export interface IVenueEventModel {
    eventId: string;
    eventType: VenueEventType;
    createdVenueTime: string;
    createdTicks: string;
    authorEmail: string | undefined;
    message: string;
}

/** 0 = Note 1 = StatusChange 2 = EventEdited 3 = EventDeleted 4 = MembershipStatusChange 5 = LiquidspaceProStatusChange 6 = Claimed */
export enum VenueEventType {
    Note = 0,
    StatusChange = 1,
    EventEdited = 2,
    EventDeleted = 3,
    MembershipStatusChange = 4,
    LiquidspaceProStatusChange = 5,
    Claimed = 6,
}

export class HooRuleSplitViewModel implements IHooRuleSplitViewModel {
    hooId!: string;
    day!: string | undefined;
    hours!: string;
    workspace!: string;
    people!: string;
    venueId!: string;

    constructor(data?: IHooRuleSplitViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.hooId = _data["hooId"];
            this.day = _data["day"];
            this.hours = _data["hours"];
            this.workspace = _data["workspace"];
            this.people = _data["people"];
            this.venueId = _data["venueId"];
        }
    }

    static fromJS(data: any): HooRuleSplitViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HooRuleSplitViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hooId"] = this.hooId;
        data["day"] = this.day;
        data["hours"] = this.hours;
        data["workspace"] = this.workspace;
        data["people"] = this.people;
        data["venueId"] = this.venueId;
        return data;
    }
}

export interface IHooRuleSplitViewModel {
    hooId: string;
    day: string | undefined;
    hours: string;
    workspace: string;
    people: string;
    venueId: string;
}

export class HooRuleFlexBaseViewModel implements IHooRuleFlexBaseViewModel {
    selectedWorkspaces!: string[];
    selectedVisas!: string[];

    constructor(data?: IHooRuleFlexBaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedWorkspaces"])) {
                this.selectedWorkspaces = [] as any;
                for (let item of _data["selectedWorkspaces"])
                    this.selectedWorkspaces!.push(item);
            }
            if (Array.isArray(_data["selectedVisas"])) {
                this.selectedVisas = [] as any;
                for (let item of _data["selectedVisas"])
                    this.selectedVisas!.push(item);
            }
        }
    }

    static fromJS(data: any): HooRuleFlexBaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HooRuleFlexBaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedWorkspaces)) {
            data["selectedWorkspaces"] = [];
            for (let item of this.selectedWorkspaces)
                data["selectedWorkspaces"].push(item);
        }
        if (Array.isArray(this.selectedVisas)) {
            data["selectedVisas"] = [];
            for (let item of this.selectedVisas)
                data["selectedVisas"].push(item);
        }
        return data;
    }
}

export interface IHooRuleFlexBaseViewModel {
    selectedWorkspaces: string[];
    selectedVisas: string[];
}

/** AKA Exceptions */
export class HooRuleSplitEditViewModel extends HooRuleFlexBaseViewModel implements IHooRuleSplitEditViewModel {
    hooId!: string;
    venueId!: string;
    description!: string | undefined;
    showDescription!: boolean;
    timeZoneId!: string | undefined;
    daysOfWeek!: SelectedDaysOfWeek[];
    hooModeSelected!: HooMode;
    dateRangeStart!: string | undefined;
    dateRangeEnd!: string | undefined;
    openCloseModeSelected!: OpenCloseMode;
    openClosePairs!: OpenClosePair[];
    splitHoursSelected!: boolean;

    constructor(data?: IHooRuleSplitEditViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hooId = _data["hooId"];
            this.venueId = _data["venueId"];
            this.description = _data["description"];
            this.showDescription = _data["showDescription"];
            this.timeZoneId = _data["timeZoneId"];
            if (Array.isArray(_data["daysOfWeek"])) {
                this.daysOfWeek = [] as any;
                for (let item of _data["daysOfWeek"])
                    this.daysOfWeek!.push(SelectedDaysOfWeek.fromJS(item));
            }
            this.hooModeSelected = _data["hooModeSelected"];
            this.dateRangeStart = _data["dateRangeStart"];
            this.dateRangeEnd = _data["dateRangeEnd"];
            this.openCloseModeSelected = _data["openCloseModeSelected"];
            if (Array.isArray(_data["openClosePairs"])) {
                this.openClosePairs = [] as any;
                for (let item of _data["openClosePairs"])
                    this.openClosePairs!.push(OpenClosePair.fromJS(item));
            }
            this.splitHoursSelected = _data["splitHoursSelected"];
        }
    }

    static fromJS(data: any): HooRuleSplitEditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HooRuleSplitEditViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hooId"] = this.hooId;
        data["venueId"] = this.venueId;
        data["description"] = this.description;
        data["showDescription"] = this.showDescription;
        data["timeZoneId"] = this.timeZoneId;
        if (Array.isArray(this.daysOfWeek)) {
            data["daysOfWeek"] = [];
            for (let item of this.daysOfWeek)
                data["daysOfWeek"].push(item.toJSON());
        }
        data["hooModeSelected"] = this.hooModeSelected;
        data["dateRangeStart"] = this.dateRangeStart;
        data["dateRangeEnd"] = this.dateRangeEnd;
        data["openCloseModeSelected"] = this.openCloseModeSelected;
        if (Array.isArray(this.openClosePairs)) {
            data["openClosePairs"] = [];
            for (let item of this.openClosePairs)
                data["openClosePairs"].push(item.toJSON());
        }
        data["splitHoursSelected"] = this.splitHoursSelected;
        super.toJSON(data);
        return data;
    }
}

/** AKA Exceptions */
export interface IHooRuleSplitEditViewModel extends IHooRuleFlexBaseViewModel {
    hooId: string;
    venueId: string;
    description: string | undefined;
    showDescription: boolean;
    timeZoneId: string | undefined;
    daysOfWeek: SelectedDaysOfWeek[];
    hooModeSelected: HooMode;
    dateRangeStart: string | undefined;
    dateRangeEnd: string | undefined;
    openCloseModeSelected: OpenCloseMode;
    openClosePairs: OpenClosePair[];
    splitHoursSelected: boolean;
}

export class SelectedDaysOfWeek implements ISelectedDaysOfWeek {
    dayOfWeek!: DayOfWeek;
    isSelected!: boolean;

    constructor(data?: ISelectedDaysOfWeek) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SelectedDaysOfWeek {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedDaysOfWeek();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISelectedDaysOfWeek {
    dayOfWeek: DayOfWeek;
    isSelected: boolean;
}

/** 0 = DateRange 1 = DaysOfWeek */
export enum HooMode {
    DateRange = 0,
    DaysOfWeek = 1,
}

/** 0 = OpenHours 1 = Closed24Hours */
export enum OpenCloseMode {
    OpenHours = 0,
    Closed24Hours = 1,
}

export class OpenClosePair implements IOpenClosePair {
    offsetToOpening!: string | undefined;
    offsetToClosing!: string | undefined;

    constructor(data?: IOpenClosePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.offsetToOpening = _data["offsetToOpening"];
            this.offsetToClosing = _data["offsetToClosing"];
        }
    }

    static fromJS(data: any): OpenClosePair {
        data = typeof data === 'object' ? data : {};
        let result = new OpenClosePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offsetToOpening"] = this.offsetToOpening;
        data["offsetToClosing"] = this.offsetToClosing;
        return data;
    }
}

export interface IOpenClosePair {
    offsetToOpening: string | undefined;
    offsetToClosing: string | undefined;
}

export class HooRuleForBookingWindowFlexViewModel implements IHooRuleForBookingWindowFlexViewModel {
    hooId!: string;
    minNotice!: string;
    maxNotice!: string;
    venueId!: string;
    workspace!: string;
    people!: string;
    isPeriodRule!: boolean;

    constructor(data?: IHooRuleForBookingWindowFlexViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.hooId = _data["hooId"];
            this.minNotice = _data["minNotice"];
            this.maxNotice = _data["maxNotice"];
            this.venueId = _data["venueId"];
            this.workspace = _data["workspace"];
            this.people = _data["people"];
            this.isPeriodRule = _data["isPeriodRule"];
        }
    }

    static fromJS(data: any): HooRuleForBookingWindowFlexViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HooRuleForBookingWindowFlexViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hooId"] = this.hooId;
        data["minNotice"] = this.minNotice;
        data["maxNotice"] = this.maxNotice;
        data["venueId"] = this.venueId;
        data["workspace"] = this.workspace;
        data["people"] = this.people;
        data["isPeriodRule"] = this.isPeriodRule;
        return data;
    }
}

export interface IHooRuleForBookingWindowFlexViewModel {
    hooId: string;
    minNotice: string;
    maxNotice: string;
    venueId: string;
    workspace: string;
    people: string;
    isPeriodRule: boolean;
}

export class HooRuleForBookingWindowFlexEditViewModel extends HooRuleFlexBaseViewModel implements IHooRuleForBookingWindowFlexEditViewModel {
    hooId!: string;
    venueId!: string;
    advanceNoticeTypeSelected!: MinAdvanceNoticeRangeType;
    advanceNotice!: number;
    unavailableAfter!: number;

    constructor(data?: IHooRuleForBookingWindowFlexEditViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hooId = _data["hooId"];
            this.venueId = _data["venueId"];
            this.advanceNoticeTypeSelected = _data["advanceNoticeTypeSelected"];
            this.advanceNotice = _data["advanceNotice"];
            this.unavailableAfter = _data["unavailableAfter"];
        }
    }

    static fromJS(data: any): HooRuleForBookingWindowFlexEditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HooRuleForBookingWindowFlexEditViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hooId"] = this.hooId;
        data["venueId"] = this.venueId;
        data["advanceNoticeTypeSelected"] = this.advanceNoticeTypeSelected;
        data["advanceNotice"] = this.advanceNotice;
        data["unavailableAfter"] = this.unavailableAfter;
        super.toJSON(data);
        return data;
    }
}

export interface IHooRuleForBookingWindowFlexEditViewModel extends IHooRuleFlexBaseViewModel {
    hooId: string;
    venueId: string;
    advanceNoticeTypeSelected: MinAdvanceNoticeRangeType;
    advanceNotice: number;
    unavailableAfter: number;
}

/** 0 = Hours 1 = Days */
export enum MinAdvanceNoticeRangeType {
    Hours = 0,
    Days = 1,
}

export class OwnerInfoModel implements IOwnerInfoModel {
    id!: string;
    fullName!: string | undefined;
    email!: string;

    constructor(data?: IOwnerInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): OwnerInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        return data;
    }
}

export interface IOwnerInfoModel {
    id: string;
    fullName: string | undefined;
    email: string;
}

export class ExchangeConfigurationModel implements IExchangeConfigurationModel {
    user!: string;
    workspaces!: ExchangeWorkspaceModel[];

    constructor(data?: IExchangeConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(ExchangeWorkspaceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExchangeConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExchangeConfigurationModel {
    user: string;
    workspaces: ExchangeWorkspaceModel[];
}

export class ExchangeWorkspaceModel implements IExchangeWorkspaceModel {
    id!: string;
    name!: string | undefined;
    email!: string;

    constructor(data?: IExchangeWorkspaceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ExchangeWorkspaceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeWorkspaceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IExchangeWorkspaceModel {
    id: string;
    name: string | undefined;
    email: string;
}

export class OfficeRnDWorkspacesSyncModel implements IOfficeRnDWorkspacesSyncModel {
    workspaces!: OfficeRnDWorkspaceSyncModel[];
    venueWorkspaces!: WorkspaceSelectListItem[];

    constructor(data?: IOfficeRnDWorkspacesSyncModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(OfficeRnDWorkspaceSyncModel.fromJS(item));
            }
            if (Array.isArray(_data["venueWorkspaces"])) {
                this.venueWorkspaces = [] as any;
                for (let item of _data["venueWorkspaces"])
                    this.venueWorkspaces!.push(WorkspaceSelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfficeRnDWorkspacesSyncModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRnDWorkspacesSyncModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        if (Array.isArray(this.venueWorkspaces)) {
            data["venueWorkspaces"] = [];
            for (let item of this.venueWorkspaces)
                data["venueWorkspaces"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfficeRnDWorkspacesSyncModel {
    workspaces: OfficeRnDWorkspaceSyncModel[];
    venueWorkspaces: WorkspaceSelectListItem[];
}

export class OfficeRnDWorkspaceSyncModel implements IOfficeRnDWorkspaceSyncModel {
    enable!: boolean;
    officeRnDResourceId!: string;
    officeRnDResourceName!: string | undefined;
    workspaceId!: string;

    constructor(data?: IOfficeRnDWorkspaceSyncModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
            this.officeRnDResourceId = _data["officeRnDResourceId"];
            this.officeRnDResourceName = _data["officeRnDResourceName"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): OfficeRnDWorkspaceSyncModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRnDWorkspaceSyncModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        data["officeRnDResourceId"] = this.officeRnDResourceId;
        data["officeRnDResourceName"] = this.officeRnDResourceName;
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

export interface IOfficeRnDWorkspaceSyncModel {
    enable: boolean;
    officeRnDResourceId: string;
    officeRnDResourceName: string | undefined;
    workspaceId: string;
}

export class WorkspaceSelectListItem implements IWorkspaceSelectListItem {
    name!: string;
    id!: string;

    constructor(data?: IWorkspaceSelectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkspaceSelectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceSelectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IWorkspaceSelectListItem {
    name: string;
    id: string;
}

export class OfficeRnDWorkspacesSyncSubmitModel implements IOfficeRnDWorkspacesSyncSubmitModel {
    workspaces!: OfficeRnDWorkspaceSyncSubmitModel[];

    constructor(data?: IOfficeRnDWorkspacesSyncSubmitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(OfficeRnDWorkspaceSyncSubmitModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfficeRnDWorkspacesSyncSubmitModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRnDWorkspacesSyncSubmitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfficeRnDWorkspacesSyncSubmitModel {
    workspaces: OfficeRnDWorkspaceSyncSubmitModel[];
}

export class OfficeRnDWorkspaceSyncSubmitModel implements IOfficeRnDWorkspaceSyncSubmitModel {
    officeRnDResourceId!: string;
    workspaceId!: string;

    constructor(data?: IOfficeRnDWorkspaceSyncSubmitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.officeRnDResourceId = _data["officeRnDResourceId"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): OfficeRnDWorkspaceSyncSubmitModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRnDWorkspaceSyncSubmitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeRnDResourceId"] = this.officeRnDResourceId;
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

export interface IOfficeRnDWorkspaceSyncSubmitModel {
    officeRnDResourceId: string;
    workspaceId: string;
}

export class DashboardLeadViewModel implements IDashboardLeadViewModel {
    leadDate!: string;
    leadDateString!: string;
    leadDateMoreThanWeekAgo!: boolean;
    currentState!: InteractionStateEnum;
    workspaceId!: string | undefined;
    workspaceName!: string | undefined;
    memberId!: string;
    memberFirstName!: string | undefined;
    memberLastName!: string | undefined;
    memberFullName!: string | undefined;
    memberCompany!: string | undefined;
    memberIsDeleted!: boolean;
    memberEnterpriseAccountId!: string | undefined;
    memberEnterpriseAccountName!: string | undefined;
    memberImageUrl!: string | undefined;
    tourId!: string | undefined;
    tourStatus!: TourStatus;
    activeVenueTourId!: string | undefined;
    workflowId!: string | undefined;
    chainId!: string | undefined;
    hasVenueRespondedToMessage!: boolean;
    monthlyVisaState!: VisaState | undefined;
    reservationId!: string | undefined;
    rcpUrl!: string | undefined;
    doNotRenewAllowed!: boolean | undefined;
    dealProposalDetailsUrl!: string | undefined;
    proposalId!: string | undefined;
    spaceTypeForCapacity!: string | undefined;
    isUpdatedMoreThanYearAgo!: boolean;
    isDeleted!: boolean;
    isEnterpriseAccountLead!: boolean;
    dashboardLeadStatus!: DashboardLeadStatus;
    statusText!: string;

    constructor(data?: IDashboardLeadViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.leadDate = _data["leadDate"];
            this.leadDateString = _data["leadDateString"];
            this.leadDateMoreThanWeekAgo = _data["leadDateMoreThanWeekAgo"];
            this.currentState = _data["currentState"];
            this.workspaceId = _data["workspaceId"];
            this.workspaceName = _data["workspaceName"];
            this.memberId = _data["memberId"];
            this.memberFirstName = _data["memberFirstName"];
            this.memberLastName = _data["memberLastName"];
            this.memberFullName = _data["memberFullName"];
            this.memberCompany = _data["memberCompany"];
            this.memberIsDeleted = _data["memberIsDeleted"];
            this.memberEnterpriseAccountId = _data["memberEnterpriseAccountId"];
            this.memberEnterpriseAccountName = _data["memberEnterpriseAccountName"];
            this.memberImageUrl = _data["memberImageUrl"];
            this.tourId = _data["tourId"];
            this.tourStatus = _data["tourStatus"];
            this.activeVenueTourId = _data["activeVenueTourId"];
            this.workflowId = _data["workflowId"];
            this.chainId = _data["chainId"];
            this.hasVenueRespondedToMessage = _data["hasVenueRespondedToMessage"];
            this.monthlyVisaState = _data["monthlyVisaState"];
            this.reservationId = _data["reservationId"];
            this.rcpUrl = _data["rcpUrl"];
            this.doNotRenewAllowed = _data["doNotRenewAllowed"];
            this.dealProposalDetailsUrl = _data["dealProposalDetailsUrl"];
            this.proposalId = _data["proposalId"];
            this.spaceTypeForCapacity = _data["spaceTypeForCapacity"];
            this.isUpdatedMoreThanYearAgo = _data["isUpdatedMoreThanYearAgo"];
            this.isDeleted = _data["isDeleted"];
            this.isEnterpriseAccountLead = _data["isEnterpriseAccountLead"];
            this.dashboardLeadStatus = _data["dashboardLeadStatus"];
            this.statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): DashboardLeadViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardLeadViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadDate"] = this.leadDate;
        data["leadDateString"] = this.leadDateString;
        data["leadDateMoreThanWeekAgo"] = this.leadDateMoreThanWeekAgo;
        data["currentState"] = this.currentState;
        data["workspaceId"] = this.workspaceId;
        data["workspaceName"] = this.workspaceName;
        data["memberId"] = this.memberId;
        data["memberFirstName"] = this.memberFirstName;
        data["memberLastName"] = this.memberLastName;
        data["memberFullName"] = this.memberFullName;
        data["memberCompany"] = this.memberCompany;
        data["memberIsDeleted"] = this.memberIsDeleted;
        data["memberEnterpriseAccountId"] = this.memberEnterpriseAccountId;
        data["memberEnterpriseAccountName"] = this.memberEnterpriseAccountName;
        data["memberImageUrl"] = this.memberImageUrl;
        data["tourId"] = this.tourId;
        data["tourStatus"] = this.tourStatus;
        data["activeVenueTourId"] = this.activeVenueTourId;
        data["workflowId"] = this.workflowId;
        data["chainId"] = this.chainId;
        data["hasVenueRespondedToMessage"] = this.hasVenueRespondedToMessage;
        data["monthlyVisaState"] = this.monthlyVisaState;
        data["reservationId"] = this.reservationId;
        data["rcpUrl"] = this.rcpUrl;
        data["doNotRenewAllowed"] = this.doNotRenewAllowed;
        data["dealProposalDetailsUrl"] = this.dealProposalDetailsUrl;
        data["proposalId"] = this.proposalId;
        data["spaceTypeForCapacity"] = this.spaceTypeForCapacity;
        data["isUpdatedMoreThanYearAgo"] = this.isUpdatedMoreThanYearAgo;
        data["isDeleted"] = this.isDeleted;
        data["isEnterpriseAccountLead"] = this.isEnterpriseAccountLead;
        data["dashboardLeadStatus"] = this.dashboardLeadStatus;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IDashboardLeadViewModel {
    leadDate: string;
    leadDateString: string;
    leadDateMoreThanWeekAgo: boolean;
    currentState: InteractionStateEnum;
    workspaceId: string | undefined;
    workspaceName: string | undefined;
    memberId: string;
    memberFirstName: string | undefined;
    memberLastName: string | undefined;
    memberFullName: string | undefined;
    memberCompany: string | undefined;
    memberIsDeleted: boolean;
    memberEnterpriseAccountId: string | undefined;
    memberEnterpriseAccountName: string | undefined;
    memberImageUrl: string | undefined;
    tourId: string | undefined;
    tourStatus: TourStatus;
    activeVenueTourId: string | undefined;
    workflowId: string | undefined;
    chainId: string | undefined;
    hasVenueRespondedToMessage: boolean;
    monthlyVisaState: VisaState | undefined;
    reservationId: string | undefined;
    rcpUrl: string | undefined;
    doNotRenewAllowed: boolean | undefined;
    dealProposalDetailsUrl: string | undefined;
    proposalId: string | undefined;
    spaceTypeForCapacity: string | undefined;
    isUpdatedMoreThanYearAgo: boolean;
    isDeleted: boolean;
    isEnterpriseAccountLead: boolean;
    dashboardLeadStatus: DashboardLeadStatus;
    statusText: string;
}

/** 0 = Unknown 1 = Inquire 2 = ScheduleTour 3 = RequestToBook 4 = Approved 5 = Rejected 6 = Booked 7 = ManuallyBooked 8 = ManuallyBookedReservationEdited 9 = TourChangedByGuest 10 = TourChangedByVenue 11 = TourConfirmed 12 = TourCanceledByVenue 13 = TourCanceledByGuest 14 = TourComplete 15 = TourExpired 16 = MessageHost 17 = Manual 18 = Proposal 19 = FurnitureRequest 20 = ProposalReply 21 = RequestSpace 22 = ProposalToRequest 23 = ProposalRejected 24 = HostReferral 25 = DealProposal 26 = CloseDeal 27 = TourSuggested 28 = DealProposalAccepted 29 = DealProposalDeclined 30 = DealProposalSigned 31 = DealProposalChangedByVenue 32 = DealProposalChangedByMember 33 = CloseDealByMember 34 = Pending 35 = ManuallyBookedReservationExtended 36 = ManuallyBookedReservationReduced 37 = MessageSpaceExpert 38 = NotifyMe */
export enum InteractionStateEnum {
    Unknown = 0,
    Inquire = 1,
    ScheduleTour = 2,
    RequestToBook = 3,
    Approved = 4,
    Rejected = 5,
    Booked = 6,
    ManuallyBooked = 7,
    ManuallyBookedReservationEdited = 8,
    TourChangedByGuest = 9,
    TourChangedByVenue = 10,
    TourConfirmed = 11,
    TourCanceledByVenue = 12,
    TourCanceledByGuest = 13,
    TourComplete = 14,
    TourExpired = 15,
    MessageHost = 16,
    Manual = 17,
    Proposal = 18,
    FurnitureRequest = 19,
    ProposalReply = 20,
    RequestSpace = 21,
    ProposalToRequest = 22,
    ProposalRejected = 23,
    HostReferral = 24,
    DealProposal = 25,
    CloseDeal = 26,
    TourSuggested = 27,
    DealProposalAccepted = 28,
    DealProposalDeclined = 29,
    DealProposalSigned = 30,
    DealProposalChangedByVenue = 31,
    DealProposalChangedByMember = 32,
    CloseDealByMember = 33,
    Pending = 34,
    ManuallyBookedReservationExtended = 35,
    ManuallyBookedReservationReduced = 36,
    MessageSpaceExpert = 37,
    NotifyMe = 38,
}

/** 0 = Unknown 1 = New 2 = Active 3 = ClosedLost 4 = ClosedWon 5 = Archived */
export enum DashboardLeadStatus {
    Unknown = 0,
    New = 1,
    Active = 2,
    ClosedLost = 3,
    ClosedWon = 4,
    Archived = 5,
}

export class CheckResult implements ICheckResult {
    fields!: CheckResultField[] | undefined;

    constructor(data?: ICheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(CheckResultField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new CheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICheckResult {
    fields: CheckResultField[] | undefined;
}

export class CheckResultField implements ICheckResultField {
    name!: string | undefined;
    isModelField!: boolean;
    isTemplateField!: boolean;

    constructor(data?: ICheckResultField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isModelField = _data["isModelField"];
            this.isTemplateField = _data["isTemplateField"];
        }
    }

    static fromJS(data: any): CheckResultField {
        data = typeof data === 'object' ? data : {};
        let result = new CheckResultField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isModelField"] = this.isModelField;
        data["isTemplateField"] = this.isTemplateField;
        return data;
    }
}

export interface ICheckResultField {
    name: string | undefined;
    isModelField: boolean;
    isTemplateField: boolean;
}

export class ManageVenueMemberInvitationPreviewEmailViewModel implements IManageVenueMemberInvitationPreviewEmailViewModel {
    message!: string | undefined;
    fName!: string | undefined;
    lName!: string | undefined;

    constructor(data?: IManageVenueMemberInvitationPreviewEmailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.fName = _data["fName"];
            this.lName = _data["lName"];
        }
    }

    static fromJS(data: any): ManageVenueMemberInvitationPreviewEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManageVenueMemberInvitationPreviewEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["fName"] = this.fName;
        data["lName"] = this.lName;
        return data;
    }
}

export interface IManageVenueMemberInvitationPreviewEmailViewModel {
    message: string | undefined;
    fName: string | undefined;
    lName: string | undefined;
}

export class VenueMemberModel implements IVenueMemberModel {
    id!: string;
    firstName!: string;
    lastName!: string;
    company!: string;
    email!: string;
    phone!: string;
    visaId!: string;
    visaName!: string;
    visaState!: VisaState;

    constructor(data?: IVenueMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.company = _data["company"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.visaId = _data["visaId"];
            this.visaName = _data["visaName"];
            this.visaState = _data["visaState"];
        }
    }

    static fromJS(data: any): VenueMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["company"] = this.company;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["visaId"] = this.visaId;
        data["visaName"] = this.visaName;
        data["visaState"] = this.visaState;
        return data;
    }
}

export interface IVenueMemberModel {
    id: string;
    firstName: string;
    lastName: string;
    company: string;
    email: string;
    phone: string;
    visaId: string;
    visaName: string;
    visaState: VisaState;
}

export class VenueMemberProfileModel implements IVenueMemberProfileModel {
    id!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    company!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    imageUrl!: string | undefined;
    agreedToShareContactInfo!: boolean;
    visaId!: string | undefined;
    currentMemberVisaStateId!: string | undefined;
    availableVisas!: { [key: string]: string; };
    visaState!: VisaState | undefined;
    denyVisaReason!: DenyVisaReason;
    paymentMethod!: string | undefined;
    memberPackage!: string | undefined;
    venueApprovalRequiredVisaIds!: string[];
    confirmRelation!: boolean;

    constructor(data?: IVenueMemberProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.company = _data["company"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.imageUrl = _data["imageUrl"];
            this.agreedToShareContactInfo = _data["agreedToShareContactInfo"];
            this.visaId = _data["visaId"];
            this.currentMemberVisaStateId = _data["currentMemberVisaStateId"];
            if (_data["availableVisas"]) {
                this.availableVisas = {} as any;
                for (let key in _data["availableVisas"]) {
                    if (_data["availableVisas"].hasOwnProperty(key))
                        (<any>this.availableVisas)![key] = _data["availableVisas"][key];
                }
            }
            this.visaState = _data["visaState"];
            this.denyVisaReason = _data["denyVisaReason"];
            this.paymentMethod = _data["paymentMethod"];
            this.memberPackage = _data["memberPackage"];
            if (Array.isArray(_data["venueApprovalRequiredVisaIds"])) {
                this.venueApprovalRequiredVisaIds = [] as any;
                for (let item of _data["venueApprovalRequiredVisaIds"])
                    this.venueApprovalRequiredVisaIds!.push(item);
            }
            this.confirmRelation = _data["confirmRelation"];
        }
    }

    static fromJS(data: any): VenueMemberProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueMemberProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["company"] = this.company;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["imageUrl"] = this.imageUrl;
        data["agreedToShareContactInfo"] = this.agreedToShareContactInfo;
        data["visaId"] = this.visaId;
        data["currentMemberVisaStateId"] = this.currentMemberVisaStateId;
        if (this.availableVisas) {
            data["availableVisas"] = {};
            for (let key in this.availableVisas) {
                if (this.availableVisas.hasOwnProperty(key))
                    (<any>data["availableVisas"])[key] = (<any>this.availableVisas)[key];
            }
        }
        data["visaState"] = this.visaState;
        data["denyVisaReason"] = this.denyVisaReason;
        data["paymentMethod"] = this.paymentMethod;
        data["memberPackage"] = this.memberPackage;
        if (Array.isArray(this.venueApprovalRequiredVisaIds)) {
            data["venueApprovalRequiredVisaIds"] = [];
            for (let item of this.venueApprovalRequiredVisaIds)
                data["venueApprovalRequiredVisaIds"].push(item);
        }
        data["confirmRelation"] = this.confirmRelation;
        return data;
    }
}

export interface IVenueMemberProfileModel {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    company: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    imageUrl: string | undefined;
    agreedToShareContactInfo: boolean;
    visaId: string | undefined;
    currentMemberVisaStateId: string | undefined;
    availableVisas: { [key: string]: string; };
    visaState: VisaState | undefined;
    denyVisaReason: DenyVisaReason;
    paymentMethod: string | undefined;
    memberPackage: string | undefined;
    venueApprovalRequiredVisaIds: string[];
    confirmRelation: boolean;
}

/** 0 = None 1 = SpaceNoLongerAvailable 2 = GuestNoShow 3 = GuestNotFit 4 = PriceIssues 5 = MyReasonIsNotListed */
export enum DenyVisaReason {
    None = 0,
    SpaceNoLongerAvailable = 1,
    GuestNoShow = 2,
    GuestNotFit = 3,
    PriceIssues = 4,
    MyReasonIsNotListed = 5,
}

export class AddMemberToVisaModel implements IAddMemberToVisaModel {
    venueId!: string;
    email!: string | undefined;
    visaId!: string;
    availableVisas!: { [key: string]: string; };
    visaState!: VisaState;
    originatingFrom!: ReservationSource;
    notes!: string | undefined;

    constructor(data?: IAddMemberToVisaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.email = _data["email"];
            this.visaId = _data["visaId"];
            if (_data["availableVisas"]) {
                this.availableVisas = {} as any;
                for (let key in _data["availableVisas"]) {
                    if (_data["availableVisas"].hasOwnProperty(key))
                        (<any>this.availableVisas)![key] = _data["availableVisas"][key];
                }
            }
            this.visaState = _data["visaState"];
            this.originatingFrom = _data["originatingFrom"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AddMemberToVisaModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddMemberToVisaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["email"] = this.email;
        data["visaId"] = this.visaId;
        if (this.availableVisas) {
            data["availableVisas"] = {};
            for (let key in this.availableVisas) {
                if (this.availableVisas.hasOwnProperty(key))
                    (<any>data["availableVisas"])[key] = (<any>this.availableVisas)[key];
            }
        }
        data["visaState"] = this.visaState;
        data["originatingFrom"] = this.originatingFrom;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IAddMemberToVisaModel {
    venueId: string;
    email: string | undefined;
    visaId: string;
    availableVisas: { [key: string]: string; };
    visaState: VisaState;
    originatingFrom: ReservationSource;
    notes: string | undefined;
}

/** 0 = LiquidSpace 1 = Exchange 2 = iPhone 3 = AndroidPhone 4 = iPad 5 = AndroidTablet 6 = MorningStar 7 = GCal 8 = MeetingRequestor 9 = LES 10 = ServCorp 11 = IntelligentOffice 12 = RJMetis 13 = MobileWeb 14 = LSApi 15 = Widget 16 = MobileWidget 17 = OfficeRnD 18 = MSGraph 19 = Deskimo 20 = WeWorkIndia */
export enum ReservationSource {
    LiquidSpace = 0,
    Exchange = 1,
    IPhone = 2,
    AndroidPhone = 3,
    IPad = 4,
    AndroidTablet = 5,
    MorningStar = 6,
    GCal = 7,
    MeetingRequestor = 8,
    LES = 9,
    ServCorp = 10,
    IntelligentOffice = 11,
    RJMetis = 12,
    MobileWeb = 13,
    LSApi = 14,
    Widget = 15,
    MobileWidget = 16,
    OfficeRnD = 17,
    MSGraph = 18,
    Deskimo = 19,
    WeWorkIndia = 20,
}

export class ChangeVisaStateReponse implements IChangeVisaStateReponse {
    success!: boolean;
    message!: string | undefined;
    unableToProcess!: boolean;
    redirectToCalendar!: boolean;

    constructor(data?: IChangeVisaStateReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.unableToProcess = _data["unableToProcess"];
            this.redirectToCalendar = _data["redirectToCalendar"];
        }
    }

    static fromJS(data: any): ChangeVisaStateReponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeVisaStateReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["unableToProcess"] = this.unableToProcess;
        data["redirectToCalendar"] = this.redirectToCalendar;
        return data;
    }
}

export interface IChangeVisaStateReponse {
    success: boolean;
    message: string | undefined;
    unableToProcess: boolean;
    redirectToCalendar: boolean;
}

export class VenueReservationViewModel extends BaseReservationViewModel implements IVenueReservationViewModel {

    constructor(data?: IVenueReservationViewModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): VenueReservationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueReservationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IVenueReservationViewModel extends IBaseReservationViewModel {
}

export class VenueScoreViewModel implements IVenueScoreViewModel {
    venueId!: string;
    freshness!: WorkspaceFreshness;
    freshnessDaysSinceLastUpdate!: number;
    freshnessWorkspacesCount!: number;
    responseRatePercent!: number;
    conversionRatePercent!: number;
    conversionRateAveragePercent!: number;
    leadRequestTotal!: number;
    workflowsTotal!: number;
    venueScoreCurrent!: number;
    venueScoreAverage!: number;
    venueScoreDelta!: number;
    hide!: boolean;

    constructor(data?: IVenueScoreViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.freshness = _data["freshness"];
            this.freshnessDaysSinceLastUpdate = _data["freshnessDaysSinceLastUpdate"];
            this.freshnessWorkspacesCount = _data["freshnessWorkspacesCount"];
            this.responseRatePercent = _data["responseRatePercent"];
            this.conversionRatePercent = _data["conversionRatePercent"];
            this.conversionRateAveragePercent = _data["conversionRateAveragePercent"];
            this.leadRequestTotal = _data["leadRequestTotal"];
            this.workflowsTotal = _data["workflowsTotal"];
            this.venueScoreCurrent = _data["venueScoreCurrent"];
            this.venueScoreAverage = _data["venueScoreAverage"];
            this.venueScoreDelta = _data["venueScoreDelta"];
            this.hide = _data["hide"];
        }
    }

    static fromJS(data: any): VenueScoreViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueScoreViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["freshness"] = this.freshness;
        data["freshnessDaysSinceLastUpdate"] = this.freshnessDaysSinceLastUpdate;
        data["freshnessWorkspacesCount"] = this.freshnessWorkspacesCount;
        data["responseRatePercent"] = this.responseRatePercent;
        data["conversionRatePercent"] = this.conversionRatePercent;
        data["conversionRateAveragePercent"] = this.conversionRateAveragePercent;
        data["leadRequestTotal"] = this.leadRequestTotal;
        data["workflowsTotal"] = this.workflowsTotal;
        data["venueScoreCurrent"] = this.venueScoreCurrent;
        data["venueScoreAverage"] = this.venueScoreAverage;
        data["venueScoreDelta"] = this.venueScoreDelta;
        data["hide"] = this.hide;
        return data;
    }
}

export interface IVenueScoreViewModel {
    venueId: string;
    freshness: WorkspaceFreshness;
    freshnessDaysSinceLastUpdate: number;
    freshnessWorkspacesCount: number;
    responseRatePercent: number;
    conversionRatePercent: number;
    conversionRateAveragePercent: number;
    leadRequestTotal: number;
    workflowsTotal: number;
    venueScoreCurrent: number;
    venueScoreAverage: number;
    venueScoreDelta: number;
    hide: boolean;
}

/** 0 = Fresh 1 = Stale 2 = Rotten 3 = Compost */
export enum WorkspaceFreshness {
    Fresh = 0,
    Stale = 1,
    Rotten = 2,
    Compost = 3,
}

export class VenueStatementSummaryModel implements IVenueStatementSummaryModel {
    date!: string;
    createdDate!: string | undefined;
    hourly!: VenueStatementSummaryDetails;
    monthly!: VenueStatementSummaryDetails;

    constructor(data?: IVenueStatementSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.createdDate = _data["createdDate"];
            this.hourly = _data["hourly"] ? VenueStatementSummaryDetails.fromJS(_data["hourly"]) : <any>undefined;
            this.monthly = _data["monthly"] ? VenueStatementSummaryDetails.fromJS(_data["monthly"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VenueStatementSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueStatementSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["createdDate"] = this.createdDate;
        data["hourly"] = this.hourly ? this.hourly.toJSON() : <any>undefined;
        data["monthly"] = this.monthly ? this.monthly.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVenueStatementSummaryModel {
    date: string;
    createdDate: string | undefined;
    hourly: VenueStatementSummaryDetails;
    monthly: VenueStatementSummaryDetails;
}

export class VenueStatementSummaryDetails implements IVenueStatementSummaryDetails {
    reservationsCount!: number;
    totalToVenue!: number;
    incidentals!: number;
    salesPrice!: number;
    isGenerated!: boolean;

    constructor(data?: IVenueStatementSummaryDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.reservationsCount = _data["reservationsCount"];
            this.totalToVenue = _data["totalToVenue"];
            this.incidentals = _data["incidentals"];
            this.salesPrice = _data["salesPrice"];
            this.isGenerated = _data["isGenerated"];
        }
    }

    static fromJS(data: any): VenueStatementSummaryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new VenueStatementSummaryDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationsCount"] = this.reservationsCount;
        data["totalToVenue"] = this.totalToVenue;
        data["incidentals"] = this.incidentals;
        data["salesPrice"] = this.salesPrice;
        data["isGenerated"] = this.isGenerated;
        return data;
    }
}

export interface IVenueStatementSummaryDetails {
    reservationsCount: number;
    totalToVenue: number;
    incidentals: number;
    salesPrice: number;
    isGenerated: boolean;
}

export class VisaInfoModel implements IVisaInfoModel {
    id!: string;
    name!: string;
    paymentMethod!: PaymentMethod;
    defaultMemberOriginationScenario!: DefaultMemberOriginationScenario;

    constructor(data?: IVisaInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.paymentMethod = _data["paymentMethod"];
            this.defaultMemberOriginationScenario = _data["defaultMemberOriginationScenario"];
        }
    }

    static fromJS(data: any): VisaInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new VisaInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["paymentMethod"] = this.paymentMethod;
        data["defaultMemberOriginationScenario"] = this.defaultMemberOriginationScenario;
        return data;
    }
}

export interface IVisaInfoModel {
    id: string;
    name: string;
    paymentMethod: PaymentMethod;
    defaultMemberOriginationScenario: DefaultMemberOriginationScenario;
}

export class VisaModel implements IVisaModel {
    id!: string;
    name!: string;
    description!: string | undefined;
    paymentMethod!: PaymentMethod;
    defaultMemberOriginationScenario!: DefaultMemberOriginationScenario;
    reservationType!: ReservationType;
    requiresMemberDataApproval!: boolean;
    freeFormTextForApproval!: string | undefined;
    hidePrice!: boolean;
    earlyCheckInMinutesPermitted!: number;
    needGrantedVisaBeforeMemberCanBook!: boolean;

    constructor(data?: IVisaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.paymentMethod = _data["paymentMethod"];
            this.defaultMemberOriginationScenario = _data["defaultMemberOriginationScenario"];
            this.reservationType = _data["reservationType"];
            this.requiresMemberDataApproval = _data["requiresMemberDataApproval"];
            this.freeFormTextForApproval = _data["freeFormTextForApproval"];
            this.hidePrice = _data["hidePrice"];
            this.earlyCheckInMinutesPermitted = _data["earlyCheckInMinutesPermitted"];
            this.needGrantedVisaBeforeMemberCanBook = _data["needGrantedVisaBeforeMemberCanBook"];
        }
    }

    static fromJS(data: any): VisaModel {
        data = typeof data === 'object' ? data : {};
        let result = new VisaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["paymentMethod"] = this.paymentMethod;
        data["defaultMemberOriginationScenario"] = this.defaultMemberOriginationScenario;
        data["reservationType"] = this.reservationType;
        data["requiresMemberDataApproval"] = this.requiresMemberDataApproval;
        data["freeFormTextForApproval"] = this.freeFormTextForApproval;
        data["hidePrice"] = this.hidePrice;
        data["earlyCheckInMinutesPermitted"] = this.earlyCheckInMinutesPermitted;
        data["needGrantedVisaBeforeMemberCanBook"] = this.needGrantedVisaBeforeMemberCanBook;
        return data;
    }
}

export interface IVisaModel {
    id: string;
    name: string;
    description: string | undefined;
    paymentMethod: PaymentMethod;
    defaultMemberOriginationScenario: DefaultMemberOriginationScenario;
    reservationType: ReservationType;
    requiresMemberDataApproval: boolean;
    freeFormTextForApproval: string | undefined;
    hidePrice: boolean;
    earlyCheckInMinutesPermitted: number;
    needGrantedVisaBeforeMemberCanBook: boolean;
}

/** 0 = Confidential 1 = Public 2 = Connections */
export enum ReservationType {
    Confidential = 0,
    Public = 1,
    Connections = 2,
}

export abstract class WorkspaceModel implements IWorkspaceModel {
    id!: string;
    imageUrl!: string;
    name!: string | undefined;
    order!: number | undefined;
    spaceType!: SpaceType;
    spaceTypeFormatted!: string;
    capacity!: number;
    prices!: string[];
    status!: WorkspaceStatus;
    hasReservation!: boolean;
    hasTour!: boolean;
    hasRequestToBook!: boolean;
    hasIncompleteFields!: boolean;
    previewUrl!: string;
    reservationMethod!: ReservationMethod;
    modifiedDate!: string;
    isDesk!: boolean;
    bookingMethod!: BookingMethod;

    protected _discriminator: string;

    constructor(data?: IWorkspaceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "WorkspaceModel";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageUrl = _data["imageUrl"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.spaceType = _data["spaceType"];
            this.spaceTypeFormatted = _data["spaceTypeFormatted"];
            this.capacity = _data["capacity"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(item);
            }
            this.status = _data["status"];
            this.hasReservation = _data["hasReservation"];
            this.hasTour = _data["hasTour"];
            this.hasRequestToBook = _data["hasRequestToBook"];
            this.hasIncompleteFields = _data["hasIncompleteFields"];
            this.previewUrl = _data["previewUrl"];
            this.reservationMethod = _data["reservationMethod"];
            this.modifiedDate = _data["modifiedDate"];
            this.isDesk = _data["isDesk"];
            this.bookingMethod = _data["bookingMethod"];
        }
    }

    static fromJS(data: any): WorkspaceModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "WorkspaceHourlyModel") {
            let result = new WorkspaceHourlyModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "WorkspacePeriodModel") {
            let result = new WorkspacePeriodModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'WorkspaceModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["id"] = this.id;
        data["imageUrl"] = this.imageUrl;
        data["name"] = this.name;
        data["order"] = this.order;
        data["spaceType"] = this.spaceType;
        data["spaceTypeFormatted"] = this.spaceTypeFormatted;
        data["capacity"] = this.capacity;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item);
        }
        data["status"] = this.status;
        data["hasReservation"] = this.hasReservation;
        data["hasTour"] = this.hasTour;
        data["hasRequestToBook"] = this.hasRequestToBook;
        data["hasIncompleteFields"] = this.hasIncompleteFields;
        data["previewUrl"] = this.previewUrl;
        data["reservationMethod"] = this.reservationMethod;
        data["modifiedDate"] = this.modifiedDate;
        data["isDesk"] = this.isDesk;
        data["bookingMethod"] = this.bookingMethod;
        return data;
    }
}

export interface IWorkspaceModel {
    id: string;
    imageUrl: string;
    name: string | undefined;
    order: number | undefined;
    spaceType: SpaceType;
    spaceTypeFormatted: string;
    capacity: number;
    prices: string[];
    status: WorkspaceStatus;
    hasReservation: boolean;
    hasTour: boolean;
    hasRequestToBook: boolean;
    hasIncompleteFields: boolean;
    previewUrl: string;
    reservationMethod: ReservationMethod;
    modifiedDate: string;
    isDesk: boolean;
    bookingMethod: BookingMethod;
}

export class WorkspaceHourlyModel extends WorkspaceModel implements IWorkspaceHourlyModel {
    hasIntegration!: boolean;
    integrationExemption!: boolean;

    constructor(data?: IWorkspaceHourlyModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "WorkspaceHourlyModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasIntegration = _data["hasIntegration"];
            this.integrationExemption = _data["integrationExemption"];
        }
    }

    static fromJS(data: any): WorkspaceHourlyModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceHourlyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasIntegration"] = this.hasIntegration;
        data["integrationExemption"] = this.integrationExemption;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkspaceHourlyModel extends IWorkspaceModel {
    hasIntegration: boolean;
    integrationExemption: boolean;
}

export class WorkspacePeriodModel extends WorkspaceModel implements IWorkspacePeriodModel {
    minimumTermMonths!: number | undefined;
    nextAvailableDateVenueTime!: string | undefined;
    freshness!: WorkspaceFreshness | undefined;
    availableDesksCount!: number;

    constructor(data?: IWorkspacePeriodModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "WorkspacePeriodModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minimumTermMonths = _data["minimumTermMonths"];
            this.nextAvailableDateVenueTime = _data["nextAvailableDateVenueTime"];
            this.freshness = _data["freshness"];
            this.availableDesksCount = _data["availableDesksCount"];
        }
    }

    static fromJS(data: any): WorkspacePeriodModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspacePeriodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumTermMonths"] = this.minimumTermMonths;
        data["nextAvailableDateVenueTime"] = this.nextAvailableDateVenueTime;
        data["freshness"] = this.freshness;
        data["availableDesksCount"] = this.availableDesksCount;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkspacePeriodModel extends IWorkspaceModel {
    minimumTermMonths: number | undefined;
    nextAvailableDateVenueTime: string | undefined;
    freshness: WorkspaceFreshness | undefined;
    availableDesksCount: number;
}

export class DeskimoMarketModel implements IDeskimoMarketModel {
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IDeskimoMarketModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): DeskimoMarketModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeskimoMarketModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IDeskimoMarketModel {
    name: string | undefined;
    code: string | undefined;
}

export class DeskimoPropertyModel implements IDeskimoPropertyModel {
    name!: string | undefined;
    reference!: string | undefined;

    constructor(data?: IDeskimoPropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): DeskimoPropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeskimoPropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IDeskimoPropertyModel {
    name: string | undefined;
    reference: string | undefined;
}

export class EvoOptionsModel implements IEvoOptionsModel {
    connections!: EvoConnectionModel[];
    centers!: EvoCenterModel[] | undefined;

    constructor(data?: IEvoOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["connections"])) {
                this.connections = [] as any;
                for (let item of _data["connections"])
                    this.connections!.push(EvoConnectionModel.fromJS(item));
            }
            if (Array.isArray(_data["centers"])) {
                this.centers = [] as any;
                for (let item of _data["centers"])
                    this.centers!.push(EvoCenterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EvoOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new EvoOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connections)) {
            data["connections"] = [];
            for (let item of this.connections)
                data["connections"].push(item.toJSON());
        }
        if (Array.isArray(this.centers)) {
            data["centers"] = [];
            for (let item of this.centers)
                data["centers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEvoOptionsModel {
    connections: EvoConnectionModel[];
    centers: EvoCenterModel[] | undefined;
}

export class EvoConnectionModel implements IEvoConnectionModel {
    id!: string;
    name!: string | undefined;

    constructor(data?: IEvoConnectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EvoConnectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new EvoConnectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEvoConnectionModel {
    id: string;
    name: string | undefined;
}

export class EvoCenterModel implements IEvoCenterModel {
    id!: string;
    name!: string | undefined;

    constructor(data?: IEvoCenterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EvoCenterModel {
        data = typeof data === 'object' ? data : {};
        let result = new EvoCenterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEvoCenterModel {
    id: string;
    name: string | undefined;
}

export class MSGraphUserModel implements IMSGraphUserModel {
    id!: string;
    email!: string;

    constructor(data?: IMSGraphUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): MSGraphUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new MSGraphUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        return data;
    }
}

export interface IMSGraphUserModel {
    id: string;
    email: string;
}

export class MorningStarSettingsModel implements IMorningStarSettingsModel {
    morningStarURL!: string;
    morningStarIntegrationUser!: string;
    morningStarIntegrationPassword!: string;
    morningStarClientId!: string;
    morningStarLocationId!: string;
    morningStarVisaId!: string | undefined;

    constructor(data?: IMorningStarSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.morningStarURL = _data["morningStarURL"];
            this.morningStarIntegrationUser = _data["morningStarIntegrationUser"];
            this.morningStarIntegrationPassword = _data["morningStarIntegrationPassword"];
            this.morningStarClientId = _data["morningStarClientId"];
            this.morningStarLocationId = _data["morningStarLocationId"];
            this.morningStarVisaId = _data["morningStarVisaId"];
        }
    }

    static fromJS(data: any): MorningStarSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new MorningStarSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["morningStarURL"] = this.morningStarURL;
        data["morningStarIntegrationUser"] = this.morningStarIntegrationUser;
        data["morningStarIntegrationPassword"] = this.morningStarIntegrationPassword;
        data["morningStarClientId"] = this.morningStarClientId;
        data["morningStarLocationId"] = this.morningStarLocationId;
        data["morningStarVisaId"] = this.morningStarVisaId;
        return data;
    }
}

export interface IMorningStarSettingsModel {
    morningStarURL: string;
    morningStarIntegrationUser: string;
    morningStarIntegrationPassword: string;
    morningStarClientId: string;
    morningStarLocationId: string;
    morningStarVisaId: string | undefined;
}

export class OfficeRnDOrganizationListItemModel implements IOfficeRnDOrganizationListItemModel {
    id!: string;
    slug!: string;
    type!: OfficeRnDOrganizationType;
    connectionTypes!: OfficeRnDOrganizationConnectionType[];
    name!: string;

    constructor(data?: IOfficeRnDOrganizationListItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.type = _data["type"];
            if (Array.isArray(_data["connectionTypes"])) {
                this.connectionTypes = [] as any;
                for (let item of _data["connectionTypes"])
                    this.connectionTypes!.push(item);
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OfficeRnDOrganizationListItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRnDOrganizationListItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["type"] = this.type;
        if (Array.isArray(this.connectionTypes)) {
            data["connectionTypes"] = [];
            for (let item of this.connectionTypes)
                data["connectionTypes"].push(item);
        }
        data["name"] = this.name;
        return data;
    }
}

export interface IOfficeRnDOrganizationListItemModel {
    id: string;
    slug: string;
    type: OfficeRnDOrganizationType;
    connectionTypes: OfficeRnDOrganizationConnectionType[];
    name: string;
}

/** 0 = Flex 1 = Hybrid */
export enum OfficeRnDOrganizationType {
    Flex = 0,
    Hybrid = 1,
}

/** 0 = Manual 1 = PartnerIntegration */
export enum OfficeRnDOrganizationConnectionType {
    Manual = 0,
    PartnerIntegration = 1,
}

export class OfficeRnDOrganizationDetailsModel implements IOfficeRnDOrganizationDetailsModel {
    id!: string;
    slug!: string;
    name!: string;
    clientId!: string;
    clientSecret!: string | undefined;
    type!: OfficeRnDOrganizationType;
    connectionTypes!: OfficeRnDOrganizationConnectionType[];
    webhookUrl!: string;
    partnerIntegrationSettings!: OfficeRnDOrganizationPartnerIntegrationDetailsModel | undefined;

    constructor(data?: IOfficeRnDOrganizationDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.type = _data["type"];
            if (Array.isArray(_data["connectionTypes"])) {
                this.connectionTypes = [] as any;
                for (let item of _data["connectionTypes"])
                    this.connectionTypes!.push(item);
            }
            this.webhookUrl = _data["webhookUrl"];
            this.partnerIntegrationSettings = _data["partnerIntegrationSettings"] ? OfficeRnDOrganizationPartnerIntegrationDetailsModel.fromJS(_data["partnerIntegrationSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OfficeRnDOrganizationDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRnDOrganizationDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["type"] = this.type;
        if (Array.isArray(this.connectionTypes)) {
            data["connectionTypes"] = [];
            for (let item of this.connectionTypes)
                data["connectionTypes"].push(item);
        }
        data["webhookUrl"] = this.webhookUrl;
        data["partnerIntegrationSettings"] = this.partnerIntegrationSettings ? this.partnerIntegrationSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOfficeRnDOrganizationDetailsModel {
    id: string;
    slug: string;
    name: string;
    clientId: string;
    clientSecret: string | undefined;
    type: OfficeRnDOrganizationType;
    connectionTypes: OfficeRnDOrganizationConnectionType[];
    webhookUrl: string;
    partnerIntegrationSettings: OfficeRnDOrganizationPartnerIntegrationDetailsModel | undefined;
}

export class OfficeRnDOrganizationPartnerIntegrationDetailsModel implements IOfficeRnDOrganizationPartnerIntegrationDetailsModel {
    appClientId!: string;
    accessToken!: string;
    refreshToken!: string;
    timestamp!: string;
    expiresIn!: number;
    secret!: string;
    contactFullName!: string | undefined;
    contactEmail!: string | undefined;
    contactPhoneNumber!: string | undefined;
    zendeskTicketId!: number | undefined;

    constructor(data?: IOfficeRnDOrganizationPartnerIntegrationDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.appClientId = _data["appClientId"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.timestamp = _data["timestamp"];
            this.expiresIn = _data["expiresIn"];
            this.secret = _data["secret"];
            this.contactFullName = _data["contactFullName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.zendeskTicketId = _data["zendeskTicketId"];
        }
    }

    static fromJS(data: any): OfficeRnDOrganizationPartnerIntegrationDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRnDOrganizationPartnerIntegrationDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appClientId"] = this.appClientId;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["timestamp"] = this.timestamp;
        data["expiresIn"] = this.expiresIn;
        data["secret"] = this.secret;
        data["contactFullName"] = this.contactFullName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["zendeskTicketId"] = this.zendeskTicketId;
        return data;
    }
}

export interface IOfficeRnDOrganizationPartnerIntegrationDetailsModel {
    appClientId: string;
    accessToken: string;
    refreshToken: string;
    timestamp: string;
    expiresIn: number;
    secret: string;
    contactFullName: string | undefined;
    contactEmail: string | undefined;
    contactPhoneNumber: string | undefined;
    zendeskTicketId: number | undefined;
}

export class OfficeRnDOrganizationEditModel implements IOfficeRnDOrganizationEditModel {
    name!: string;
    slug!: string;
    clientId!: string;
    clientSecret!: string | undefined;
    type!: OfficeRnDOrganizationType;
    partnerIntegrationContactFullName!: string | undefined;
    partnerIntegrationContactEmail!: string | undefined;
    partnerIntegrationContactPhoneNumber!: string | undefined;

    constructor(data?: IOfficeRnDOrganizationEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.type = _data["type"];
            this.partnerIntegrationContactFullName = _data["partnerIntegrationContactFullName"];
            this.partnerIntegrationContactEmail = _data["partnerIntegrationContactEmail"];
            this.partnerIntegrationContactPhoneNumber = _data["partnerIntegrationContactPhoneNumber"];
        }
    }

    static fromJS(data: any): OfficeRnDOrganizationEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRnDOrganizationEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["type"] = this.type;
        data["partnerIntegrationContactFullName"] = this.partnerIntegrationContactFullName;
        data["partnerIntegrationContactEmail"] = this.partnerIntegrationContactEmail;
        data["partnerIntegrationContactPhoneNumber"] = this.partnerIntegrationContactPhoneNumber;
        return data;
    }
}

export interface IOfficeRnDOrganizationEditModel {
    name: string;
    slug: string;
    clientId: string;
    clientSecret: string | undefined;
    type: OfficeRnDOrganizationType;
    partnerIntegrationContactFullName: string | undefined;
    partnerIntegrationContactEmail: string | undefined;
    partnerIntegrationContactPhoneNumber: string | undefined;
}

export class OfficeRnDOrganizationPartnerIntegrationContactEditModel implements IOfficeRnDOrganizationPartnerIntegrationContactEditModel {
    fullName!: string;
    email!: string;
    phoneNumber!: string | undefined;

    constructor(data?: IOfficeRnDOrganizationPartnerIntegrationContactEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): OfficeRnDOrganizationPartnerIntegrationContactEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRnDOrganizationPartnerIntegrationContactEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IOfficeRnDOrganizationPartnerIntegrationContactEditModel {
    fullName: string;
    email: string;
    phoneNumber: string | undefined;
}

export class OfficeRndOfficeModel implements IOfficeRndOfficeModel {
    id!: string;
    name!: string;
    formattedAddress!: string;

    constructor(data?: IOfficeRndOfficeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.formattedAddress = _data["formattedAddress"];
        }
    }

    static fromJS(data: any): OfficeRndOfficeModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRndOfficeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["formattedAddress"] = this.formattedAddress;
        return data;
    }
}

export interface IOfficeRndOfficeModel {
    id: string;
    name: string;
    formattedAddress: string;
}

export class OfficeRndTeamModel implements IOfficeRndTeamModel {
    id!: string;
    name!: string;
    email!: string | undefined;

    constructor(data?: IOfficeRndTeamModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): OfficeRndTeamModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRndTeamModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IOfficeRndTeamModel {
    id: string;
    name: string;
    email: string | undefined;
}

export class OfficeRndMemberModel implements IOfficeRndMemberModel {
    id!: string;
    name!: string;
    email!: string;
    teamName!: string | undefined;

    constructor(data?: IOfficeRndMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.teamName = _data["teamName"];
        }
    }

    static fromJS(data: any): OfficeRndMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeRndMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["teamName"] = this.teamName;
        return data;
    }
}

export interface IOfficeRndMemberModel {
    id: string;
    name: string;
    email: string;
    teamName: string | undefined;
}

export class DiagnosticsAuditLogType implements IDiagnosticsAuditLogType {
    fullName!: string | undefined;
    name!: string;

    constructor(data?: IDiagnosticsAuditLogType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DiagnosticsAuditLogType {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsAuditLogType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["name"] = this.name;
        return data;
    }
}

export interface IDiagnosticsAuditLogType {
    fullName: string | undefined;
    name: string;
}

export class AuditLogMessageViewModel implements IAuditLogMessageViewModel {
    changeId!: string;
    entityPartitionKey!: string;
    entityRowKey!: string | undefined;
    updateAuthor!: string;
    updateAuthorEmail!: string;
    changeDate!: string;
    changeBody!: string;
    insertOperation!: boolean;

    constructor(data?: IAuditLogMessageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.changeId = _data["changeId"];
            this.entityPartitionKey = _data["entityPartitionKey"];
            this.entityRowKey = _data["entityRowKey"];
            this.updateAuthor = _data["updateAuthor"];
            this.updateAuthorEmail = _data["updateAuthorEmail"];
            this.changeDate = _data["changeDate"];
            this.changeBody = _data["changeBody"];
            this.insertOperation = _data["insertOperation"];
        }
    }

    static fromJS(data: any): AuditLogMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeId"] = this.changeId;
        data["entityPartitionKey"] = this.entityPartitionKey;
        data["entityRowKey"] = this.entityRowKey;
        data["updateAuthor"] = this.updateAuthor;
        data["updateAuthorEmail"] = this.updateAuthorEmail;
        data["changeDate"] = this.changeDate;
        data["changeBody"] = this.changeBody;
        data["insertOperation"] = this.insertOperation;
        return data;
    }
}

export interface IAuditLogMessageViewModel {
    changeId: string;
    entityPartitionKey: string;
    entityRowKey: string | undefined;
    updateAuthor: string;
    updateAuthorEmail: string;
    changeDate: string;
    changeBody: string;
    insertOperation: boolean;
}

export class DiagnosticsAuditLogFilter implements IDiagnosticsAuditLogFilter {
    from!: string | undefined;
    to!: string | undefined;

    protected _discriminator: string;

    constructor(data?: IDiagnosticsAuditLogFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "DiagnosticsAuditLogFilter";
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
        }
    }

    static fromJS(data: any): DiagnosticsAuditLogFilter {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DiagnosticsAuditLogFilterByEntity") {
            let result = new DiagnosticsAuditLogFilterByEntity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DiagnosticsAuditLogFilterByAuthor") {
            let result = new DiagnosticsAuditLogFilterByAuthor();
            result.init(data);
            return result;
        }
        let result = new DiagnosticsAuditLogFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["from"] = this.from;
        data["to"] = this.to;
        return data;
    }
}

export interface IDiagnosticsAuditLogFilter {
    from: string | undefined;
    to: string | undefined;
}

export class DiagnosticsAuditLogFilterByEntity extends DiagnosticsAuditLogFilter implements IDiagnosticsAuditLogFilterByEntity {
    selectedType!: string;
    entityId!: string;

    constructor(data?: IDiagnosticsAuditLogFilterByEntity) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "DiagnosticsAuditLogFilterByEntity";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.selectedType = _data["selectedType"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): DiagnosticsAuditLogFilterByEntity {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsAuditLogFilterByEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedType"] = this.selectedType;
        data["entityId"] = this.entityId;
        super.toJSON(data);
        return data;
    }
}

export interface IDiagnosticsAuditLogFilterByEntity extends IDiagnosticsAuditLogFilter {
    selectedType: string;
    entityId: string;
}

export class DiagnosticsAuditLogFilterByAuthor extends DiagnosticsAuditLogFilter implements IDiagnosticsAuditLogFilterByAuthor {
    updateAuthor!: string;

    constructor(data?: IDiagnosticsAuditLogFilterByAuthor) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

        this._discriminator = "DiagnosticsAuditLogFilterByAuthor";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.updateAuthor = _data["updateAuthor"];
        }
    }

    static fromJS(data: any): DiagnosticsAuditLogFilterByAuthor {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsAuditLogFilterByAuthor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateAuthor"] = this.updateAuthor;
        super.toJSON(data);
        return data;
    }
}

export interface IDiagnosticsAuditLogFilterByAuthor extends IDiagnosticsAuditLogFilter {
    updateAuthor: string;
}

export class DiagnosticsConsoleMethod implements IDiagnosticsConsoleMethod {
    name!: string;
    parameters!: DiagnosticsConsoleMethodParameter[];
    declaringTypeName!: string;

    constructor(data?: IDiagnosticsConsoleMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(DiagnosticsConsoleMethodParameter.fromJS(item));
            }
            this.declaringTypeName = _data["declaringTypeName"];
        }
    }

    static fromJS(data: any): DiagnosticsConsoleMethod {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsConsoleMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["declaringTypeName"] = this.declaringTypeName;
        return data;
    }
}

export interface IDiagnosticsConsoleMethod {
    name: string;
    parameters: DiagnosticsConsoleMethodParameter[];
    declaringTypeName: string;
}

export class DiagnosticsConsoleMethodParameter implements IDiagnosticsConsoleMethodParameter {
    name!: string;
    typeName!: string;

    constructor(data?: IDiagnosticsConsoleMethodParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.typeName = _data["typeName"];
        }
    }

    static fromJS(data: any): DiagnosticsConsoleMethodParameter {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsConsoleMethodParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeName"] = this.typeName;
        return data;
    }
}

export interface IDiagnosticsConsoleMethodParameter {
    name: string;
    typeName: string;
}

export class DiagnosticsConsoleRunKey implements IDiagnosticsConsoleRunKey {
    id!: string;
    notBeforeTicks!: number;

    constructor(data?: IDiagnosticsConsoleRunKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notBeforeTicks = _data["notBeforeTicks"];
        }
    }

    static fromJS(data: any): DiagnosticsConsoleRunKey {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsConsoleRunKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notBeforeTicks"] = this.notBeforeTicks;
        return data;
    }
}

export interface IDiagnosticsConsoleRunKey {
    id: string;
    notBeforeTicks: number;
}

/** 0 = Worker 1 = BusinessService */
export enum DiagnosticsMethodRunner {
    Worker = 0,
    BusinessService = 1,
}

export class DiagnosticsConsoleLineViewModel implements IDiagnosticsConsoleLineViewModel {
    timestamp!: string | undefined;
    ticks!: string;
    taskId!: string;
    taskName!: string | undefined;
    text!: string | undefined;

    constructor(data?: IDiagnosticsConsoleLineViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"];
            this.ticks = _data["ticks"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DiagnosticsConsoleLineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsConsoleLineViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp;
        data["ticks"] = this.ticks;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["text"] = this.text;
        return data;
    }
}

export interface IDiagnosticsConsoleLineViewModel {
    timestamp: string | undefined;
    ticks: string;
    taskId: string;
    taskName: string | undefined;
    text: string | undefined;
}

export class ContentSecurityPolicyViewModel implements IContentSecurityPolicyViewModel {
    enabled!: boolean;
    placement!: ContentSecurityPolicyPlacement;
    useReportEndpoint!: boolean;
    reportOnly!: boolean;
    formattedHeaderValue!: string | undefined;
    timestablUtc!: string;

    constructor(data?: IContentSecurityPolicyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.placement = _data["placement"];
            this.useReportEndpoint = _data["useReportEndpoint"];
            this.reportOnly = _data["reportOnly"];
            this.formattedHeaderValue = _data["formattedHeaderValue"];
            this.timestablUtc = _data["timestablUtc"];
        }
    }

    static fromJS(data: any): ContentSecurityPolicyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContentSecurityPolicyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["placement"] = this.placement;
        data["useReportEndpoint"] = this.useReportEndpoint;
        data["reportOnly"] = this.reportOnly;
        data["formattedHeaderValue"] = this.formattedHeaderValue;
        data["timestablUtc"] = this.timestablUtc;
        return data;
    }
}

export interface IContentSecurityPolicyViewModel {
    enabled: boolean;
    placement: ContentSecurityPolicyPlacement;
    useReportEndpoint: boolean;
    reportOnly: boolean;
    formattedHeaderValue: string | undefined;
    timestablUtc: string;
}

/** 0 = Headers 1 = MetaHttpEquiv */
export enum ContentSecurityPolicyPlacement {
    Headers = 0,
    MetaHttpEquiv = 1,
}

export class EmailTemplate implements IEmailTemplate {
    name!: string;
    description!: string | undefined;

    constructor(data?: IEmailTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EmailTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IEmailTemplate {
    name: string;
    description: string | undefined;
}

export class DiagnosticsEmailModel implements IDiagnosticsEmailModel {
    readonlyProperties!: { [key: string]: any; };
    writableProperties!: { [key: string]: { [key: string]: any; }; };
    id!: string;
    interfaces!: string[];

    constructor(data?: IDiagnosticsEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            if (_data["readonlyProperties"]) {
                this.readonlyProperties = {} as any;
                for (let key in _data["readonlyProperties"]) {
                    if (_data["readonlyProperties"].hasOwnProperty(key))
                        (<any>this.readonlyProperties)![key] = _data["readonlyProperties"][key];
                }
            }
            if (_data["writableProperties"]) {
                this.writableProperties = {} as any;
                for (let key in _data["writableProperties"]) {
                    if (_data["writableProperties"].hasOwnProperty(key))
                        (<any>this.writableProperties)![key] = _data["writableProperties"][key] !== undefined ? _data["writableProperties"][key] : {};
                }
            }
            this.id = _data["id"];
            if (Array.isArray(_data["interfaces"])) {
                this.interfaces = [] as any;
                for (let item of _data["interfaces"])
                    this.interfaces!.push(item);
            }
        }
    }

    static fromJS(data: any): DiagnosticsEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.readonlyProperties) {
            data["readonlyProperties"] = {};
            for (let key in this.readonlyProperties) {
                if (this.readonlyProperties.hasOwnProperty(key))
                    (<any>data["readonlyProperties"])[key] = (<any>this.readonlyProperties)[key];
            }
        }
        if (this.writableProperties) {
            data["writableProperties"] = {};
            for (let key in this.writableProperties) {
                if (this.writableProperties.hasOwnProperty(key))
                    (<any>data["writableProperties"])[key] = (<any>this.writableProperties)[key];
            }
        }
        data["id"] = this.id;
        if (Array.isArray(this.interfaces)) {
            data["interfaces"] = [];
            for (let item of this.interfaces)
                data["interfaces"].push(item);
        }
        return data;
    }
}

export interface IDiagnosticsEmailModel {
    readonlyProperties: { [key: string]: any; };
    writableProperties: { [key: string]: { [key: string]: any; }; };
    id: string;
    interfaces: string[];
}

export class SendTestEmailModel implements ISendTestEmailModel {
    recipient!: string | undefined;
    subject!: string | undefined;
    templates!: string[];

    constructor(data?: ISendTestEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.recipient = _data["recipient"];
            this.subject = _data["subject"];
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(item);
            }
        }
    }

    static fromJS(data: any): SendTestEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient;
        data["subject"] = this.subject;
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item);
        }
        return data;
    }
}

export interface ISendTestEmailModel {
    recipient: string | undefined;
    subject: string | undefined;
    templates: string[];
}

export class DiagnosticsIntegrationListItemModel implements IDiagnosticsIntegrationListItemModel {
    venueId!: string;
    venueName!: string;
    workspaceId!: string;
    workspaceName!: string;
    integration!: IntegrationTypeEnum;
    isPaused!: boolean;
    pooledEvents!: number;
    deletedActivityCount!: number;
    upsertedActivityCount!: number;
    lastProcessed!: string;
    lastErrorCount!: number;

    constructor(data?: IDiagnosticsIntegrationListItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
            this.workspaceId = _data["workspaceId"];
            this.workspaceName = _data["workspaceName"];
            this.integration = _data["integration"];
            this.isPaused = _data["isPaused"];
            this.pooledEvents = _data["pooledEvents"];
            this.deletedActivityCount = _data["deletedActivityCount"];
            this.upsertedActivityCount = _data["upsertedActivityCount"];
            this.lastProcessed = _data["lastProcessed"];
            this.lastErrorCount = _data["lastErrorCount"];
        }
    }

    static fromJS(data: any): DiagnosticsIntegrationListItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsIntegrationListItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        data["workspaceId"] = this.workspaceId;
        data["workspaceName"] = this.workspaceName;
        data["integration"] = this.integration;
        data["isPaused"] = this.isPaused;
        data["pooledEvents"] = this.pooledEvents;
        data["deletedActivityCount"] = this.deletedActivityCount;
        data["upsertedActivityCount"] = this.upsertedActivityCount;
        data["lastProcessed"] = this.lastProcessed;
        data["lastErrorCount"] = this.lastErrorCount;
        return data;
    }
}

export interface IDiagnosticsIntegrationListItemModel {
    venueId: string;
    venueName: string;
    workspaceId: string;
    workspaceName: string;
    integration: IntegrationTypeEnum;
    isPaused: boolean;
    pooledEvents: number;
    deletedActivityCount: number;
    upsertedActivityCount: number;
    lastProcessed: string;
    lastErrorCount: number;
}

export class DiagnosticsLogItem implements IDiagnosticsLogItem {
    partitionKey!: string;
    timestamp!: string | undefined;
    role!: string | undefined;
    message!: string | undefined;
    clientCity!: string | undefined;
    clientState!: string | undefined;
    clientCountry!: string | undefined;

    constructor(data?: IDiagnosticsLogItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.partitionKey = _data["partitionKey"];
            this.timestamp = _data["timestamp"];
            this.role = _data["role"];
            this.message = _data["message"];
            this.clientCity = _data["clientCity"];
            this.clientState = _data["clientState"];
            this.clientCountry = _data["clientCountry"];
        }
    }

    static fromJS(data: any): DiagnosticsLogItem {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsLogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partitionKey"] = this.partitionKey;
        data["timestamp"] = this.timestamp;
        data["role"] = this.role;
        data["message"] = this.message;
        data["clientCity"] = this.clientCity;
        data["clientState"] = this.clientState;
        data["clientCountry"] = this.clientCountry;
        return data;
    }
}

export interface IDiagnosticsLogItem {
    partitionKey: string;
    timestamp: string | undefined;
    role: string | undefined;
    message: string | undefined;
    clientCity: string | undefined;
    clientState: string | undefined;
    clientCountry: string | undefined;
}

/** 1 = Undefined 2 = Critical 4 = Error 8 = Warning 16 = Information 32 = Verbose */
export enum DiagnosticsLogLevels {
    Undefined = 1,
    Critical = 2,
    Error = 4,
    Warning = 8,
    Information = 16,
    Verbose = 32,
}

export class PoisonMessageViewModel implements IPoisonMessageViewModel {
    envelopeId!: string;
    messageType!: string;
    exception!: string;
    lastActivity!: string;
    machineType!: string;
    syncMode!: boolean;

    constructor(data?: IPoisonMessageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.envelopeId = _data["envelopeId"];
            this.messageType = _data["messageType"];
            this.exception = _data["exception"];
            this.lastActivity = _data["lastActivity"];
            this.machineType = _data["machineType"];
            this.syncMode = _data["syncMode"];
        }
    }

    static fromJS(data: any): PoisonMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PoisonMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["envelopeId"] = this.envelopeId;
        data["messageType"] = this.messageType;
        data["exception"] = this.exception;
        data["lastActivity"] = this.lastActivity;
        data["machineType"] = this.machineType;
        data["syncMode"] = this.syncMode;
        return data;
    }
}

export interface IPoisonMessageViewModel {
    envelopeId: string;
    messageType: string;
    exception: string;
    lastActivity: string;
    machineType: string;
    syncMode: boolean;
}

export class PoisonMessageDetailsViewModel implements IPoisonMessageDetailsViewModel {
    message!: any;
    quarantineMessage!: QuarantineMessage;

    constructor(data?: IPoisonMessageDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.quarantineMessage = _data["quarantineMessage"] ? QuarantineMessage.fromJS(_data["quarantineMessage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PoisonMessageDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PoisonMessageDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["quarantineMessage"] = this.quarantineMessage ? this.quarantineMessage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPoisonMessageDetailsViewModel {
    message: any;
    quarantineMessage: QuarantineMessage;
}

export class QuarantineMessage implements IQuarantineMessage {
    envelopeId!: string;
    retryCount!: number;
    envelopeBodyId!: string;
    exception!: string | undefined;
    queueName!: string | undefined;
    messageType!: string | undefined;
    machineType!: string | undefined;
    lastActivity!: string;
    compressed!: boolean;
    syncMode!: boolean;

    constructor(data?: IQuarantineMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.envelopeId = _data["envelopeId"];
            this.retryCount = _data["retryCount"];
            this.envelopeBodyId = _data["envelopeBodyId"];
            this.exception = _data["exception"];
            this.queueName = _data["queueName"];
            this.messageType = _data["messageType"];
            this.machineType = _data["machineType"];
            this.lastActivity = _data["lastActivity"];
            this.compressed = _data["compressed"];
            this.syncMode = _data["syncMode"];
        }
    }

    static fromJS(data: any): QuarantineMessage {
        data = typeof data === 'object' ? data : {};
        let result = new QuarantineMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["envelopeId"] = this.envelopeId;
        data["retryCount"] = this.retryCount;
        data["envelopeBodyId"] = this.envelopeBodyId;
        data["exception"] = this.exception;
        data["queueName"] = this.queueName;
        data["messageType"] = this.messageType;
        data["machineType"] = this.machineType;
        data["lastActivity"] = this.lastActivity;
        data["compressed"] = this.compressed;
        data["syncMode"] = this.syncMode;
        return data;
    }
}

export interface IQuarantineMessage {
    envelopeId: string;
    retryCount: number;
    envelopeBodyId: string;
    exception: string | undefined;
    queueName: string | undefined;
    messageType: string | undefined;
    machineType: string | undefined;
    lastActivity: string;
    compressed: boolean;
    syncMode: boolean;
}

export class DiagnosticsShortUrlViewModel implements IDiagnosticsShortUrlViewModel {
    id!: string;
    url!: string;
    created!: string;
    validTo!: string;
    type!: ShortUrlType;
    tags!: string[];

    constructor(data?: IDiagnosticsShortUrlViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.created = _data["created"];
            this.validTo = _data["validTo"];
            this.type = _data["type"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): DiagnosticsShortUrlViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsShortUrlViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["created"] = this.created;
        data["validTo"] = this.validTo;
        data["type"] = this.type;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IDiagnosticsShortUrlViewModel {
    id: string;
    url: string;
    created: string;
    validTo: string;
    type: ShortUrlType;
    tags: string[];
}

/** 0 = Unknown 1 = Temp 2 = Unexpiring */
export enum ShortUrlType {
    Unknown = 0,
    Temp = 1,
    Unexpiring = 2,
}

export class DiagnosticsShortUrlCreateModel implements IDiagnosticsShortUrlCreateModel {
    url!: string;
    id!: string | undefined;
    type!: ShortUrlType;
    tags!: string[];

    constructor(data?: IDiagnosticsShortUrlCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.id = _data["id"];
            this.type = _data["type"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): DiagnosticsShortUrlCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsShortUrlCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["id"] = this.id;
        data["type"] = this.type;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IDiagnosticsShortUrlCreateModel {
    url: string;
    id: string | undefined;
    type: ShortUrlType;
    tags: string[];
}

export class DiagnosticsWorkspaceScenarioViewModel implements IDiagnosticsWorkspaceScenarioViewModel {
    id!: string;
    displayName!: string;
    description!: string;
    longDescription!: string;
    spaceType!: SpaceType;
    isHidden!: boolean;
    isOnlyMonthly!: boolean;
    isMonthly!: boolean;
    isDaypass!: boolean;
    isMonthlyWithFloorSpace!: boolean;

    constructor(data?: IDiagnosticsWorkspaceScenarioViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.longDescription = _data["longDescription"];
            this.spaceType = _data["spaceType"];
            this.isHidden = _data["isHidden"];
            this.isOnlyMonthly = _data["isOnlyMonthly"];
            this.isMonthly = _data["isMonthly"];
            this.isDaypass = _data["isDaypass"];
            this.isMonthlyWithFloorSpace = _data["isMonthlyWithFloorSpace"];
        }
    }

    static fromJS(data: any): DiagnosticsWorkspaceScenarioViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsWorkspaceScenarioViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["longDescription"] = this.longDescription;
        data["spaceType"] = this.spaceType;
        data["isHidden"] = this.isHidden;
        data["isOnlyMonthly"] = this.isOnlyMonthly;
        data["isMonthly"] = this.isMonthly;
        data["isDaypass"] = this.isDaypass;
        data["isMonthlyWithFloorSpace"] = this.isMonthlyWithFloorSpace;
        return data;
    }
}

export interface IDiagnosticsWorkspaceScenarioViewModel {
    id: string;
    displayName: string;
    description: string;
    longDescription: string;
    spaceType: SpaceType;
    isHidden: boolean;
    isOnlyMonthly: boolean;
    isMonthly: boolean;
    isDaypass: boolean;
    isMonthlyWithFloorSpace: boolean;
}

export class DiagnosticsSpaceTypeViewModel implements IDiagnosticsSpaceTypeViewModel {
    id!: SpaceType;
    name!: string;
    description!: string;
    isHourly!: boolean;
    isMonthly!: boolean;
    workspaceTypes!: WorkspaceScenarioViewModel[];

    constructor(data?: IDiagnosticsSpaceTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isHourly = _data["isHourly"];
            this.isMonthly = _data["isMonthly"];
            if (Array.isArray(_data["workspaceTypes"])) {
                this.workspaceTypes = [] as any;
                for (let item of _data["workspaceTypes"])
                    this.workspaceTypes!.push(WorkspaceScenarioViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiagnosticsSpaceTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsSpaceTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isHourly"] = this.isHourly;
        data["isMonthly"] = this.isMonthly;
        if (Array.isArray(this.workspaceTypes)) {
            data["workspaceTypes"] = [];
            for (let item of this.workspaceTypes)
                data["workspaceTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDiagnosticsSpaceTypeViewModel {
    id: SpaceType;
    name: string;
    description: string;
    isHourly: boolean;
    isMonthly: boolean;
    workspaceTypes: WorkspaceScenarioViewModel[];
}

export class EditableInternationalConfigurationModel implements IEditableInternationalConfigurationModel {
    country!: string | undefined;
    currency!: CurrencyType;
    merchantAccountId!: string;
    allowCreditCardPayments!: boolean;
    onDemandServiceChargeEnabled!: boolean;
    onDemandServiceChargePercentage!: number;
    onDemandServiceChargeMerchandisingEnabled!: boolean;
    hourlySpaceVisibility!: SpaceVisibility;
    monthlySpaceVisibility!: SpaceVisibility;

    constructor(data?: IEditableInternationalConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.currency = _data["currency"];
            this.merchantAccountId = _data["merchantAccountId"];
            this.allowCreditCardPayments = _data["allowCreditCardPayments"];
            this.onDemandServiceChargeEnabled = _data["onDemandServiceChargeEnabled"];
            this.onDemandServiceChargePercentage = _data["onDemandServiceChargePercentage"];
            this.onDemandServiceChargeMerchandisingEnabled = _data["onDemandServiceChargeMerchandisingEnabled"];
            this.hourlySpaceVisibility = _data["hourlySpaceVisibility"];
            this.monthlySpaceVisibility = _data["monthlySpaceVisibility"];
        }
    }

    static fromJS(data: any): EditableInternationalConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditableInternationalConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["currency"] = this.currency;
        data["merchantAccountId"] = this.merchantAccountId;
        data["allowCreditCardPayments"] = this.allowCreditCardPayments;
        data["onDemandServiceChargeEnabled"] = this.onDemandServiceChargeEnabled;
        data["onDemandServiceChargePercentage"] = this.onDemandServiceChargePercentage;
        data["onDemandServiceChargeMerchandisingEnabled"] = this.onDemandServiceChargeMerchandisingEnabled;
        data["hourlySpaceVisibility"] = this.hourlySpaceVisibility;
        data["monthlySpaceVisibility"] = this.monthlySpaceVisibility;
        return data;
    }
}

export interface IEditableInternationalConfigurationModel {
    country: string | undefined;
    currency: CurrencyType;
    merchantAccountId: string;
    allowCreditCardPayments: boolean;
    onDemandServiceChargeEnabled: boolean;
    onDemandServiceChargePercentage: number;
    onDemandServiceChargeMerchandisingEnabled: boolean;
    hourlySpaceVisibility: SpaceVisibility;
    monthlySpaceVisibility: SpaceVisibility;
}

export class InternationalConfigurationModel extends EditableInternationalConfigurationModel implements IInternationalConfigurationModel {
    id!: string;
    allowSearching!: boolean;
    allowNewListings!: boolean;
    allowVenueBilledPayments!: boolean;
    allowACHPayments!: boolean;

    constructor(data?: IInternationalConfigurationModel) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.allowSearching = _data["allowSearching"];
            this.allowNewListings = _data["allowNewListings"];
            this.allowVenueBilledPayments = _data["allowVenueBilledPayments"];
            this.allowACHPayments = _data["allowACHPayments"];
        }
    }

    static fromJS(data: any): InternationalConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allowSearching"] = this.allowSearching;
        data["allowNewListings"] = this.allowNewListings;
        data["allowVenueBilledPayments"] = this.allowVenueBilledPayments;
        data["allowACHPayments"] = this.allowACHPayments;
        super.toJSON(data);
        return data;
    }
}

export interface IInternationalConfigurationModel extends IEditableInternationalConfigurationModel {
    id: string;
    allowSearching: boolean;
    allowNewListings: boolean;
    allowVenueBilledPayments: boolean;
    allowACHPayments: boolean;
}

/** 0 = Public 1 = EnterpriseOnly 2 = None */
export enum SpaceVisibility {
    Public = 0,
    EnterpriseOnly = 1,
    None = 2,
}

export class MerchantAccountModel implements IMerchantAccountModel {
    id!: string;
    name!: string;

    constructor(data?: IMerchantAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MerchantAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMerchantAccountModel {
    id: string;
    name: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* eslint-disable */
//THIS FILE IS INCLUDED INTO NSWAG GENERATED CODE (API.ts)
//KEEP SAME NESTING LEVEL

//Hey, Hotshot! You are here due to error caused by exposed EntityBase to client.
type IEntityBase = never;

//TODO: Use ReservationMethod instead
// type WorkspaceReservationMethod = never;